/*
 * AUTO-GENERATED by scripts/generate-chapter.ts.
 * Source: LearningHub / beginner-level3
 * Do not edit by hand — regenerate from extracted JSON + translations.
 */
import type { Chapter, Level } from "../types";

export const CHAPTER_ID = "beginner-level3";

export const CHAPTER: Chapter = {
    id: "beginner-level3",
    title: { zh: "星耀", en: "Astral" },
    description: {
        zh: "劫争、双活、收官与综合判断",
        en: "Ko, seki, endgame and integrated judgement",
    },
};

const bl3Capture1Levels: Level[] = [
    {
        id: "beginner-level3-bl3-capture-1-1",
        chapterId: "beginner-level3",
        order: 1,
        title: { zh: "提子 · 1/12", en: "Capture · 1/12" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dmemcncodpfpdq", white: "clcmbndndo" },
            correct: ["cpbobp"],
            wrong: ["cpboaobp", "bocp"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-1-2",
        chapterId: "beginner-level3",
        order: 2,
        title: { zh: "提子 · 2/12", en: "Capture · 2/12" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fmgndobpdpgphpcqhqbrcr", white: "cncocpepbqdqeqgqgr" },
            correct: ["en"],
            wrong: ["dneo", "eodn", "boaq"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-1-3",
        chapterId: "beginner-level3",
        order: 3,
        title: { zh: "提子 · 3/12", en: "Capture · 3/12" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbqcqdqgqerfr", white: "coepeqarbrcrdr" },
            correct: ["bp", "cp", "dp"],
            wrong: ["apbp"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-1-4",
        chapterId: "beginner-level3",
        order: 4,
        title: { zh: "提子 · 4/12", en: "Capture · 4/12" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ckelbmfmbnbodocpcqcr", white: "cmcncodpdqfqdr" },
            correct: ["eneofoepeq", "eneofoepfp"],
            wrong: ["eneodnfo", "eneofnfogodndmemgndl", "eodnendm", "eodndmen", "eodnemdm", "dneo", "fnen"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-1-5",
        chapterId: "beginner-level3",
        order: 5,
        title: { zh: "提子 · 5/12", en: "Capture · 5/12" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dsfrergqdqcqbqdpdocncm", white: "drcrbreqepeocobodn" },
            correct: ["aqarasapbparcp", "aqarasapcparbp", "aqarbpapcpaqao", "bp", "cp"],
            wrong: ["aqarapbs", "aqarasaparcs", "aqarbpapcpaqasbs", "apendmemdlfo", "cses"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-1-6",
        chapterId: "beginner-level3",
        order: 6,
        title: { zh: "提子 · 6/12", en: "Capture · 6/12" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "hnbpephpaqcqdqhqbr", white: "cnbocpdpeqfq" },
            correct: ["fo"],
            wrong: ["eofpgpfofngo", "fpeo"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-1-7",
        chapterId: "beginner-level3",
        order: 7,
        title: { zh: "提子 · 7/12", en: "Capture · 7/12" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmcmcncodpaqbqdqfqbrerasbs", white: "bnbobpcpcqcrdr" },
            correct: ["cs", "ap"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-1-8",
        chapterId: "beginner-level3",
        order: 8,
        title: { zh: "提子 · 8/12", en: "Capture · 8/12" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gmhndoeocphpcqdqeqgqhq", white: "dmcncodpepfpgp" },
            correct: ["fn"],
            wrong: ["foenemfn", "foenfmfn", "foenfnem", "enfogofn", "enfofngo", "enfogngo"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-1-9",
        chapterId: "beginner-level3",
        order: 9,
        title: { zh: "提子 · 9/12", en: "Capture · 9/12" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dlbmbncocpdpcqarbr", white: "cndnbobpbqeqcrdr" },
            correct: ["ep"],
            wrong: ["dqepfpeoenfo", "dqepfpeofoen", "dqepfpeofnao", "doepfpeoenfo", "doepfpeofoen", "doepfpeofnao", "bsaq", "aqao"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-1-10",
        chapterId: "beginner-level3",
        order: 10,
        title: { zh: "提子 · 10/12", en: "Capture · 10/12" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bogohoapcpepcqeqfqcrdr", white: "cmbncododpdqgqerfr" },
            correct: ["fo"],
            wrong: ["eofp", "fpeo"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-1-11",
        chapterId: "beginner-level3",
        order: 11,
        title: { zh: "提子 · 11/12", en: "Capture · 11/12" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "elcmcndoeofobpcpfqdrer", white: "dnenfnbocogodpeq" },
            correct: ["fp"],
            wrong: ["epfp", "cqdq"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-1-12",
        chapterId: "beginner-level3",
        order: 12,
        title: { zh: "提子 · 12/12", en: "Capture · 12/12" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dlelbmcmdmcpdpeqfqhqcrdr", white: "emfmdneogoepbqcqdq" },
            correct: ["bobpap"],
            wrong: ["bobpcoaq", "bpcocnbobnan", "cobpboaq", "cobpbrbo"],
        },
    },
];

const bl3Capture2Levels: Level[] = [
    {
        id: "beginner-level3-bl3-capture-2-1",
        chapterId: "beginner-level3",
        order: 13,
        title: { zh: "提子 · 1/12", en: "Capture · 1/12" },
        instruction: { zh: "黑先。通过追击尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "blcmbncncocpcq", white: "ambmanbobpbqcrdrer" },
            correct: ["aoapalaobr"],
            wrong: ["alao", "braraoapalbsaoan"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-2-2",
        chapterId: "beginner-level3",
        order: 14,
        title: { zh: "提子 · 2/12", en: "Capture · 2/12" },
        instruction: { zh: "黑先。通过追击尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bndndodpaqdqarbrcr", white: "bmcmdmcnaoboapcpbqcqfqdrer" },
            correct: ["co"],
            wrong: ["anam"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-2-3",
        chapterId: "beginner-level3",
        order: 15,
        title: { zh: "提子 · 3/12", en: "Capture · 3/12" },
        instruction: { zh: "黑先。通过追击尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "doeofocpgpcqgqcrdr", white: "bocobpdpepbqdqbrer" },
            correct: ["eqfqfpeqfr", "eqfqfpeqes"],
            wrong: ["fpeqfrds", "fpeqescs", "fpeqfqfrgrcs", "fpeqfqfresgrhrcs", "frds"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-2-4",
        chapterId: "beginner-level3",
        order: 16,
        title: { zh: "提子 · 4/12", en: "Capture · 4/12" },
        instruction: { zh: "黑先。通过追击尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdpepgpeqgqfrhresfs", white: "dmbodofobpfpbqdqfqcrercsds" },
            correct: ["cqdrbr"],
            wrong: ["drcq", "brcq"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-2-5",
        chapterId: "beginner-level3",
        order: 17,
        title: { zh: "提子 · 5/12", en: "Capture · 5/12" },
        instruction: { zh: "黑先。通过追击尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cnbocodpepcqeqfqbr", white: "bmcmdndoeofobpcpfphpbqgqcr" },
            correct: ["apdqaq", "aqdqap"],
            wrong: ["drdq"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-2-6",
        chapterId: "beginner-level3",
        order: 18,
        title: { zh: "提子 · 6/12", en: "Capture · 6/12" },
        instruction: { zh: "黑先。通过追击尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmdmdndoapcpaqbqcqdqeqgq", white: "cldlelbmancnbocoeobpdpep" },
            correct: ["aobnbl"],
            wrong: ["blem", "enfn"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-2-7",
        chapterId: "beginner-level3",
        order: 19,
        title: { zh: "提子 · 7/12", en: "Capture · 7/12" },
        instruction: { zh: "黑先。通过追击尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "codoeofogocpgpdqgqergrgs", white: "bobpepfpbqcqfqdrfres" },
            correct: ["fseqdpercr", "dpfseqdscr"],
            wrong: ["eqdp", "creqfsdp", "creqdpfs"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-2-8",
        chapterId: "beginner-level3",
        order: 20,
        title: { zh: "提子 · 8/12", en: "Capture · 8/12" },
        instruction: { zh: "黑先。通过追击尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dmandncododpdqarbrcr", white: "ckdlbmcmcnboapcpaqbqcq" },
            correct: ["ao"],
            wrong: ["bnam"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-2-9",
        chapterId: "beginner-level3",
        order: 21,
        title: { zh: "提子 · 9/12", en: "Capture · 9/12" },
        instruction: { zh: "黑先。通过追击尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eneocpdpfpfqcrdrfrgrhs", white: "codobpepbqeqbrerbsdsgs" },
            correct: ["esfsdq"],
            wrong: ["dqes", "fscq", "cscq"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-2-10",
        chapterId: "beginner-level3",
        order: 22,
        title: { zh: "提子 · 10/12", en: "Capture · 10/12" },
        instruction: { zh: "黑先。通过追击尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmdmemfnfocpfpcqdqeqbr", white: "blclflbmfmbndnencoeobpdpepbq" },
            correct: ["cn"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-2-11",
        chapterId: "beginner-level3",
        order: 23,
        title: { zh: "提子 · 11/12", en: "Capture · 11/12" },
        instruction: { zh: "黑先。通过追击尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aobocodpepeqcrdr", white: "apbpcqdqbrerfr" },
            correct: ["bqaqcpbqbs"],
            wrong: ["cpbq", "bsds"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-2-12",
        chapterId: "beginner-level3",
        order: 24,
        title: { zh: "提子 · 12/12", en: "Capture · 12/12" },
        instruction: { zh: "黑先。通过追击尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cldmcndofocpepcqfresfs", white: "bnbocodpdqfqgqcrerhrds" },
            correct: ["eqdrbr"],
            wrong: ["breq"],
        },
    },
];

const bl3Capture3Levels: Level[] = [
    {
        id: "beginner-level3-bl3-capture-3-1",
        chapterId: "beginner-level3",
        order: 25,
        title: { zh: "提子 · 1/23", en: "Capture · 1/23" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eofogocpdphpeqhq", white: "cnfngnhoepfpgp" },
            correct: ["doenem"],
            wrong: ["endo", "dndo"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-3-2",
        chapterId: "beginner-level3",
        order: 26,
        title: { zh: "提子 · 2/23", en: "Capture · 2/23" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clelbmbncodoeodpcqarbrcrdrer", white: "cndnbobpcpepbqdqeqfqfr" },
            correct: ["fnfogo"],
            wrong: ["foenemfngnfm", "foenemfnfmgn", "foenfnem", "enfo"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-3-3",
        chapterId: "beginner-level3",
        order: 27,
        title: { zh: "提子 · 3/23", en: "Capture · 3/23" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "blcldlcodocpdqfqgqhqcrdrbs", white: "eneobpdpepgpbqcqbr" },
            correct: ["cnbobn"],
            wrong: ["bndmdncn", "dncncmdm", "dncnbncm", "dncnbocm", "bocn"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-3-4",
        chapterId: "beginner-level3",
        order: 28,
        title: { zh: "提子 · 4/23", en: "Capture · 4/23" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dlemfmgmcndnboeogodpbqcqeq", white: "bmcmdmbnenfnaobpcp" },
            correct: ["do"],
            wrong: ["codo", "fodo"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-3-5",
        chapterId: "beginner-level3",
        order: 29,
        title: { zh: "提子 · 5/23", en: "Capture · 5/23" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clelbmcpdpepfqcrdrerfr", white: "dofofpbqcqdqeq" },
            correct: ["bococneoendnbp"],
            wrong: ["bpcocnbobnaneoao", "bpcocnbobnanapao", "bpcocnboaobn", "bpcobocn", "cobpapbobncn", "cobpapboaobn", "eobp"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-3-6",
        chapterId: "beginner-level3",
        order: 30,
        title: { zh: "提子 · 6/23", en: "Capture · 6/23" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "embncndndpaqbqcqgqdrerfr", white: "enfndoepdqeqarbrcr" },
            correct: ["bpapao"],
            wrong: ["cpao", "apbp", "cocs", "bocs"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-3-7",
        chapterId: "beginner-level3",
        order: 31,
        title: { zh: "提子 · 7/23", en: "Capture · 7/23" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocoeofodpcqeqcrerhrds", white: "bpcpepfpbqfqbrfrbscsfs" },
            correct: ["dqdres"],
            wrong: ["esdq", "drdq"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-3-8",
        chapterId: "beginner-level3",
        order: 32,
        title: { zh: "提子 · 8/23", en: "Capture · 8/23" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dofobpepfpbqcqdqdr", white: "cnbocoeogocpdphpeqfq" },
            correct: ["fnengpeoem"],
            wrong: ["fnenemgnfmgphogq", "enfn", "dnfn", "gpfn"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-3-9",
        chapterId: "beginner-level3",
        order: 33,
        title: { zh: "提子 · 9/23", en: "Capture · 9/23" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dnenbocoeocpbqcrdrer", white: "cldmanbncndodpcqdq" },
            correct: ["bpapaobpbr"],
            wrong: ["bpapbrao", "aobp", "brar"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-3-10",
        chapterId: "beginner-level3",
        order: 34,
        title: { zh: "提子 · 10/23", en: "Capture · 10/23" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmcncodpdqfqer", white: "bnbocpepcqcrdr" },
            correct: ["eqdofr"],
            wrong: ["doeq"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-3-11",
        chapterId: "beginner-level3",
        order: 35,
        title: { zh: "提子 · 11/23", en: "Capture · 11/23" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "emcnendobpcpaqbr", white: "fneofodpbqcqeqcrcs" },
            correct: ["arasbs"],
            wrong: ["bsar", "apar"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-3-12",
        chapterId: "beginner-level3",
        order: 36,
        title: { zh: "提子 · 12/23", en: "Capture · 12/23" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "blcmemenaobodofocpdpaqbqdqdr", white: "anbncndncoeocqarbrcr" },
            correct: ["bp"],
            wrong: ["apbp"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-3-13",
        chapterId: "beginner-level3",
        order: 37,
        title: { zh: "提子 · 13/23", en: "Capture · 13/23" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aobpcpepfpbqdqfqcrdrfr", white: "bmbocododpeqbrercses" },
            correct: ["dscqaq"],
            wrong: ["aqfs", "apfs"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-3-14",
        chapterId: "beginner-level3",
        order: 38,
        title: { zh: "提子 · 14/23", en: "Capture · 14/23" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncndneogoepfpcqdqfqgq", white: "enfngnhnbocodofodpgpeqergr" },
            correct: ["hqhpfrgpip"],
            wrong: ["hqhpiphriqfr", "frhq", "hohq", "bqhq"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-3-15",
        chapterId: "beginner-level3",
        order: 39,
        title: { zh: "提子 · 15/23", en: "Capture · 15/23" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ckcmdmdncoeoapbpcpfpcqbrbs", white: "bncnbododpbqdqarcrdr" },
            correct: ["ao"],
            wrong: ["aqas", "csbm", "asaq"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-3-16",
        chapterId: "beginner-level3",
        order: 40,
        title: { zh: "提子 · 16/23", en: "Capture · 16/23" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dmemcnbocpdpfpeqdrer", white: "dneobpepaqcqdqcr" },
            correct: ["co"],
            wrong: ["doco", "fqgq"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-3-17",
        chapterId: "beginner-level3",
        order: 41,
        title: { zh: "提子 · 17/23", en: "Capture · 17/23" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bobpaqcqdqcrercses", white: "cpdpepbqeqbrfrbs" },
            correct: ["drdsfs", "dsdrfs"],
            wrong: ["fsardras", "fsardsas"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-3-18",
        chapterId: "beginner-level3",
        order: 42,
        title: { zh: "提子 · 18/23", en: "Capture · 18/23" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dlemfmdngndobpdpgphpaqcqeqfqhqbrcrhr", white: "cmdmcnbocofocpdqgqdrerfrgr" },
            correct: ["enfpep"],
            wrong: ["epen", "eoen", "fpen"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-3-19",
        chapterId: "beginner-level3",
        order: 43,
        title: { zh: "提子 · 19/23", en: "Capture · 19/23" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dlflcmcnenfnbododpaqbqcqdq", white: "dmemdneoapbpepeqarbrcrdr" },
            correct: ["co"],
            wrong: ["cpco"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-3-20",
        chapterId: "beginner-level3",
        order: 44,
        title: { zh: "提子 · 20/23", en: "Capture · 20/23" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmcmancndodpaqbqcqdq", white: "bndnencoeobpepeqbrcrdr" },
            correct: ["apboar"],
            wrong: ["apbocpao", "arap", "cpap", "boap"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-3-21",
        chapterId: "beginner-level3",
        order: 45,
        title: { zh: "提子 · 21/23", en: "Capture · 21/23" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dnfndogodpcqeqfqcrcs", white: "dmcncofocpepbqdqdrds" },
            correct: ["en"],
            wrong: ["bren", "eoen"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-3-22",
        chapterId: "beginner-level3",
        order: 46,
        title: { zh: "提子 · 22/23", en: "Capture · 22/23" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncndneoepgpbqdqcrdr", white: "bocododpcqeqbrer" },
            correct: ["cscpdscqaq", "cscpdscqbp", "dscpcscqaq", "dscpcscqbp"],
            wrong: ["cscpbpap", "dscpbpap", "cpbp", "bpcp"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-3-23",
        chapterId: "beginner-level3",
        order: 47,
        title: { zh: "提子 · 23/23", en: "Capture · 23/23" },
        instruction: { zh: "白先。尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "alblcldlambncncobpcp", white: "bmcmdmandnaododpcqdr" },
            correct: ["bqapaqboan"],
            wrong: ["bqapaqboaoan", "apaq", "boap"],
        },
    },
];

const bl3Capture4Levels: Level[] = [
    {
        id: "beginner-level3-bl3-capture-4-1",
        chapterId: "beginner-level3",
        order: 48,
        title: { zh: "提子 · 1/24", en: "Capture · 1/24" },
        instruction: { zh: "黑先。尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmdnencoeoepeqbrcrdr", white: "clbmbncndodpbqcqdq" },
            correct: ["bpapaoboaq"],
            wrong: ["aqbpapbo", "aqbpboao", "apbobpcp", "boapaoan"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-4-2",
        chapterId: "beginner-level3",
        order: 49,
        title: { zh: "提子 · 2/24", en: "Capture · 2/24" },
        instruction: { zh: "黑先。尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dmenbpcpdpeqfqfr", white: "hneohoephpbqcqdqcrerds" },
            correct: ["fodoco"],
            wrong: ["dofo", "fpfofngo", "fpfogogn"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-4-3",
        chapterId: "beginner-level3",
        order: 50,
        title: { zh: "提子 · 3/24", en: "Capture · 3/24" },
        instruction: { zh: "黑先。尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ckdlemanbnencodocqdqarbrcr", white: "bmcmdmdnaoeoapcpdpepaqbqeqer" },
            correct: ["bp"],
            wrong: ["bobp", "blbp", "cnam"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-4-4",
        chapterId: "beginner-level3",
        order: 51,
        title: { zh: "提子 · 4/24", en: "Capture · 4/24" },
        instruction: { zh: "黑先。尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpepbqcqfqgqdrcsds", white: "dlbocodobpaqbrcr" },
            correct: ["arasbs"],
            wrong: ["bsar", "asar", "apar"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-4-5",
        chapterId: "beginner-level3",
        order: 52,
        title: { zh: "提子 · 5/24", en: "Capture · 5/24" },
        instruction: { zh: "黑先。尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcmdmdnfncoeoepdqbrdrer", white: "blcldlemfmgmcnendocpdpgpeqfq" },
            correct: ["bpbocq"],
            wrong: ["bnfo", "bofo", "cqbpbofo", "cqbpbqbo"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-4-6",
        chapterId: "beginner-level3",
        order: 53,
        title: { zh: "提子 · 6/24", en: "Capture · 6/24" },
        instruction: { zh: "黑先。尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bocobpdpdqbrdrgrbsgs", white: "doeocpcqcrercsds" },
            correct: ["esfsbqeseq"],
            wrong: ["esfsbqesfreq", "esfsfreq", "esfseqfq", "bqeseqfq", "eqfq", "fqeq"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-4-7",
        chapterId: "beginner-level3",
        order: 54,
        title: { zh: "提子 · 7/24", en: "Capture · 7/24" },
        instruction: { zh: "黑先。尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "doeofogohodphpcqeqcrds", white: "cnbpcpepfpgpdqhqiqdrer" },
            correct: ["frfqes"],
            wrong: ["gqfqgrfr", "gqfqfrgr", "fqfrgqgr"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-4-8",
        chapterId: "beginner-level3",
        order: 55,
        title: { zh: "提子 · 8/24", en: "Capture · 8/24" },
        instruction: { zh: "黑先。尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bldlcmcncobpcp", white: "ambmbnboapdpbqcqeq" },
            correct: ["aoaqal"],
            wrong: ["alao", "aqao", "anao"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-4-9",
        chapterId: "beginner-level3",
        order: 56,
        title: { zh: "提子 · 9/24", en: "Capture · 9/24" },
        instruction: { zh: "黑先。尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmdnenfngncogocpcqdrer", white: "doeofohodpgpbqdqgqbrcr" },
            correct: ["fpfqeq"],
            wrong: ["fqfp", "eqfp", "epfp"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-4-10",
        chapterId: "beginner-level3",
        order: 57,
        title: { zh: "提子 · 10/24", en: "Capture · 10/24" },
        instruction: { zh: "黑先。尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bncndnenfogogpeqgqcrergrfsgs", white: "bocodoeoepfpfqbrfrcsdses" },
            correct: ["bsasdrbsbq"],
            wrong: ["drbsbqcq", "drbscqbq", "bqcq", "aocq", "cqbq"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-4-11",
        chapterId: "beginner-level3",
        order: 58,
        title: { zh: "提子 · 11/24", en: "Capture · 11/24" },
        instruction: { zh: "黑先。尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bobpbqeqbrdrfrcs", white: "codogocqdqgqcrergres" },
            correct: ["fs"],
            wrong: ["dsbs", "dpdscpbs", "cpdsdpbs"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-4-12",
        chapterId: "beginner-level3",
        order: 59,
        title: { zh: "提子 · 12/24", en: "Capture · 12/24" },
        instruction: { zh: "黑先。尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dlbncobpcpdpepfpbq", white: "aoboapaqcqdqeqfqgqbr" },
            correct: ["arasanarcr"],
            wrong: ["anar", "crar"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-4-13",
        chapterId: "beginner-level3",
        order: 60,
        title: { zh: "提子 · 13/24", en: "Capture · 13/24" },
        instruction: { zh: "黑先。尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "codobpepfpbqbrer", white: "clbnboeofogocpdphpeqhqdr" },
            correct: ["dqcqcrdqfq"],
            wrong: ["dqcqcrdqfrdn", "dqcqfqdn", "cqdq", "fqdq", "crdq"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-4-14",
        chapterId: "beginner-level3",
        order: 61,
        title: { zh: "提子 · 14/24", en: "Capture · 14/24" },
        instruction: { zh: "黑先。尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dmaobocoeodpeqcrdr", white: "goapbpcqdqgqarbrerfr" },
            correct: ["bqaqcpbqbs"],
            wrong: ["bqaqcpbqasbs", "bqaqbsds", "cpbq", "bsds", "ascs"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-4-15",
        chapterId: "beginner-level3",
        order: 62,
        title: { zh: "提子 · 15/24", en: "Capture · 15/24" },
        instruction: { zh: "黑先。尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cnbocodpepcqeqfqbr", white: "dlbmcmdndoeogobpcpfpbqgqcr" },
            correct: ["apdqaqcqdr", "apdqaqcqcs", "aqdqapcqdr", "aqdqapcqcs"],
            wrong: ["apdqdrbn", "aqdqdrao", "drao", "dqao"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-4-16",
        chapterId: "beginner-level3",
        order: 63,
        title: { zh: "提子 · 16/24", en: "Capture · 16/24" },
        instruction: { zh: "黑先。尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpcpdpfphpbqeqfqcrfrasfs", white: "cmgncodoeoepcqdqarbrdrer" },
            correct: ["dscsescraq", "escsdscraq"],
            wrong: ["dscsaqes", "escsaqds", "csbs", "aqcs", "bscs"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-4-17",
        chapterId: "beginner-level3",
        order: 64,
        title: { zh: "提子 · 17/24", en: "Capture · 17/24" },
        instruction: { zh: "黑先。尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "doeocpaqcqeqbrcrcsdses", white: "flcmgmcnbocobpdpepbqdqerfs" },
            correct: ["fpfqdreqgq"],
            wrong: ["fpfqgqfo", "fqfpgpfo", "fqfpfogp", "drfp", "frfq"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-4-18",
        chapterId: "beginner-level3",
        order: 65,
        title: { zh: "提子 · 18/24", en: "Capture · 18/24" },
        instruction: { zh: "黑先。尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "enhncodoepcqeqbr", white: "clbncpdphpbqgqcr" },
            correct: ["bpdqdrcqaq", "bpdqdrcqcs"],
            wrong: ["bpdqaqer", "dqbp"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-4-19",
        chapterId: "beginner-level3",
        order: 66,
        title: { zh: "提子 · 19/24", en: "Capture · 19/24" },
        instruction: { zh: "黑先。尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fmcodoeobpepbqfqbrdrfrbs", white: "cmbnbohocpdpcqgqcrergrdsfsgs" },
            correct: ["csdqeq"],
            wrong: ["dqeq", "eqcs"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-4-20",
        chapterId: "beginner-level3",
        order: 67,
        title: { zh: "提子 · 20/24", en: "Capture · 20/24" },
        instruction: { zh: "黑先。尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fnfohogpeqgqcrergrfsgs", white: "dmcoeoepfpfqbrfrcsdses" },
            correct: ["bsasdrbsbq"],
            wrong: ["drbs"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-4-21",
        chapterId: "beginner-level3",
        order: 68,
        title: { zh: "提子 · 21/24", en: "Capture · 21/24" },
        instruction: { zh: "黑先。尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bodoeocpbqbrerbscs", white: "dphpcqeqgqcrdrds" },
            correct: ["esdqfq"],
            wrong: ["esdqepfq", "epfr", "fqfr", "frfq"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-4-22",
        chapterId: "beginner-level3",
        order: 69,
        title: { zh: "提子 · 22/24", en: "Capture · 22/24" },
        instruction: { zh: "黑先。尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dmenepfpdqgqgrgs", white: "hmcogocpgpipbqeqfqhqbrdrfrfs" },
            correct: ["esercrdscs"],
            wrong: ["eres", "dsdp"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-4-23",
        chapterId: "beginner-level3",
        order: 70,
        title: { zh: "提子 · 23/24", en: "Capture · 23/24" },
        instruction: { zh: "黑先。尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "clcnbocobpdphpdqhqbrdrgrbsgs", white: "emdoeocpcqcrercsds" },
            correct: ["esfsbqeseq"],
            wrong: ["esfsbqesfreq", "esfseqfq", "esfsfreq", "bqes", "eqfq", "epfp"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-4-24",
        chapterId: "beginner-level3",
        order: 71,
        title: { zh: "提子 · 24/24", en: "Capture · 24/24" },
        instruction: { zh: "黑先。尽可能多吃掉棋子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "gobqcqdqfqdrergrhr", white: "clcnboeobpaqbrcrdsesfs" },
            correct: ["arascsbsgs", "arascsbsfr"],
            wrong: ["arasgscs", "csar", "gscs", "frcs"],
        },
    },
];

const bl3Capture5Levels: Level[] = [
    {
        id: "beginner-level3-bl3-capture-5-1",
        chapterId: "beginner-level3",
        order: 72,
        title: { zh: "提子 · 1/14", en: "Capture · 1/14" },
        instruction: { zh: "白棋可以通过两次弃子（扑）吃掉五颗棋子：首先白棋在A位扑，黑棋提掉两颗棋子后，白棋可以再次扑。黑棋最终将因气不够而被吃。白先。通过扑吃掉五颗棋子。", en: "White can capture five stones by throwing in twice: first White throws in at A and, after Black has captured the two stones, White can throw in again. Black will end up with a shortage of liberties. White to play. Capture the five stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqbrcocpcsdldrerfrgrgs", white: "cqcrdqeqesfqgqhohrir" },
            marks: { A: "ds" },
            correct: ["dsfsdseshs"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-5-2",
        chapterId: "beginner-level3",
        order: 73,
        title: { zh: "提子 · 2/14", en: "Capture · 2/14" },
        instruction: { zh: "白先。通过扑吃掉棋子。", en: "White to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eofpgphpcqeqarbrcrergrhrdses", white: "cmbpcpdpepdqfqdrfrbs" },
            correct: ["csascsbsfs"],
            wrong: ["csascsbsbqfs", "fscs", "ascs", "bqcs"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-5-3",
        chapterId: "beginner-level3",
        order: 74,
        title: { zh: "提子 · 3/14", en: "Capture · 3/14" },
        instruction: { zh: "白先。通过扑吃掉棋子。", en: "White to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmembocofoapfpbqfqbrfrbs", white: "bpcpdpcqeqarcrer" },
            correct: ["aqasaqarcs", "aqasaqaocs", "aqaocsasaq"],
            wrong: ["csaq"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-5-4",
        chapterId: "beginner-level3",
        order: 75,
        title: { zh: "提子 · 4/14", en: "Capture · 4/14" },
        instruction: { zh: "白先。通过扑吃掉棋子。", en: "White to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eogphphqcrdrerfrhrgs", white: "cnbpcqdqeqfqgqbrgrbses" },
            correct: ["fsdsfsescs"],
            wrong: ["fsdscsfs", "csfs", "dsfs"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-5-5",
        chapterId: "beginner-level3",
        order: 76,
        title: { zh: "提子 · 5/14", en: "Capture · 5/14" },
        instruction: { zh: "白先。通过扑吃掉棋子。", en: "White to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmbocodoeoepbqdqbrdrcsds", white: "apbpcpdpfpcqeqfqhqcrer" },
            correct: ["bsasesbsaq", "bsasesbsar"],
            wrong: ["bsasaqao", "bsasarao", "esbs", "asbs", "aqbs", "arbs"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-5-6",
        chapterId: "beginner-level3",
        order: 77,
        title: { zh: "提子 · 6/14", en: "Capture · 6/14" },
        instruction: { zh: "白先。通过扑吃掉棋子。", en: "White to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fleneogoapbpcpdpaqfqgqbrcrdrergrcsgs", white: "clbmbocodoepfpbqcqdqeqfrases" },
            correct: ["arbsarasao"],
            wrong: ["bsar", "aoar", "dsfs"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-5-7",
        chapterId: "beginner-level3",
        order: 78,
        title: { zh: "提子 · 7/14", en: "Capture · 7/14" },
        instruction: { zh: "白先。通过扑吃掉棋子。", en: "White to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "blbncndneneodpaqbqdqeqfqbrdrfrcsfs", white: "codogoapbpcpepfpcqgqcrgrires" },
            correct: ["dserdsesgs"],
            wrong: ["dsergsds", "bsasdsbo", "gsds", "asbo"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-5-8",
        chapterId: "beginner-level3",
        order: 79,
        title: { zh: "提子 · 8/14", en: "Capture · 8/14" },
        instruction: { zh: "白先。通过扑吃掉棋子。", en: "White to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eogpgqiqarcrdrerfrhrasbs", white: "cnbqcqdqeqfqbrgrds" },
            correct: ["csescs"],
            wrong: ["gscs", "escs", "fsgs"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-5-9",
        chapterId: "beginner-level3",
        order: 80,
        title: { zh: "提子 · 9/14", en: "Capture · 9/14" },
        instruction: { zh: "白先。通过扑吃掉棋子。", en: "White to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fmeofodpipcqdqgqcrercs", white: "cldnbodocpepbqeqbrbs" },
            correct: ["dsdrfr"],
            wrong: ["drds", "esfq"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-5-10",
        chapterId: "beginner-level3",
        order: 81,
        title: { zh: "提子 · 10/14", en: "Capture · 10/14" },
        instruction: { zh: "白先。通过扑吃掉棋子。", en: "White to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "elcmbnbocpcqbrdrds", white: "codofobpdphpbqeqercses" },
            correct: ["crbscrcsdq"],
            wrong: ["crbscrcsarap", "crbsdqcr", "bscr", "dqcr", "arcr"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-5-11",
        chapterId: "beginner-level3",
        order: 82,
        title: { zh: "提子 · 11/14", en: "Capture · 11/14" },
        instruction: { zh: "白先。通过扑吃掉棋子。", en: "White to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aofoapbpepcqdqfqbrfrhrfs", white: "clanbndnbocpdpeqcrer" },
            correct: ["bqaqdrbqbs", "bqaqdrbqcs"],
            wrong: ["bqaqbsdr", "drbqbscsdses", "aqbq"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-5-12",
        chapterId: "beginner-level3",
        order: 83,
        title: { zh: "提子 · 12/14", en: "Capture · 12/14" },
        instruction: { zh: "白先。通过扑吃掉棋子。", en: "White to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbpaqeqgqbrcrdrfrcs", white: "bmenbococpbqcqdqeras" },
            correct: ["arbsar"],
            wrong: ["arbsesar", "esar", "bsar"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-5-13",
        chapterId: "beginner-level3",
        order: 84,
        title: { zh: "提子 · 13/14", en: "Capture · 13/14" },
        instruction: { zh: "白先。通过扑吃掉棋子。", en: "White to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gmdoeofohobpcpcqdqeqhqbrfrgr", white: "elcndnaobocodpepfpbqfqdrer" },
            correct: ["craqapbqbs"],
            wrong: ["apcr", "aqcr"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-5-14",
        chapterId: "beginner-level3",
        order: 85,
        title: { zh: "提子 · 14/14", en: "Capture · 14/14" },
        instruction: { zh: "白先。通过扑吃掉棋子。", en: "White to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmaobocodoapbqbrbscs", white: "bpcpepaqcqcrerds" },
            correct: ["arasaq"],
            wrong: ["arasaraq", "asar"],
        },
    },
];

const bl3Capture6Levels: Level[] = [
    {
        id: "beginner-level3-bl3-capture-6-1",
        chapterId: "beginner-level3",
        order: 86,
        title: { zh: "提子 · 1/9", en: "Capture · 1/9" },
        instruction: { zh: "黑先。通过追击吃掉棋子。", en: "Black to play. Capture stones by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fmdncobpdpepgpdqfqfr", white: "clcmbnbocpcqeqdrer" },
            correct: ["bqcrbr"],
            wrong: ["crbq", "escr"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-6-2",
        chapterId: "beginner-level3",
        order: 87,
        title: { zh: "提子 · 2/9", en: "Capture · 2/9" },
        instruction: { zh: "黑先。通过追击吃掉棋子。", en: "Black to play. Capture stones by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cldleneobpcpdpbq", white: "codoepfpcqdqhqbrer" },
            correct: ["bo"],
            wrong: ["cnbo", "dnbo"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-6-3",
        chapterId: "beginner-level3",
        order: 88,
        title: { zh: "提子 · 3/9", en: "Capture · 3/9" },
        instruction: { zh: "黑先。通过追击吃掉棋子。", en: "Black to play. Capture stones by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dpdqdrereofofmemdmgl", white: "cqcpcodoeqepfpfrcmcldkgognhm" },
            correct: ["gpfqgqgrhr"],
            wrong: ["fqgq", "grgq"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-6-4",
        chapterId: "beginner-level3",
        order: 89,
        title: { zh: "提子 · 4/9", en: "Capture · 4/9" },
        instruction: { zh: "黑先。通过追击吃掉棋子。", en: "Black to play. Capture stones by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cneneogobpcpdpbq", white: "blcldlbocodoepdqeqhqbrcr" },
            correct: ["bn"],
            wrong: ["dnbn", "aobn"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-6-5",
        chapterId: "beginner-level3",
        order: 90,
        title: { zh: "提子 · 5/9", en: "Capture · 5/9" },
        instruction: { zh: "黑先。通过追击吃掉棋子。", en: "Black to play. Capture stones by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "gmbncofobpcpdpgpdqeqgqfr", white: "dlelbmcmhneohoephpaqbqcqhqarcrgrbs" },
            correct: ["en"],
            wrong: ["fpen", "doen"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-6-6",
        chapterId: "beginner-level3",
        order: 91,
        title: { zh: "提子 · 6/9", en: "Capture · 6/9" },
        instruction: { zh: "黑先。通过追击吃掉棋子。", en: "Black to play. Capture stones by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "drdpcpbqeofnfmgohmgk", white: "codnendlckfofpjqioinim" },
            correct: ["gpfqgq"],
            wrong: ["fqgp"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-6-7",
        chapterId: "beginner-level3",
        order: 92,
        title: { zh: "提子 · 7/9", en: "Capture · 7/9" },
        instruction: { zh: "黑先。通过追击吃掉棋子。", en: "Black to play. Capture stones by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "emfmbncnbpcpdqdr", white: "dpfpaqbqcqfqhqarcrbs" },
            correct: ["epdoeo"],
            wrong: ["epdodneo", "doep", "eoep"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-6-8",
        chapterId: "beginner-level3",
        order: 93,
        title: { zh: "提子 · 8/9", en: "Capture · 8/9" },
        instruction: { zh: "黑先。通过追击吃掉棋子。", en: "Black to play. Capture stones by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bndngnbocobpdpephpdqhqdr", white: "flbmcmemcndoeocpbqcqcrbs" },
            correct: ["enfofn"],
            wrong: ["enfogofn", "enfofpfn", "foen", "dmdl"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-6-9",
        chapterId: "beginner-level3",
        order: 94,
        title: { zh: "提子 · 9/9", en: "Capture · 9/9" },
        instruction: { zh: "黑先。通过追击吃掉棋子。", en: "Black to play. Capture stones by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcmdnendpcq", white: "blclelfldmcn" },
            correct: ["bncobo"],
            wrong: ["bncocpbo", "bncodobo", "bncobpbo", "cobn"],
        },
    },
];

const bl3Capture7Levels: Level[] = [
    {
        id: "beginner-level3-bl3-capture-7-1",
        chapterId: "beginner-level3",
        order: 95,
        title: { zh: "提子 · 1/18", en: "Capture · 1/18" },
        instruction: { zh: "白先。在倒扑中尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible in a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fmfofparbrcqdqeqeresdscs", white: "crbqaqbpcpdpepfqfrfsgphqcndm" },
            correct: ["bs"],
            wrong: ["asbs"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-7-2",
        chapterId: "beginner-level3",
        order: 96,
        title: { zh: "提子 · 2/18", en: "Capture · 2/18" },
        instruction: { zh: "白先。在倒扑中尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible in a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqcpdqeqbobncmdnenfpfoeo", white: "bqbpcrdrerfqgqepdo" },
            correct: ["co"],
            wrong: ["dpco", "cnco"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-7-3",
        chapterId: "beginner-level3",
        order: 97,
        title: { zh: "提子 · 3/18", en: "Capture · 3/18" },
        instruction: { zh: "白先。在倒扑中尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible in a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fpereqbsbraqapbpcpdpdqgphpiqhr", white: "esfrfqbqepeodocoboaofogocscrdr" },
            correct: ["ar"],
            wrong: ["cqds", "ascq"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-7-4",
        chapterId: "beginner-level3",
        order: 98,
        title: { zh: "提子 · 4/18", en: "Capture · 4/18" },
        instruction: { zh: "白先。在倒扑中尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible in a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eododpcqcrcsesereqemgrgqhphogn", white: "drbsepfpfqfrfsbrbqcpcocn" },
            correct: ["dqdsdq"],
            wrong: ["dsdq"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-7-5",
        chapterId: "beginner-level3",
        order: 99,
        title: { zh: "提子 · 5/18", en: "Capture · 5/18" },
        instruction: { zh: "白先。在倒扑中尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible in a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrcrdscpdqdpfqgqgrepbocn", white: "csdrcqbqaqerfreqfpfofnho" },
            correct: ["bsascs"],
            wrong: ["asbs", "esbp"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-7-6",
        chapterId: "beginner-level3",
        order: 100,
        title: { zh: "提子 · 6/18", en: "Capture · 6/18" },
        instruction: { zh: "白先。在倒扑中尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible in a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fnenhncmbqbrcpcqdrdscobmamandn", white: "aqbpbocnfqgpbndocrdpdqeres" },
            correct: ["bs"],
            wrong: ["csao", "arcs"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-7-7",
        chapterId: "beginner-level3",
        order: 101,
        title: { zh: "提子 · 7/18", en: "Capture · 7/18" },
        instruction: { zh: "白先。在倒扑中尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible in a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpcoboasaraqapbscrdrepdnfqfrfsgp", white: "eresaoanbmcmbrbpdlcpcqdqeq" },
            correct: ["cs"],
            wrong: ["dsbq", "bqds"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-7-8",
        chapterId: "beginner-level3",
        order: 102,
        title: { zh: "提子 · 8/18", en: "Capture · 8/18" },
        instruction: { zh: "白先。在倒扑中尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible in a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrbqcqdrdsdpdocobn", white: "craqapbpcpdqeqeres" },
            correct: ["bs"],
            wrong: ["csbo", "ascs"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-7-9",
        chapterId: "beginner-level3",
        order: 103,
        title: { zh: "提子 · 9/18", en: "Capture · 9/18" },
        instruction: { zh: "白先。在倒扑中尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible in a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bsbrbqcqdpepfqdrfofnemcocncm", white: "bpcpdoeofpgpgqfrer" },
            correct: ["dq"],
            wrong: ["eqdq"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-7-10",
        chapterId: "beginner-level3",
        order: 104,
        title: { zh: "提子 · 10/18", en: "Capture · 10/18" },
        instruction: { zh: "白先。在倒扑中尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible in a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fpfneodpbraqbqcqdqfqflcsfrhr", white: "epapbpcpdocncmascrdrereq" },
            correct: ["bsarbs"],
            wrong: ["dses", "esfs", "arbs"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-7-11",
        chapterId: "beginner-level3",
        order: 105,
        title: { zh: "提子 · 11/18", en: "Capture · 11/18" },
        instruction: { zh: "白先。在倒扑中尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible in a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "drcmfrgrgqhqcocnipelindpepfpdq", white: "crcqcpdoeofogpfqergobnbo" },
            correct: ["ds"],
            wrong: ["eqes", "eseq"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-7-12",
        chapterId: "beginner-level3",
        order: 106,
        title: { zh: "提子 · 12/18", en: "Capture · 12/18" },
        instruction: { zh: "白先。在倒扑中尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible in a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "epdpcparasbscrdresfsfrfqcnfobndnbl", white: "eqeraqbqbpbobrcqdqco" },
            correct: ["ds"],
            wrong: ["csds"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-7-13",
        chapterId: "beginner-level3",
        order: 107,
        title: { zh: "提子 · 13/18", en: "Capture · 13/18" },
        instruction: { zh: "白先。在倒扑中尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible in a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmbnbodqeqfqgqgpfoeodobpcp", white: "dpbqcqdrerfrgrhqbrcocndnenfngohphn" },
            correct: ["epfpdp"],
            wrong: ["fpep"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-7-14",
        chapterId: "beginner-level3",
        order: 108,
        title: { zh: "提子 · 14/18", en: "Capture · 14/18" },
        instruction: { zh: "白先。在倒扑中尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible in a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqapbqcqbscrdreqepfogohofm", white: "dqcpbobpcneodofpfqdl" },
            correct: ["er"],
            wrong: ["dper"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-7-15",
        chapterId: "beginner-level3",
        order: 109,
        title: { zh: "提子 · 15/18", en: "Capture · 15/18" },
        instruction: { zh: "白先。在倒扑中尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible in a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrcrcqdqeresepeodocobn", white: "draqbqbpcpdpeqfrfsfq" },
            correct: ["cs"],
            wrong: ["dsbo", "bsds"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-7-16",
        chapterId: "beginner-level3",
        order: 110,
        title: { zh: "提子 · 16/18", en: "Capture · 16/18" },
        instruction: { zh: "白先。在倒扑中尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible in a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "esgpgobrbqbpcrcocnfneodqeqfqer", white: "csdrcpdpepfpfrgrgqcqhphoiq" },
            correct: ["fs"],
            wrong: ["dsbs", "bsds"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-7-17",
        chapterId: "beginner-level3",
        order: 111,
        title: { zh: "提子 · 17/18", en: "Capture · 17/18" },
        instruction: { zh: "白先。在倒扑中尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible in a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cscrdpdqepfperfqgrgs", white: "bsbrcqcpdrhshrgqgpfoeodohobo" },
            correct: ["es"],
            wrong: ["dses", "fsds", "frfs"],
        },
    },
    {
        id: "beginner-level3-bl3-capture-7-18",
        chapterId: "beginner-level3",
        order: 112,
        title: { zh: "提子 · 18/18", en: "Capture · 18/18" },
        instruction: { zh: "白先。在倒扑中尽可能多吃掉棋子。", en: "White to play. Capture as many stones as possible in a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "csbsbrbqbpdrerfrfqepfocofneo", white: "eqdqcqcrgsgrgqgpfpgoes" },
            correct: ["dsfsds"],
            wrong: ["fsds"],
        },
    },
];

const bl3Joseki1Levels: Level[] = [
    {
        id: "beginner-level3-bl3-joseki-1-1",
        chapterId: "beginner-level3",
        order: 113,
        title: { zh: "定式 · 1/19", en: "Joseki · 1/19" },
        instruction: { zh: "在布局阶段，棋盘角落常会下出特定的棋形。这些棋形被称为定式。死记硬背大量定式并无意义。最好从理解下定式时的原理开始。我们将展示一些简单定式并解释着法背后的思路。首先看一个定式：一颗位于4-4点的棋子被小飞挂角（角落侵入）攻击。这是攻击4-4点棋子的常见方式。黑棋可以有多种应对。这里我们看一种平稳的防守应对：黑棋2下在第三线。白棋3进入角落，黑棋4挡，白棋5建立根据地。请用白棋下这个定式。", en: "In the opening, specific patterns of moves are often played in the corners. These patterns are called joseki. It does not make sense to memorize a lot of josekis. It is better to start with understanding the principles when playing a joseki. We will show some simple josekis and explain the ideas behind the moves. To start with we look at a joseki where a stone at the 4-4 point is attacked (kakari, corner approach) by a knight's move at 1. This is the usual approach of a stone at the 4-4 point. Black can respond in different ways. Here we look at a quiet, defensive response: black 2 on the 3th line. White moves with 3 into the corner, Black blocks with 4 and White creates a base with 5. Play this joseki with White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dp", white: "" },
            marks: { 1: "fq", 2: "cn", 3: "dr", 4: "cq", 5: "iq" },
            correct: ["fqcndrcqiq"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-1-2",
        chapterId: "beginner-level3",
        order: 114,
        title: { zh: "定式 · 2/19", en: "Joseki · 2/19" },
        instruction: { zh: "这里黑棋2下在第四线。在这种情况下，黑棋应该下6来防守自己的领地。请用黑棋下这个定式。", en: "Here Black plays 2 on the 4th line. In this case Black should play 6 to defend Black's territory. Play this joseki with Black." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dp", white: "fq" },
            marks: { 1: "fq", 2: "dn", 3: "dr", 4: "cq", 5: "iq", 6: "cj" },
            correct: ["dndrcqiqcj"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-1-3",
        chapterId: "beginner-level3",
        order: 115,
        title: { zh: "定式 · 3/19", en: "Joseki · 3/19" },
        instruction: { zh: "请用白棋下这个定式。", en: "Play this joseki with White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cp", white: "" },
            marks: { 1: "ep", 2: "eq", 3: "fq", 4: "dq", 5: "fp", 6: "cn", 7: "jq" },
            correct: ["epeqfqdqfpcnjq"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-1-4",
        chapterId: "beginner-level3",
        order: 116,
        title: { zh: "定式 · 4/19", en: "Joseki · 4/19" },
        instruction: { zh: "请用白棋下这个定式。", en: "Play this joseki with White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cp", white: "" },
            marks: { 1: "ep", 2: "eq", 3: "fq", 4: "dq", 5: "gp", 6: "cn", 7: "kq" },
            correct: ["epeqfqdqgpcnkq"],
            wrong: [""],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-1-5",
        chapterId: "beginner-level3",
        order: 117,
        title: { zh: "定式 · 5/19", en: "Joseki · 5/19" },
        instruction: { zh: "请用白棋下这个定式。", en: "Play this joseki with White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cq", white: "" },
            marks: { 1: "dp", 2: "dq", 3: "ep", 4: "bo", 5: "dm", 6: "fr", 7: "hp" },
            correct: ["dpdqepbodmfrhp"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-1-6",
        chapterId: "beginner-level3",
        order: 118,
        title: { zh: "定式 · 6/19", en: "Joseki · 6/19" },
        instruction: { zh: "请用黑棋下这个定式。", en: "Play this joseki with Black." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cq", white: "fp" },
            marks: { 1: "fp", 2: "dn", 3: "jq", 4: "cj" },
            correct: ["dnjqcj"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-1-7",
        chapterId: "beginner-level3",
        order: 119,
        title: { zh: "定式 · 7/19", en: "Joseki · 7/19" },
        instruction: { zh: "请用黑棋下这个定式。", en: "Play this joseki with Black." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dp", white: "cq" },
            marks: { 1: "cq", 2: "cp", 3: "dq", 4: "eq", 5: "er", 6: "fq", 7: "fr", 8: "gq", 9: "bp", 10: "bo", 11: "bq", 12: "cn" },
            correct: ["cpdqeqerfqfrgqbpbobqcn"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-1-8",
        chapterId: "beginner-level3",
        order: 120,
        title: { zh: "定式 · 8/19", en: "Joseki · 8/19" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndphpcq", white: "fqiqdr" },
            marks: { 1: "hp", A: "ip", B: "gq", C: "hq" },
            correct: ["hqfpeq"],
            wrong: ["iphq"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-1-9",
        chapterId: "beginner-level3",
        order: 121,
        title: { zh: "定式 · 9/19", en: "Joseki · 9/19" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndpgpcq", white: "fqiqdr" },
            marks: { 1: "gp", A: "dq", B: "gq", C: "hq" },
            correct: ["gq"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-1-10",
        chapterId: "beginner-level3",
        order: 122,
        title: { zh: "定式 · 10/19", en: "Joseki · 10/19" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndpfpcq", white: "fqiqdr" },
            marks: { 1: "fp", A: "eq", B: "gq", C: "cr" },
            correct: ["gq"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-1-11",
        chapterId: "beginner-level3",
        order: 123,
        title: { zh: "定式 · 11/19", en: "Joseki · 11/19" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpepbqcqdqerfr", white: "cnbocpdpeqfqgq" },
            marks: { 1: "ep", A: "do", B: "eo", C: "fo" },
            correct: ["foeoendndmfndo"],
            wrong: ["foeoendndoco", "foeoendnfpdocodm", "foeoendnfpdodmco", "foeodoen", "eofpgodocofo", "eofpfogp"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-1-12",
        chapterId: "beginner-level3",
        order: 124,
        title: { zh: "定式 · 12/19", en: "Joseki · 12/19" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndpcqhr", white: "fqiqdr" },
            marks: { 1: "hr", A: "hq", B: "gr", C: "ir" },
            correct: ["hq"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-1-13",
        chapterId: "beginner-level3",
        order: 125,
        title: { zh: "定式 · 13/19", en: "Joseki · 13/19" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndpcqhq", white: "fqiqdr" },
            marks: { 1: "hq", A: "hp", B: "hr", C: "ir" },
            correct: ["hrgrgqhpjr"],
            wrong: ["hrgrgqhpfrir", "hrgrgqhpipir", "hrgrhpgq"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-1-14",
        chapterId: "beginner-level3",
        order: 126,
        title: { zh: "定式 · 14/19", en: "Joseki · 14/19" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndphpcqeq", white: "fqhqiqdr" },
            marks: { 1: "eq", A: "ep", B: "dq", C: "er" },
            correct: ["erfpgpgogq"],
            wrong: ["erfpgpgocrgq", "erfpgpgoipgq", "erfpcrgq", "eper", "dqer"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-1-15",
        chapterId: "beginner-level3",
        order: 127,
        title: { zh: "定式 · 15/19", en: "Joseki · 15/19" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eobpbqcqdqerfr", white: "cnbocpdpeqfqgq" },
            marks: { 1: "eo", A: "do", B: "ep", C: "gr" },
            correct: ["ep"],
            wrong: ["grep", "doep"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-1-16",
        chapterId: "beginner-level3",
        order: 128,
        title: { zh: "定式 · 16/19", en: "Joseki · 16/19" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndpcqeq", white: "fqiqdr" },
            marks: { 1: "eq", A: "dq", B: "cr", C: "er" },
            correct: ["erfpgq"],
            wrong: ["dqer", "crer"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-1-17",
        chapterId: "beginner-level3",
        order: 129,
        title: { zh: "定式 · 17/19", en: "Joseki · 17/19" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndpcqer", white: "fqiqdr" },
            marks: { 1: "er", A: "dq", B: "eq", C: "fr" },
            correct: ["eqdqcrbrfr"],
            wrong: ["eqdqcrbrbsds", "eqdqcrbrbqcs", "eqdqfrcr", "eqdqdscr", "dqeq", "freq"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-1-18",
        chapterId: "beginner-level3",
        order: 130,
        title: { zh: "定式 · 18/19", en: "Joseki · 18/19" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dobpbqcqdqerfr", white: "cnbocpdpeqfqgq" },
            marks: { 1: "do", A: "co", B: "eo", C: "ep" },
            correct: ["co"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-1-19",
        chapterId: "beginner-level3",
        order: 131,
        title: { zh: "定式 · 19/19", en: "Joseki · 19/19" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndpcqgr", white: "fqiqdr" },
            marks: { 1: "gr", A: "gq", B: "cr", C: "fr" },
            correct: ["gq"],
        },
    },
];

const bl3Joseki2Levels: Level[] = [
    {
        id: "beginner-level3-bl3-joseki-2-1",
        chapterId: "beginner-level3",
        order: 132,
        title: { zh: "定式 · 1/12", en: "Joseki · 1/12" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dodp", white: "fq" },
            marks: { 1: "do", A: "dq", B: "eq", C: "dr" },
            correct: ["dr"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-2-2",
        chapterId: "beginner-level3",
        order: 133,
        title: { zh: "定式 · 2/12", en: "Joseki · 2/12" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fqer", white: "cndp" },
            marks: { 1: "er", A: "cq", B: "dq", C: "dr" },
            correct: ["dr"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-2-3",
        chapterId: "beginner-level3",
        order: 134,
        title: { zh: "定式 · 3/12", en: "Joseki · 3/12" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eqfq", white: "cndp" },
            marks: { 1: "eq", A: "cq", B: "dq", C: "dr" },
            correct: ["dq"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-2-4",
        chapterId: "beginner-level3",
        order: 135,
        title: { zh: "定式 · 4/12", en: "Joseki · 4/12" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "epfq", white: "dndp" },
            marks: { 1: "ep", A: "dl", B: "eo", C: "dq" },
            correct: ["dq"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-2-5",
        chapterId: "beginner-level3",
        order: 136,
        title: { zh: "定式 · 5/12", en: "Joseki · 5/12" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fqcr", white: "cndp" },
            marks: { 1: "cr", A: "cq", B: "dq", C: "dr" },
            correct: ["dr"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-2-6",
        chapterId: "beginner-level3",
        order: 137,
        title: { zh: "定式 · 6/12", en: "Joseki · 6/12" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fqiq", white: "cndp" },
            marks: { 1: "iq", A: "cp", B: "cq", C: "dq" },
            correct: ["dq"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-2-7",
        chapterId: "beginner-level3",
        order: 138,
        title: { zh: "定式 · 7/12", en: "Joseki · 7/12" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dofq", white: "cndp" },
            marks: { 1: "do", A: "co", B: "cp", C: "ep" },
            correct: ["coepdq"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-2-8",
        chapterId: "beginner-level3",
        order: 139,
        title: { zh: "定式 · 8/12", en: "Joseki · 8/12" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndpdq", white: "fqdr" },
            marks: { 1: "dq", A: "eq", B: "cr", C: "er" },
            correct: ["crereqfrgr"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-2-9",
        chapterId: "beginner-level3",
        order: 140,
        title: { zh: "定式 · 9/12", en: "Joseki · 9/12" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndpeq", white: "fqdr" },
            marks: { 1: "eq", A: "cq", B: "iq", C: "er" },
            correct: ["er"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-2-10",
        chapterId: "beginner-level3",
        order: 141,
        title: { zh: "定式 · 10/12", en: "Joseki · 10/12" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndpcr", white: "fqdr" },
            marks: { 1: "cr", A: "cq", B: "dq", C: "eq" },
            correct: ["cqdqbrercscpbpboeq"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-2-11",
        chapterId: "beginner-level3",
        order: 142,
        title: { zh: "定式 · 11/12", en: "Joseki · 11/12" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpfqiq", white: "cnbp" },
            marks: { 1: "iq", A: "co", B: "cp", C: "cq" },
            correct: ["cq"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-2-12",
        chapterId: "beginner-level3",
        order: 143,
        title: { zh: "定式 · 12/12", en: "Joseki · 12/12" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndper", white: "fqdr" },
            marks: { 1: "er", A: "dq", B: "eq", C: "cr" },
            correct: ["eqdqcr"],
        },
    },
];

const bl3Joseki3Levels: Level[] = [
    {
        id: "beginner-level3-bl3-joseki-3-1",
        chapterId: "beginner-level3",
        order: 144,
        title: { zh: "定式 · 1/12", en: "Joseki · 1/12" },
        instruction: { zh: "黑先。在白棋1之后，选择最佳着法：A、B或C。", en: "Black to play. Choose the best answer after White's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpeq", white: "epdq" },
            marks: { 1: "dq", A: "dp", B: "cq", C: "fq" },
            correct: ["dp"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-3-2",
        chapterId: "beginner-level3",
        order: 145,
        title: { zh: "定式 · 2/12", en: "Joseki · 2/12" },
        instruction: { zh: "黑先。在白棋1之后，选择最佳着法：A、B或C。", en: "Black to play. Choose the best answer after White's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "epfq", white: "cncpeq" },
            marks: { 1: "cn", A: "dp", B: "fp", C: "dq" },
            correct: ["dq"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-3-3",
        chapterId: "beginner-level3",
        order: 146,
        title: { zh: "定式 · 3/12", en: "Joseki · 3/12" },
        instruction: { zh: "黑先。在白棋1之后，选择最佳着法：A、B或C。", en: "Black to play. Choose the best answer after White's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "epfpfq", white: "cpdqeqfr" },
            marks: { 1: "fr", A: "cn", B: "jq", C: "gr" },
            correct: ["gr"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-3-4",
        chapterId: "beginner-level3",
        order: 147,
        title: { zh: "定式 · 4/12", en: "Joseki · 4/12" },
        instruction: { zh: "黑先。在白棋1之后，选择最佳着法：A、B或C。", en: "Black to play. Choose the best answer after White's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cncpdqeq", white: "clepfpfq" },
            marks: { 1: "cl", A: "dm", B: "iq", C: "fr" },
            correct: ["iq"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-3-5",
        chapterId: "beginner-level3",
        order: 148,
        title: { zh: "定式 · 5/12", en: "Joseki · 5/12" },
        instruction: { zh: "黑先。在白棋1之后，选择最佳着法：A、B或C。", en: "Black to play. Choose the best answer after White's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpcq", white: "dpdq" },
            marks: { 1: "dq", A: "co", B: "do", C: "dr" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-3-6",
        chapterId: "beginner-level3",
        order: 149,
        title: { zh: "定式 · 6/12", en: "Joseki · 6/12" },
        instruction: { zh: "黑先。在白棋1之后，选择最佳着法：A、B或C。", en: "Black to play. Choose the best answer after White's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpcq", white: "codp" },
            marks: { 1: "co", A: "do", B: "dq", C: "er" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-3-7",
        chapterId: "beginner-level3",
        order: 150,
        title: { zh: "定式 · 7/12", en: "Joseki · 7/12" },
        instruction: { zh: "黑先。在白棋1之后，选择最佳着法：A、B或C。", en: "Black to play. Choose the best answer after White's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dodp", white: "cocpcq" },
            marks: { 1: "co", A: "cn", B: "dn", C: "dq" },
            correct: ["dn"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-3-8",
        chapterId: "beginner-level3",
        order: 151,
        title: { zh: "定式 · 8/12", en: "Joseki · 8/12" },
        instruction: { zh: "黑先。在白棋1之后，选择最佳着法：A、B或C。", en: "Black to play. Choose the best answer after White's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dodp", white: "cpcqfq" },
            marks: { 1: "fq", A: "co", B: "fp", C: "dq" },
            correct: ["dq"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-3-9",
        chapterId: "beginner-level3",
        order: 152,
        title: { zh: "定式 · 9/12", en: "Joseki · 9/12" },
        instruction: { zh: "黑先。在白棋1之后，选择最佳着法：A、B或C。", en: "Black to play. Choose the best answer after White's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdp", white: "cqeq" },
            marks: { 1: "eq", A: "ep", B: "bq", C: "dq" },
            correct: ["dq"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-3-10",
        chapterId: "beginner-level3",
        order: 153,
        title: { zh: "定式 · 10/12", en: "Joseki · 10/12" },
        instruction: { zh: "黑先。在白棋1之后，选择最佳着法：A、B或C。", en: "Black to play. Choose the best answer after White's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdpeq", white: "epcqdq" },
            marks: { 1: "ep", A: "eo", B: "fp", C: "fq" },
            correct: ["fqbpbobqcnerfr"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-3-11",
        chapterId: "beginner-level3",
        order: 154,
        title: { zh: "定式 · 11/12", en: "Joseki · 11/12" },
        instruction: { zh: "黑先。在白棋1之后，选择最佳着法：A、B或C。", en: "Black to play. Choose the best answer after White's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdpeqfqgq", white: "cqdqerfrgr" },
            marks: { 1: "gr", A: "hq", B: "iq", C: "hr" },
            correct: ["hq"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-3-12",
        chapterId: "beginner-level3",
        order: 155,
        title: { zh: "定式 · 12/12", en: "Joseki · 12/12" },
        instruction: { zh: "黑先。在白棋1之后，选择最佳着法：A、B或C。", en: "Black to play. Choose the best answer after White's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bocpdpeqfqgq", white: "cobpcqdqerfr" },
            marks: { 1: "co", A: "cn", B: "do", C: "bq" },
            correct: ["bq"],
            wrong: ["cndo"],
        },
    },
];

const bl3Joseki4Levels: Level[] = [
    {
        id: "beginner-level3-bl3-joseki-4-1",
        chapterId: "beginner-level3",
        order: 156,
        title: { zh: "定式 · 1/12", en: "Joseki · 1/12" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dqfq", white: "cndp" },
            marks: { 1: "dq", A: "cp", B: "cq", C: "cr" },
            correct: ["cq"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-4-2",
        chapterId: "beginner-level3",
        order: 157,
        title: { zh: "定式 · 2/12", en: "Joseki · 2/12" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqfq", white: "cndp" },
            marks: { 1: "cq", A: "cp", B: "dq", C: "eq" },
            correct: ["dq"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-4-3",
        chapterId: "beginner-level3",
        order: 158,
        title: { zh: "定式 · 3/12", en: "Joseki · 3/12" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "epfqiq", white: "cpdqeq" },
            marks: { 1: "iq", A: "cn", B: "fp", C: "fr" },
            correct: ["fp"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-4-4",
        chapterId: "beginner-level3",
        order: 159,
        title: { zh: "定式 · 4/12", en: "Joseki · 4/12" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpdpeq", white: "epfq" },
            marks: { 1: "dp", A: "fp", B: "dq", C: "er" },
            correct: ["er"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-4-5",
        chapterId: "beginner-level3",
        order: 160,
        title: { zh: "定式 · 5/12", en: "Joseki · 5/12" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpdqcr", white: "cpcq" },
            marks: { 1: "cr", A: "co", B: "do", C: "br" },
            correct: ["br"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-4-6",
        chapterId: "beginner-level3",
        order: 161,
        title: { zh: "定式 · 6/12", en: "Joseki · 6/12" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqeq", white: "cpdp" },
            marks: { 1: "eq", A: "ep", B: "bq", C: "dq" },
            correct: ["dq"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-4-7",
        chapterId: "beginner-level3",
        order: 162,
        title: { zh: "定式 · 7/12", en: "Joseki · 7/12" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cododpdq", white: "bocpcq" },
            marks: { 1: "do", A: "bn", B: "cr", C: "dr" },
            correct: ["bn"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-4-8",
        chapterId: "beginner-level3",
        order: 163,
        title: { zh: "定式 · 8/12", en: "Joseki · 8/12" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqdqdr", white: "cpdpeq" },
            marks: { 1: "dr", A: "bp", B: "bq", C: "er" },
            correct: ["er"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-4-9",
        chapterId: "beginner-level3",
        order: 164,
        title: { zh: "定式 · 9/12", en: "Joseki · 9/12" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmcncodpdq", white: "bnbocpcq" },
            marks: { 1: "bm", A: "am", B: "cm", C: "dr" },
            correct: ["cm"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-4-10",
        chapterId: "beginner-level3",
        order: 165,
        title: { zh: "定式 · 10/12", en: "Joseki · 10/12" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqdqerfrgr", white: "cpdpeqfqgq" },
            marks: { 1: "gr", A: "bq", B: "hq", C: "hr" },
            correct: ["hq"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-4-11",
        chapterId: "beginner-level3",
        order: 166,
        title: { zh: "定式 · 11/12", en: "Joseki · 11/12" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmcmcncodpdqer", white: "bnbocpcqcrdr" },
            marks: { 1: "bm", A: "am", B: "ap", C: "eq" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level3-bl3-joseki-4-12",
        chapterId: "beginner-level3",
        order: 167,
        title: { zh: "定式 · 12/12", en: "Joseki · 12/12" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳着法：A、B或C。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcpdpeqfq", white: "cqdqerfr" },
            marks: { 1: "bp", A: "ep", B: "bq", C: "gq" },
            correct: ["gq"],
        },
    },
];

const bl3Opening1Levels: Level[] = [
    {
        id: "beginner-level3-bl3-opening-1-1",
        chapterId: "beginner-level3",
        order: 168,
        title: { zh: "布局 · 1/15", en: "Opening · 1/15" },
        instruction: { zh: "布局阶段的最初几步通常在角落下出。适合落子的位置在本图中标记为A-H。下在A、B、C或D点最为常见。下在E、F、G或H点则会导致复杂的定式。A点是3-3点。下在这里是为了以小角落作为领地。对手无法阻止。B点是4-4点。下在4-4点并非为了控制角落。对手可以轻易地通过下3-3点侵入角落。如果你想在中腹发展势力，就下在4-4点。C和D点是3-4点。下在3-4点旨在争夺角落领地。接着，你可以通过小目守角来封锁角落。在标记点中选择一个落子以继续。", en: "The first moves in the opening are played in the corners. The points suitable to play are marked in this diagram with the letters A-H. Playing at A, B, C or D is most common. Playing at E, F, G or H leads to complex josekis. A is the 3-3 point. You play here to take a small corner as territory. Your opponent can not prevent this. B is the 4-4-point. You should not play at 4-4 to take control of the corner. Your opponent can easily invade the corner by playing at the 3-3 point. You play at the 4-4 point if you want to develop influence in the centre. C and D are the 3-4 points. Playing at 3-4 is aiming at territory in the corner. Next, you can close the corner with a shimari. Play at one of the marked points to continue." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "", white: "" },
            marks: { A: "cq", B: "dp", C: "cp", D: "dq", E: "co", F: "do", G: "ep", H: "eq" },
            correct: ["cq", "dp", "cp", "dq", "co", "do", "ep", "eq"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-1-2",
        chapterId: "beginner-level3",
        order: 169,
        title: { zh: "布局 · 2/15", en: "Opening · 2/15" },
        instruction: { zh: "通过守角（小目）你可以封锁角落。被守角封锁的角落很难被攻击。这是一种高效的占地方法，因为你用两颗棋子组成守角，而不是用四、五颗棋子筑成的墙来保护领地。之后你可以增加棋子来更好地保护或扩大领地。在此例中，白棋在1和3位攻击守角，黑棋在2和4位防守。黑先。防守白棋的攻击。", en: "With a shimari you can close a corner. It is hard to attack a corner that is closed by a shimari. This is an efficient way of making territory, because you use two stones with a shimari instead of a wall of four or five stones to protect your territory. Later you can add stones to better protect or expand your territory. In this example, White attacks the shimari at 1 and 3 and Black defends at 2 and 4. Black to play. Defend against the white attack." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "codq", white: "dp" },
            marks: { 1: "dp", 2: "cp", 3: "eq", 4: "dr" },
            correct: ["cpeqdr"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-1-3",
        chapterId: "beginner-level3",
        order: 170,
        title: { zh: "布局 · 3/15", en: "Opening · 3/15" },
        instruction: { zh: "如果白棋用1过深地侵入角落，白棋的棋子将被吃掉。黑先。防守侵入。", en: "If White invades too deep into the corner with 1, the white stones will be captured. Black to play. Defend against the invasion." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "codq", white: "cp" },
            marks: { 1: "cp", 2: "dp", 3: "bo", 4: "bp" },
            correct: ["dpbobp"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-1-4",
        chapterId: "beginner-level3",
        order: 171,
        title: { zh: "布局 · 4/15", en: "Opening · 4/15" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳应对：A、B或C。", en: "White to play. Choose the best reply on Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "co", white: "dq" },
            marks: { 1: "co", A: "ep", B: "cq", C: "fq" },
            correct: ["ep"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-1-5",
        chapterId: "beginner-level3",
        order: 172,
        title: { zh: "布局 · 5/15", en: "Opening · 5/15" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳应对：A、B或C。", en: "White to play. Choose the best reply on Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cn", white: "dq" },
            marks: { 1: "cn", A: "cp", B: "cq", C: "fq" },
            correct: ["cp"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-1-6",
        chapterId: "beginner-level3",
        order: 173,
        title: { zh: "布局 · 6/15", en: "Opening · 6/15" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳应对：A、B或C。", en: "White to play. Choose the best reply on Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dn", white: "cq" },
            marks: { 1: "dn", A: "cp", B: "dp", C: "ep" },
            correct: ["ep"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-1-7",
        chapterId: "beginner-level3",
        order: 174,
        title: { zh: "布局 · 7/15", en: "Opening · 7/15" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳应对：A、B或C。", en: "White to play. Choose the best reply on Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "do", white: "eq" },
            marks: { 1: "do", A: "cp", B: "bq", C: "dq" },
            correct: ["cp"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-1-8",
        chapterId: "beginner-level3",
        order: 175,
        title: { zh: "布局 · 8/15", en: "Opening · 8/15" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳应对：A、B或C。", en: "White to play. Choose the best reply on Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dq", white: "do" },
            marks: { 1: "dq", A: "dp", B: "ep", C: "fp" },
            correct: ["fp"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-1-9",
        chapterId: "beginner-level3",
        order: 176,
        title: { zh: "布局 · 9/15", en: "Opening · 9/15" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳应对：A、B或C。", en: "White to play. Choose the best reply on Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "do", white: "dq" },
            marks: { 1: "do", A: "cn", B: "co", C: "cp" },
            correct: ["co"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-1-10",
        chapterId: "beginner-level3",
        order: 177,
        title: { zh: "布局 · 10/15", en: "Opening · 10/15" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳应对：A、B或C。", en: "White to play. Choose the best reply on Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dp", white: "cq" },
            marks: { 1: "dp", A: "dq", B: "eq", C: "fq" },
            correct: ["dq"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-1-11",
        chapterId: "beginner-level3",
        order: 178,
        title: { zh: "布局 · 11/15", en: "Opening · 11/15" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳应对：A、B或C。", en: "White to play. Choose the best reply on Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dq", white: "dp" },
            marks: { 1: "dq", A: "do", B: "fp", C: "cq" },
            correct: ["cq"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-1-12",
        chapterId: "beginner-level3",
        order: 179,
        title: { zh: "布局 · 12/15", en: "Opening · 12/15" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳应对：A、B或C。", en: "White to play. Choose the best reply on Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpeq", white: "ep" },
            marks: { 1: "eq", A: "fp", B: "gp", C: "fq" },
            correct: ["fq"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-1-13",
        chapterId: "beginner-level3",
        order: 180,
        title: { zh: "布局 · 13/15", en: "Opening · 13/15" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳应对：A、B或C。", en: "White to play. Choose the best reply on Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eocp", white: "ep" },
            marks: { 1: "eo", A: "fo", C: "gp", B: "fq" },
            correct: ["fo"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-1-14",
        chapterId: "beginner-level3",
        order: 181,
        title: { zh: "布局 · 14/15", en: "Opening · 14/15" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳应对：A、B或C。", en: "White to play. Choose the best reply on Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpfp", white: "fq" },
            marks: { 1: "fp", A: "gp", B: "gq", C: "hq" },
            correct: ["gp"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-1-15",
        chapterId: "beginner-level3",
        order: 182,
        title: { zh: "布局 · 15/15", en: "Opening · 15/15" },
        instruction: { zh: "白先。在黑棋1之后，选择最佳应对：A、B或C。", en: "White to play. Choose the best reply on Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "docq", white: "dq" },
            marks: { 1: "cq", A: "dp", C: "eq", B: "cr" },
            correct: ["cr"],
        },
    },
];

const bl3Opening2Levels: Level[] = [
    {
        id: "beginner-level3-bl3-opening-2-1",
        chapterId: "beginner-level3",
        order: 183,
        title: { zh: "布局 · 1/10", en: "Opening · 1/10" },
        instruction: { zh: "在布局阶段，你试图尽可能多地圈定领地，尤其是在角落和边线上。你通过将棋子作为边界标杆放在精心选择的位置来圈定领地。你不想将边界标杆放得太远，因为那样对手可能会在中间落子。但你也不想它们靠得太近。有一些经验法则可以帮助你。一个重要的法则是根据地。根据地是两颗分隔的棋子位于第三线，中间有两个空交叉点的阵型。这里，黑棋可以通过下在A位建立根据地。白棋不会很快在这两颗黑棋中间落子。有了根据地，你通常能成功做成活棋块。黑先。建立根据地。", en: "In the opening you try to stake out as much territory as possible, in particular in the corners and along the sides. You stake out by placing your stones as boundary posts at well-chosen points. You do not want to place your boundary posts too far apart, because you would risk your opponent placing a stone in between. But you do also not want them to be too close to each other. There are rules of thumb to help you. An important one is the base. A base is a formation of two separate stones at the third line, with two empty intersections in between. Here, Black can make a base by playing at A. White will not play in between these two black stones any time soon. With a base, usually you succeed in making a living group. Black to play. Make a base." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fq", white: "codq" },
            marks: { A: "iq" },
            correct: ["iq"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-2-2",
        chapterId: "beginner-level3",
        order: 184,
        title: { zh: "布局 · 2/10", en: "Opening · 2/10" },
        instruction: { zh: "白先。选择最佳着法：A、B或C。", en: "White to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "djdndp", white: "fq" },
            marks: { A: "hq", B: "dr", C: "er" },
            correct: ["dr"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-2-3",
        chapterId: "beginner-level3",
        order: 185,
        title: { zh: "布局 · 3/10", en: "Opening · 3/10" },
        instruction: { zh: "白先。选择最佳着法：A、B或C。", en: "White to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cnbp", white: "dpjpfq" },
            marks: { A: "bq", B: "cq", C: "cr" },
            correct: ["cq"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-2-4",
        chapterId: "beginner-level3",
        order: 186,
        title: { zh: "布局 · 4/10", en: "Opening · 4/10" },
        instruction: { zh: "白先。选择最佳着法：A、B或C。", en: "White to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fq", white: "djdpjqmq" },
            marks: { A: "cn", B: "dn", C: "eq" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-2-5",
        chapterId: "beginner-level3",
        order: 187,
        title: { zh: "布局 · 5/10", en: "Opening · 5/10" },
        instruction: { zh: "白先。选择最佳着法：A、B或C。", en: "White to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "djcndpeqkq", white: "fpfq" },
            marks: { A: "ip", B: "hq", C: "iq" },
            correct: ["iq"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-2-6",
        chapterId: "beginner-level3",
        order: 188,
        title: { zh: "布局 · 6/10", en: "Opening · 6/10" },
        instruction: { zh: "白先。选择最佳着法：A、B或C。", en: "White to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndpkqnq", white: "iq" },
            marks: { A: "io", B: "fq", C: "gq" },
            correct: ["fq"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-2-7",
        chapterId: "beginner-level3",
        order: 189,
        title: { zh: "布局 · 7/10", en: "Opening · 7/10" },
        instruction: { zh: "黑先。选择最佳着法：A、B或C。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdpp", white: "dddq" },
            marks: { A: "nc", B: "jj", C: "do" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-2-8",
        chapterId: "beginner-level3",
        order: 190,
        title: { zh: "布局 · 8/10", en: "Opening · 8/10" },
        instruction: { zh: "黑先。选择最佳着法：A、B或C。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdcnpp", white: "ddcpdq" },
            marks: { A: "ck", B: "en", C: "jq" },
            correct: ["ck"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-2-9",
        chapterId: "beginner-level3",
        order: 191,
        title: { zh: "布局 · 9/10", en: "Opening · 9/10" },
        instruction: { zh: "黑先。选择最佳着法：A、B或C。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dbfcpdpjpp", white: "ccdddfdjdp" },
            marks: { A: "hc", B: "ic", C: "fe" },
            correct: ["ic"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-2-10",
        chapterId: "beginner-level3",
        order: 192,
        title: { zh: "布局 · 10/10", en: "Opening · 10/10" },
        instruction: { zh: "黑先。选择最佳着法：A、B或C。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "mcpdciqlppfqiqoqdr", white: "fcddrdcgqgqjcndpcq" },
            marks: { A: "jc", B: "ei", C: "cl" },
            correct: ["cl"],
        },
    },
];

const bl3Opening3Levels: Level[] = [
    {
        id: "beginner-level3-bl3-opening-3-1",
        chapterId: "beginner-level3",
        order: 193,
        title: { zh: "布局 · 1/7", en: "Opening · 1/7" },
        instruction: { zh: "当黑棋用挂角攻击角落的白棋时，白棋可以从另一侧用夹攻攻击挂角的黑棋。通过这种夹攻，黑棋受到两面攻击。白棋可以在标记点中选择一个落子进行夹攻。白棋阻止黑棋建立根据地。白先。进行夹攻。", en: "When Black attacks the white stone in the corner with a kakari at 1, White can attack the attacking black stone from the other side with a pincer. With this pincer, Black is attacked from two sides. White can play a pincer by playing at one of the marked points. White prevents black from making a base. White to play. Play a pincer." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fq", white: "dp" },
            marks: { X: "hphqipiqjpjq" },
            correct: ["hp", "hq", "ip", "jp", "iq", "jq"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-3-2",
        chapterId: "beginner-level3",
        order: 194,
        title: { zh: "布局 · 2/7", en: "Opening · 2/7" },
        instruction: { zh: "黑先。下出最佳夹攻。", en: "Black to play. Play the best pincer." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dp", white: "fq" },
            correct: ["hq", "hp", "ip", "iq", "jp", "jq"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-3-3",
        chapterId: "beginner-level3",
        order: 195,
        title: { zh: "布局 · 3/7", en: "Opening · 3/7" },
        instruction: { zh: "黑先。下出最佳夹攻。", en: "Black to play. Play the best pincer." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cp", white: "eq" },
            correct: ["gp", "gq", "hp", "hq", "ip", "iq"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-3-4",
        chapterId: "beginner-level3",
        order: 196,
        title: { zh: "布局 · 4/7", en: "Opening · 4/7" },
        instruction: { zh: "黑先。下出最佳夹攻。", en: "Black to play. Play the best pincer." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cp", white: "ep" },
            correct: ["gp", "gq", "hp", "hq", "ip", "iq"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-3-5",
        chapterId: "beginner-level3",
        order: 197,
        title: { zh: "布局 · 5/7", en: "Opening · 5/7" },
        instruction: { zh: "黑先。下出最佳夹攻。", en: "Black to play. Play the best pincer." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "docp", white: "eq" },
            correct: ["gp", "gq", "hp", "hq", "ip", "iq"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-3-6",
        chapterId: "beginner-level3",
        order: 198,
        title: { zh: "布局 · 6/7", en: "Opening · 6/7" },
        instruction: { zh: "黑先。下出最佳夹攻。", en: "Black to play. Play the best pincer." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dndpeq", white: "fpfq" },
            correct: ["hp", "hq", "ip", "iq", "jp", "jq"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-3-7",
        chapterId: "beginner-level3",
        order: 199,
        title: { zh: "布局 · 7/7", en: "Opening · 7/7" },
        instruction: { zh: "黑先。下出最佳夹攻。", en: "Black to play. Play the best pincer." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dncpdpcq", white: "epdqeq" },
            correct: ["gp", "gq", "hp", "hq", "ip", "iq"],
        },
    },
];

const bl3Opening4Levels: Level[] = [
    {
        id: "beginner-level3-bl3-opening-4-1",
        chapterId: "beginner-level3",
        order: 200,
        title: { zh: "布局 · 1/14", en: "Opening · 1/14" },
        instruction: { zh: "如果你有一面棋墙，从边线向中腹延伸，就像这里的黑棋墙，经验法则现在指出：你可以从这面墙延伸，其距离比该墙的长度宽两个交叉点。在此例中，墙的长度为三颗棋子，因此你可以下在距离该墙五个点的延伸处，例如A点。黑先。下出良好的延伸。", en: "If you have a wall of stones, which runs from the side towards the centre, like the black wall here, the rule of thumb now states that you can play an extension from that wall, which is two intersections wider than the length of that wall. In this example the length of the wall is three stones, so you can play an extension, which is at a distance of five points from that wall, e.g. at A. Black to play. Play a good extension." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eoepeq", white: "cncpdq" },
            marks: { A: "jp" },
            correct: ["jp"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-4-2",
        chapterId: "beginner-level3",
        order: 201,
        title: { zh: "布局 · 2/14", en: "Opening · 2/14" },
        instruction: { zh: "白先。选择最佳着法：A、B或C。", en: "White to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "codpfp", white: "cndn" },
            marks: { A: "cj", B: "ck", C: "cl" },
            correct: ["cj"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-4-3",
        chapterId: "beginner-level3",
        order: 202,
        title: { zh: "布局 · 3/14", en: "Opening · 3/14" },
        instruction: { zh: "黑先。选择最佳延伸：A、B或C。", en: "Black to play. Choose the best extension, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "jq", white: "coppdqlq" },
            marks: { A: "fq", B: "gq", C: "hq" },
            correct: ["gq"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-4-4",
        chapterId: "beginner-level3",
        order: 203,
        title: { zh: "布局 · 4/14", en: "Opening · 4/14" },
        instruction: { zh: "黑先。选择最佳延伸：A、B或C。", en: "Black to play. Choose the best extension, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ppfqdr", white: "cndpcq" },
            marks: { A: "hq", B: "iq", C: "jq" },
            correct: ["iq"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-4-5",
        chapterId: "beginner-level3",
        order: 204,
        title: { zh: "布局 · 5/14", en: "Opening · 5/14" },
        instruction: { zh: "黑先。选择最佳延伸：A、B或C。", en: "Black to play. Choose the best extension, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "codqnqpr", white: "pnppfqiqqq" },
            marks: { A: "kp", B: "kq", C: "lq" },
            correct: ["kq"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-4-6",
        chapterId: "beginner-level3",
        order: 205,
        title: { zh: "布局 · 6/14", en: "Opening · 6/14" },
        instruction: { zh: "黑先。选择最佳延伸：A、B或C。", en: "Black to play. Choose the best extension, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "codqmq", white: "qpoq" },
            marks: { A: "hq", B: "iq", C: "jq" },
            correct: ["jq"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-4-7",
        chapterId: "beginner-level3",
        order: 206,
        title: { zh: "布局 · 7/14", en: "Opening · 7/14" },
        instruction: { zh: "黑先。选择最佳延伸：A、B或C。", en: "Black to play. Choose the best extension, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "qogqpq", white: "cpeqlq" },
            marks: { A: "jp", B: "iq", C: "jq" },
            correct: ["jq"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-4-8",
        chapterId: "beginner-level3",
        order: 207,
        title: { zh: "布局 · 8/14", en: "Opening · 8/14" },
        instruction: { zh: "黑先。选择最佳延伸：A、B或C。", en: "Black to play. Choose the best extension, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "qpeqoq", white: "cocqjqmq" },
            marks: { A: "hp", B: "gq", C: "hq" },
            correct: ["hq"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-4-9",
        chapterId: "beginner-level3",
        order: 208,
        title: { zh: "布局 · 9/14", en: "Opening · 9/14" },
        instruction: { zh: "黑先。选择最佳延伸：A、B或C。", en: "Black to play. Choose the best extension, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "epfpfq", white: "cncpppdqeq" },
            marks: { A: "iq", B: "jq", C: "kq" },
            correct: ["jq"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-4-10",
        chapterId: "beginner-level3",
        order: 209,
        title: { zh: "布局 · 10/14", en: "Opening · 10/14" },
        instruction: { zh: "黑先。选择最佳延伸：A、B或C。", en: "Black to play. Choose the best extension, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "jq", white: "coppdqnq" },
            marks: { A: "fq", B: "gq", C: "lq" },
            correct: ["gq"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-4-11",
        chapterId: "beginner-level3",
        order: 210,
        title: { zh: "布局 · 11/14", en: "Opening · 11/14" },
        instruction: { zh: "黑先。选择最佳延伸：A、B或C。", en: "Black to play. Choose the best extension, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "qodpcqdqpq", white: "cmcocpbqkqnqbr" },
            marks: { A: "gq", B: "hq", C: "iq" },
            correct: ["hq"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-4-12",
        chapterId: "beginner-level3",
        order: 211,
        title: { zh: "布局 · 12/14", en: "Opening · 12/14" },
        instruction: { zh: "黑先。选择最佳延伸：A、B或C。", en: "Black to play. Choose the best extension, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pnppfq", white: "cpkpdqnq" },
            marks: { A: "ip", B: "hq", C: "iq" },
            correct: ["iq"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-4-13",
        chapterId: "beginner-level3",
        order: 212,
        title: { zh: "布局 · 13/14", en: "Opening · 13/14" },
        instruction: { zh: "黑先。选择最佳延伸：A、B或C。", en: "Black to play. Choose the best extension, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "npnq", white: "pncoppdqoq" },
            marks: { A: "jq", B: "kq", C: "lq" },
            correct: ["jq"],
        },
    },
    {
        id: "beginner-level3-bl3-opening-4-14",
        chapterId: "beginner-level3",
        order: 213,
        title: { zh: "布局 · 14/14", en: "Opening · 14/14" },
        instruction: { zh: "黑先。选择最佳延伸：A、B或C。", en: "Black to play. Choose the best extension, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "qkqnlprplq", white: "conpppdqmqqq" },
            marks: { A: "gq", B: "hq", C: "iq" },
            correct: ["hq"],
        },
    },
];

const bl3Haengma1Levels: Level[] = [
    {
        id: "beginner-level3-bl3-haengma-1-1",
        chapterId: "beginner-level3",
        order: 214,
        title: { zh: "行棋方向 · 1/19", en: "Haengma · 1/19" },
        instruction: { zh: "在此例中下在A点是好的行棋方向。你将一颗棋子贴近自己的棋子，延伸这颗棋子。这是一步慢棋，但也非常坚实。通常这是一种防守着法。在此例中黑棋防守角落。黑先。在白棋1之后，选择最佳后续着法。", en: "Playing at A in this example is good haengma. You attach a stone to your own, stretching this stone. This is a slow move, but it is also very solid. Often it is a defensive move. In this example Black defends the corner. Black to play. Choose the best continuation after White's 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpepiq", white: "cmgq" },
            marks: { 1: "gq", A: "eq" },
            correct: ["eqgo"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-1-2",
        chapterId: "beginner-level3",
        order: 215,
        title: { zh: "行棋方向 · 2/19", en: "Haengma · 2/19" },
        instruction: { zh: "白棋用1攻击黑棋。A点的尖（对角落子）加强了黑棋的阵型。它也攻击了1位棋子并阻止白棋从下方连接。黑先。下出尖来防守黑棋。", en: "White attacks the black stone with 1. A diagonal move (kosumi) at A strengthens Black's position. It also attacks stone 1 and prevents that White connects underneath. Black to play. Play a diagonal move to defend the black stone." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ep", white: "cpgq" },
            marks: { 1: "gq", A: "fo" },
            correct: ["fo"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-1-3",
        chapterId: "beginner-level3",
        order: 216,
        title: { zh: "行棋方向 · 3/19", en: "Haengma · 3/19" },
        instruction: { zh: "白棋用1攻击黑棋。比尖更快的着法是A点的单关跳。这仍然很坚实：白棋很难分隔这两颗棋子。通常你用这步棋向中腹逃跑。黑先。下出单关跳以向中腹逃跑。", en: "White attacks the black stone with 1. A faster move than the diagonal move is the one-point jump (ikken-tobi) at A. This is still solid: it is very difficult for white to separate the two stones. Often you use this move to escape towards the centre. Black to play. Play a one-point jump to escape towards the centre." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fq", white: "codqhq" },
            marks: { 1: "hq", A: "fo" },
            correct: ["fo"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-1-4",
        chapterId: "beginner-level3",
        order: 217,
        title: { zh: "行棋方向 · 4/19", en: "Haengma · 4/19" },
        instruction: { zh: "更快的着法是双关跳。黑棋可以在A位下这步棋，沿边线延伸，建立根据地。有了根据地，你通常能成功做成活棋块。黑先。建立根据地。", en: "An even faster move is the two-points jump. Black can make this move at A to make an extension along the side, creating a base. With a base usually you achieve to make a living group. Black to play. Make a base." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eq", white: "cpdo" },
            marks: { 1: "do", A: "hq" },
            correct: ["hq"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-1-5",
        chapterId: "beginner-level3",
        order: 218,
        title: { zh: "行棋方向 · 5/19", en: "Haengma · 5/19" },
        instruction: { zh: "小飞是一步强而快的着法。其名称来源于国际象棋中马的走法。通常你用小飞进行攻击。黑先。在白棋1位小飞之后，下出小飞攻击角落。", en: "The knight's move (keima) is a strong and fast move. The name derives from the move of the knight in chess. Often you use the knight's move to attack. Black to play. Play a keima to attack the corner after White's keima at 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fq", white: "dpcn" },
            marks: { 1: "cn", A: "dr" },
            correct: ["dr"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-1-6",
        chapterId: "beginner-level3",
        order: 219,
        title: { zh: "行棋方向 · 6/19", en: "Haengma · 6/19" },
        instruction: { zh: "大飞跳通常不是一步好棋。在中文中，这步棋称为象步，源自中国象棋中象的走法。这里，黑棋在白棋1之后下出大飞跳2。大飞跳的一个大缺点是棋子很容易被分隔。通过下在A位，白棋可以使黑棋棋子分隔。白先。分隔黑棋棋子。", en: "The diagonal jump is usually not a good move. In Chinese this move is called the elephant move, after the way the elephant moves in Chinese chess. Here, Black plays a diagonal jump 2 after White's 1. The big disadvantage of a diagonal jump is that the stones can be separated easily. By playing at A, White can keep the black stones separated. White to play. Separate the black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpfn", white: "fq" },
            marks: { 1: "fq", 2: "fn", A: "eo" },
            correct: ["eo"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-1-7",
        chapterId: "beginner-level3",
        order: 220,
        title: { zh: "行棋方向 · 7/19", en: "Haengma · 7/19" },
        instruction: { zh: "白棋被两块强大的黑棋棋块包围。如果黑棋1之后白棋在A位弯曲，黑棋将在C位切断。随后的战斗中，白棋三子可能有一块会被分离。由于白棋两侧的黑棋都很强，白棋应避免战斗。白棋应对黑棋1的接触的最好着法是在B或C位延伸。这将使白棋棋块更强。白先。对黑棋的接触进行良好应对。", en: "The white stones are surrounded by two strong black groups. If White bends at A after Black's 1, Black will cut at C. In the battle that follows probably one of the three white stones will be separated from the others. Because black is strong at both sides of the white stones, White should avoid a battle. White's best response to the attachment 1 is to stretch at B or C. This makes white's group stronger. White to play. Play a good response to Black's attachment." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dndpfqkppppqqn", white: "hqkqnq" },
            marks: { 1: "kp", A: "lp", B: "jq", C: "lq" },
            correct: ["jq", "lq"],
            wrong: ["lplq"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-1-8",
        chapterId: "beginner-level3",
        order: 221,
        title: { zh: "行棋方向 · 8/19", en: "Haengma · 8/19" },
        instruction: { zh: "白先。在黑棋1之后选择最佳后续着法，A或B。", en: "White to play. Choose the best continuation after Black's 1, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cncp", white: "dndp" },
            marks: { 1: "cp", A: "co", B: "cq" },
            correct: ["co"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-1-9",
        chapterId: "beginner-level3",
        order: 222,
        title: { zh: "行棋方向 · 9/19", en: "Haengma · 9/19" },
        instruction: { zh: "白先。在黑棋1之后选择最佳后续着法，A或B。", en: "White to play. Choose the best continuation after Black's 1, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmcnbocpcq", white: "bndncododp" },
            marks: { 1: "cm", A: "dm", B: "bp" },
            correct: ["bp"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-1-10",
        chapterId: "beginner-level3",
        order: 223,
        title: { zh: "行棋方向 · 10/19", en: "Haengma · 10/19" },
        instruction: { zh: "白先。在黑棋1之后选择最佳后续着法，A或B。", en: "White to play. Choose the best continuation after Black's 1, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clcn", white: "dndpdq" },
            marks: { 1: "cn", A: "cm", B: "co" },
            correct: ["co"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-1-11",
        chapterId: "beginner-level3",
        order: 224,
        title: { zh: "行棋方向 · 11/19", en: "Haengma · 11/19" },
        instruction: { zh: "白先。在黑棋1之后选择最佳后续着法，A或B。", en: "White to play. Choose the best continuation after Black's 1, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cldmcn", white: "dncodpdq" },
            marks: { 1: "dm", A: "em", B: "bn" },
            correct: ["bn"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-1-12",
        chapterId: "beginner-level3",
        order: 225,
        title: { zh: "行棋方向 · 12/19", en: "Haengma · 12/19" },
        instruction: { zh: "白先。在黑棋1之后选择最佳后续着法，A或B。", en: "White to play. Choose the best continuation after Black's 1, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clcmdmcn", white: "bndncodpdq" },
            marks: { 1: "cm", B: "bm", A: "en" },
            correct: ["en"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-1-13",
        chapterId: "beginner-level3",
        order: 226,
        title: { zh: "行棋方向 · 13/19", en: "Haengma · 13/19" },
        instruction: { zh: "白先。在黑棋1之后选择最佳后续着法，A或B。", en: "White to play. Choose the best continuation after Black's 1, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cldm", white: "dndpdq" },
            marks: { 1: "dm", A: "cn", B: "do" },
            correct: ["cn"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-1-14",
        chapterId: "beginner-level3",
        order: 227,
        title: { zh: "行棋方向 · 14/19", en: "Haengma · 14/19" },
        instruction: { zh: "白先。在黑棋1之后选择最佳后续着法，A或B。", en: "White to play. Choose the best continuation after Black's 1, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpcqdq", white: "dodp" },
            marks: { 1: "dq", A: "ep", B: "fp" },
            correct: ["fp"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-1-15",
        chapterId: "beginner-level3",
        order: 228,
        title: { zh: "行棋方向 · 15/19", en: "Haengma · 15/19" },
        instruction: { zh: "白先。在黑棋1之后选择最佳后续着法，A或B。", en: "White to play. Choose the best continuation after Black's 1, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndndo", white: "cocpdq" },
            marks: { 1: "dn", A: "dp", B: "fq" },
            correct: ["fq"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-1-16",
        chapterId: "beginner-level3",
        order: 229,
        title: { zh: "行棋方向 · 16/19", en: "Haengma · 16/19" },
        instruction: { zh: "白先。在黑棋1之后选择最佳后续着法，A或B。", en: "White to play. Choose the best continuation after Black's 1, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clcodocp", white: "dpcqdq" },
            marks: { 1: "do", A: "ep", B: "fp" },
            correct: ["fp"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-1-17",
        chapterId: "beginner-level3",
        order: 230,
        title: { zh: "行棋方向 · 17/19", en: "Haengma · 17/19" },
        instruction: { zh: "白先。在黑棋1之后选择最佳后续着法，A或B。", en: "White to play. Choose the best continuation after Black's 1, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cldp", white: "cn" },
            marks: { 1: "cl", A: "en", B: "fn" },
            correct: ["en"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-1-18",
        chapterId: "beginner-level3",
        order: 231,
        title: { zh: "行棋方向 · 18/19", en: "Haengma · 18/19" },
        instruction: { zh: "白先。在黑棋1之后选择最佳后续着法，A或B。", en: "White to play. Choose the best continuation after Black's 1, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "do", white: "dq" },
            marks: { 1: "do", A: "ep", B: "fp" },
            correct: ["fp"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-1-19",
        chapterId: "beginner-level3",
        order: 232,
        title: { zh: "行棋方向 · 19/19", en: "Haengma · 19/19" },
        instruction: { zh: "白先。在黑棋1之后选择最佳后续着法，A或B。", en: "White to play. Choose the best continuation after Black's 1, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocododpeqer", white: "bpcpdqdr" },
            marks: { 1: "bo", A: "cq", B: "br" },
            correct: ["br"],
        },
    },
];

const bl3Haengma2Levels: Level[] = [
    {
        id: "beginner-level3-bl3-haengma-2-1",
        chapterId: "beginner-level3",
        order: 233,
        title: { zh: "行棋方向 · 1/14", en: "Haengma · 1/14" },
        instruction: { zh: "黑先。选择最佳着法：A、B或C。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dp", white: "cpcq" },
            marks: { A: "cn", B: "bo", C: "do" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-2-2",
        chapterId: "beginner-level3",
        order: 234,
        title: { zh: "行棋方向 · 2/14", en: "Haengma · 2/14" },
        instruction: { zh: "黑先。选择最佳着法：A、B或C。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqfq", white: "dpdqhq" },
            marks: { A: "bo", B: "co", C: "cp" },
            correct: ["cp"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-2-3",
        chapterId: "beginner-level3",
        order: 235,
        title: { zh: "行棋方向 · 3/14", en: "Haengma · 3/14" },
        instruction: { zh: "黑先。选择最佳着法：A、B或C。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fodpfp", white: "gpeqfq" },
            marks: { A: "ep", B: "dq", C: "gq" },
            correct: ["dq"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-2-4",
        chapterId: "beginner-level3",
        order: 236,
        title: { zh: "行棋方向 · 4/14", en: "Haengma · 4/14" },
        instruction: { zh: "黑先。选择最佳着法：A、B或C。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dodp", white: "cpcqdq" },
            marks: { A: "ep", B: "fp", C: "gp" },
            correct: ["fp"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-2-5",
        chapterId: "beginner-level3",
        order: 237,
        title: { zh: "行棋方向 · 5/14", en: "Haengma · 5/14" },
        instruction: { zh: "黑先。选择最佳着法：A、B或C。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqfq", white: "cpdphq" },
            marks: { A: "bp", B: "bq", C: "dq" },
            correct: ["dq"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-2-6",
        chapterId: "beginner-level3",
        order: 238,
        title: { zh: "行棋方向 · 6/14", en: "Haengma · 6/14" },
        instruction: { zh: "黑先。选择最佳着法：A、B或C。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "epcq", white: "dncpbq" },
            marks: { A: "bp", B: "dq", C: "br" },
            correct: ["dq"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-2-7",
        chapterId: "beginner-level3",
        order: 239,
        title: { zh: "行棋方向 · 7/14", en: "Haengma · 7/14" },
        instruction: { zh: "黑先。选择最佳着法，A或B。", en: "Black to play. Choose the best move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fpdqeqhq", white: "focpdpepcq" },
            marks: { A: "go", B: "gp" },
            correct: ["gp"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-2-8",
        chapterId: "beginner-level3",
        order: 240,
        title: { zh: "行棋方向 · 8/14", en: "Haengma · 8/14" },
        instruction: { zh: "黑先。选择最佳着法，A或B。", en: "Black to play. Choose the best move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdp", white: "cqdq" },
            marks: { A: "bq", B: "eq" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-2-9",
        chapterId: "beginner-level3",
        order: 241,
        title: { zh: "行棋方向 · 9/14", en: "Haengma · 9/14" },
        instruction: { zh: "黑先。选择最佳着法，A或B。", en: "Black to play. Choose the best move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cnbocpdpepeq", white: "bpbqcqdqer" },
            marks: { A: "fq", B: "fr" },
            correct: ["fr"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-2-10",
        chapterId: "beginner-level3",
        order: 242,
        title: { zh: "行棋方向 · 10/14", en: "Haengma · 10/14" },
        instruction: { zh: "黑先。选择最佳着法，A或B。", en: "Black to play. Choose the best move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdpeqgq", white: "cqdqer" },
            marks: { A: "fq", B: "fr" },
            correct: ["fr"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-2-11",
        chapterId: "beginner-level3",
        order: 243,
        title: { zh: "行棋方向 · 11/14", en: "Haengma · 11/14" },
        instruction: { zh: "黑先。选择最佳着法，A或B。", en: "Black to play. Choose the best move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dodpdq", white: "cocpcq" },
            marks: { A: "cn", B: "cr" },
            correct: ["cn"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-2-12",
        chapterId: "beginner-level3",
        order: 244,
        title: { zh: "行棋方向 · 12/14", en: "Haengma · 12/14" },
        instruction: { zh: "黑先。选择最佳着法，A或B。", en: "Black to play. Choose the best move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "codpcq", white: "dqeqgqcr" },
            marks: { A: "bq", B: "br" },
            correct: ["bq"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-2-13",
        chapterId: "beginner-level3",
        order: 245,
        title: { zh: "行棋方向 · 13/14", en: "Haengma · 13/14" },
        instruction: { zh: "黑先。选择最佳着法，A或B。", en: "Black to play. Choose the best move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cnbocpdpeq", white: "bpbqcqdqer" },
            marks: { A: "fq", B: "fr" },
            correct: ["fq"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-2-14",
        chapterId: "beginner-level3",
        order: 246,
        title: { zh: "行棋方向 · 14/14", en: "Haengma · 14/14" },
        instruction: { zh: "黑先。选择最佳着法，A或B。", en: "Black to play. Choose the best move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqdqerfr", white: "cncpdpeqfq" },
            marks: { A: "bp", B: "gq" },
            correct: ["gq"],
        },
    },
];

const bl3Haengma3Levels: Level[] = [
    {
        id: "beginner-level3-bl3-haengma-3-1",
        chapterId: "beginner-level3",
        order: 247,
        title: { zh: "行棋方向 · 1/12", en: "Haengma · 1/12" },
        instruction: { zh: "白先。选择最佳着法，A或B，弯曲或延伸。", en: "White to play. Choose the best move, A or B, bend or stretch." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpeq", white: "ep" },
            marks: { B: "fp", A: "fq" },
            correct: ["fq"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-3-2",
        chapterId: "beginner-level3",
        order: 248,
        title: { zh: "行棋方向 · 2/12", en: "Haengma · 2/12" },
        instruction: { zh: "白先。选择最佳着法，A或B，弯曲或延伸。", en: "White to play. Choose the best move, A or B, bend or stretch." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpcqfq", white: "dpdq" },
            marks: { A: "co", B: "do" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-3-3",
        chapterId: "beginner-level3",
        order: 249,
        title: { zh: "行棋方向 · 3/12", en: "Haengma · 3/12" },
        instruction: { zh: "白先。选择最佳着法，A或B，弯曲或延伸。", en: "White to play. Choose the best move, A or B, bend or stretch." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpfp", white: "ep" },
            marks: { B: "eq", A: "fq" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-3-4",
        chapterId: "beginner-level3",
        order: 250,
        title: { zh: "行棋方向 · 4/12", en: "Haengma · 4/12" },
        instruction: { zh: "白先。选择最佳着法，A或B，弯曲或延伸。", en: "White to play. Choose the best move, A or B, bend or stretch." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eodpfpdq", white: "docpcq" },
            marks: { B: "dn", A: "en" },
            correct: ["dn"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-3-5",
        chapterId: "beginner-level3",
        order: 251,
        title: { zh: "行棋方向 · 5/12", en: "Haengma · 5/12" },
        instruction: { zh: "白先。选择最佳着法，A或B，弯曲或延伸。", en: "White to play. Choose the best move, A or B, bend or stretch." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpep", white: "eq" },
            marks: { A: "fp", B: "fq" },
            correct: ["fp"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-3-6",
        chapterId: "beginner-level3",
        order: 252,
        title: { zh: "行棋方向 · 6/12", en: "Haengma · 6/12" },
        instruction: { zh: "白先。选择最佳着法，A或B，弯曲或延伸。", en: "White to play. Choose the best move, A or B, bend or stretch." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bnbocpcq", white: "cncodpdq" },
            marks: { A: "bm", B: "cm" },
            correct: ["cm"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-3-7",
        chapterId: "beginner-level3",
        order: 253,
        title: { zh: "行棋方向 · 7/12", en: "Haengma · 7/12" },
        instruction: { zh: "白先。选择最佳着法，A或B，弯曲或延伸。", en: "White to play. Choose the best move, A or B, bend or stretch." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpeq", white: "fq" },
            marks: { B: "fp", A: "er" },
            correct: ["fp"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-3-8",
        chapterId: "beginner-level3",
        order: 254,
        title: { zh: "行棋方向 · 8/12", en: "Haengma · 8/12" },
        instruction: { zh: "白先。选择最佳着法，A或B，弯曲或延伸。", en: "White to play. Choose the best move, A or B, bend or stretch." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmcpdpcq", white: "fmgmhoepdqeqhq" },
            marks: { A: "do", B: "eo" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-3-9",
        chapterId: "beginner-level3",
        order: 255,
        title: { zh: "行棋方向 · 9/12", en: "Haengma · 9/12" },
        instruction: { zh: "白先。选择最佳着法，A或B，弯曲或延伸。", en: "White to play. Choose the best move, A or B, bend or stretch." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpgq", white: "fq" },
            marks: { B: "fp", A: "gp" },
            correct: ["fp"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-3-10",
        chapterId: "beginner-level3",
        order: 256,
        title: { zh: "行棋方向 · 10/12", en: "Haengma · 10/12" },
        instruction: { zh: "白先。选择最佳着法，A或B，弯曲或延伸。", en: "White to play. Choose the best move, A or B, bend or stretch." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dmfmdpdq", white: "ephpeq" },
            marks: { A: "do", B: "eo" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-3-11",
        chapterId: "beginner-level3",
        order: 257,
        title: { zh: "行棋方向 · 11/12", en: "Haengma · 11/12" },
        instruction: { zh: "白先。选择最佳着法，A或B，弯曲或延伸。", en: "White to play. Choose the best move, A or B, bend or stretch." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpfr", white: "fq" },
            marks: { B: "eq", A: "er" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-3-12",
        chapterId: "beginner-level3",
        order: 258,
        title: { zh: "行棋方向 · 12/12", en: "Haengma · 12/12" },
        instruction: { zh: "白先。选择最佳着法，A或B，弯曲或延伸。", en: "White to play. Choose the best move, A or B, bend or stretch." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpdqeqdr", white: "codocpepcqcr" },
            marks: { B: "fp", A: "fq" },
            correct: ["fq"],
        },
    },
];

const bl3Haengma4Levels: Level[] = [
    {
        id: "beginner-level3-bl3-haengma-4-1",
        chapterId: "beginner-level3",
        order: 259,
        title: { zh: "行棋方向 · 1/12", en: "Haengma · 1/12" },
        instruction: { zh: "黑先。下一手使黑棋形成好形，白棋形成愚形。", en: "Black to play. Play a move that causes good shape for Black and bad shape for White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cododpeqfq", white: "bpcpdqgqcrerfr" },
            correct: ["fo"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-4-2",
        chapterId: "beginner-level3",
        order: 260,
        title: { zh: "行棋方向 · 2/12", en: "Haengma · 2/12" },
        instruction: { zh: "黑先。下一手使黑棋形成好形，白棋形成愚形。", en: "Black to play. Play a move that causes good shape for Black and bad shape for White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpbqeqcrdr", white: "cpcqdq" },
            correct: ["co"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-4-3",
        chapterId: "beginner-level3",
        order: 261,
        title: { zh: "行棋方向 · 3/12", en: "Haengma · 3/12" },
        instruction: { zh: "黑先。下一手使黑棋形成好形，白棋形成愚形。", en: "Black to play. Play a move that causes good shape for Black and bad shape for White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cncocpdqeq", white: "cmbnenbobpcqcr" },
            correct: ["eo"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-4-4",
        chapterId: "beginner-level3",
        order: 262,
        title: { zh: "行棋方向 · 4/12", en: "Haengma · 4/12" },
        instruction: { zh: "黑先。下一手使黑棋形成好形，白棋形成愚形。", en: "Black to play. Play a move that causes good shape for Black and bad shape for White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "epaqbqfqcrdrerbs", white: "cobpdpcqdqeq" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-4-5",
        chapterId: "beginner-level3",
        order: 263,
        title: { zh: "行棋方向 · 5/12", en: "Haengma · 5/12" },
        instruction: { zh: "黑先。下一手使黑棋形成好形，白棋形成愚形。", en: "Black to play. Play a move that causes good shape for Black and bad shape for White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpgpcqfqcrdrergr", white: "fodpfpdqeq" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-4-6",
        chapterId: "beginner-level3",
        order: 264,
        title: { zh: "行棋方向 · 6/12", en: "Haengma · 6/12" },
        instruction: { zh: "黑先。下一手使黑棋形成好形，白棋形成愚形。", en: "Black to play. Play a move that causes good shape for Black and bad shape for White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dnencogocpgpbqdqdr", white: "doeodpfpeqgqhqfr" },
            correct: ["foeper"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-4-7",
        chapterId: "beginner-level3",
        order: 265,
        title: { zh: "行棋方向 · 7/12", en: "Haengma · 7/12" },
        instruction: { zh: "黑先。下一手使黑棋形成好形，白棋形成愚形。", en: "Black to play. Play a move that causes good shape for Black and bad shape for White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dodpeqer", white: "dncocpbqdqdr" },
            correct: ["fo"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-4-8",
        chapterId: "beginner-level3",
        order: 266,
        title: { zh: "行棋方向 · 8/12", en: "Haengma · 8/12" },
        instruction: { zh: "黑先。下一手使黑棋形成好形，白棋形成愚形。", en: "Black to play. Play a move that causes good shape for Black and bad shape for White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "hocpgpcqfqdrergr", white: "gneogodpfpdqeq" },
            correct: ["doepen"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-4-9",
        chapterId: "beginner-level3",
        order: 267,
        title: { zh: "行棋方向 · 9/12", en: "Haengma · 9/12" },
        instruction: { zh: "黑先。下一手使黑棋形成好形，白棋形成愚形。", en: "Black to play. Play a move that causes good shape for Black and bad shape for White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bncngncogodpepfp", white: "gmhnbohocpgpbqdqeqfqhq" },
            correct: ["en"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-4-10",
        chapterId: "beginner-level3",
        order: 268,
        title: { zh: "行棋方向 · 10/12", en: "Haengma · 10/12" },
        instruction: { zh: "黑先。下一手使黑棋形成好形，白棋形成愚形。", en: "Black to play. Play a move that causes good shape for Black and bad shape for White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmdmembnenbobpcqdq", white: "cndncoeofocpdp" },
            correct: ["ep"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-4-11",
        chapterId: "beginner-level3",
        order: 269,
        title: { zh: "行棋方向 · 11/12", en: "Haengma · 11/12" },
        instruction: { zh: "黑先。下一手使黑棋形成好形，白棋形成愚形。", en: "Black to play. Play a move that causes good shape for Black and bad shape for White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eogobpfpcqeqfqbrdr", white: "cnbodocpdpepdq" },
            correct: ["dn"],
        },
    },
    {
        id: "beginner-level3-bl3-haengma-4-12",
        chapterId: "beginner-level3",
        order: 270,
        title: { zh: "行棋方向 · 12/12", en: "Haengma · 12/12" },
        instruction: { zh: "黑先。下一手使黑棋形成好形，白棋形成愚形。", en: "Black to play. Play a move that causes good shape for Black and bad shape for White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmcnbocobpdpep", white: "blcldlcpfpbqcqdqeq" },
            correct: ["en"],
        },
    },
];

const bl3Seki1Levels: Level[] = [
    {
        id: "beginner-level3-bl3-seki-1-1",
        chapterId: "beginner-level3",
        order: 271,
        title: { zh: "双活 · 1/12", en: "Seki · 1/12" },
        instruction: { zh: "白先。制造双活。", en: "White to play. Make seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "anbndncodpepeqbrcrdrbsds", white: "aobogoapcpgpbqcqdqfqergres" },
            correct: ["ar"],
            wrong: ["aqar", "asar"],
        },
    },
    {
        id: "beginner-level3-bl3-seki-1-2",
        chapterId: "beginner-level3",
        order: 272,
        title: { zh: "双活 · 2/12", en: "Seki · 2/12" },
        instruction: { zh: "白先。制造双活。", en: "White to play. Make seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ambmdmcncodpaqdqbrdrbsds", white: "anbnboapbpcpcqcrcs" },
            correct: ["ar", "as"],
        },
    },
    {
        id: "beginner-level3-bl3-seki-1-3",
        chapterId: "beginner-level3",
        order: 273,
        title: { zh: "双活 · 3/12", en: "Seki · 3/12" },
        instruction: { zh: "白先。制造双活。", en: "White to play. Make seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ambmdmcndodpaqbqdqbrdrbsds", white: "anbnaocobpcpcqcrcs" },
            correct: ["ar", "as"],
        },
    },
    {
        id: "beginner-level3-bl3-seki-1-4",
        chapterId: "beginner-level3",
        order: 274,
        title: { zh: "双活 · 4/12", en: "Seki · 4/12" },
        instruction: { zh: "白先。制造双活。", en: "White to play. Make seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "enaobococpdqeqcrerfrbscsfs", white: "apbpdpepgpbqcqfqarbrgrgs" },
            correct: ["ds"],
        },
    },
    {
        id: "beginner-level3-bl3-seki-1-5",
        chapterId: "beginner-level3",
        order: 275,
        title: { zh: "双活 · 5/12", en: "Seki · 5/12" },
        instruction: { zh: "白先。制造双活。", en: "White to play. Make seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "alblclcmbncndnaoboeoepeqhqarbrcrdrfr", white: "akbkckdkdlamdmfmencodobpdpaqbqcqdq" },
            correct: ["an", "bm"],
        },
    },
    {
        id: "beginner-level3-bl3-seki-1-6",
        chapterId: "beginner-level3",
        order: 276,
        title: { zh: "双活 · 6/12", en: "Seki · 6/12" },
        instruction: { zh: "白先。制造双活。", en: "White to play. Make seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "alblclcmanbncndodpcqarbrdr", white: "akbkckdkdldmdnbocoapcpaqbq" },
            correct: ["am", "bm"],
        },
    },
    {
        id: "beginner-level3-bl3-seki-1-7",
        chapterId: "beginner-level3",
        order: 277,
        title: { zh: "双活 · 7/12", en: "Seki · 7/12" },
        instruction: { zh: "白先。制造双活。", en: "White to play. Make seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcqdqarbrerfrgrbsesgs", white: "apbpcpdpephpaqfqgqdrhrcshs" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level3-bl3-seki-1-8",
        chapterId: "beginner-level3",
        order: 278,
        title: { zh: "双活 · 8/12", en: "Seki · 8/12" },
        instruction: { zh: "白先。制造双活。", en: "White to play. Make seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "anbncncoapbpcpcqcrcs", white: "ambmcmdmdndodpdqbrdrbsds" },
            correct: ["araqao", "araqbo"],
            wrong: ["bqaq", "aqbq", "aoar", "boar"],
        },
    },
    {
        id: "beginner-level3-bl3-seki-1-9",
        chapterId: "beginner-level3",
        order: 279,
        title: { zh: "双活 · 9/12", en: "Seki · 9/12" },
        instruction: { zh: "白先。制造双活。", en: "White to play. Make seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aobobpcpaqcqarcrdrds", white: "anbncncodpbqdqfqbreres" },
            correct: ["bs"],
        },
    },
    {
        id: "beginner-level3-bl3-seki-1-10",
        chapterId: "beginner-level3",
        order: 280,
        title: { zh: "双活 · 10/12", en: "Seki · 10/12" },
        instruction: { zh: "白先。制造双活。", en: "White to play. Make seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aoapbpcpbqdqarcrdrds", white: "bmanbocodpepeqbreres" },
            correct: ["bs"],
        },
    },
    {
        id: "beginner-level3-bl3-seki-1-11",
        chapterId: "beginner-level3",
        order: 281,
        title: { zh: "双活 · 11/12", en: "Seki · 11/12" },
        instruction: { zh: "白先。制造双活。", en: "White to play. Make seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gocpdpepfpaqbqgqbrcrgrcsfsgs", white: "bnencoapbpcqdqeqfqdrfrases" },
            correct: ["bsaras", "bsarbs", "arbsar", "arbsas"],
        },
    },
    {
        id: "beginner-level3-bl3-seki-1-12",
        chapterId: "beginner-level3",
        order: 282,
        title: { zh: "双活 · 12/12", en: "Seki · 12/12" },
        instruction: { zh: "白先。制造双活。", en: "White to play. Make seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncndnaodobpcpdpdqardrbsds", white: "ambmcmdmemanencoeoepaqbqcqeqcreres" },
            correct: ["cs"],
            wrong: ["apbo", "brcsasap"],
        },
    },
];

const bl3Seki2Levels: Level[] = [
    {
        id: "beginner-level3-bl3-seki-2-1",
        chapterId: "beginner-level3",
        order: 283,
        title: { zh: "双活 · 1/8", en: "Seki · 1/8" },
        instruction: { zh: "如果你想赢得对杀，你必须阻止对手制造双活。所以如果有可能形成双活，你应该小心应对。如果白棋在B位落子，黑棋可以在A位制造双活。为防止这种情况发生，白棋应在C位落子。白先。阻止双活并赢得对杀。", en: "If you want to win the capturing race, you should prevent your opponent from making a seki. So if seki is possible, you should take good care of that. If White plays at B, Black can make seki by playing at A. To prevent this to happen, White should play at C. White to play. Prevent seki and win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqcrdpdqdsepfqgqgrgs", white: "dreqerfpgphphqhr" },
            marks: { A: "cs", B: "es", C: "fs" },
            correct: ["fscshs"],
            wrong: ["escs"],
        },
    },
    {
        id: "beginner-level3-bl3-seki-2-2",
        chapterId: "beginner-level3",
        order: 284,
        title: { zh: "双活 · 2/8", en: "Seki · 2/8" },
        instruction: { zh: "黑先。阻止双活并赢得对杀，或者制造双活。", en: "Black to play. Prevent seki and win the capturing race or make seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "hlinfogohodpepipdqiqcrdreriresis", white: "clbodoeocpfpgphpbqhqbrfrgrhrbsgs" },
            correct: ["fq"],
            wrong: ["csfq", "hsfq"],
        },
    },
    {
        id: "beginner-level3-bl3-seki-2-3",
        chapterId: "beginner-level3",
        order: 285,
        title: { zh: "双活 · 3/8", en: "Seki · 3/8" },
        instruction: { zh: "黑先。阻止双活并赢得对杀，或者制造双活。", en: "Black to play. Prevent seki and win the capturing race or make seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ingohoepfpipeqiqcrdreriresis", white: "cldneofocpdpgpcqgqbrgrgs" },
            correct: ["cs"],
            wrong: ["hpcs", "hqcs", "hrcs", "hscs"],
        },
    },
    {
        id: "beginner-level3-bl3-seki-2-4",
        chapterId: "beginner-level3",
        order: 286,
        title: { zh: "双活 · 4/8", en: "Seki · 4/8" },
        instruction: { zh: "黑先。阻止双活并赢得对杀，或者制造双活。", en: "Black to play. Prevent seki and win the capturing race or make seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fnfohodpepgpdqhqiqdrirds", white: "cmbodoeocpfpbqfqbrfrgrhrhs" },
            correct: ["fseres"],
            wrong: ["gqfs", "isfs", "esfs"],
        },
    },
    {
        id: "beginner-level3-bl3-seki-2-5",
        chapterId: "beginner-level3",
        order: 287,
        title: { zh: "双活 · 5/8", en: "Seki · 5/8" },
        instruction: { zh: "黑先。阻止双活并赢得对杀，或者制造双活。", en: "Black to play. Prevent seki and win the capturing race or make seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "hsglhneofogodphpcqdqhqarbrdrhras", white: "gscmdmencodobpcpepfpaqfqerfrgres" },
            correct: ["cs"],
            wrong: ["dscs", "gpcs", "gqcs"],
        },
    },
    {
        id: "beginner-level3-bl3-seki-2-6",
        chapterId: "beginner-level3",
        order: 288,
        title: { zh: "双活 · 6/8", en: "Seki · 6/8" },
        instruction: { zh: "黑先。阻止双活并赢得对杀，或者制造双活。", en: "Black to play. Prevent seki and win the capturing race or make seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmanbncocpfpcqdqeqhqfrasfs", white: "aobobpaqbqcrdrercses" },
            correct: ["br"],
        },
    },
    {
        id: "beginner-level3-bl3-seki-2-7",
        chapterId: "beginner-level3",
        order: 289,
        title: { zh: "双活 · 7/8", en: "Seki · 7/8" },
        instruction: { zh: "黑先。阻止双活并赢得对杀，或者制造双活。", en: "Black to play. Prevent seki and win the capturing race or make seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aqbqcqdqcrerdses", white: "apbpcpdpfpeqhqfrbsfs" },
            correct: ["br"],
            wrong: ["csar", "arcs"],
        },
    },
    {
        id: "beginner-level3-bl3-seki-2-8",
        chapterId: "beginner-level3",
        order: 290,
        title: { zh: "双活 · 8/8", en: "Seki · 8/8" },
        instruction: { zh: "黑先。阻止双活并赢得对杀，或者制造双活。", en: "Black to play. Prevent seki and win the capturing race or make seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "gscmcnfndoapbpcpdqeqerfrgr", white: "fpdpephpaqbqcqfqgqarcrhrascshs" },
            correct: ["esdrbr", "esdrbs"],
            wrong: ["dses", "drds", "bres", "bses"],
        },
    },
];

const bl3Skills1Levels: Level[] = [
    {
        id: "beginner-level3-bl3-skills-1-1",
        chapterId: "beginner-level3",
        order: 291,
        title: { zh: "技巧 · 1/24", en: "Skills · 1/24" },
        instruction: { zh: "白先。黑棋1之后，白棋在A点防守是否必要且正确？如果并非必要或有更好的选择，在A点落子就不合适。", en: "White to play. Is playing at A a necessary and good defense against Black's 1? Playing at A is not good if it is not necessary or if there is a better alternative." },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmbncocp", white: "bpdpcqeq" },
            marks: { 1: "cp", A: "bq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋1之后，白棋在A点防守是否必要且正确？如果并非必要或有更好的选择，在A点落子就不合适。", en: "White to play. Is playing at A a necessary and good defense against Black's 1? Playing at A is not good if it is not necessary or if there is a better alternative." },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "not good", label: { zh: "不好", en: "not good" } }],
            correctValue: "not good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cmbncocp", white: "bpdpcqeq" },
                marks: { 1: "cp", A: "bq" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-1-2",
        chapterId: "beginner-level3",
        order: 292,
        title: { zh: "技巧 · 2/24", en: "Skills · 2/24" },
        instruction: { zh: "白先。黑棋1之后，白棋在A点防守是否必要且正确？", en: "White to play. Is playing at A a necessary and good defense against Black's 1?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dmdnaodobpcp", white: "clcmcnbocodpbqcqdq" },
            marks: { 1: "ao", A: "an" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋1之后，白棋在A点防守是否必要且正确？", en: "White to play. Is playing at A a necessary and good defense against Black's 1?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "not good", label: { zh: "不好", en: "not good" } }],
            correctValue: "not good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dmdnaodobpcp", white: "clcmcnbocodpbqcqdq" },
                marks: { 1: "ao", A: "an" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-1-3",
        chapterId: "beginner-level3",
        order: 293,
        title: { zh: "技巧 · 3/24", en: "Skills · 3/24" },
        instruction: { zh: "白先。黑棋1之后，白棋在A点防守是否必要且正确？", en: "White to play. Is playing at A a necessary and good defense against Black's 1?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmbococpdq", white: "bpdpfpcqeq" },
            marks: { 1: "bo", A: "bq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋1之后，白棋在A点防守是否必要且正确？", en: "White to play. Is playing at A a necessary and good defense against Black's 1?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "not good", label: { zh: "不好", en: "not good" } }],
            correctValue: "good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cmbococpdq", white: "bpdpfpcqeq" },
                marks: { 1: "bo", A: "bq" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-1-4",
        chapterId: "beginner-level3",
        order: 294,
        title: { zh: "技巧 · 4/24", en: "Skills · 4/24" },
        instruction: { zh: "白先。黑棋1之后，白棋在A点防守是否必要且正确？", en: "White to play. Is playing at A a necessary and good defense against Black's 1?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "blcldldmdncocp", white: "bmcmancnbododpcq" },
            marks: { 1: "bl", A: "bp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋1之后，白棋在A点防守是否必要且正确？", en: "White to play. Is playing at A a necessary and good defense against Black's 1?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "not good", label: { zh: "不好", en: "not good" } }],
            correctValue: "not good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "blcldldmdncocp", white: "bmcmancnbododpcq" },
                marks: { 1: "bl", A: "bp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-1-5",
        chapterId: "beginner-level3",
        order: 295,
        title: { zh: "技巧 · 5/24", en: "Skills · 5/24" },
        instruction: { zh: "白先。黑棋1之后，白棋在A点防守是否必要且正确？", en: "White to play. Is playing at A a necessary and good defense against Black's 1?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eofocpfpdqfq", white: "dncodobpepcqeqcrdrfres" },
            marks: { 1: "eo", A: "dp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋1之后，白棋在A点防守是否必要且正确？", en: "White to play. Is playing at A a necessary and good defense against Black's 1?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "not good", label: { zh: "不好", en: "not good" } }],
            correctValue: "not good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "eofocpfpdqfq", white: "dncodobpepcqeqcrdrfres" },
                marks: { 1: "eo", A: "dp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-1-6",
        chapterId: "beginner-level3",
        order: 296,
        title: { zh: "技巧 · 6/24", en: "Skills · 6/24" },
        instruction: { zh: "白先。黑棋1之后，白棋在A点防守是否必要且正确？", en: "White to play. Is playing at A a necessary and good defense against Black's 1?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eneobpepdqdrfr", white: "cmbocododpcqcr" },
            marks: { 1: "bp", A: "cp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋1之后，白棋在A点防守是否必要且正确？", en: "White to play. Is playing at A a necessary and good defense against Black's 1?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "not good", label: { zh: "不好", en: "not good" } }],
            correctValue: "not good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "eneobpepdqdrfr", white: "cmbocododpcqcr" },
                marks: { 1: "bp", A: "cp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-1-7",
        chapterId: "beginner-level3",
        order: 297,
        title: { zh: "技巧 · 7/24", en: "Skills · 7/24" },
        instruction: { zh: "白先。黑棋1之后，白棋在A点防守是否必要且正确？", en: "White to play. Is playing at A a necessary and good defense against Black's 1?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "emdoeobpcpep", white: "cncodpbqcqeqfq" },
            marks: { 1: "do", A: "dq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋1之后，白棋在A点防守是否必要且正确？", en: "White to play. Is playing at A a necessary and good defense against Black's 1?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "not good", label: { zh: "不好", en: "not good" } }],
            correctValue: "good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "emdoeobpcpep", white: "cncodpbqcqeqfq" },
                marks: { 1: "do", A: "dq" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-1-8",
        chapterId: "beginner-level3",
        order: 298,
        title: { zh: "技巧 · 8/24", en: "Skills · 8/24" },
        instruction: { zh: "白先。黑棋1之后，白棋在A点防守是否必要且正确？", en: "White to play. Is playing at A a necessary and good defense against Black's 1?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncncocp", white: "bobpcqdqeq" },
            marks: { 1: "bn", A: "bq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋1之后，白棋在A点防守是否必要且正确？", en: "White to play. Is playing at A a necessary and good defense against Black's 1?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "not good", label: { zh: "不好", en: "not good" } }],
            correctValue: "not good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bncncocp", white: "bobpcqdqeq" },
                marks: { 1: "bn", A: "bq" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-1-9",
        chapterId: "beginner-level3",
        order: 299,
        title: { zh: "技巧 · 9/24", en: "Skills · 9/24" },
        instruction: { zh: "白先。黑棋1之后，白棋在A点防守是否必要且正确？", en: "White to play. Is playing at A a necessary and good defense against Black's 1?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "anbncncocp", white: "aobobpcqdqeq" },
            marks: { 1: "an", A: "bq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋1之后，白棋在A点防守是否必要且正确？", en: "White to play. Is playing at A a necessary and good defense against Black's 1?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "not good", label: { zh: "不好", en: "not good" } }],
            correctValue: "good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "anbncncocp", white: "aobobpcqdqeq" },
                marks: { 1: "an", A: "bq" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-1-10",
        chapterId: "beginner-level3",
        order: 300,
        title: { zh: "技巧 · 10/24", en: "Skills · 10/24" },
        instruction: { zh: "白先。黑棋1之后，白棋在A点防守是否必要且正确？", en: "White to play. Is playing at A a necessary and good defense against Black's 1?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eofq", white: "clcndpdq" },
            marks: { 1: "eo", A: "do" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋1之后，白棋在A点防守是否必要且正确？", en: "White to play. Is playing at A a necessary and good defense against Black's 1?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "not good", label: { zh: "不好", en: "not good" } }],
            correctValue: "not good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "eofq", white: "clcndpdq" },
                marks: { 1: "eo", A: "do" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-1-11",
        chapterId: "beginner-level3",
        order: 301,
        title: { zh: "技巧 · 11/24", en: "Skills · 11/24" },
        instruction: { zh: "白先。黑棋1之后，白棋在A点防守是否必要且正确？", en: "White to play. Is playing at A a necessary and good defense against Black's 1?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "encofofq", white: "clcndpdq" },
            marks: { 1: "co", A: "do" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋1之后，白棋在A点防守是否必要且正确？", en: "White to play. Is playing at A a necessary and good defense against Black's 1?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "not good", label: { zh: "不好", en: "not good" } }],
            correctValue: "good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "encofofq", white: "clcndpdq" },
                marks: { 1: "co", A: "do" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-1-12",
        chapterId: "beginner-level3",
        order: 302,
        title: { zh: "技巧 · 12/24", en: "Skills · 12/24" },
        instruction: { zh: "白先。黑棋1之后，白棋在A点防守是否必要且正确？", en: "White to play. Is playing at A a necessary and good defense against Black's 1?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncododpdqcrdr", white: "bmcmcnbocpcqbrbs" },
            marks: { 1: "co", A: "bp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋1之后，白棋在A点防守是否必要且正确？", en: "White to play. Is playing at A a necessary and good defense against Black's 1?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "not good", label: { zh: "不好", en: "not good" } }],
            correctValue: "good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bncododpdqcrdr", white: "bmcmcnbocpcqbrbs" },
                marks: { 1: "co", A: "bp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-1-13",
        chapterId: "beginner-level3",
        order: 303,
        title: { zh: "技巧 · 13/24", en: "Skills · 13/24" },
        instruction: { zh: "黑先。在A点防守是否正确？如果并非必要或有更好的选择，在A点落子就不合适。", en: "Black to play. Is playing at A a good defense? Playing at A is not good if it is not necessary or if there is a better alternative." },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bococpdqeq", white: "fnbpdpaqcqbrcr" },
            marks: { A: "eo" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。在A点防守是否正确？如果并非必要或有更好的选择，在A点落子就不合适。", en: "Black to play. Is playing at A a good defense? Playing at A is not good if it is not necessary or if there is a better alternative." },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "not good", label: { zh: "不好", en: "not good" } }],
            correctValue: "good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bococpdqeq", white: "fnbpdpaqcqbrcr" },
                marks: { A: "eo" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-1-14",
        chapterId: "beginner-level3",
        order: 304,
        title: { zh: "技巧 · 14/24", en: "Skills · 14/24" },
        instruction: { zh: "黑先。在A点防守是否正确？", en: "Black to play. Is playing at A a good defense?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bncndoepdqfqgq", white: "bmcmdmdneofofp" },
            marks: { A: "co" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。在A点防守是否正确？", en: "Black to play. Is playing at A a good defense?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "not good", label: { zh: "不好", en: "not good" } }],
            correctValue: "good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bncndoepdqfqgq", white: "bmcmdmdneofofp" },
                marks: { A: "co" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-1-15",
        chapterId: "beginner-level3",
        order: 305,
        title: { zh: "技巧 · 15/24", en: "Skills · 15/24" },
        instruction: { zh: "黑先。在A点防守是否正确？", en: "Black to play. Is playing at A a good defense?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bncnencocpdqeq", white: "bodofobpdpcqbrcr" },
            marks: { A: "ep" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。在A点防守是否正确？", en: "Black to play. Is playing at A a good defense?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "not good", label: { zh: "不好", en: "not good" } }],
            correctValue: "not good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bncnencocpdqeq", white: "bodofobpdpcqbrcr" },
                marks: { A: "ep" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-1-16",
        chapterId: "beginner-level3",
        order: 306,
        title: { zh: "技巧 · 16/24", en: "Skills · 16/24" },
        instruction: { zh: "黑先。在A点防守是否正确？", en: "Black to play. Is playing at A a good defense?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bncnbodoeocqdq", white: "bmcmdmdncobpcp" },
            marks: { A: "ap" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。在A点防守是否正确？", en: "Black to play. Is playing at A a good defense?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "not good", label: { zh: "不好", en: "not good" } }],
            correctValue: "not good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bncnbodoeocqdq", white: "bmcmdmdncobpcp" },
                marks: { A: "ap" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-1-17",
        chapterId: "beginner-level3",
        order: 307,
        title: { zh: "技巧 · 17/24", en: "Skills · 17/24" },
        instruction: { zh: "黑先。在A点防守是否正确？", en: "Black to play. Is playing at A a good defense?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bobpcqeqdrer", white: "bncncocpdpdq" },
            marks: { A: "bq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。在A点防守是否正确？", en: "Black to play. Is playing at A a good defense?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "not good", label: { zh: "不好", en: "not good" } }],
            correctValue: "good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bobpcqeqdrer", white: "bncncocpdpdq" },
                marks: { A: "bq" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-1-18",
        chapterId: "beginner-level3",
        order: 308,
        title: { zh: "技巧 · 18/24", en: "Skills · 18/24" },
        instruction: { zh: "黑先。在A点防守是否正确？", en: "Black to play. Is playing at A a good defense?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcmcnbocpcqcrdrer", white: "bncododpfpdqfqfr" },
            marks: { A: "bp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。在A点防守是否正确？", en: "Black to play. Is playing at A a good defense?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "not good", label: { zh: "不好", en: "not good" } }],
            correctValue: "not good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bmcmcnbocpcqcrdrer", white: "bncododpfpdqfqfr" },
                marks: { A: "bp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-1-19",
        chapterId: "beginner-level3",
        order: 309,
        title: { zh: "技巧 · 19/24", en: "Skills · 19/24" },
        instruction: { zh: "黑先。在A点防守是否正确？", en: "Black to play. Is playing at A a good defense?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmcncobpcqbrdrds", white: "dndocpdpdqeqerbses" },
            marks: { A: "cr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。在A点防守是否正确？", en: "Black to play. Is playing at A a good defense?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "not good", label: { zh: "不好", en: "not good" } }],
            correctValue: "good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cmcncobpcqbrdrds", white: "dndocpdpdqeqerbses" },
                marks: { A: "cr" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-1-20",
        chapterId: "beginner-level3",
        order: 310,
        title: { zh: "技巧 · 20/24", en: "Skills · 20/24" },
        instruction: { zh: "黑先。在A点防守是否正确？", en: "Black to play. Is playing at A a good defense?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "blclcmbnaococpaqbq", white: "bmcndndodpcqdqarbr" },
            marks: { A: "bp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。在A点防守是否正确？", en: "Black to play. Is playing at A a good defense?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "not good", label: { zh: "不好", en: "not good" } }],
            correctValue: "good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "blclcmbnaococpaqbq", white: "bmcndndodpcqdqarbr" },
                marks: { A: "bp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-1-21",
        chapterId: "beginner-level3",
        order: 311,
        title: { zh: "技巧 · 21/24", en: "Skills · 21/24" },
        instruction: { zh: "黑先。在A点防守是否正确？", en: "Black to play. Is playing at A a good defense?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcmancnbocpcqbrcrdrcsds", white: "codobpdpbqdqfqeres" },
            marks: { A: "ap" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。在A点防守是否正确？", en: "Black to play. Is playing at A a good defense?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "not good", label: { zh: "不好", en: "not good" } }],
            correctValue: "good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bmcmancnbocpcqbrcrdrcsds", white: "codobpdpbqdqfqeres" },
                marks: { A: "ap" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-1-22",
        chapterId: "beginner-level3",
        order: 312,
        title: { zh: "技巧 · 22/24", en: "Skills · 22/24" },
        instruction: { zh: "黑先。在A点防守是否正确？", en: "Black to play. Is playing at A a good defense?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aobococpcqdqbreres", white: "anbncndndodpeqfqfrfs" },
            marks: { A: "dr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。在A点防守是否正确？", en: "Black to play. Is playing at A a good defense?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "not good", label: { zh: "不好", en: "not good" } }],
            correctValue: "good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "aobococpcqdqbreres", white: "anbncndndodpeqfqfrfs" },
                marks: { A: "dr" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-1-23",
        chapterId: "beginner-level3",
        order: 313,
        title: { zh: "技巧 · 23/24", en: "Skills · 23/24" },
        instruction: { zh: "黑先。在A点防守是否正确？", en: "Black to play. Is playing at A a good defense?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpcpdpaqeqcreres", white: "aobocodoapepfpfqfr" },
            marks: { A: "bq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。在A点防守是否正确？", en: "Black to play. Is playing at A a good defense?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "not good", label: { zh: "不好", en: "not good" } }],
            correctValue: "good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bpcpdpaqeqcreres", white: "aobocodoapepfpfqfr" },
                marks: { A: "bq" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-1-24",
        chapterId: "beginner-level3",
        order: 314,
        title: { zh: "技巧 · 24/24", en: "Skills · 24/24" },
        instruction: { zh: "黑先。在A点防守是否正确？", en: "Black to play. Is playing at A a good defense?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dnbocodpcqcr", white: "eobpcpfpdqeq" },
            marks: { A: "do" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。在A点防守是否正确？", en: "Black to play. Is playing at A a good defense?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "not good", label: { zh: "不好", en: "not good" } }],
            correctValue: "good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dnbocodpcqcr", white: "eobpcpfpdqeq" },
                marks: { A: "do" },
            },
        },
    },
];

const bl3Skills2Levels: Level[] = [
    {
        id: "beginner-level3-bl3-skills-2-1",
        chapterId: "beginner-level3",
        order: 315,
        title: { zh: "技巧 · 1/10", en: "Skills · 1/10" },
        instruction: { zh: "如果能吃掉棋子，你应该用最高效的方式，以获得最大收益。黑棋可以通过在A、B或C位落子来吃掉白棋两子。但只有其中一手是高效的。另外两手有缺点。如果黑棋在A或B位落子，被吃的白棋仍有余味。白棋之后可以在C位落子，在角部获得一些目数。先在A或B位落子看看会发生什么。最后，下出最高效的一手。", en: "If you can capture stones, you should do that in the most efficient way, so that you gain the most profit. Black can capture the two white stones by playing at A, B or C. But only one of the three is efficient. The other two moves have a disadvantage. If Black plays at A or B, the captured white stones still have influence (aji). White can later play at C and get some points in the corner. First, play at A or B to see what happens. Finally, make the most efficient move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcocqdodp", white: "bpcpcrdqeq" },
            marks: { A: "bo", B: "ap", C: "br" },
            correct: ["brbobn"],
            wrong: ["bobr", "apbr"],
        },
    },
    {
        id: "beginner-level3-bl3-skills-2-2",
        chapterId: "beginner-level3",
        order: 316,
        title: { zh: "技巧 · 2/10", en: "Skills · 2/10" },
        instruction: { zh: "黑先。选择最佳且最高效的着法，A、B或C。", en: "Black to play. Choose the best and most efficient play, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bncododpdqcrdrbs", white: "bmcmcnbocpcqbr" },
            marks: { A: "an", B: "bp", C: "bq" },
            correct: ["bp"],
            wrong: ["anbp", "bqbp"],
        },
    },
    {
        id: "beginner-level3-bl3-skills-2-3",
        chapterId: "beginner-level3",
        order: 317,
        title: { zh: "技巧 · 3/10", en: "Skills · 3/10" },
        instruction: { zh: "黑先。选择最佳且最高效的着法，A、B或C。", en: "Black to play. Choose the best and most efficient play, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cocpdqeqcr", white: "cnbododpcq" },
            marks: { A: "bp", B: "bq", C: "br" },
            correct: ["bq"],
            wrong: ["bpbq", "brbq"],
        },
    },
    {
        id: "beginner-level3-bl3-skills-2-4",
        chapterId: "beginner-level3",
        order: 318,
        title: { zh: "技巧 · 4/10", en: "Skills · 4/10" },
        instruction: { zh: "黑先。选择最佳且最高效的着法，A、B或C。", en: "Black to play. Choose the best and most efficient play, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdpdqcrercs", white: "epcqeqbrdrfrds" },
            marks: { A: "bp", B: "bq", C: "es" },
            correct: ["es"],
            wrong: ["bqes", "bpes"],
        },
    },
    {
        id: "beginner-level3-bl3-skills-2-5",
        chapterId: "beginner-level3",
        order: 319,
        title: { zh: "技巧 · 5/10", en: "Skills · 5/10" },
        instruction: { zh: "黑先。选择最佳且最高效的着法，A、B或C。", en: "Black to play. Choose the best and most efficient play, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcmcnbo", white: "anbncododq" },
            marks: { A: "am", B: "ao", C: "bp" },
            correct: ["bp"],
            wrong: ["aobp", "ambp"],
        },
    },
    {
        id: "beginner-level3-bl3-skills-2-6",
        chapterId: "beginner-level3",
        order: 320,
        title: { zh: "技巧 · 6/10", en: "Skills · 6/10" },
        instruction: { zh: "黑先。选择最佳且最高效的着法，A、B或C。", en: "Black to play. Choose the best and most efficient play, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmemdncoeocpdpbqeqfqdr", white: "cldldmcnbobpepfpcqdq" },
            marks: { A: "bm", B: "bn", C: "cr" },
            correct: ["bn"],
            wrong: ["crbm", "bmbn"],
        },
    },
    {
        id: "beginner-level3-bl3-skills-2-7",
        chapterId: "beginner-level3",
        order: 321,
        title: { zh: "技巧 · 7/10", en: "Skills · 7/10" },
        instruction: { zh: "黑先。选择最佳且最高效的着法，A、B或C。", en: "Black to play. Choose the best and most efficient play, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bodocpdpeqfqgq", white: "cobpcqdqerfr" },
            marks: { A: "bn", B: "cn", C: "bq" },
            correct: ["bq"],
            wrong: ["bnbq", "cnbq"],
        },
    },
    {
        id: "beginner-level3-bl3-skills-2-8",
        chapterId: "beginner-level3",
        order: 322,
        title: { zh: "技巧 · 8/10", en: "Skills · 8/10" },
        instruction: { zh: "黑先。选择最佳且最高效的着法，A、B或C。", en: "Black to play. Choose the best and most efficient play, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcmcnbobpcpcqbr", white: "bncodoapdpbqdqcrdr" },
            marks: { A: "an", B: "aq", C: "bs" },
            correct: ["aq"],
            wrong: ["anbs", "bsao"],
        },
    },
    {
        id: "beginner-level3-bl3-skills-2-9",
        chapterId: "beginner-level3",
        order: 323,
        title: { zh: "技巧 · 9/10", en: "Skills · 9/10" },
        instruction: { zh: "黑先。选择最佳且最高效的着法，A、B或C。", en: "Black to play. Choose the best and most efficient play, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bnaocododpcqcr", white: "bobpcpepdqfqbrdr" },
            marks: { A: "ap", B: "bq", C: "bs" },
            correct: ["bq"],
            wrong: ["apbq", "bsbq"],
        },
    },
    {
        id: "beginner-level3-bl3-skills-2-10",
        chapterId: "beginner-level3",
        order: 324,
        title: { zh: "技巧 · 10/10", en: "Skills · 10/10" },
        instruction: { zh: "黑先。选择最佳且最高效的着法，A、B或C。", en: "Black to play. Choose the best and most efficient play, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmcododpbqcqcr", white: "bpcpepdqfqbrdr" },
            marks: { A: "bo", B: "aq", C: "bs" },
            correct: ["bs"],
            wrong: ["aqcs", "bocs"],
        },
    },
];

const bl3Skills3Levels: Level[] = [
    {
        id: "beginner-level3-bl3-skills-3-1",
        chapterId: "beginner-level3",
        order: 325,
        title: { zh: "技巧 · 1/14", en: "Skills · 1/14" },
        instruction: { zh: "有时对手落子后，你会想知道它是否有害以及是否需要应对。如果没有害处，你完全可以下在其他地方。这种下在别处的做法称为脱先。因此脱先时，你不对对手的棋进行防守回应，而是下在其他地方。这里白棋1大幅跳入黑棋领地。白棋威胁着在A点连接此子与其他白棋。如果黑棋想阻止这一连接，应该应对白1并在A点落子。白1之后在A点落子是否是好的回应，还是脱先更好？", en: "Sometimes your opponent plays a move, that makes you wonder if it does any harm and if you should react to it. If it does not do any harm, you can play a good move completely somewhere else. This playing somewhere else we call tenuki. So with tenuki you do not respond to the move of your opponent with a defensive move, but you play somewhere else. Here, White jumps with move 1 far into the black territory. White threatens to connect this stone with the other white stones by playing at A. If Black wants to prevent this, he should react to white 1 by playing at A. Is playing at A a good reply to white 1 or is it better to play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clcocqdmdq", white: "crfqhpip" },
            marks: { 1: "cr", A: "dr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "有时对手落子后，你会想知道它是否有害以及是否需要应对。如果没有害处，你完全可以下在其他地方。这种下在别处的做法称为脱先。因此脱先时，你不对对手的棋进行防守回应，而是下在其他地方。这里白棋1大幅跳入黑棋领地。白棋威胁着在A点连接此子与其他白棋。如果黑棋想阻止这一连接，应该应对白1并在A点落子。白1之后在A点落子是否是好的回应，还是脱先更好？", en: "Sometimes your opponent plays a move, that makes you wonder if it does any harm and if you should react to it. If it does not do any harm, you can play a good move completely somewhere else. This playing somewhere else we call tenuki. So with tenuki you do not respond to the move of your opponent with a defensive move, but you play somewhere else. Here, White jumps with move 1 far into the black territory. White threatens to connect this stone with the other white stones by playing at A. If Black wants to prevent this, he should react to white 1 by playing at A. Is playing at A a good reply to white 1 or is it better to play tenuki?" },
            options: [{ value: "good reply", label: { zh: "好的回应", en: "good reply" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "good reply",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "clcocqdmdq", white: "crfqhpip" },
                marks: { 1: "cr", A: "dr" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-3-2",
        chapterId: "beginner-level3",
        order: 326,
        title: { zh: "技巧 · 2/14", en: "Skills · 2/14" },
        instruction: { zh: "这里白棋无法将其1号棋子与其他棋子连接。黑棋可以冷静地脱先下在其他地方。黑棋在A点落子是否是对白1的良好回应，还是脱先更好？", en: "Here, White can not connect his stone 1 with the other stones. Black can calmly play somewhere else, tenuki. Is playing at A by Black a good reply to white 1 or is it better to play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clcocqdmdqfq", white: "crhphrip" },
            marks: { 1: "cr", A: "dr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "这里白棋无法将其1号棋子与其他棋子连接。黑棋可以冷静地脱先下在其他地方。黑棋在A点落子是否是对白1的良好回应，还是脱先更好？", en: "Here, White can not connect his stone 1 with the other stones. Black can calmly play somewhere else, tenuki. Is playing at A by Black a good reply to white 1 or is it better to play tenuki?" },
            options: [{ value: "good reply", label: { zh: "好的回应", en: "good reply" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "tenuki",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "clcocqdmdqfq", white: "crhphrip" },
                marks: { 1: "cr", A: "dr" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-3-3",
        chapterId: "beginner-level3",
        order: 327,
        title: { zh: "技巧 · 3/14", en: "Skills · 3/14" },
        instruction: { zh: "白先。黑棋1之后，在A点落子是否是好的回应，还是脱先更好？", en: "White to play. Is playing at A a good reply to black 1 or is it better to play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fpcqfqfr", white: "cobpdpdq" },
            marks: { 1: "cq", A: "dr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋1之后，在A点落子是否是好的回应，还是脱先更好？", en: "White to play. Is playing at A a good reply to black 1 or is it better to play tenuki?" },
            options: [{ value: "good reply", label: { zh: "好的回应", en: "good reply" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "good reply",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "fpcqfqfr", white: "cobpdpdq" },
                marks: { 1: "cq", A: "dr" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-3-4",
        chapterId: "beginner-level3",
        order: 328,
        title: { zh: "技巧 · 4/14", en: "Skills · 4/14" },
        instruction: { zh: "白先。黑棋1之后，在A点落子是否是好的回应，还是脱先更好？", en: "White to play. Is playing at A a good reply to black 1 or is it better to play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpdpbqdqdr", white: "bncncobpcqcrcs" },
            marks: { 1: "bq", A: "br" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋1之后，在A点落子是否是好的回应，还是脱先更好？", en: "White to play. Is playing at A a good reply to black 1 or is it better to play tenuki?" },
            options: [{ value: "good reply", label: { zh: "好的回应", en: "good reply" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "good reply",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cpdpbqdqdr", white: "bncncobpcqcrcs" },
                marks: { 1: "bq", A: "br" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-3-5",
        chapterId: "beginner-level3",
        order: 329,
        title: { zh: "技巧 · 5/14", en: "Skills · 5/14" },
        instruction: { zh: "白先。黑棋1之后，在A点落子是否是好的回应，还是脱先更好？", en: "White to play. Is playing at A a good reply to black 1 or is it better to play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "br", white: "cncocpcqeqgq" },
            marks: { 1: "br", A: "cr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋1之后，在A点落子是否是好的回应，还是脱先更好？", en: "White to play. Is playing at A a good reply to black 1 or is it better to play tenuki?" },
            options: [{ value: "good reply", label: { zh: "好的回应", en: "good reply" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "tenuki",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "br", white: "cncocpcqeqgq" },
                marks: { 1: "br", A: "cr" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-3-6",
        chapterId: "beginner-level3",
        order: 330,
        title: { zh: "技巧 · 6/14", en: "Skills · 6/14" },
        instruction: { zh: "白先。黑棋1之后，在A点落子是否是好的回应，还是脱先更好？", en: "White to play. Is playing at A a good reply to black 1 or is it better to play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ambmbncocpcqbrcr", white: "blcmcnbobpbq" },
            marks: { 1: "am", A: "al" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋1之后，在A点落子是否是好的回应，还是脱先更好？", en: "White to play. Is playing at A a good reply to black 1 or is it better to play tenuki?" },
            options: [{ value: "good reply", label: { zh: "好的回应", en: "good reply" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "tenuki",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "ambmbncocpcqbrcr", white: "blcmcnbobpbq" },
                marks: { 1: "am", A: "al" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-3-7",
        chapterId: "beginner-level3",
        order: 331,
        title: { zh: "技巧 · 7/14", en: "Skills · 7/14" },
        instruction: { zh: "白先。黑棋1之后，在A点落子是否是好的回应，还是脱先更好？", en: "White to play. Is playing at A a good reply to black 1 or is it better to play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "foeqfqdr", white: "clcndpdq" },
            marks: { 1: "dr", A: "cr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋1之后，在A点落子是否是好的回应，还是脱先更好？", en: "White to play. Is playing at A a good reply to black 1 or is it better to play tenuki?" },
            options: [{ value: "good reply", label: { zh: "好的回应", en: "good reply" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "good reply",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "foeqfqdr", white: "clcndpdq" },
                marks: { 1: "dr", A: "cr" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-3-8",
        chapterId: "beginner-level3",
        order: 332,
        title: { zh: "技巧 · 8/14", en: "Skills · 8/14" },
        instruction: { zh: "白先。黑棋1之后，在A点落子是否是好的回应，还是脱先更好？", en: "White to play. Is playing at A a good reply to black 1 or is it better to play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fnbpdpfpaqcqbrcr", white: "dlcmbocoeocpdqeq" },
            marks: { 1: "fp", A: "ep" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋1之后，在A点落子是否是好的回应，还是脱先更好？", en: "White to play. Is playing at A a good reply to black 1 or is it better to play tenuki?" },
            options: [{ value: "good reply", label: { zh: "好的回应", en: "good reply" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "good reply",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "fnbpdpfpaqcqbrcr", white: "dlcmbocoeocpdqeq" },
                marks: { 1: "fp", A: "ep" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-3-9",
        chapterId: "beginner-level3",
        order: 333,
        title: { zh: "技巧 · 9/14", en: "Skills · 9/14" },
        instruction: { zh: "白先。黑棋1之后，在A点落子是否是好的回应，还是脱先更好？", en: "White to play. Is playing at A a good reply to black 1 or is it better to play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "enfnbpdpaqcqbrcr", white: "dlcmbocoeocpdqeq" },
            marks: { 1: "en", A: "do" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋1之后，在A点落子是否是好的回应，还是脱先更好？", en: "White to play. Is playing at A a good reply to black 1 or is it better to play tenuki?" },
            options: [{ value: "good reply", label: { zh: "好的回应", en: "good reply" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "tenuki",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "enfnbpdpaqcqbrcr", white: "dlcmbocoeocpdqeq" },
                marks: { 1: "en", A: "do" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-3-10",
        chapterId: "beginner-level3",
        order: 334,
        title: { zh: "技巧 · 10/14", en: "Skills · 10/14" },
        instruction: { zh: "白先。黑棋1之后，在A点落子是否是好的回应，还是脱先更好？", en: "White to play. Is playing at A a good reply to black 1 or is it better to play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocododpcqcrbs", white: "bpcpbqdqeqbr" },
            marks: { 1: "bs", A: "dr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋1之后，在A点落子是否是好的回应，还是脱先更好？", en: "White to play. Is playing at A a good reply to black 1 or is it better to play tenuki?" },
            options: [{ value: "good reply", label: { zh: "好的回应", en: "good reply" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "tenuki",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bocododpcqcrbs", white: "bpcpbqdqeqbr" },
                marks: { 1: "bs", A: "dr" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-3-11",
        chapterId: "beginner-level3",
        order: 335,
        title: { zh: "技巧 · 11/14", en: "Skills · 11/14" },
        instruction: { zh: "白先。黑棋1之后，在A点落子是否是好的回应，还是脱先更好？", en: "White to play. Is playing at A a good reply to black 1 or is it better to play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocododpcqcr", white: "bpcpbqdqeq" },
            marks: { 1: "cr", A: "br" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋1之后，在A点落子是否是好的回应，还是脱先更好？", en: "White to play. Is playing at A a good reply to black 1 or is it better to play tenuki?" },
            options: [{ value: "good reply", label: { zh: "好的回应", en: "good reply" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "good reply",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bocododpcqcr", white: "bpcpbqdqeq" },
                marks: { 1: "cr", A: "br" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-3-12",
        chapterId: "beginner-level3",
        order: 336,
        title: { zh: "技巧 · 12/14", en: "Skills · 12/14" },
        instruction: { zh: "白先。黑棋1之后，在A点落子是否是好的回应，还是脱先更好？", en: "White to play. Is playing at A a good reply to black 1 or is it better to play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmemencodocp", white: "fngneodpcqdr" },
            marks: { 1: "do", A: "ep" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋1之后，在A点落子是否是好的回应，还是脱先更好？", en: "White to play. Is playing at A a good reply to black 1 or is it better to play tenuki?" },
            options: [{ value: "good reply", label: { zh: "好的回应", en: "good reply" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "good reply",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cmemencodocp", white: "fngneodpcqdr" },
                marks: { 1: "do", A: "ep" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-3-13",
        chapterId: "beginner-level3",
        order: 337,
        title: { zh: "技巧 · 13/14", en: "Skills · 13/14" },
        instruction: { zh: "白先。黑棋1之后，在A点落子是否是好的回应，还是脱先更好？", en: "White to play. Is playing at A a good reply to black 1 or is it better to play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dlcmcodocp", white: "engneodpgpcqfqdr" },
            marks: { 1: "do", A: "ep" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋1之后，在A点落子是否是好的回应，还是脱先更好？", en: "White to play. Is playing at A a good reply to black 1 or is it better to play tenuki?" },
            options: [{ value: "good reply", label: { zh: "好的回应", en: "good reply" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "tenuki",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dlcmcodocp", white: "engneodpgpcqfqdr" },
                marks: { 1: "do", A: "ep" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-3-14",
        chapterId: "beginner-level3",
        order: 338,
        title: { zh: "技巧 · 14/14", en: "Skills · 14/14" },
        instruction: { zh: "白先。黑棋1之后，在A点落子是否是好的回应，还是脱先更好？", en: "White to play. Is playing at A a good reply to black 1 or is it better to play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpepdqfqdr", white: "dnbododpbqcqcr" },
            marks: { 1: "bp", A: "cp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋1之后，在A点落子是否是好的回应，还是脱先更好？", en: "White to play. Is playing at A a good reply to black 1 or is it better to play tenuki?" },
            options: [{ value: "good reply", label: { zh: "好的回应", en: "good reply" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "tenuki",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bpepdqfqdr", white: "dnbododpbqcqcr" },
                marks: { 1: "bp", A: "cp" },
            },
        },
    },
];

const bl3Skills4Levels: Level[] = [
    {
        id: "beginner-level3-bl3-skills-4-1",
        chapterId: "beginner-level3",
        order: 339,
        title: { zh: "技巧 · 1/12", en: "Skills · 1/12" },
        instruction: { zh: "白先。选择对黑棋1的最佳防御，A、B或C。", en: "White to play. Choose the best defense against black 1: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dnenbocoeo", white: "bndocpdpdq" },
            marks: { 1: "bo", A: "cn", B: "bp", C: "bq" },
            correct: ["cn"],
            wrong: ["bpcn", "bqcn"],
        },
    },
    {
        id: "beginner-level3-bl3-skills-4-2",
        chapterId: "beginner-level3",
        order: 340,
        title: { zh: "技巧 · 2/12", en: "Skills · 2/12" },
        instruction: { zh: "白先。选择对黑棋1的最佳防御，A、B或C。", en: "White to play. Choose the best defense against black 1: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "codpepeqeres", white: "cmcpbqdqdrds" },
            marks: { 1: "co", A: "bn", B: "bo", C: "bp" },
            correct: ["bo"],
            wrong: ["bnbo", "bpbo"],
        },
    },
    {
        id: "beginner-level3-bl3-skills-4-3",
        chapterId: "beginner-level3",
        order: 341,
        title: { zh: "技巧 · 3/12", en: "Skills · 3/12" },
        instruction: { zh: "白先。选择对黑棋1的最佳防御，A、B或C。", en: "White to play. Choose the best defense against black 1: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dqfqcrbs", white: "cmcncpcqbr" },
            marks: { 1: "bs", A: "aq", B: "bq", C: "dr" },
            correct: ["dr"],
            wrong: ["bqdr", "aqdr"],
        },
    },
    {
        id: "beginner-level3-bl3-skills-4-4",
        chapterId: "beginner-level3",
        order: 342,
        title: { zh: "技巧 · 4/12", en: "Skills · 4/12" },
        instruction: { zh: "白先。选择对黑棋1的最佳防御，A、B或C。", en: "White to play. Choose the best defense against black 1: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcpdqeqbr", white: "cododpbqcq" },
            marks: { 1: "br", A: "bo", B: "ar", C: "cr" },
            correct: ["cr"],
            wrong: ["bocr", "arcr"],
        },
    },
    {
        id: "beginner-level3-bl3-skills-4-5",
        chapterId: "beginner-level3",
        order: 343,
        title: { zh: "技巧 · 5/12", en: "Skills · 5/12" },
        instruction: { zh: "白先。选择对黑棋1的最佳防御，A、B或C。", en: "White to play. Choose the best defense against black 1: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dofoeqfqfr", white: "cmcnendpepdqdrer" },
            marks: { 1: "do", A: "dn", B: "co", C: "eo" },
            correct: ["eo"],
            wrong: ["coeo", "dneo"],
        },
    },
    {
        id: "beginner-level3-bl3-skills-4-6",
        chapterId: "beginner-level3",
        order: 344,
        title: { zh: "技巧 · 6/12", en: "Skills · 6/12" },
        instruction: { zh: "白先。选择对黑棋1的最佳防御，A、B或C。", en: "White to play. Choose the best defense against black 1: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eoepdqeqcr", white: "cmdncpdpcq" },
            marks: { 1: "cr", A: "bq", B: "br", C: "dr" },
            correct: ["br"],
            wrong: ["bqbr", "drbr"],
        },
    },
    {
        id: "beginner-level3-bl3-skills-4-7",
        chapterId: "beginner-level3",
        order: 345,
        title: { zh: "技巧 · 7/12", en: "Skills · 7/12" },
        instruction: { zh: "白先。选择对黑棋1的最佳防御，A、B或C。", en: "White to play. Choose the best defense against black 1: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncnaococp", white: "bobpcqdqeq" },
            marks: { 1: "ao", A: "ap", B: "bq", C: "br" },
            correct: ["bq"],
            wrong: ["brap", "apbq"],
        },
    },
    {
        id: "beginner-level3-bl3-skills-4-8",
        chapterId: "beginner-level3",
        order: 346,
        title: { zh: "技巧 · 8/12", en: "Skills · 8/12" },
        instruction: { zh: "白先。选择对黑棋1的最佳防御，A、B或C。", en: "White to play. Choose the best defense against black 1: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "epdqeq", white: "dpcqcr" },
            marks: { 1: "ep", A: "dn", B: "do", C: "cp" },
            correct: ["do"],
            wrong: ["dndo", "cpdo"],
        },
    },
    {
        id: "beginner-level3-bl3-skills-4-9",
        chapterId: "beginner-level3",
        order: 347,
        title: { zh: "技巧 · 9/12", en: "Skills · 9/12" },
        instruction: { zh: "白先。选择对黑棋1的最佳防御，A、B或C。", en: "White to play. Choose the best defense against black 1: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "doepeq", white: "cndnendpcqdq" },
            marks: { 1: "do", B: "co", C: "eo", A: "bp" },
            correct: ["eo"],
            wrong: ["coeo", "bpeo"],
        },
    },
    {
        id: "beginner-level3-bl3-skills-4-10",
        chapterId: "beginner-level3",
        order: 348,
        title: { zh: "技巧 · 10/12", en: "Skills · 10/12" },
        instruction: { zh: "白先。选择对黑棋1的最佳防御，A、B或C。", en: "White to play. Choose the best defense against black 1: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dmbndnfncpdpepfp", white: "cobpcqdqeqfqgq" },
            marks: { 1: "bn", A: "cn", B: "bo", C: "bq" },
            correct: ["bo"],
            wrong: ["cnbo", "bqbo"],
        },
    },
    {
        id: "beginner-level3-bl3-skills-4-11",
        chapterId: "beginner-level3",
        order: 349,
        title: { zh: "技巧 · 11/12", en: "Skills · 11/12" },
        instruction: { zh: "白先。选择对黑棋1的最佳防御，A、B或C。", en: "White to play. Choose the best defense against black 1: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "enfobpcpfpdqeq", white: "dmdnbocodpepcqgqcr" },
            marks: { 1: "en", A: "em", B: "do", C: "fq" },
            correct: ["do"],
            wrong: ["emdo", "fqdo"],
        },
    },
    {
        id: "beginner-level3-bl3-skills-4-12",
        chapterId: "beginner-level3",
        order: 350,
        title: { zh: "技巧 · 12/12", en: "Skills · 12/12" },
        instruction: { zh: "白先。选择对黑棋1的最佳防御，A、B或C。", en: "White to play. Choose the best defense against black 1: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "frfqcqbqfpepdp", white: "crbreqdqcpcocn" },
            marks: { 1: "fr", C: "er", A: "bp", B: "ds" },
            correct: ["dsesdr"],
            wrong: ["bpdr", "eres"],
        },
    },
];

const bl3Skills5Levels: Level[] = [
    {
        id: "beginner-level3-bl;3-skills-5-1",
        chapterId: "beginner-level3",
        order: 351,
        title: { zh: "技巧 · 1/24", en: "Skills · 1/24" },
        instruction: { zh: "白先。下在A点能否救出标记的棋子？", en: "White to play. Can you save the marked stones by playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bococpcqarcrcs", white: "bkclbmapbpbqbrbs" },
            marks: { A: "ao", triangle: "bsbrbqbpap" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。下在A点能否救出标记的棋子？", en: "White to play. Can you save the marked stones by playing at A?" },
            options: [{ value: "A saves", label: { zh: "A能救出", en: "A saves" } }, { value: "A doesn't save", label: { zh: "A救不出", en: "A doesn't save" } }],
            correctValue: "A saves",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bococpcqarcrcs", white: "bkclbmapbpbqbrbs" },
                marks: { A: "ao", triangle: "bsbrbqbpap" },
            },
        },
    },
    {
        id: "beginner-level3-bl;3-skills-5-2",
        chapterId: "beginner-level3",
        order: 352,
        title: { zh: "技巧 · 2/24", en: "Skills · 2/24" },
        instruction: { zh: "白先。下在A点能否救出标记的棋子？", en: "White to play. Can you save the marked stone by playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cnbocpdpdqcrdrbs", white: "bpcqbr" },
            marks: { A: "bq", triangle: "cq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。下在A点能否救出标记的棋子？", en: "White to play. Can you save the marked stone by playing at A?" },
            options: [{ value: "A saves", label: { zh: "A能救出", en: "A saves" } }, { value: "A doesn't save", label: { zh: "A救不出", en: "A doesn't save" } }],
            correctValue: "A doesn't save",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cnbocpdpdqcrdrbs", white: "bpcqbr" },
                marks: { A: "bq", triangle: "cq" },
            },
        },
    },
    {
        id: "beginner-level3-bl;3-skills-5-3",
        chapterId: "beginner-level3",
        order: 353,
        title: { zh: "技巧 · 3/24", en: "Skills · 3/24" },
        instruction: { zh: "白先。下在A点能否救出标记的棋子？", en: "White to play. Can you save the marked stone by playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpdpdqcrdrbs", white: "cncobpcqbr" },
            marks: { A: "bq", triangle: "cq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。下在A点能否救出标记的棋子？", en: "White to play. Can you save the marked stone by playing at A?" },
            options: [{ value: "A saves", label: { zh: "A能救出", en: "A saves" } }, { value: "A doesn't save", label: { zh: "A救不出", en: "A doesn't save" } }],
            correctValue: "A saves",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cpdpdqcrdrbs", white: "cncobpcqbr" },
                marks: { A: "bq", triangle: "cq" },
            },
        },
    },
    {
        id: "beginner-level3-bl;3-skills-5-4",
        chapterId: "beginner-level3",
        order: 354,
        title: { zh: "技巧 · 4/24", en: "Skills · 4/24" },
        instruction: { zh: "白先。下在A点能否救出标记的棋子？", en: "White to play. Can you save the marked stones by playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dnbodoepcqdqeq", white: "cmdmemeneocpdp" },
            marks: { A: "co", triangle: "dpcp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。下在A点能否救出标记的棋子？", en: "White to play. Can you save the marked stones by playing at A?" },
            options: [{ value: "A saves", label: { zh: "A能救出", en: "A saves" } }, { value: "A doesn't save", label: { zh: "A救不出", en: "A doesn't save" } }],
            correctValue: "A saves",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dnbodoepcqdqeq", white: "cmdmemeneocpdp" },
                marks: { A: "co", triangle: "dpcp" },
            },
        },
    },
    {
        id: "beginner-level3-bl;3-skills-5-5",
        chapterId: "beginner-level3",
        order: 355,
        title: { zh: "技巧 · 5/24", en: "Skills · 5/24" },
        instruction: { zh: "白先。下在A点能否救出标记的棋子？", en: "White to play. Can you save the marked stones by playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cnencoeofpcqdqfqer", white: "cmemfmfnfodpepeq" },
            marks: { A: "do", triangle: "eqepdp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。下在A点能否救出标记的棋子？", en: "White to play. Can you save the marked stones by playing at A?" },
            options: [{ value: "A saves", label: { zh: "A能救出", en: "A saves" } }, { value: "A doesn't save", label: { zh: "A救不出", en: "A doesn't save" } }],
            correctValue: "A doesn't save",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cnencoeofpcqdqfqer", white: "cmemfmfnfodpepeq" },
                marks: { A: "do", triangle: "eqepdp" },
            },
        },
    },
    {
        id: "beginner-level3-bl;3-skills-5-6",
        chapterId: "beginner-level3",
        order: 356,
        title: { zh: "技巧 · 6/24", en: "Skills · 6/24" },
        instruction: { zh: "白先。下在A点能否救出标记的棋子？", en: "White to play. Can you save the marked stones by playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpdpbqdqfqbr", white: "bnaocobpcqcr" },
            marks: { A: "dr", triangle: "crcq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。下在A点能否救出标记的棋子？", en: "White to play. Can you save the marked stones by playing at A?" },
            options: [{ value: "A saves", label: { zh: "A能救出", en: "A saves" } }, { value: "A doesn't save", label: { zh: "A救不出", en: "A doesn't save" } }],
            correctValue: "A doesn't save",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cpdpbqdqfqbr", white: "bnaocobpcqcr" },
                marks: { A: "dr", triangle: "crcq" },
            },
        },
    },
    {
        id: "beginner-level3-bl;3-skills-5-7",
        chapterId: "beginner-level3",
        order: 357,
        title: { zh: "技巧 · 7/24", en: "Skills · 7/24" },
        instruction: { zh: "白先。下在A点能否救出标记的棋子？", en: "White to play. Can you save the marked stones by playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpdpbqdqdr", white: "bnaocobpcqcr" },
            marks: { A: "br", triangle: "crcq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。下在A点能否救出标记的棋子？", en: "White to play. Can you save the marked stones by playing at A?" },
            options: [{ value: "A saves", label: { zh: "A能救出", en: "A saves" } }, { value: "A doesn't save", label: { zh: "A救不出", en: "A doesn't save" } }],
            correctValue: "A saves",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cpdpbqdqdr", white: "bnaocobpcqcr" },
                marks: { A: "br", triangle: "crcq" },
            },
        },
    },
    {
        id: "beginner-level3-bl;3-skills-5-8",
        chapterId: "beginner-level3",
        order: 358,
        title: { zh: "技巧 · 8/24", en: "Skills · 8/24" },
        instruction: { zh: "白先。下在A点能否救出标记的棋子？", en: "White to play. Can you save the marked stones by playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmcncobpcp", white: "bnboapbqcqdq" },
            marks: { A: "ao", triangle: "bobn" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。下在A点能否救出标记的棋子？", en: "White to play. Can you save the marked stones by playing at A?" },
            options: [{ value: "A saves", label: { zh: "A能救出", en: "A saves" } }, { value: "A doesn't save", label: { zh: "A救不出", en: "A doesn't save" } }],
            correctValue: "A saves",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bmcncobpcp", white: "bnboapbqcqdq" },
                marks: { A: "ao", triangle: "bobn" },
            },
        },
    },
    {
        id: "beginner-level3-bl;3-skills-5-9",
        chapterId: "beginner-level3",
        order: 359,
        title: { zh: "技巧 · 9/24", en: "Skills · 9/24" },
        instruction: { zh: "白先。下在A点能否救出标记的棋子？", en: "White to play. Can you save the marked stones by playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "akbkckclbmcmcncocp", white: "alblambnbobpcqdq" },
            marks: { A: "an", triangle: "amblal" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。下在A点能否救出标记的棋子？", en: "White to play. Can you save the marked stones by playing at A?" },
            options: [{ value: "A saves", label: { zh: "A能救出", en: "A saves" } }, { value: "A doesn't save", label: { zh: "A救不出", en: "A doesn't save" } }],
            correctValue: "A saves",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "akbkckclbmcmcncocp", white: "alblambnbobpcqdq" },
                marks: { A: "an", triangle: "amblal" },
            },
        },
    },
    {
        id: "beginner-level3-bl;3-skills-5-10",
        chapterId: "beginner-level3",
        order: 360,
        title: { zh: "技巧 · 10/24", en: "Skills · 10/24" },
        instruction: { zh: "白先。下在A点能否救出标记的棋子？", en: "White to play. Can you save the marked stones by playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "akbkckdkdlbmcmdmcncocp", white: "alblclambnaobobpcqdq" },
            marks: { A: "an", triangle: "amclblal" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。下在A点能否救出标记的棋子？", en: "White to play. Can you save the marked stones by playing at A?" },
            options: [{ value: "A saves", label: { zh: "A能救出", en: "A saves" } }, { value: "A doesn't save", label: { zh: "A救不出", en: "A doesn't save" } }],
            correctValue: "A doesn't save",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "akbkckdkdlbmcmdmcncocp", white: "alblclambnaobobpcqdq" },
                marks: { A: "an", triangle: "amclblal" },
            },
        },
    },
    {
        id: "beginner-level3-bl;3-skills-5-11",
        chapterId: "beginner-level3",
        order: 361,
        title: { zh: "技巧 · 11/24", en: "Skills · 11/24" },
        instruction: { zh: "白先。下在A点能否救出标记的棋子？", en: "White to play. Can you save the marked stones by playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cnbododpbqcqcr", white: "cobpcpepdqfqdr" },
            marks: { A: "ap", triangle: "cpbpco" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。下在A点能否救出标记的棋子？", en: "White to play. Can you save the marked stones by playing at A?" },
            options: [{ value: "A saves", label: { zh: "A能救出", en: "A saves" } }, { value: "A doesn't save", label: { zh: "A救不出", en: "A doesn't save" } }],
            correctValue: "A doesn't save",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cnbododpbqcqcr", white: "cobpcpepdqfqdr" },
                marks: { A: "ap", triangle: "cpbpco" },
            },
        },
    },
    {
        id: "beginner-level3-bl;3-skills-5-12",
        chapterId: "beginner-level3",
        order: 362,
        title: { zh: "技巧 · 12/24", en: "Skills · 12/24" },
        instruction: { zh: "白先。下在A点能否救出标记的棋子？", en: "White to play. Can you save the marked stones by playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpdpdqcrdr", white: "clcnbqcqbr" },
            marks: { A: "bp", triangle: "brcqbq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。下在A点能否救出标记的棋子？", en: "White to play. Can you save the marked stones by playing at A?" },
            options: [{ value: "A saves", label: { zh: "A能救出", en: "A saves" } }, { value: "A doesn't save", label: { zh: "A救不出", en: "A doesn't save" } }],
            correctValue: "A saves",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cpdpdqcrdr", white: "clcnbqcqbr" },
                marks: { A: "bp", triangle: "brcqbq" },
            },
        },
    },
    {
        id: "beginner-level3-bl;3-skills-5-13",
        chapterId: "beginner-level3",
        order: 363,
        title: { zh: "技巧 · 13/24", en: "Skills · 13/24" },
        instruction: { zh: "黑先。下在A点能否救出标记的棋子？", en: "Black to play. Can you save the marked stone by playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ambnaobobpcqdq", white: "bkalbmcmcncocp" },
            marks: { A: "an", triangle: "am" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。下在A点能否救出标记的棋子？", en: "Black to play. Can you save the marked stone by playing at A?" },
            options: [{ value: "A saves", label: { zh: "A能救出", en: "A saves" } }, { value: "A doesn't save", label: { zh: "A救不出", en: "A doesn't save" } }],
            correctValue: "A doesn't save",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "ambnaobobpcqdq", white: "bkalbmcmcncocp" },
                marks: { A: "an", triangle: "am" },
            },
        },
    },
    {
        id: "beginner-level3-bl;3-skills-5-14",
        chapterId: "beginner-level3",
        order: 364,
        title: { zh: "技巧 · 14/24", en: "Skills · 14/24" },
        instruction: { zh: "黑先。下在A点能否救出标记的棋子？", en: "Black to play. Can you save the marked stone by playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ambnbobpcqdq", white: "bkalbmcmcncocp" },
            marks: { A: "an", triangle: "am" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。下在A点能否救出标记的棋子？", en: "Black to play. Can you save the marked stone by playing at A?" },
            options: [{ value: "A saves", label: { zh: "A能救出", en: "A saves" } }, { value: "A doesn't save", label: { zh: "A救不出", en: "A doesn't save" } }],
            correctValue: "A saves",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "ambnbobpcqdq", white: "bkalbmcmcncocp" },
                marks: { A: "an", triangle: "am" },
            },
        },
    },
    {
        id: "beginner-level3-bl;3-skills-5-15",
        chapterId: "beginner-level3",
        order: 365,
        title: { zh: "技巧 · 15/24", en: "Skills · 15/24" },
        instruction: { zh: "黑先。下在A点能否救出标记的棋子？", en: "Black to play. Can you save the marked stones by playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aqbqcqcrdrds", white: "doapbpcpdqeqerbses" },
            marks: { A: "ar", triangle: "dsdrcrcqbqaq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。下在A点能否救出标记的棋子？", en: "Black to play. Can you save the marked stones by playing at A?" },
            options: [{ value: "A saves", label: { zh: "A能救出", en: "A saves" } }, { value: "A doesn't save", label: { zh: "A救不出", en: "A doesn't save" } }],
            correctValue: "A doesn't save",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "aqbqcqcrdrds", white: "doapbpcpdqeqerbses" },
                marks: { A: "ar", triangle: "dsdrcrcqbqaq" },
            },
        },
    },
    {
        id: "beginner-level3-bl;3-skills-5-16",
        chapterId: "beginner-level3",
        order: 366,
        title: { zh: "技巧 · 16/24", en: "Skills · 16/24" },
        instruction: { zh: "黑先。下在A点能否救出标记的棋子？", en: "Black to play. Can you save the marked stones by playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "codobpbqbr", white: "cmdmbneneocpepcqeqcrbs" },
            marks: { A: "bo", triangle: "brbqbp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。下在A点能否救出标记的棋子？", en: "Black to play. Can you save the marked stones by playing at A?" },
            options: [{ value: "A saves", label: { zh: "A能救出", en: "A saves" } }, { value: "A doesn't save", label: { zh: "A救不出", en: "A doesn't save" } }],
            correctValue: "A doesn't save",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "codobpbqbr", white: "cmdmbneneocpepcqeqcrbs" },
                marks: { A: "bo", triangle: "brbqbp" },
            },
        },
    },
    {
        id: "beginner-level3-bl;3-skills-5-17",
        chapterId: "beginner-level3",
        order: 367,
        title: { zh: "技巧 · 17/24", en: "Skills · 17/24" },
        instruction: { zh: "黑先。下在A点能否救出标记的棋子？", en: "Black to play. Can you save the marked stones by playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmdmcodobpbqbr", white: "bneneocpepcqeqcrbs" },
            marks: { A: "bo", triangle: "brbqbp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。下在A点能否救出标记的棋子？", en: "Black to play. Can you save the marked stones by playing at A?" },
            options: [{ value: "A saves", label: { zh: "A能救出", en: "A saves" } }, { value: "A doesn't save", label: { zh: "A救不出", en: "A doesn't save" } }],
            correctValue: "A saves",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cmdmcodobpbqbr", white: "bneneocpepcqeqcrbs" },
                marks: { A: "bo", triangle: "brbqbp" },
            },
        },
    },
    {
        id: "beginner-level3-bl;3-skills-5-18",
        chapterId: "beginner-level3",
        order: 368,
        title: { zh: "技巧 · 18/24", en: "Skills · 18/24" },
        instruction: { zh: "黑先。下在A点能否救出标记的棋子？", en: "Black to play. Can you save the marked stones by playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "clbmcnbobqcq", white: "bpcpdpdqdr" },
            marks: { A: "ap", triangle: "cqbq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。下在A点能否救出标记的棋子？", en: "Black to play. Can you save the marked stones by playing at A?" },
            options: [{ value: "A saves", label: { zh: "A能救出", en: "A saves" } }, { value: "A doesn't save", label: { zh: "A救不出", en: "A doesn't save" } }],
            correctValue: "A saves",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "clbmcnbobqcq", white: "bpcpdpdqdr" },
                marks: { A: "ap", triangle: "cqbq" },
            },
        },
    },
    {
        id: "beginner-level3-bl;3-skills-5-19",
        chapterId: "beginner-level3",
        order: 369,
        title: { zh: "技巧 · 19/24", en: "Skills · 19/24" },
        instruction: { zh: "黑先。下在A点能否救出标记的棋子？", en: "Black to play. Can you save the marked stones by playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bncndodpcqdq", white: "bmcmdmdncocp" },
            marks: { A: "bp", triangle: "cnbn" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。下在A点能否救出标记的棋子？", en: "Black to play. Can you save the marked stones by playing at A?" },
            options: [{ value: "A saves", label: { zh: "A能救出", en: "A saves" } }, { value: "A doesn't save", label: { zh: "A救不出", en: "A doesn't save" } }],
            correctValue: "A saves",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bncndodpcqdq", white: "bmcmdmdncocp" },
                marks: { A: "bp", triangle: "cnbn" },
            },
        },
    },
    {
        id: "beginner-level3-bl;3-skills-5-20",
        chapterId: "beginner-level3",
        order: 370,
        title: { zh: "技巧 · 20/24", en: "Skills · 20/24" },
        instruction: { zh: "黑先。下在A点能否救出标记的棋子？", en: "Black to play. Can you save the marked stones by playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bobpdpcqeqcrbs", white: "bncncocpbqbr" },
            marks: { A: "ar", triangle: "bpbo" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。下在A点能否救出标记的棋子？", en: "Black to play. Can you save the marked stones by playing at A?" },
            options: [{ value: "A saves", label: { zh: "A能救出", en: "A saves" } }, { value: "A doesn't save", label: { zh: "A救不出", en: "A doesn't save" } }],
            correctValue: "A saves",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bobpdpcqeqcrbs", white: "bncncocpbqbr" },
                marks: { A: "ar", triangle: "bpbo" },
            },
        },
    },
    {
        id: "beginner-level3-bl;3-skills-5-21",
        chapterId: "beginner-level3",
        order: 371,
        title: { zh: "技巧 · 21/24", en: "Skills · 21/24" },
        instruction: { zh: "黑先。下在A点能否救出标记的棋子？", en: "Black to play. Can you save the marked stone by playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bncodobqdqdr", white: "bmcmcnbobp" },
            marks: { A: "an", triangle: "bn" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。下在A点能否救出标记的棋子？", en: "Black to play. Can you save the marked stone by playing at A?" },
            options: [{ value: "A saves", label: { zh: "A能救出", en: "A saves" } }, { value: "A doesn't save", label: { zh: "A救不出", en: "A doesn't save" } }],
            correctValue: "A doesn't save",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bncodobqdqdr", white: "bmcmcnbobp" },
                marks: { A: "an", triangle: "bn" },
            },
        },
    },
    {
        id: "beginner-level3-bl;3-skills-5-22",
        chapterId: "beginner-level3",
        order: 372,
        title: { zh: "技巧 · 22/24", en: "Skills · 22/24" },
        instruction: { zh: "黑先。下在A点能否救出标记的棋子？", en: "Black to play. Can you save the marked stone by playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcnbocq", white: "bpdpeq" },
            marks: { A: "cp", triangle: "cq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。下在A点能否救出标记的棋子？", en: "Black to play. Can you save the marked stone by playing at A?" },
            options: [{ value: "A saves", label: { zh: "A能救出", en: "A saves" } }, { value: "A doesn't save", label: { zh: "A救不出", en: "A doesn't save" } }],
            correctValue: "A saves",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bmcnbocq", white: "bpdpeq" },
                marks: { A: "cp", triangle: "cq" },
            },
        },
    },
    {
        id: "beginner-level3-bl;3-skills-5-23",
        chapterId: "beginner-level3",
        order: 373,
        title: { zh: "技巧 · 23/24", en: "Skills · 23/24" },
        instruction: { zh: "黑先。下在A点能否救出标记的棋子？", en: "Black to play. Can you save the marked stone by playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "coeodpdqdr", white: "cndndocpcqcr" },
            marks: { A: "bo", triangle: "co" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。下在A点能否救出标记的棋子？", en: "Black to play. Can you save the marked stone by playing at A?" },
            options: [{ value: "A saves", label: { zh: "A能救出", en: "A saves" } }, { value: "A doesn't save", label: { zh: "A救不出", en: "A doesn't save" } }],
            correctValue: "A doesn't save",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "coeodpdqdr", white: "cndndocpcqcr" },
                marks: { A: "bo", triangle: "co" },
            },
        },
    },
    {
        id: "beginner-level3-bl;3-skills-5-24",
        chapterId: "beginner-level3",
        order: 374,
        title: { zh: "技巧 · 24/24", en: "Skills · 24/24" },
        instruction: { zh: "黑先。下在A点能否救出标记的棋子？", en: "Black to play. Can you save the marked stones by playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "anbncnaobpcqdq", white: "ambmcmdnbococp" },
            marks: { A: "ap", triangle: "aocnbnan" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。下在A点能否救出标记的棋子？", en: "Black to play. Can you save the marked stones by playing at A?" },
            options: [{ value: "A saves", label: { zh: "A能救出", en: "A saves" } }, { value: "A doesn't save", label: { zh: "A救不出", en: "A doesn't save" } }],
            correctValue: "A doesn't save",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "anbncnaobpcqdq", white: "ambmcmdnbococp" },
                marks: { A: "ap", triangle: "aocnbnan" },
            },
        },
    },
];

const bl3Skills6Levels: Level[] = [
    {
        id: "beginner-level3-bl3-skills-6-1",
        chapterId: "beginner-level3",
        order: 375,
        title: { zh: "技巧 · 1/12", en: "Skills · 1/12" },
        instruction: { zh: "白先。你必须回应黑棋的上一手棋吗，还是可以脱先？", en: "White to play. Do you have to reply to Black's last move or can you play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbpcpdqdrcsds", white: "bqcqarcrbs" },
            marks: { 1: "ap" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。你必须回应黑棋的上一手棋吗，还是可以脱先？", en: "White to play. Do you have to reply to Black's last move or can you play tenuki?" },
            options: [{ value: "reply", label: { zh: "回应", en: "reply" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "reply",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "apbpcpdqdrcsds", white: "bqcqarcrbs" },
                marks: { 1: "ap" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-6-2",
        chapterId: "beginner-level3",
        order: 376,
        title: { zh: "技巧 · 2/12", en: "Skills · 2/12" },
        instruction: { zh: "白先。你必须回应黑棋的上一手棋吗，还是可以脱先？", en: "White to play. Do you have to reply to Black's last move or can you play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aobocoapcpdqdrds", white: "bpbqcqarcrbs" },
            marks: { 1: "ap" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。你必须回应黑棋的上一手棋吗，还是可以脱先？", en: "White to play. Do you have to reply to Black's last move or can you play tenuki?" },
            options: [{ value: "reply", label: { zh: "回应", en: "reply" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "tenuki",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "aobocoapcpdqdrds", white: "bpbqcqarcrbs" },
                marks: { 1: "ap" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-6-3",
        chapterId: "beginner-level3",
        order: 377,
        title: { zh: "技巧 · 3/12", en: "Skills · 3/12" },
        instruction: { zh: "白先。你必须回应黑棋的上一手棋吗，还是可以脱先？", en: "White to play. Do you have to reply to Black's last move or can you play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ambmcmancnco", white: "bnaobocpepcq" },
            marks: { 1: "co" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。你必须回应黑棋的上一手棋吗，还是可以脱先？", en: "White to play. Do you have to reply to Black's last move or can you play tenuki?" },
            options: [{ value: "reply", label: { zh: "回应", en: "reply" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "reply",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "ambmcmancnco", white: "bnaobocpepcq" },
                marks: { 1: "co" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-6-4",
        chapterId: "beginner-level3",
        order: 378,
        title: { zh: "技巧 · 4/12", en: "Skills · 4/12" },
        instruction: { zh: "白先。你必须回应黑棋的上一手棋吗，还是可以脱先？", en: "White to play. Do you have to reply to Black's last move or can you play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eobpcpdpepdqgqcrdrbs", white: "dmbocodoapbqcqbr" },
            marks: { 1: "bs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。你必须回应黑棋的上一手棋吗，还是可以脱先？", en: "White to play. Do you have to reply to Black's last move or can you play tenuki?" },
            options: [{ value: "reply", label: { zh: "回应", en: "reply" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "reply",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "eobpcpdpepdqgqcrdrbs", white: "dmbocodoapbqcqbr" },
                marks: { 1: "bs" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-6-5",
        chapterId: "beginner-level3",
        order: 379,
        title: { zh: "技巧 · 5/12", en: "Skills · 5/12" },
        instruction: { zh: "白先。你必须回应黑棋的上一手棋吗，还是可以脱先？", en: "White to play. Do you have to reply to Black's last move or can you play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmcmcnco", white: "bnbocpepcq" },
            marks: { 1: "co" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。你必须回应黑棋的上一手棋吗，还是可以脱先？", en: "White to play. Do you have to reply to Black's last move or can you play tenuki?" },
            options: [{ value: "reply", label: { zh: "回应", en: "reply" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "tenuki",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bmcmcnco", white: "bnbocpepcq" },
                marks: { 1: "co" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-6-6",
        chapterId: "beginner-level3",
        order: 380,
        title: { zh: "技巧 · 6/12", en: "Skills · 6/12" },
        instruction: { zh: "白先。你必须回应黑棋的上一手棋吗，还是可以脱先？", en: "White to play. Do you have to reply to Black's last move or can you play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "anbncncodoeofogogpgqgrfsgs", white: "aoboapcpdpepfpbqfqfres" },
            marks: { 1: "fs", 2: "es", 3: "gs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。你必须回应黑棋的上一手棋吗，还是可以脱先？", en: "White to play. Do you have to reply to Black's last move or can you play tenuki?" },
            options: [{ value: "reply", label: { zh: "回应", en: "reply" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "reply",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "anbncncodoeofogogpgqgrfsgs", white: "aoboapcpdpepfpbqfqfres" },
                marks: { 1: "fs", 2: "es", 3: "gs" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-6-7",
        chapterId: "beginner-level3",
        order: 381,
        title: { zh: "技巧 · 7/12", en: "Skills · 7/12" },
        instruction: { zh: "白先。你必须回应黑棋的上一手棋吗，还是可以脱先？", en: "White to play. Do you have to reply to Black's last move or can you play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aobocodoapdpeqerdses", white: "bpcpaqdqbrdrcs" },
            marks: { 1: "dp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。你必须回应黑棋的上一手棋吗，还是可以脱先？", en: "White to play. Do you have to reply to Black's last move or can you play tenuki?" },
            options: [{ value: "reply", label: { zh: "回应", en: "reply" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "reply",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "aobocodoapdpeqerdses", white: "bpcpaqdqbrdrcs" },
                marks: { 1: "dp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-6-8",
        chapterId: "beginner-level3",
        order: 382,
        title: { zh: "技巧 · 8/12", en: "Skills · 8/12" },
        instruction: { zh: "白先。你必须回应黑棋的上一手棋吗，还是可以脱先？", en: "White to play. Do you have to reply to Black's last move or can you play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "alblcldldmdneodpepeqerdses", white: "ambmcmcncodocpdqbrdrcs" },
            marks: { 1: "ds", 2: "cs", 3: "es" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。你必须回应黑棋的上一手棋吗，还是可以脱先？", en: "White to play. Do you have to reply to Black's last move or can you play tenuki?" },
            options: [{ value: "reply", label: { zh: "回应", en: "reply" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "tenuki",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "alblcldldmdneodpepeqerdses", white: "ambmcmcncodocpdqbrdrcs" },
                marks: { 1: "ds", 2: "cs", 3: "es" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-6-9",
        chapterId: "beginner-level3",
        order: 383,
        title: { zh: "技巧 · 9/12", en: "Skills · 9/12" },
        instruction: { zh: "白先。你必须回应黑棋的上一手棋吗，还是可以脱先？", en: "White to play. Do you have to reply to Black's last move or can you play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aobocododpeqerdses", white: "apbpcpaqdqbrdrcs" },
            marks: { 1: "dp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。你必须回应黑棋的上一手棋吗，还是可以脱先？", en: "White to play. Do you have to reply to Black's last move or can you play tenuki?" },
            options: [{ value: "reply", label: { zh: "回应", en: "reply" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "tenuki",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "aobocododpeqerdses", white: "apbpcpaqdqbrdrcs" },
                marks: { 1: "dp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-6-10",
        chapterId: "beginner-level3",
        order: 384,
        title: { zh: "技巧 · 10/12", en: "Skills · 10/12" },
        instruction: { zh: "白先。你必须回应黑棋的上一手棋吗，还是可以脱先？", en: "White to play. Do you have to reply to Black's last move or can you play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "alblcldlelamemenboeodpepcqcrer", white: "bmcmdmandncodoapbpcpbqbrbs" },
            marks: { 1: "am", 2: "an", 3: "al" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。你必须回应黑棋的上一手棋吗，还是可以脱先？", en: "White to play. Do you have to reply to Black's last move or can you play tenuki?" },
            options: [{ value: "reply", label: { zh: "回应", en: "reply" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "tenuki",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "alblcldlelamemenboeodpepcqcrer", white: "bmcmdmandncodoapbpcpbqbrbs" },
                marks: { 1: "am", 2: "an", 3: "al" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-6-11",
        chapterId: "beginner-level3",
        order: 385,
        title: { zh: "技巧 · 11/12", en: "Skills · 11/12" },
        instruction: { zh: "白先。你必须回应黑棋的上一手棋吗，还是可以脱先？", en: "White to play. Do you have to reply to Black's last move or can you play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmcndnenaoboeoap", white: "codobpepaqcqeqdr" },
            marks: { 1: "ap", 2: "aq", 3: "ao" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。你必须回应黑棋的上一手棋吗，还是可以脱先？", en: "White to play. Do you have to reply to Black's last move or can you play tenuki?" },
            options: [{ value: "reply", label: { zh: "回应", en: "reply" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "tenuki",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bmcndnenaoboeoap", white: "codobpepaqcqeqdr" },
                marks: { 1: "ap", 2: "aq", 3: "ao" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-6-12",
        chapterId: "beginner-level3",
        order: 386,
        title: { zh: "技巧 · 12/12", en: "Skills · 12/12" },
        instruction: { zh: "白先。你必须回应黑棋的上一手棋吗，还是可以脱先？", en: "White to play. Do you have to reply to Black's last move or can you play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "anbncndnenaoeoepfqgqgr", white: "bocodoapdpcqeqerfr" },
            marks: { 1: "ao", 2: "ap", 3: "an" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。你必须回应黑棋的上一手棋吗，还是可以脱先？", en: "White to play. Do you have to reply to Black's last move or can you play tenuki?" },
            options: [{ value: "reply", label: { zh: "回应", en: "reply" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "reply",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "anbncndnenaoeoepfqgqgr", white: "bocodoapdpcqeqerfr" },
                marks: { 1: "ao", 2: "ap", 3: "an" },
            },
        },
    },
];

const bl3Skills7Levels: Level[] = [
    {
        id: "beginner-level3-bl3-skills-7-1",
        chapterId: "beginner-level3",
        order: 387,
        title: { zh: "技巧 · 1/12", en: "Skills · 1/12" },
        instruction: { zh: "黑先。在A点落子能加强黑棋棋块吗，还是脱先更好？", en: "Black to play. Does playing at A strengthen the black group or is it better to play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcmcnbocpdpeqdrer", white: "bncodoeogoepdqfqfr" },
            marks: { A: "bp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。在A点落子能加强黑棋棋块吗，还是脱先更好？", en: "Black to play. Does playing at A strengthen the black group or is it better to play tenuki?" },
            options: [{ value: "strengthen", label: { zh: "加强", en: "strengthen" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "strengthen",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bmcmcnbocpdpeqdrer", white: "bncodoeogoepdqfqfr" },
                marks: { A: "bp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-7-2",
        chapterId: "beginner-level3",
        order: 388,
        title: { zh: "技巧 · 2/12", en: "Skills · 2/12" },
        instruction: { zh: "黑先。在A点落子能加强黑棋棋块吗，还是脱先更好？", en: "Black to play. Does playing at A strengthen the black group or is it better to play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcmcnbocpdpcqeqdrer", white: "bncodoeogoepfqfr" },
            marks: { A: "bp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。在A点落子能加强黑棋棋块吗，还是脱先更好？", en: "Black to play. Does playing at A strengthen the black group or is it better to play tenuki?" },
            options: [{ value: "strengthen", label: { zh: "加强", en: "strengthen" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "tenuki",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bmcmcnbocpdpcqeqdrer", white: "bncodoeogoepfqfr" },
                marks: { A: "bp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-7-3",
        chapterId: "beginner-level3",
        order: 389,
        title: { zh: "技巧 · 3/12", en: "Skills · 3/12" },
        instruction: { zh: "黑先。在A点落子能加强黑棋棋块吗，还是脱先更好？", en: "Black to play. Does playing at A strengthen the black group or is it better to play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cocpdqeq", white: "cndndodpcq" },
            marks: { A: "bq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。在A点落子能加强黑棋棋块吗，还是脱先更好？", en: "Black to play. Does playing at A strengthen the black group or is it better to play tenuki?" },
            options: [{ value: "strengthen", label: { zh: "加强", en: "strengthen" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "strengthen",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cocpdqeq", white: "cndndodpcq" },
                marks: { A: "bq" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-7-4",
        chapterId: "beginner-level3",
        order: 390,
        title: { zh: "技巧 · 4/12", en: "Skills · 4/12" },
        instruction: { zh: "黑先。在A点落子能加强黑棋棋块吗，还是脱先更好？", en: "Black to play. Does playing at A strengthen the black group or is it better to play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmbocododpcqdqcr", white: "eneobpcpepbqeqer" },
            marks: { A: "br" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。在A点落子能加强黑棋棋块吗，还是脱先更好？", en: "Black to play. Does playing at A strengthen the black group or is it better to play tenuki?" },
            options: [{ value: "strengthen", label: { zh: "加强", en: "strengthen" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "tenuki",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cmbocododpcqdqcr", white: "eneobpcpepbqeqer" },
                marks: { A: "br" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-7-5",
        chapterId: "beginner-level3",
        order: 391,
        title: { zh: "技巧 · 5/12", en: "Skills · 5/12" },
        instruction: { zh: "黑先。在A点落子能加强黑棋棋块吗，还是脱先更好？", en: "Black to play. Does playing at A strengthen the black group or is it better to play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmcncodpdqer", white: "bnbocpcqcrdr" },
            marks: { A: "fq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。在A点落子能加强黑棋棋块吗，还是脱先更好？", en: "Black to play. Does playing at A strengthen the black group or is it better to play tenuki?" },
            options: [{ value: "strengthen", label: { zh: "加强", en: "strengthen" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "strengthen",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cmcncodpdqer", white: "bnbocpcqcrdr" },
                marks: { A: "fq" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-7-6",
        chapterId: "beginner-level3",
        order: 392,
        title: { zh: "技巧 · 6/12", en: "Skills · 6/12" },
        instruction: { zh: "黑先。在A点落子能加强黑棋棋块吗，还是脱先更好？", en: "Black to play. Does playing at A strengthen the black group or is it better to play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cndnbodobpdpdq", white: "bmcmdmbncocp" },
            marks: { A: "cq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。在A点落子能加强黑棋棋块吗，还是脱先更好？", en: "Black to play. Does playing at A strengthen the black group or is it better to play tenuki?" },
            options: [{ value: "strengthen", label: { zh: "加强", en: "strengthen" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "tenuki",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cndnbodobpdpdq", white: "bmcmdmbncocp" },
                marks: { A: "cq" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-7-7",
        chapterId: "beginner-level3",
        order: 393,
        title: { zh: "技巧 · 7/12", en: "Skills · 7/12" },
        instruction: { zh: "黑先。在A点落子能加强黑棋棋块吗，还是脱先更好？", en: "Black to play. Does playing at A strengthen the black group or is it better to play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bncnaodocpdq", white: "ambmcmdman" },
            marks: { A: "bo" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。在A点落子能加强黑棋棋块吗，还是脱先更好？", en: "Black to play. Does playing at A strengthen the black group or is it better to play tenuki?" },
            options: [{ value: "strengthen", label: { zh: "加强", en: "strengthen" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "strengthen",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bncnaodocpdq", white: "ambmcmdman" },
                marks: { A: "bo" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-7-8",
        chapterId: "beginner-level3",
        order: 394,
        title: { zh: "技巧 · 8/12", en: "Skills · 8/12" },
        instruction: { zh: "黑先。在A点落子能加强黑棋棋块吗，还是脱先更好？", en: "Black to play. Does playing at A strengthen the black group or is it better to play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bocododpbqcqcrcs", white: "apbpcpepdqfqdrds" },
            marks: { A: "ao" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。在A点落子能加强黑棋棋块吗，还是脱先更好？", en: "Black to play. Does playing at A strengthen the black group or is it better to play tenuki?" },
            options: [{ value: "strengthen", label: { zh: "加强", en: "strengthen" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "tenuki",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bocododpbqcqcrcs", white: "apbpcpepdqfqdrds" },
                marks: { A: "ao" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-7-9",
        chapterId: "beginner-level3",
        order: 395,
        title: { zh: "技巧 · 9/12", en: "Skills · 9/12" },
        instruction: { zh: "黑先。在A点落子能加强黑棋棋块吗，还是脱先更好？", en: "Black to play. Does playing at A strengthen the black group or is it better to play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmcobpdpcqcr", white: "bqdqeqgq" },
            marks: { A: "br" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。在A点落子能加强黑棋棋块吗，还是脱先更好？", en: "Black to play. Does playing at A strengthen the black group or is it better to play tenuki?" },
            options: [{ value: "strengthen", label: { zh: "加强", en: "strengthen" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "tenuki",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cmcobpdpcqcr", white: "bqdqeqgq" },
                marks: { A: "br" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-7-10",
        chapterId: "beginner-level3",
        order: 396,
        title: { zh: "技巧 · 10/12", en: "Skills · 10/12" },
        instruction: { zh: "黑先。在A点落子能加强黑棋棋块吗，还是脱先更好？", en: "Black to play. Does playing at A strengthen the black group or is it better to play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "blcmcnbobpbq", white: "bmbncocpaqcqbr" },
            marks: { A: "am" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。在A点落子能加强黑棋棋块吗，还是脱先更好？", en: "Black to play. Does playing at A strengthen the black group or is it better to play tenuki?" },
            options: [{ value: "strengthen", label: { zh: "加强", en: "strengthen" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "strengthen",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "blcmcnbobpbq", white: "bmbncocpaqcqbr" },
                marks: { A: "am" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-7-11",
        chapterId: "beginner-level3",
        order: 397,
        title: { zh: "技巧 · 11/12", en: "Skills · 11/12" },
        instruction: { zh: "黑先。在A点落子能加强黑棋棋块吗，还是脱先更好？", en: "Black to play. Does playing at A strengthen the black group or is it better to play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpdpeqer", white: "bmcncq" },
            marks: { A: "cp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。在A点落子能加强黑棋棋块吗，还是脱先更好？", en: "Black to play. Does playing at A strengthen the black group or is it better to play tenuki?" },
            options: [{ value: "strengthen", label: { zh: "加强", en: "strengthen" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "strengthen",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bpdpeqer", white: "bmcncq" },
                marks: { A: "cp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-skills-7-12",
        chapterId: "beginner-level3",
        order: 398,
        title: { zh: "技巧 · 12/12", en: "Skills · 12/12" },
        instruction: { zh: "黑先。在A点落子能加强黑棋棋块吗，还是脱先更好？", en: "Black to play. Does playing at A strengthen the black group or is it better to play tenuki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bocodoeodqdr", white: "focpfp" },
            marks: { A: "dp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。在A点落子能加强黑棋棋块吗，还是脱先更好？", en: "Black to play. Does playing at A strengthen the black group or is it better to play tenuki?" },
            options: [{ value: "strengthen", label: { zh: "加强", en: "strengthen" } }, { value: "tenuki", label: { zh: "脱先", en: "tenuki" } }],
            correctValue: "tenuki",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bocodoeodqdr", white: "focpfp" },
                marks: { A: "dp" },
            },
        },
    },
];

const bl3Endgame1Levels: Level[] = [
    {
        id: "beginner-level3-bl3-endgame-1-1",
        chapterId: "beginner-level3",
        order: 399,
        title: { zh: "收官 · 1/13", en: "Endgame · 1/13" },
        instruction: { zh: "白棋在A点落子可以救活角上的棋子。但这样一来，白棋也能吃掉标记的三颗黑棋。黑棋无法通过连接B点来救活这些棋子，因为这些棋子仍然处于打吃状态（气不足）。黑棋必须先连接C点，然后白棋才能吃掉这三颗棋子。通过在A点落子，白棋获得三目领地和三颗提子，共六目。如果黑棋在A点落子，角上的白棋被吃，黑棋获得三目领地（角部、B点和C点）。所以黑棋有四目。A点的价值是多少？", en: "White can save the stone in the corner by playing at A. But then, White also catches the three marked stones. Black can not save these stones by connecting at B, because the stones would be still in atari (shortage of liberties). Black has to connect at C first and White can capture the three stones. By playing at A, White gets three points of territory and three captured stones, so six points. If Black plays at A, the white stone in the corner is captured and Black gets three points of territory (corner, B and C). So Black has four points. What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "brbscrdsepeqerfogpgr", white: "aqasbqcqdpdqdreneo" },
            marks: { A: "ar", B: "cs", C: "es", triangle: "brbscr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋在A点落子可以救活角上的棋子。但这样一来，白棋也能吃掉标记的三颗黑棋。黑棋无法通过连接B点来救活这些棋子，因为这些棋子仍然处于打吃状态（气不足）。黑棋必须先连接C点，然后白棋才能吃掉这三颗棋子。通过在A点落子，白棋获得三目领地和三颗提子，共六目。如果黑棋在A点落子，角上的白棋被吃，黑棋获得三目领地（角部、B点和C点）。所以黑棋有四目。A点的价值是多少？", en: "White can save the stone in the corner by playing at A. But then, White also catches the three marked stones. Black can not save these stones by connecting at B, because the stones would be still in atari (shortage of liberties). Black has to connect at C first and White can capture the three stones. By playing at A, White gets three points of territory and three captured stones, so six points. If Black plays at A, the white stone in the corner is captured and Black gets three points of territory (corner, B and C). So Black has four points. What is the value of playing at A?" },
            options: [{ value: "4", label: { zh: "4", en: "4" } }, { value: "6", label: { zh: "6", en: "6" } }, { value: "10", label: { zh: "10", en: "10" } }],
            correctValue: "10",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "brbscrdsepeqerfogpgr", white: "aqasbqcqdpdqdreneo" },
                marks: { A: "ar", B: "cs", C: "es", triangle: "brbscr" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-1-2",
        chapterId: "beginner-level3",
        order: 400,
        title: { zh: "收官 · 2/13", en: "Endgame · 2/13" },
        instruction: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "emfnboeoapepbqcqdqdr", white: "gnfofpaqeqgqbrcrerdses" },
            marks: { A: "ar" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }, { value: "5", label: { zh: "5", en: "5" } }],
            correctValue: "4",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "emfnboeoapepbqcqdqdr", white: "gnfofpaqeqgqbrcrerdses" },
                marks: { A: "ar" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-1-3",
        chapterId: "beginner-level3",
        order: 401,
        title: { zh: "收官 · 3/13", en: "Endgame · 3/13" },
        instruction: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "bmdmbndncodobpbqcqdqarbr", white: "enaoboeocpdpepeqcrdrfrcs" },
            marks: { A: "bs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }],
            correctValue: "2",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bmdmbndncodobpbqcqdqarbr", white: "enaoboeocpdpepeqcrdrfrcs" },
                marks: { A: "bs" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-1-4",
        chapterId: "beginner-level3",
        order: 402,
        title: { zh: "收官 · 4/13", en: "Endgame · 4/13" },
        instruction: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "clelcmemdnaobocoap", white: "fmendoeobpcpcqeqgqcrcs" },
            marks: { A: "aq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }, { value: "5", label: { zh: "5", en: "5" } }],
            correctValue: "5",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "clelcmemdnaobocoap", white: "fmendoeobpcpcqeqgqcrcs" },
                marks: { A: "aq" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-1-5",
        chapterId: "beginner-level3",
        order: 403,
        title: { zh: "收官 · 5/13", en: "Endgame · 5/13" },
        instruction: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "cldmbocodoapbqcqarcr", white: "engneobpcpdpepdqdrcsds" },
            marks: { A: "bs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }],
            correctValue: "4",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cldmbocodoapbqcqarcr", white: "engneobpcpdpepdqdrcsds" },
                marks: { A: "bs" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-1-6",
        chapterId: "beginner-level3",
        order: 404,
        title: { zh: "收官 · 6/13", en: "Endgame · 6/13" },
        instruction: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "dpfpgpbqcqdqdrds", white: "cmcncobpcpaqbrcr" },
            marks: { A: "cs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }],
            correctValue: "4",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dpfpgpbqcqdqdrds", white: "cmcncobpcpaqbrcr" },
                marks: { A: "cs" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-1-7",
        chapterId: "beginner-level3",
        order: 405,
        title: { zh: "收官 · 7/13", en: "Endgame · 7/13" },
        instruction: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "clcncoapbpcpaqbr", white: "dogodpbqcqeqcrbs" },
            marks: { A: "ar" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }],
            correctValue: "4",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "clcncoapbpcpaqbr", white: "dogodpbqcqeqcrbs" },
                marks: { A: "ar" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-1-8",
        chapterId: "beginner-level3",
        order: 406,
        title: { zh: "收官 · 8/13", en: "Endgame · 8/13" },
        instruction: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "focqdqeqfqcrfrfs", white: "cmcocpbqbrbsdses" },
            marks: { A: "cs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "2", label: { zh: "2", en: "2" } }, { value: "4", label: { zh: "4", en: "4" } }, { value: "6", label: { zh: "6", en: "6" } }],
            correctValue: "6",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "focqdqeqfqcrfrfs", white: "cmcocpbqbrbsdses" },
                marks: { A: "cs" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-1-9",
        chapterId: "beginner-level3",
        order: 407,
        title: { zh: "收官 · 9/13", en: "Endgame · 9/13" },
        instruction: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "foepgpbqcqeqcrercses", white: "cneneobpcpdpaqbrdrbsds" },
            marks: { A: "dq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "8", label: { zh: "8", en: "8" } }, { value: "12", label: { zh: "12", en: "12" } }, { value: "13", label: { zh: "13", en: "13" } }],
            correctValue: "13",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "foepgpbqcqeqcrercses", white: "cneneobpcpdpaqbrdrbsds" },
                marks: { A: "dq" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-1-10",
        chapterId: "beginner-level3",
        order: 408,
        title: { zh: "收官 · 10/13", en: "Endgame · 10/13" },
        instruction: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "epdqfqgqarbrdrcsds", white: "dmbododpaqbqcqcr" },
            marks: { A: "bs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "5", label: { zh: "5", en: "5" } }, { value: "6", label: { zh: "6", en: "6" } }, { value: "7", label: { zh: "7", en: "7" } }],
            correctValue: "6",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "epdqfqgqarbrdrcsds", white: "dmbododpaqbqcqcr" },
                marks: { A: "bs" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-1-11",
        chapterId: "beginner-level3",
        order: 409,
        title: { zh: "收官 · 11/13", en: "Endgame · 11/13" },
        instruction: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "enfogoapbpcpdpepaqdqbr", white: "fpbqcqeqfqhqcrdrerbs" },
            marks: { A: "ar" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }],
            correctValue: "4",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "enfogoapbpcpdpepaqdqbr", white: "fpbqcqeqfqhqcrdrerbs" },
                marks: { A: "ar" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-1-12",
        chapterId: "beginner-level3",
        order: 410,
        title: { zh: "收官 · 12/13", en: "Endgame · 12/13" },
        instruction: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "elemfmhmengngoepgpeqfqhqeres", white: "bldlcndnfncofodpcqdrds" },
            marks: { A: "eo" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "5", label: { zh: "5", en: "5" } }, { value: "6", label: { zh: "6", en: "6" } }, { value: "7", label: { zh: "7", en: "7" } }],
            correctValue: "5",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "elemfmhmengngoepgpeqfqhqeres", white: "bldlcndnfncofodpcqdrds" },
                marks: { A: "eo" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-1-13",
        chapterId: "beginner-level3",
        order: 411,
        title: { zh: "收官 · 13/13", en: "Endgame · 13/13" },
        instruction: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "fpgpeqbrcrergrdses", white: "dmcoeoepaqbqcqdqdr" },
            marks: { A: "ar" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }, { value: "5", label: { zh: "5", en: "5" } }],
            correctValue: "3",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "fpgpeqbrcrergrdses", white: "dmcoeoepaqbqcqdqdr" },
                marks: { A: "ar" },
            },
        },
    },
];

const bl3Endgame2Levels: Level[] = [
    {
        id: "beginner-level3-bl3-endgame-2-1",
        chapterId: "beginner-level3",
        order: 412,
        title: { zh: "收官 · 1/12", en: "Endgame · 1/12" },
        instruction: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "emcnendoapbpcparbrcrcs", white: "fneodpfpbqcqdqdrds" },
            marks: { A: "aq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "8", label: { zh: "8", en: "8" } }, { value: "10", label: { zh: "10", en: "10" } }, { value: "12", label: { zh: "12", en: "12" } }],
            correctValue: "12",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "emcnendoapbpcparbrcrcs", white: "fneodpfpbqcqdqdrds" },
                marks: { A: "aq" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-2-2",
        chapterId: "beginner-level3",
        order: 413,
        title: { zh: "收官 · 2/12", en: "Endgame · 2/12" },
        instruction: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "eneoepgpfqbrcrerfrds", white: "dmdodpbqcqdqeqardr" },
            marks: { A: "bs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "2", label: { zh: "2", en: "2" } }, { value: "4", label: { zh: "4", en: "4" } }, { value: "6", label: { zh: "6", en: "6" } }],
            correctValue: "6",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "eneoepgpfqbrcrerfrds", white: "dmdodpbqcqdqeqardr" },
                marks: { A: "bs" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-2-3",
        chapterId: "beginner-level3",
        order: 414,
        title: { zh: "收官 · 3/12", en: "Endgame · 3/12" },
        instruction: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "epfphpcqdqgqerfr", white: "cldncpdpbqcrdr" },
            marks: { A: "eq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }, { value: "5", label: { zh: "5", en: "5" } }],
            correctValue: "4",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "epfphpcqdqgqerfr", white: "cldncpdpbqcrdr" },
                marks: { A: "eq" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-2-4",
        chapterId: "beginner-level3",
        order: 415,
        title: { zh: "收官 · 4/12", en: "Endgame · 4/12" },
        instruction: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "eneoepcqdqfqbrdr", white: "dmdnbodocpdpbqarcr" },
            marks: { A: "bs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "5", label: { zh: "5", en: "5" } }, { value: "7", label: { zh: "7", en: "7" } }, { value: "8", label: { zh: "8", en: "8" } }],
            correctValue: "7",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "eneoepcqdqfqbrdr", white: "dmdnbodocpdpbqarcr" },
                marks: { A: "bs" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-2-5",
        chapterId: "beginner-level3",
        order: 416,
        title: { zh: "收官 · 5/12", en: "Endgame · 5/12" },
        instruction: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "bnboeofobpdpaqdqeqgqarbrcr", white: "ambmcmcnenfncodoapcpbqcq" },
            marks: { A: "ao" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "7", label: { zh: "7", en: "7" } }, { value: "8", label: { zh: "8", en: "8" } }, { value: "9", label: { zh: "9", en: "9" } }],
            correctValue: "8",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bnboeofobpdpaqdqeqgqarbrcr", white: "ambmcmcnenfncodoapcpbqcq" },
                marks: { A: "ao" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-2-6",
        chapterId: "beginner-level3",
        order: 417,
        title: { zh: "收官 · 6/12", en: "Endgame · 6/12" },
        instruction: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "dmbndncodoapbpaqcqcrbscs", white: "eneocpdpfpbqdqarbrdrds" },
            marks: { A: "as" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "8", label: { zh: "8", en: "8" } }, { value: "11", label: { zh: "11", en: "11" } }, { value: "14", label: { zh: "14", en: "14" } }],
            correctValue: "14",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dmbndncodoapbpaqcqcrbscs", white: "eneocpdpfpbqdqarbrdrds" },
                marks: { A: "as" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-2-7",
        chapterId: "beginner-level3",
        order: 418,
        title: { zh: "收官 · 7/12", en: "Endgame · 7/12" },
        instruction: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "cmdndoapbpcpcqbrbs", white: "eodpfpaqbqdqarcrercs" },
            marks: { A: "as" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "5", label: { zh: "5", en: "5" } }, { value: "8", label: { zh: "8", en: "8" } }, { value: "10", label: { zh: "10", en: "10" } }],
            correctValue: "10",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cmdndoapbpcpcqbrbs", white: "eodpfpaqbqdqarcrercs" },
                marks: { A: "as" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-2-8",
        chapterId: "beginner-level3",
        order: 419,
        title: { zh: "收官 · 8/12", en: "Endgame · 8/12" },
        instruction: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "bncndnfneocpepgpcqdqerfr", white: "bocodobpdpbqbrcrdr" },
            marks: { A: "eq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "5", label: { zh: "5", en: "5" } }, { value: "6", label: { zh: "6", en: "6" } }, { value: "7", label: { zh: "7", en: "7" } }],
            correctValue: "6",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bncndnfneocpepgpcqdqerfr", white: "bocodobpdpbqbrcrdr" },
                marks: { A: "eq" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-2-9",
        chapterId: "beginner-level3",
        order: 420,
        title: { zh: "收官 · 9/12", en: "Endgame · 9/12" },
        instruction: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "bpdpbqdqfqbrcrdr", white: "dlcmbndnbodocpcq" },
            marks: { A: "co" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }],
            correctValue: "4",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bpdpbqdqfqbrcrdr", white: "dlcmbndnbodocpcq" },
                marks: { A: "co" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-2-10",
        chapterId: "beginner-level3",
        order: 421,
        title: { zh: "收官 · 10/12", en: "Endgame · 10/12" },
        instruction: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "blcldlflamembnenbocoeoepgpfqfrfs", white: "bmcmdmdndoapbpcpdpdqeqbreres" },
            marks: { A: "an" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "7", label: { zh: "7", en: "7" } }, { value: "8", label: { zh: "8", en: "8" } }, { value: "9", label: { zh: "9", en: "9" } }],
            correctValue: "7",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "blcldlflamembnenbocoeoepgpfqfrfs", white: "bmcmdmdndoapbpcpdpdqeqbreres" },
                marks: { A: "an" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-2-11",
        chapterId: "beginner-level3",
        order: 422,
        title: { zh: "收官 · 11/12", en: "Endgame · 11/12" },
        instruction: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "ambmcmfmdnenfogohodpepdq", white: "bncnaocoeocpfpgpcqeqcrdrfr" },
            marks: { A: "do" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "4", label: { zh: "4", en: "4" } }, { value: "6", label: { zh: "6", en: "6" } }, { value: "8", label: { zh: "8", en: "8" } }],
            correctValue: "8",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "ambmcmfmdnenfogohodpepdq", white: "bncnaocoeocpfpgpcqeqcrdrfr" },
                marks: { A: "do" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-2-12",
        chapterId: "beginner-level3",
        order: 423,
        title: { zh: "收官 · 12/12", en: "Endgame · 12/12" },
        instruction: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "gngogpfqhqcrdrfrfs", white: "emcofofpcqdqeqbrerbs" },
            marks: { A: "es" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "1", label: { zh: "1", en: "1" } }, { value: "5", label: { zh: "5", en: "5" } }, { value: "6", label: { zh: "6", en: "6" } }],
            correctValue: "1",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "gngogpfqhqcrdrfrfs", white: "emcofofpcqdqeqbrerbs" },
                marks: { A: "es" },
            },
        },
    },
];

const bl3Endgame3Levels: Level[] = [
    {
        id: "beginner-level3-bl3-endgame-3-1",
        chapterId: "beginner-level3",
        order: 424,
        title: { zh: "收官 · 1/13", en: "Endgame · 1/13" },
        instruction: { zh: "在收官阶段，你可以计算出哪一手是最佳（最大）的。首先，你观察所有还能产生目数的着法。接着，你计算每手的价值，然后选择收益最大的着法。A位值两目，B位值三目。为黑棋选择最大的着法，A或B。", en: "In the endgame you can calculate which is the best (biggest) move. First you look at all moves, that can still yield points. Next you calculate how much each move is worth and then you choose the move that yields most points. The move at A is worth two points and the move at B three points. Choose the biggest move for Black, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "amaobmbscmdndodrdsepeqfrgoipiqir", white: "aparbnbobpbqbrcpcrdpdq" },
            marks: { A: "an", B: "cs" },
            correct: ["cs"],
        },
    },
    {
        id: "beginner-level3-bl3-endgame-3-2",
        chapterId: "beginner-level3",
        order: 425,
        title: { zh: "收官 · 2/13", en: "Endgame · 2/13" },
        instruction: { zh: "黑先。选择最大的着法，A或B。", en: "Black to play. Choose the biggest move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ckclcmdnendofodpcqbrdrdsfs", white: "dlglemfmgneogoepfpdqeqhqerfrgrhs" },
            marks: { A: "fn", B: "es" },
            correct: ["es"],
        },
    },
    {
        id: "beginner-level3-bl3-endgame-3-3",
        chapterId: "beginner-level3",
        order: 426,
        title: { zh: "收官 · 3/13", en: "Endgame · 3/13" },
        instruction: { zh: "黑先。选择最大的着法，A或B。", en: "Black to play. Choose the biggest move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "anbncnendoepfqfrfs", white: "bococpdpaqbqdqcreres" },
            marks: { A: "ao", B: "eq" },
            correct: ["ao"],
        },
    },
    {
        id: "beginner-level3-bl3-endgame-3-4",
        chapterId: "beginner-level3",
        order: 427,
        title: { zh: "收官 · 4/13", en: "Endgame · 4/13" },
        instruction: { zh: "黑先。选择最大的着法，A或B。", en: "Black to play. Choose the biggest move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "flcmfmdnencofocpfpcqarcrdrerbs", white: "gmgneogoepgpeqfqgqfrdsfs" },
            marks: { A: "fn", B: "es" },
            correct: ["fn"],
        },
    },
    {
        id: "beginner-level3-bl3-endgame-3-5",
        chapterId: "beginner-level3",
        order: 428,
        title: { zh: "收官 · 5/13", en: "Endgame · 5/13" },
        instruction: { zh: "黑先。选择最大的着法，A或B。", en: "Black to play. Choose the biggest move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "anbncndnaoeoepgpfqgrgs", white: "bocoapdpbqdqerfrfs" },
            marks: { A: "do", B: "eq" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level3-bl3-endgame-3-6",
        chapterId: "beginner-level3",
        order: 429,
        title: { zh: "收官 · 6/13", en: "Endgame · 6/13" },
        instruction: { zh: "黑先。选择最大的着法，A或B。", en: "Black to play. Choose the biggest move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cldnenfnbodocpepfpbqbrbscs", white: "gmgneofogogpcqdqeqfqhqcrfrfs" },
            marks: { A: "dp", B: "ds" },
            correct: ["dp"],
        },
    },
    {
        id: "beginner-level3-bl3-endgame-3-7",
        chapterId: "beginner-level3",
        order: 430,
        title: { zh: "收官 · 7/13", en: "Endgame · 7/13" },
        instruction: { zh: "黑先。选择最大的着法，A、B或C。", en: "Black to play. Choose the biggest move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "emanbncndnaoeoepgpaqfqfrfs", white: "bocodobpdpbqcqarcrdrercs" },
            marks: { A: "ap", B: "eq", C: "es" },
            correct: ["ap"],
        },
    },
    {
        id: "beginner-level3-bl3-endgame-3-8",
        chapterId: "beginner-level3",
        order: 431,
        title: { zh: "收官 · 8/13", en: "Endgame · 8/13" },
        instruction: { zh: "黑先。选择最大的着法，A或B。", en: "Black to play. Choose the biggest move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "gnhnfohoepgphpcqdqfqbrcrercses", white: "flgmhmimenfninboeoiocpdpipaqbqgqhqiqfrgrhs" },
            marks: { A: "ar", B: "fs" },
            correct: ["ar"],
        },
    },
    {
        id: "beginner-level3-bl3-endgame-3-9",
        chapterId: "beginner-level3",
        order: 432,
        title: { zh: "收官 · 9/13", en: "Endgame · 9/13" },
        instruction: { zh: "黑先。选择最大的着法，A、B或C。", en: "Black to play. Choose the biggest move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "anbncnenaodoepfpdqfqhqgrgs", white: "bococpdpcqarbrcrdrerfrbsds" },
            marks: { A: "ap", B: "eq", C: "fs" },
            correct: ["ap"],
        },
    },
    {
        id: "beginner-level3-bl3-endgame-3-10",
        chapterId: "beginner-level3",
        order: 433,
        title: { zh: "收官 · 10/13", en: "Endgame · 10/13" },
        instruction: { zh: "黑先。选择最大的着法，A或B。", en: "Black to play. Choose the biggest move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ekelbmemcndnbobpcpbqbrbs", white: "glgmenfnfodpepgpcqcrdreres" },
            marks: { A: "do", B: "cs" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level3-bl3-endgame-3-11",
        chapterId: "beginner-level3",
        order: 434,
        title: { zh: "收官 · 11/13", en: "Endgame · 11/13" },
        instruction: { zh: "黑先。选择最大的着法，A、B或C。", en: "Black to play. Choose the biggest move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmanbncodofoapepcqeqfqhqgrgs", white: "bobpdpbqdqarbrcrdrerfrbsds" },
            marks: { A: "ao", B: "cp", C: "fs" },
            correct: ["ao"],
        },
    },
    {
        id: "beginner-level3-bl3-endgame-3-12",
        chapterId: "beginner-level3",
        order: 435,
        title: { zh: "收官 · 12/13", en: "Endgame · 12/13" },
        instruction: { zh: "黑先。选择最大的着法，A或B。", en: "Black to play. Choose the biggest move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eldmemencoeocpdpepcqeqcreres", white: "dkbldlcmbndnbodobpbqbrdrbsds" },
            marks: { A: "cn", B: "cs" },
            correct: ["cs"],
        },
    },
    {
        id: "beginner-level3-bl3-endgame-3-13",
        chapterId: "beginner-level3",
        order: 436,
        title: { zh: "收官 · 13/13", en: "Endgame · 13/13" },
        instruction: { zh: "黑先。选择最大的着法，A或B。", en: "Black to play. Choose the biggest move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dlcmimdneninaocoioapbpipaqiqbrirbsfsgsis", white: "fmhmfnhndoeogocpgpbqcqeqhqcrfrgrhrcses" },
            marks: { A: "ar", B: "hs" },
            correct: ["ar"],
        },
    },
];

const bl3Endgame4Levels: Level[] = [
    {
        id: "beginner-level3-bl3-endgame-4-1",
        chapterId: "beginner-level3",
        order: 437,
        title: { zh: "收官 · 1/12", en: "Endgame · 1/12" },
        instruction: { zh: "黑先。选择最大的着法，A或B。", en: "Black to play. Choose the biggest move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "hmgnhnfodpfpgpdqgqarbrdrerfrhrbsds", white: "flgmdnenfnbodocpepaqbqcqeqcr" },
            marks: { A: "eo", B: "cs" },
            correct: ["cs"],
        },
    },
    {
        id: "beginner-level3-bl3-endgame-4-2",
        chapterId: "beginner-level3",
        order: 438,
        title: { zh: "收官 · 2/12", en: "Endgame · 2/12" },
        instruction: { zh: "黑先。选择最大的着法，A、B或C。", en: "Black to play. Choose the biggest move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dmanbncndoeofohoapgpdqgqgresgs", white: "bococpepfpbqcqfqardrerfrbsds" },
            marks: { A: "ao", B: "dp", C: "fs" },
            correct: ["ao"],
        },
    },
    {
        id: "beginner-level3-bl3-endgame-4-3",
        chapterId: "beginner-level3",
        order: 439,
        title: { zh: "收官 · 3/12", en: "Endgame · 3/12" },
        instruction: { zh: "黑先。选择最大的着法，A或B。", en: "Black to play. Choose the biggest move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fogohoiodpfpcqdqeqgqdrcsds", white: "cnenfngnhninbodocpepbqarbrcr" },
            marks: { A: "eo", B: "bs" },
            correct: ["eo"],
        },
    },
    {
        id: "beginner-level3-bl3-endgame-4-4",
        chapterId: "beginner-level3",
        order: 440,
        title: { zh: "收官 · 4/12", en: "Endgame · 4/12" },
        instruction: { zh: "黑先。选择最大的着法，A或B。", en: "Black to play. Choose the biggest move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "enfngndodpbqcqeqcrcs", white: "blcmdmemfmbnaocobpcpaqarbr" },
            marks: { A: "dn", B: "bs" },
            correct: ["bs"],
        },
    },
    {
        id: "beginner-level3-bl3-endgame-4-5",
        chapterId: "beginner-level3",
        order: 441,
        title: { zh: "收官 · 5/12", en: "Endgame · 5/12" },
        instruction: { zh: "黑先。选择最大的着法，A、B或C。", en: "Black to play. Choose the biggest move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "blcmdmemgmanbnfndoeogoapbpgpgqergrfsgs", white: "cndnbocofocpdpepfpaqbqcqfqarcrfrbscsds" },
            marks: { A: "en", B: "ao", C: "es" },
            correct: ["es"],
        },
    },
    {
        id: "beginner-level3-bl3-endgame-4-6",
        chapterId: "beginner-level3",
        order: 442,
        title: { zh: "收官 · 6/12", en: "Endgame · 6/12" },
        instruction: { zh: "黑先。选择最大的着法，A或B。", en: "Black to play. Choose the biggest move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "coeofogodpdqcreres", white: "bncndnenbocpcqbrbs" },
            marks: { A: "do", B: "cs" },
            correct: ["cs"],
        },
    },
    {
        id: "beginner-level3-bl3-endgame-4-7",
        chapterId: "beginner-level3",
        order: 443,
        title: { zh: "收官 · 7/12", en: "Endgame · 7/12" },
        instruction: { zh: "黑先。选择最大的着法，A或B。", en: "Black to play. Choose the biggest move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bkdkekclhlambmhmanhnbohobphphqergrhresgs", white: "fkdlelflcmgmbncngncogocpgpaqbqcqeqfqgqdrfrds" },
            marks: { A: "ao", B: "fs" },
            correct: ["ao"],
        },
    },
    {
        id: "beginner-level3-bl3-endgame-4-8",
        chapterId: "beginner-level3",
        order: 444,
        title: { zh: "收官 · 8/12", en: "Endgame · 8/12" },
        instruction: { zh: "黑先。选择最大的着法，A或B。", en: "Black to play. Choose the biggest move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cndneofoepeqcrercses", white: "blcmdmembnbocododpbqcqbrdrbs" },
            marks: { A: "en", B: "ds" },
            correct: ["ds"],
        },
    },
    {
        id: "beginner-level3-bl3-endgame-4-9",
        chapterId: "beginner-level3",
        order: 445,
        title: { zh: "收官 · 9/12", en: "Endgame · 9/12" },
        instruction: { zh: "黑先。选择最大的着法，A、B或C。", en: "Black to play. Choose the biggest move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "clambmcndnenaoeogoapcpfpcqgqergresgs", white: "bnbodobpdpaqbqdqeqfqarcrdrfrbscs" },
            marks: { A: "an", B: "co", C: "fs" },
            correct: ["fs"],
        },
    },
    {
        id: "beginner-level3-bl3-endgame-4-10",
        chapterId: "beginner-level3",
        order: 446,
        title: { zh: "收官 · 10/12", en: "Endgame · 10/12" },
        instruction: { zh: "黑先。选择最大的着法，A或B。", en: "Black to play. Choose the biggest move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "gncoeofocpfpeqbrdrfrds", white: "bmemcndnbobpdpepaqbqcqdqcr" },
            marks: { A: "do", B: "cs" },
            correct: ["cs"],
        },
    },
    {
        id: "beginner-level3-bl3-endgame-4-11",
        chapterId: "beginner-level3",
        order: 447,
        title: { zh: "收官 · 11/12", en: "Endgame · 11/12" },
        instruction: { zh: "黑先。选择最大的着法，A或B。", en: "Black to play. Choose the biggest move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "emfmgmdnhnbocoeohobpdpgphpbqcqeqfqgqarcrfrcs", white: "clelfldmanbncninioapipaqhqdrgrirfsgs" },
            marks: { A: "ao", B: "es" },
            correct: ["es"],
        },
    },
    {
        id: "beginner-level3-bl3-endgame-4-12",
        chapterId: "beginner-level3",
        order: 448,
        title: { zh: "收官 · 12/12", en: "Endgame · 12/12" },
        instruction: { zh: "黑先。选择最大的着法，A或B。", en: "Black to play. Choose the biggest move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fngnfocpdpfpeqarbrdrfrcsds", white: "emfmbndnencoeobpaqbqcqdqcr" },
            marks: { A: "ep", B: "bs" },
            correct: ["bs"],
        },
    },
];

const bl3Endgame5Levels: Level[] = [
    {
        id: "beginner-level3-bl3-endgame-5-1",
        chapterId: "beginner-level3",
        order: 449,
        title: { zh: "收官 · 1/14", en: "Endgame · 1/14" },
        instruction: { zh: "先手和后手（保持或失去先手权）是重要概念，在收官中同样如此。如果一手棋能保持先手权，它就是先手：对手必须回应你的着法。当然，回应从来不是强制性的，但如果对手不回应会给自己带来很大麻烦，那么这手棋就是先手。这里，黑棋落子1后，白棋用2挡。接下来，黑棋用3连接棋子，白棋必须用4封住切断。否则，黑棋将侵入角部。黑棋保持先手权，可以在别处落子。对于黑棋来说，落子1是先手还是后手？", en: "Sente and gote (keeping or losing the initiative) are important concepts, also in the endgame. A move is sente if you keep the initiative: your opponent has to respond to your move. Of course, responding is never obligatory, but a move is sente if your opponent would cause himself a lot of trouble, if he would not respond to it. Here, after Black has played 1, White blocks with 2. Next, Black connects his stone with 3 and White has to cover the cut with 4. If not, Black would enter the corner by playing there. Black keeps the initiative and can play somewhere else. Is playing 1 sente or gote for Black?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eqerfpfqgphpiqdses", white: "bmcncodpdqdrepcrcs" },
            marks: { 1: "ds", 2: "cs", 3: "es", 4: "cr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "先手和后手（保持或失去先手权）是重要概念，在收官中同样如此。如果一手棋能保持先手权，它就是先手：对手必须回应你的着法。当然，回应从来不是强制性的，但如果对手不回应会给自己带来很大麻烦，那么这手棋就是先手。这里，黑棋落子1后，白棋用2挡。接下来，黑棋用3连接棋子，白棋必须用4封住切断。否则，黑棋将侵入角部。黑棋保持先手权，可以在别处落子。对于黑棋来说，落子1是先手还是后手？", en: "Sente and gote (keeping or losing the initiative) are important concepts, also in the endgame. A move is sente if you keep the initiative: your opponent has to respond to your move. Of course, responding is never obligatory, but a move is sente if your opponent would cause himself a lot of trouble, if he would not respond to it. Here, after Black has played 1, White blocks with 2. Next, Black connects his stone with 3 and White has to cover the cut with 4. If not, Black would enter the corner by playing there. Black keeps the initiative and can play somewhere else. Is playing 1 sente or gote for Black?" },
            options: [{ value: "sente", label: { zh: "先手", en: "sente" } }, { value: "gote", label: { zh: "后手", en: "gote" } }],
            correctValue: "sente",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "eqerfpfqgphpiqdses", white: "bmcncodpdqdrepcrcs" },
                marks: { 1: "ds", 2: "cs", 3: "es", 4: "cr" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-5-2",
        chapterId: "beginner-level3",
        order: 450,
        title: { zh: "收官 · 2/14", en: "Endgame · 2/14" },
        instruction: { zh: "如果白棋落子1，黑棋会用2挡，白棋必须用3防守棋子。之后，黑棋不必在这里回应，因为他的领地是安全的。对于白棋来说，落子1是先手还是后手？", en: "If White plays 1, Black will block with 2 and White has to defend his stone with 3. After that, Black does not have to respond here, because his territory is safe. Is playing 1 sente or gote for White?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eqerfpfqgphpiqfs", white: "bmcncodpdqdrepesds" },
            marks: { 1: "es", 2: "fs", 3: "ds" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "如果白棋落子1，黑棋会用2挡，白棋必须用3防守棋子。之后，黑棋不必在这里回应，因为他的领地是安全的。对于白棋来说，落子1是先手还是后手？", en: "If White plays 1, Black will block with 2 and White has to defend his stone with 3. After that, Black does not have to respond here, because his territory is safe. Is playing 1 sente or gote for White?" },
            options: [{ value: "sente", label: { zh: "先手", en: "sente" } }, { value: "gote", label: { zh: "后手", en: "gote" } }],
            correctValue: "gote",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "eqerfpfqgphpiqfs", white: "bmcncodpdqdrepesds" },
                marks: { 1: "es", 2: "fs", 3: "ds" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-5-3",
        chapterId: "beginner-level3",
        order: 451,
        title: { zh: "收官 · 3/14", en: "Endgame · 3/14" },
        instruction: { zh: "落子1是先手还是后手？", en: "Is playing 1 sente or gote?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpbqcqarcrbs", white: "aobocoapcpepdqdrds" },
            marks: { 1: "ap" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "落子1是先手还是后手？", en: "Is playing 1 sente or gote?" },
            options: [{ value: "sente", label: { zh: "先手", en: "sente" } }, { value: "gote", label: { zh: "后手", en: "gote" } }],
            correctValue: "gote",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bpbqcqarcrbs", white: "aobocoapcpepdqdrds" },
                marks: { 1: "ap" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-5-4",
        chapterId: "beginner-level3",
        order: 452,
        title: { zh: "收官 · 4/14", en: "Endgame · 4/14" },
        instruction: { zh: "落子1是先手还是后手？", en: "Is playing 1 sente or gote?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eneogofphpfqiqjqerdses", white: "cldmcndocpepdqeqbrdrcs" },
            marks: { 1: "eq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "落子1是先手还是后手？", en: "Is playing 1 sente or gote?" },
            options: [{ value: "sente", label: { zh: "先手", en: "sente" } }, { value: "gote", label: { zh: "后手", en: "gote" } }],
            correctValue: "sente",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "eneogofphpfqiqjqerdses", white: "cldmcndocpepdqeqbrdrcs" },
                marks: { 1: "eq" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-5-5",
        chapterId: "beginner-level3",
        order: 453,
        title: { zh: "收官 · 5/14", en: "Endgame · 5/14" },
        instruction: { zh: "落子1是先手还是后手？", en: "Is playing 1 sente or gote?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpbqcqarcrbs", white: "aobocoapcpepdqgqdrcsds" },
            marks: { 1: "ap" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "落子1是先手还是后手？", en: "Is playing 1 sente or gote?" },
            options: [{ value: "sente", label: { zh: "先手", en: "sente" } }, { value: "gote", label: { zh: "后手", en: "gote" } }],
            correctValue: "sente",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bpbqcqarcrbs", white: "aobocoapcpepdqgqdrcsds" },
                marks: { 1: "ap" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-5-6",
        chapterId: "beginner-level3",
        order: 454,
        title: { zh: "收官 · 6/14", en: "Endgame · 6/14" },
        instruction: { zh: "落子1是先手还是后手？", en: "Is playing 1 sente or gote?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clcmdnbocodoapbqcqbr", white: "eobpcpdpfpdqfqhqiqcrdrbs" },
            marks: { 1: "bs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "落子1是先手还是后手？", en: "Is playing 1 sente or gote?" },
            options: [{ value: "sente", label: { zh: "先手", en: "sente" } }, { value: "gote", label: { zh: "后手", en: "gote" } }],
            correctValue: "sente",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "clcmdnbocodoapbqcqbr", white: "eobpcpdpfpdqfqhqiqcrdrbs" },
                marks: { 1: "bs" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-5-7",
        chapterId: "beginner-level3",
        order: 455,
        title: { zh: "收官 · 7/14", en: "Endgame · 7/14" },
        instruction: { zh: "落子1是先手还是后手？", en: "Is playing 1 sente or gote?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "blbmcncobpcpcqcr", white: "dodpfpdqgqhqiqdrcs" },
            marks: { 1: "cs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "落子1是先手还是后手？", en: "Is playing 1 sente or gote?" },
            options: [{ value: "sente", label: { zh: "先手", en: "sente" } }, { value: "gote", label: { zh: "后手", en: "gote" } }],
            correctValue: "sente",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "blbmcncobpcpcqcr", white: "dodpfpdqgqhqiqdrcs" },
                marks: { 1: "cs" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-5-8",
        chapterId: "beginner-level3",
        order: 456,
        title: { zh: "收官 · 8/14", en: "Endgame · 8/14" },
        instruction: { zh: "落子1是先手还是后手？", en: "Is playing 1 sente or gote?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrcrdrerfrds", white: "clcmcnbobqcqdqeqfqhqiqgrfs" },
            marks: { 1: "fs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "落子1是先手还是后手？", en: "Is playing 1 sente or gote?" },
            options: [{ value: "sente", label: { zh: "先手", en: "sente" } }, { value: "gote", label: { zh: "后手", en: "gote" } }],
            correctValue: "sente",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "arbrcrdrerfrds", white: "clcmcnbobqcqdqeqfqhqiqgrfs" },
                marks: { 1: "fs" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-5-9",
        chapterId: "beginner-level3",
        order: 457,
        title: { zh: "收官 · 9/14", en: "Endgame · 9/14" },
        instruction: { zh: "落子1是先手还是后手？", en: "Is playing 1 sente or gote?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ambmbncncpbqcqcrcs", white: "alblclcmdmdncobpdpdqgqhqiqdrfr" },
            marks: { 1: "co" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "落子1是先手还是后手？", en: "Is playing 1 sente or gote?" },
            options: [{ value: "sente", label: { zh: "先手", en: "sente" } }, { value: "gote", label: { zh: "后手", en: "gote" } }],
            correctValue: "gote",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "ambmbncncpbqcqcrcs", white: "alblclcmdmdncobpdpdqgqhqiqdrfr" },
                marks: { 1: "co" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-5-10",
        chapterId: "beginner-level3",
        order: 458,
        title: { zh: "收官 · 10/14", en: "Endgame · 10/14" },
        instruction: { zh: "落子1是先手还是后手？", en: "Is playing 1 sente or gote?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcpdpdqcrerfrgrgs", white: "cldmbocodofoapepeqfqgqiqhr" },
            marks: { 1: "ap" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "落子1是先手还是后手？", en: "Is playing 1 sente or gote?" },
            options: [{ value: "sente", label: { zh: "先手", en: "sente" } }, { value: "gote", label: { zh: "后手", en: "gote" } }],
            correctValue: "sente",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bpcpdpdqcrerfrgrgs", white: "cldmbocodofoapepeqfqgqiqhr" },
                marks: { 1: "ap" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-5-11",
        chapterId: "beginner-level3",
        order: 459,
        title: { zh: "收官 · 11/14", en: "Endgame · 11/14" },
        instruction: { zh: "落子1是先手还是后手？", en: "Is playing 1 sente or gote?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "blcldmbndnbococpcqarcr", white: "endofodpgphpdqiqdrcs" },
            marks: { 1: "cs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "落子1是先手还是后手？", en: "Is playing 1 sente or gote?" },
            options: [{ value: "sente", label: { zh: "先手", en: "sente" } }, { value: "gote", label: { zh: "后手", en: "gote" } }],
            correctValue: "gote",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "blcldmbndnbococpcqarcr", white: "endofodpgphpdqiqdrcs" },
                marks: { 1: "cs" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-5-12",
        chapterId: "beginner-level3",
        order: 460,
        title: { zh: "收官 · 12/14", en: "Endgame · 12/14" },
        instruction: { zh: "落子1是先手还是后手？", en: "Is playing 1 sente or gote?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "epgpdqfqhqiqbrcrdrfr", white: "clcmcndodpbqcqeqarerbs" },
            marks: { 1: "bs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "落子1是先手还是后手？", en: "Is playing 1 sente or gote?" },
            options: [{ value: "sente", label: { zh: "先手", en: "sente" } }, { value: "gote", label: { zh: "后手", en: "gote" } }],
            correctValue: "gote",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "epgpdqfqhqiqbrcrdrfr", white: "clcmcndodpbqcqeqarerbs" },
                marks: { 1: "bs" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-5-13",
        chapterId: "beginner-level3",
        order: 461,
        title: { zh: "收官 · 13/14", en: "Endgame · 13/14" },
        instruction: { zh: "落子1是先手还是后手？", en: "Is playing 1 sente or gote?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncncocpbqbrcrdreres", white: "bmcmandndodpcqdqeqgqfr" },
            marks: { 1: "an" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "落子1是先手还是后手？", en: "Is playing 1 sente or gote?" },
            options: [{ value: "sente", label: { zh: "先手", en: "sente" } }, { value: "gote", label: { zh: "后手", en: "gote" } }],
            correctValue: "sente",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bncncocpbqbrcrdreres", white: "bmcmandndodpcqdqeqgqfr" },
                marks: { 1: "an" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-endgame-5-14",
        chapterId: "beginner-level3",
        order: 462,
        title: { zh: "收官 · 14/14", en: "Endgame · 14/14" },
        instruction: { zh: "落子1是先手还是后手？", en: "Is playing 1 sente or gote?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cobpcpdpbqeqfqdrfrfs", white: "bncnenbodoapepfphpcqgqgrir" },
            marks: { 1: "ap" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "落子1是先手还是后手？", en: "Is playing 1 sente or gote?" },
            options: [{ value: "sente", label: { zh: "先手", en: "sente" } }, { value: "gote", label: { zh: "后手", en: "gote" } }],
            correctValue: "gote",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cobpcpdpbqeqfqdrfrfs", white: "bncnenbodoapepfphpcqgqgrir" },
                marks: { 1: "ap" },
            },
        },
    },
];

const bl3FalseEye1Levels: Level[] = [
    {
        id: "beginner-level3-bl3-false-eye-1-1",
        chapterId: "beginner-level3",
        order: 463,
        title: { zh: "假眼 · 1/12", en: "False Eye · 1/12" },
        instruction: { zh: "白先。制造一个假眼。", en: "White to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dnenbocoeofodpbqcq", white: "flcmdmfmbncngngogpdqbrcrdrgr" },
            correct: ["ep"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-1-2",
        chapterId: "beginner-level3",
        order: 464,
        title: { zh: "假眼 · 2/12", en: "False Eye · 2/12" },
        instruction: { zh: "白先。制造一个假眼。", en: "White to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aobodoeoapcpfpbqdqeqfqar", white: "bncndnenfngocqgqhqbrcrdrerfr" },
            correct: ["co"],
            wrong: ["dpco"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-1-3",
        chapterId: "beginner-level3",
        order: 465,
        title: { zh: "假眼 · 3/12", en: "False Eye · 3/12" },
        instruction: { zh: "白先。制造一个假眼。", en: "White to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbpaqbrcrascs", white: "cnbocpcqdqdrfr" },
            correct: ["bq"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-1-4",
        chapterId: "beginner-level3",
        order: 466,
        title: { zh: "假眼 · 4/12", en: "False Eye · 4/12" },
        instruction: { zh: "白先。制造一个假眼。", en: "White to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aobocoeofogobpdpgpaqbqcqeqfq", white: "bncndnenfngnindoipdqiqbrcrdrerfrgr" },
            correct: ["ep"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-1-5",
        chapterId: "beginner-level3",
        order: 467,
        title: { zh: "假眼 · 5/12", en: "False Eye · 5/12" },
        instruction: { zh: "白先。制造一个假眼。", en: "White to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocodoapcpbqbrbs", white: "clemanbncngndpepcqcrfrdneo" },
            correct: ["ao", "aqarao"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-1-6",
        chapterId: "beginner-level3",
        order: 468,
        title: { zh: "假眼 · 6/12", en: "False Eye · 6/12" },
        instruction: { zh: "白先。制造一个假眼。", en: "White to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dodpcqeqfqgqcrdrgrcsgs", white: "cndnfnbogocpgphpbqhqbrhres" },
            correct: ["ep"],
            wrong: ["erep"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-1-7",
        chapterId: "beginner-level3",
        order: 469,
        title: { zh: "假眼 · 7/12", en: "False Eye · 7/12" },
        instruction: { zh: "白先。制造一个假眼。", en: "White to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbpbqbrdrerascses", white: "bocoeocpepcqfqfrhr" },
            correct: ["cr"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-1-8",
        chapterId: "beginner-level3",
        order: 470,
        title: { zh: "假眼 · 8/12", en: "False Eye · 8/12" },
        instruction: { zh: "白先。制造一个假眼。", en: "White to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fqgqarbrdrergrcsesgs", white: "hofpgpbqcqdqeqhqcrhr" },
            correct: ["bs"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-1-9",
        chapterId: "beginner-level3",
        order: 471,
        title: { zh: "假眼 · 9/12", en: "False Eye · 9/12" },
        instruction: { zh: "白先。制造一个假眼。", en: "White to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dnenfncoeogohocpdpfphpfqgq", white: "flbmdmemgmcngninboioipbqdqeqhqcrfrgrir" },
            correct: ["ep"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-1-10",
        chapterId: "beginner-level3",
        order: 472,
        title: { zh: "假眼 · 10/12", en: "False Eye · 10/12" },
        instruction: { zh: "白先。制造一个假眼。", en: "White to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "doeodpcqeqarbrcrdrerdsfs", white: "cndnenfnhnbpcpfpbqfqhqfrhrbs" },
            correct: ["ep"],
            wrong: ["gsep"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-1-11",
        chapterId: "beginner-level3",
        order: 473,
        title: { zh: "假眼 · 11/12", en: "False Eye · 11/12" },
        instruction: { zh: "白先。制造一个假眼。", en: "White to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbpbqbrdrercses", white: "bodocpcqeqfqfr" },
            correct: ["crarbs"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-1-12",
        chapterId: "beginner-level3",
        order: 474,
        title: { zh: "假眼 · 12/12", en: "False Eye · 12/12" },
        instruction: { zh: "白先。制造一个假眼。", en: "White to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncnaodoeofobpcpaqbq", white: "bmcmemgmdngodpepfpgpcqbrdr" },
            correct: ["co"],
        },
    },
];

const bl3FalseEye2Levels: Level[] = [
    {
        id: "beginner-level3-bl3-false-eye-2-1",
        chapterId: "beginner-level3",
        order: 475,
        title: { zh: "假眼 · 1/13", en: "False Eye · 1/13" },
        instruction: { zh: "有时你可以通过扑来使眼变成假眼。在此例中，白棋需要扑两次来使黑棋的眼变成假眼。首先，白棋在A位扑，黑棋吃掉白棋两子后，白棋可以再次扑。通过两次扑来使黑棋的眼变成假眼。", en: "You can sometimes make an eye false by trowing in. In this example, White needs to throw in twice to make the black eye false. First, White throws in at A and after Black has captured the two white stones, White can throw in again. Make the black eye false by throwing in twice." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrbscrdrerfs", white: "bpbqdqeqfpfrgres" },
            marks: { A: "ds" },
            correct: ["dscsesds"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-2-2",
        chapterId: "beginner-level3",
        order: 476,
        title: { zh: "假眼 · 2/13", en: "False Eye · 2/13" },
        instruction: { zh: "黑先。通过两次扑来制造一个假眼。", en: "Black to play. Make a false eye by throwing in twice." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dnbocodpephpcqfqgqcrhrires", white: "bpaqbqbrdrerfrgrascsgs" },
            correct: ["dsfsds"],
            wrong: ["fsds"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-2-3",
        chapterId: "beginner-level3",
        order: 477,
        title: { zh: "假眼 · 3/13", en: "False Eye · 3/13" },
        instruction: { zh: "黑先。通过两次扑来制造一个假眼。", en: "Black to play. Make a false eye by throwing in twice." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpfpcqdqeqfrgres", white: "arbrcrdrerbsfs" },
            correct: ["dscses"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-2-4",
        chapterId: "beginner-level3",
        order: 478,
        title: { zh: "假眼 · 4/13", en: "False Eye · 4/13" },
        instruction: { zh: "黑先。通过两次扑来制造一个假眼。", en: "Black to play. Make a false eye by throwing in twice." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bldlcmdnaodocpepbqcqdrfr", white: "anbncncobpaqarbrcrcs" },
            correct: ["apboap"],
            wrong: ["boap"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-2-5",
        chapterId: "beginner-level3",
        order: 479,
        title: { zh: "假眼 · 5/13", en: "False Eye · 5/13" },
        instruction: { zh: "黑先。通过两次扑来制造一个假眼。", en: "Black to play. Make a false eye by throwing in twice." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cnbohocpepfpgpcqdqhqcrhrasfs", white: "bpaqbqeqfqgqbrdrergrcsdsgs" },
            correct: ["bsarbs"],
            wrong: ["arbs", "esbs", "frbs"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-2-6",
        chapterId: "beginner-level3",
        order: 480,
        title: { zh: "假眼 · 6/13", en: "False Eye · 6/13" },
        instruction: { zh: "黑先。通过两次扑来制造一个假眼。", en: "Black to play. Make a false eye by throwing in twice." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmbocoeogodpcqfqhqdrerfr", white: "apbpcpdqeqarbrcrcs" },
            correct: ["bqaqcq"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-2-7",
        chapterId: "beginner-level3",
        order: 481,
        title: { zh: "假眼 · 7/13", en: "False Eye · 7/13" },
        instruction: { zh: "黑先。通过两次扑来制造一个假眼。", en: "Black to play. Make a false eye by throwing in twice." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "codoeogobpfpbqeqgqhqbrcrhr", white: "dpepcqfqdrfrgresgs" },
            correct: ["dqerdqeqcp"],
            wrong: ["erdq"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-2-8",
        chapterId: "beginner-level3",
        order: 482,
        title: { zh: "假眼 · 8/13", en: "False Eye · 8/13" },
        instruction: { zh: "黑先。通过两次扑来制造一个假眼。", en: "Black to play. Make a false eye by throwing in twice." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "clbmfmcndnengnhndoiofpipdqiqbrcrdrergrhr", white: "bocoeofogoapcpdphpbqcqeqfqgqhq" },
            correct: ["epgpep"],
            wrong: ["gpep"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-2-9",
        chapterId: "beginner-level3",
        order: 483,
        title: { zh: "假眼 · 9/13", en: "False Eye · 9/13" },
        instruction: { zh: "黑先。通过两次扑来制造一个假眼。", en: "Black to play. Make a false eye by throwing in twice." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "blglcmdmfmbngngohobpepbqcqdqfqgqhqbrhres", white: "dnenfncofocpdpfpeqcrdrerfrgrcsgs" },
            correct: ["eodoep"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-2-10",
        chapterId: "beginner-level3",
        order: 484,
        title: { zh: "假眼 · 10/13", en: "False Eye · 10/13" },
        instruction: { zh: "黑先。通过两次扑来制造一个假眼。", en: "Black to play. Make a false eye by throwing in twice." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bldlbncndoapdpepeqfrbs", white: "amanbobpbqcqdqardrds" },
            correct: ["aoaqao"],
            wrong: ["aqao"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-2-11",
        chapterId: "beginner-level3",
        order: 485,
        title: { zh: "假眼 · 11/13", en: "False Eye · 11/13" },
        instruction: { zh: "黑先。通过两次扑来制造一个假眼。", en: "Black to play. Make a false eye by throwing in twice." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eobpfpgpipbqdqeqhqdrhrbs", white: "fqgqarbrcrergrdsesgs" },
            correct: ["csascs"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-2-12",
        chapterId: "beginner-level3",
        order: 486,
        title: { zh: "假眼 · 12/13", en: "False Eye · 12/13" },
        instruction: { zh: "黑先。通过两次扑来制造一个假眼。", en: "Black to play. Make a false eye by throwing in twice." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cldlelflbmbngnfobpcpepfphpbqdqbrgr", white: "dmemcnencodoeodpcqeqcrercses" },
            correct: ["drdsdq"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-2-13",
        chapterId: "beginner-level3",
        order: 487,
        title: { zh: "假眼 · 13/13", en: "False Eye · 13/13" },
        instruction: { zh: "黑先。通过两次扑来制造一个假眼。", en: "Black to play. Make a false eye by throwing in twice." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmbncoeocpaqeqcrdrfr", white: "aobobpcqdqarbrbs" },
            correct: ["bqapbq"],
        },
    },
];

const bl3FalseEye3Levels: Level[] = [
    {
        id: "beginner-level3-bl3-false-eye-3-1",
        chapterId: "beginner-level3",
        order: 488,
        title: { zh: "假眼 · 1/13", en: "False Eye · 1/13" },
        instruction: { zh: "你也可以利用气的不足来使眼变成假眼。在此例中，黑棋看起来有两个眼。但如果白棋在A位落子，黑棋不能在B位落子，因为黑棋三子将处于打吃状态。存在气的不足。白先。利用气的不足来制造一个假眼。", en: "You can also make an eye false by using a shortage of liberties. In this example, it looks like Black has two eyes. But if White plays at A, Black can not play at B, because the three black stones would be in atari. There is a shortage of liberties. White to play. Make a false eye by using a shortage of liberties." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbqbrbscqdrer", white: "bpcpdqeqfpfrfs" },
            marks: { A: "ds", B: "es" },
            correct: ["dscses"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-3-2",
        chapterId: "beginner-level3",
        order: 489,
        title: { zh: "假眼 · 2/13", en: "False Eye · 2/13" },
        instruction: { zh: "白先。利用气的不足来制造一个假眼。", en: "White to play. Make a false eye by using a shortage of liberties." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpepfpdqfqcrercs", white: "bodoeofohocpgpcqgqbrgrgs" },
            correct: ["es"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-3-3",
        chapterId: "beginner-level3",
        order: 490,
        title: { zh: "假眼 · 3/13", en: "False Eye · 3/13" },
        instruction: { zh: "白先。利用气的不足来制造一个假眼。", en: "White to play. Make a false eye by using a shortage of liberties." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcpaqcqbrbs", white: "dmbocodpdqarcrer" },
            correct: ["ao"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-3-4",
        chapterId: "beginner-level3",
        order: 491,
        title: { zh: "假眼 · 4/13", en: "False Eye · 4/13" },
        instruction: { zh: "白先。利用气的不足来制造一个假眼。", en: "White to play. Make a false eye by using a shortage of liberties." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqdqarbrdrcs", white: "bpcpdpfpeqerbses" },
            correct: ["bq"],
            wrong: ["dsbq"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-3-5",
        chapterId: "beginner-level3",
        order: 492,
        title: { zh: "假眼 · 5/13", en: "False Eye · 5/13" },
        instruction: { zh: "白先。利用气的不足来制造一个假眼。", en: "White to play. Make a false eye by using a shortage of liberties." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcpbqdqcrdrbsds", white: "bocoeoapdpeqbrer" },
            correct: ["ar"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-3-6",
        chapterId: "beginner-level3",
        order: 493,
        title: { zh: "假眼 · 6/13", en: "False Eye · 6/13" },
        instruction: { zh: "白先。利用气的不足来制造一个假眼。", en: "White to play. Make a false eye by using a shortage of liberties." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbqcqbrdrerfrbs", white: "bnbpcpgpdqeqfqgrfsgs" },
            correct: ["ds"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-3-7",
        chapterId: "beginner-level3",
        order: 494,
        title: { zh: "假眼 · 7/13", en: "False Eye · 7/13" },
        instruction: { zh: "白先。利用气的不足来制造一个假眼。", en: "White to play. Make a false eye by using a shortage of liberties." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpdpepfpcqeqgqdrerdsfs", white: "embncoeofohobpgpbqhqbrcrhrgs" },
            correct: ["fr"],
            wrong: ["grfr"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-3-8",
        chapterId: "beginner-level3",
        order: 495,
        title: { zh: "假眼 · 8/13", en: "False Eye · 8/13" },
        instruction: { zh: "白先。利用气的不足来制造一个假眼。", en: "White to play. Make a false eye by using a shortage of liberties." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqdqeqarbrdrfres", white: "bocpdpepgpbqfqgrbscsds" },
            correct: ["gs"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-3-9",
        chapterId: "beginner-level3",
        order: 496,
        title: { zh: "假眼 · 9/13", en: "False Eye · 9/13" },
        instruction: { zh: "白先。利用气的不足来制造一个假眼。", en: "White to play. Make a false eye by using a shortage of liberties." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbqcqbrdrercs", white: "bpcpfpdqeqfrasbses" },
            correct: ["fsards"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-3-10",
        chapterId: "beginner-level3",
        order: 497,
        title: { zh: "假眼 · 10/13", en: "False Eye · 10/13" },
        instruction: { zh: "白先。利用气的不足来制造一个假眼。", en: "White to play. Make a false eye by using a shortage of liberties." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncndnencoeoapbpdpepbq", white: "alblelcmemgmfohocpfpcqdqeqarbrfr" },
            correct: ["anaoam"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-3-11",
        chapterId: "beginner-level3",
        order: 498,
        title: { zh: "假眼 · 11/13", en: "False Eye · 11/13" },
        instruction: { zh: "白先。利用气的不足来制造一个假眼。", en: "White to play. Make a false eye by using a shortage of liberties." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fpgpdqeqgqarbrcrfrgrcs", white: "bndofogobpcpephpbqhqhresgs" },
            correct: ["er"],
            wrong: ["drer"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-3-12",
        chapterId: "beginner-level3",
        order: 499,
        title: { zh: "假眼 · 12/13", en: "False Eye · 12/13" },
        instruction: { zh: "白先。利用气的不足来制造一个假眼。", en: "White to play. Make a false eye by using a shortage of liberties." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpbqcqarbrdrcs", white: "boeoapcpdpeqerbses" },
            correct: ["dqasds"],
            wrong: ["dsdq"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-3-13",
        chapterId: "beginner-level3",
        order: 500,
        title: { zh: "假眼 · 13/13", en: "False Eye · 13/13" },
        instruction: { zh: "白先。利用气的不足来制造一个假眼。", en: "White to play. Make a false eye by using a shortage of liberties." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbpcpdpbqdqarcrds", white: "bmbocodofoepdrergrbses" },
            correct: ["br"],
            wrong: ["csbr"],
        },
    },
];

const bl3FalseEye4Levels: Level[] = [
    {
        id: "beginner-level3-bl3-false-eye-4-1",
        chapterId: "beginner-level3",
        order: 501,
        title: { zh: "假眼 · 1/21", en: "False Eye · 1/21" },
        instruction: { zh: "黑先。制造一个假眼。", en: "Black to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmbocpdpepfpcqhqdrfras", white: "aqbqdqeqbrcrercs" },
            correct: ["es"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-4-2",
        chapterId: "beginner-level3",
        order: 502,
        title: { zh: "假眼 · 2/21", en: "False Eye · 2/21" },
        instruction: { zh: "黑先。制造一个假眼。", en: "Black to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eobpcpdqeqcrfr", white: "bqcqarbrdr" },
            correct: ["dscses"],
            wrong: ["csbs"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-4-3",
        chapterId: "beginner-level3",
        order: 503,
        title: { zh: "假眼 · 3/21", en: "False Eye · 3/21" },
        instruction: { zh: "黑先。制造一个假眼。", en: "Black to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eobpcpdqeqfqcrgrfs", white: "bqcqarbrdrerbs" },
            correct: ["dscses"],
            wrong: ["esds"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-4-4",
        chapterId: "beginner-level3",
        order: 504,
        title: { zh: "假眼 · 4/21", en: "False Eye · 4/21" },
        instruction: { zh: "黑先。制造一个假眼。", en: "Black to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fmbncndnboeofodpfphpgqarbrgres", white: "codocpepeqfqcrdrfrcsfs" },
            correct: ["cqbpapdqbq", "cqbpbqapdq"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-4-5",
        chapterId: "beginner-level3",
        order: 505,
        title: { zh: "假眼 · 5/21", en: "False Eye · 5/21" },
        instruction: { zh: "黑先。制造一个假眼。", en: "Black to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "coeohocpepgpbqeqhqbrdrhrfs", white: "dpcqdqfqgqcrergrgs" },
            correct: ["csdsbs"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-4-6",
        chapterId: "beginner-level3",
        order: 506,
        title: { zh: "假眼 · 6/21", en: "False Eye · 6/21" },
        instruction: { zh: "黑先。制造一个假眼。", en: "Black to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmfmcndnenbofobpfpaqcqfqargr", white: "coeocpepbqbrcrdrerbses" },
            correct: ["dpdqdo"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-4-7",
        chapterId: "beginner-level3",
        order: 507,
        title: { zh: "假眼 · 7/21", en: "False Eye · 7/21" },
        instruction: { zh: "黑先。制造一个假眼。", en: "Black to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmdmembngncobpdpgpbqgqbrhrds", white: "dndocpfpcqdqeqcrerfrcsfs" },
            correct: ["eo"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-4-8",
        chapterId: "beginner-level3",
        order: 508,
        title: { zh: "假眼 · 8/21", en: "False Eye · 8/21" },
        instruction: { zh: "黑先。制造一个假眼。", en: "Black to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cofoiocpepbqfqgqiqbrerircsgs", white: "cqdqeqcrfrgrhreshs" },
            correct: ["dsdrbs"],
            wrong: ["drds"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-4-9",
        chapterId: "beginner-level3",
        order: 509,
        title: { zh: "假眼 · 9/21", en: "False Eye · 9/21" },
        instruction: { zh: "黑先。制造一个假眼。", en: "Black to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dlbmcmdneodpcqeqerds", white: "bncnaocoapbpcpdqcrdr" },
            correct: ["br"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-4-10",
        chapterId: "beginner-level3",
        order: 510,
        title: { zh: "假眼 · 10/21", en: "False Eye · 10/21" },
        instruction: { zh: "黑先。制造一个假眼。", en: "Black to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bogocpdpepbqfqhqgresgs", white: "cqarbrcrerfrcsfs" },
            correct: ["drdsdq"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-4-11",
        chapterId: "beginner-level3",
        order: 511,
        title: { zh: "假眼 · 11/21", en: "False Eye · 11/21" },
        instruction: { zh: "黑先。制造一个假眼。", en: "Black to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcndnbofobpfpaqcqfqarfr", white: "cocpepbqeqbrcrdrbsds" },
            correct: ["dpdqdo"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-4-12",
        chapterId: "beginner-level3",
        order: 512,
        title: { zh: "假眼 · 12/21", en: "False Eye · 12/21" },
        instruction: { zh: "黑先。制造一个假眼。", en: "Black to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "enbocoapdpepfpgpcqgqfr", white: "bpcpbqdqeqfqarbr" },
            correct: ["drcrer"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-4-13",
        chapterId: "beginner-level3",
        order: 513,
        title: { zh: "假眼 · 13/21", en: "False Eye · 13/21" },
        instruction: { zh: "白先。制造一个假眼。", en: "White to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbqcqcrdrerbsfs", white: "bnbpcpfpdqeqarfrgrds" },
            correct: ["escses"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-4-14",
        chapterId: "beginner-level3",
        order: 514,
        title: { zh: "假眼 · 14/21", en: "False Eye · 14/21" },
        instruction: { zh: "白先。制造一个假眼。", en: "White to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcpdpdqbrcrerfrbsds", white: "gnaobocodoepaqbqeqgqargrfs" },
            correct: ["cq", "gsescq"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-4-15",
        chapterId: "beginner-level3",
        order: 515,
        title: { zh: "假眼 · 15/21", en: "False Eye · 15/21" },
        instruction: { zh: "白先。制造一个假眼。", en: "White to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocodobpepcqdqeqdrfrfsgs", white: "fmbncndnaogoapbqfqgqbrgrhrbshs" },
            correct: ["ds"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-4-16",
        chapterId: "beginner-level3",
        order: 516,
        title: { zh: "假眼 · 16/21", en: "False Eye · 16/21" },
        instruction: { zh: "白先。制造一个假眼。", en: "White to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cnbococpaqbqbrcrdrds", white: "flbmcmdmbnfobpdpcqdqfqerasbs" },
            correct: ["aoapan"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-4-17",
        chapterId: "beginner-level3",
        order: 517,
        title: { zh: "假眼 · 17/21", en: "False Eye · 17/21" },
        instruction: { zh: "白先。制造一个假眼。", en: "White to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bnbococpbqbrcrbs", white: "dlambmcmcndneobpdpcqdqardr" },
            correct: ["aoapan"],
            wrong: ["anao"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-4-18",
        chapterId: "beginner-level3",
        order: 518,
        title: { zh: "假眼 · 18/21", en: "False Eye · 18/21" },
        instruction: { zh: "白先。制造一个假眼。", en: "White to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqdqeqfqbrdrfrcsfs", white: "bogocpepfpaqbqgqargrdses" },
            correct: ["as"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-4-19",
        chapterId: "beginner-level3",
        order: 519,
        title: { zh: "假眼 · 19/21", en: "False Eye · 19/21" },
        instruction: { zh: "白先。制造一个假眼。", en: "White to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dodpepfpaqbqcqdqfqcrerbs", white: "dnengnbocofogpgqarfrhrdsfs" },
            correct: ["dr"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-4-20",
        chapterId: "beginner-level3",
        order: 520,
        title: { zh: "假眼 · 20/21", en: "False Eye · 20/21" },
        instruction: { zh: "白先。制造一个假眼。", en: "White to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcqeqfqbrdrfrcsfs", white: "eofoapbpcpdpgpaqdqgqarhrdses" },
            correct: ["aserbs"],
            wrong: ["bsas"],
        },
    },
    {
        id: "beginner-level3-bl3-false-eye-4-21",
        chapterId: "beginner-level3",
        order: 521,
        title: { zh: "假眼 · 21/21", en: "False Eye · 21/21" },
        instruction: { zh: "白先。制造一个假眼。", en: "White to play. Make a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpepfpcqdqfqbrdrerbs", white: "bodoeofocpgpbqgqarcrfrgrfs" },
            correct: ["dscses"],
        },
    },
];

const bl3LifeDeath1Levels: Level[] = [
    {
        id: "beginner-level3-bl3-life-death-1-1",
        chapterId: "beginner-level3",
        order: 522,
        title: { zh: "死活 · 1/10", en: "Life&Death · 1/10" },
        instruction: { zh: "在死活局面中，下在要点很重要。但有时你必须先扩大眼位才能活棋。同样，你可以通过先缩小眼位来吃掉一块棋。在此，黑棋可以通过在A位落子来扩大眼位。然而，如果黑棋先下在B或C这两个要点之一，黑棋棋块将死亡。黑先。在B或C位落子看看会发生什么，然后先扩大眼位使黑棋棋块活棋。", en: "In situations of life and death, it is important to play at the vital point. But sometimes you first have to increase your eye space in order to live. And you can capture a group by first reducing the eye space. Here, Black can increase the eye space by playing at A. However, if Black first plays at one of the vital points B or C, the black group dies. Black to play. Play at B or C to see what happens and then make the black group alive by increasing the eye space first." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcqcrdq", white: "cmcodpdreoeqer" },
            marks: { A: "bo", B: "ar", C: "bs" },
            correct: ["bobnao"],
            wrong: ["arbscsbp", "bsarbobnaoaq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-1-2",
        chapterId: "beginner-level3",
        order: 523,
        title: { zh: "死活 · 2/10", en: "Life&Death · 2/10" },
        instruction: { zh: "白先。先扩大眼位使白棋棋块活棋。", en: "White to play. Make the white group alive by increasing the eye space first." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eobpcpdpbqeqfqfrhr", white: "cqdqbrdrer" },
            correct: ["arcsbsescr"],
            wrong: ["arcsbsesdscr", "arcsesbs", "arcscrbs", "csaresbs", "escsarbs", "escsbsar", "aqarcsapbses", "aqarcsapesbs", "aqarascs", "fscsarbs", "fscsbsar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-1-3",
        chapterId: "beginner-level3",
        order: 524,
        title: { zh: "死活 · 3/10", en: "Life&Death · 3/10" },
        instruction: { zh: "白先。先扩大眼位使白棋棋块活棋。", en: "White to play. Make the white group alive by increasing the eye space first." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gqdqcpcobo", white: "cqbqbp" },
            correct: ["dreqerfrcs", "dreqerfrapbscsbrar", "dreqerfrbr", "dreqerfrar"],
            wrong: ["dreqerfrapbsarcrbrds", "dreqerfrapbsbrcscresdsarfsao", "crdrarbscsap", "crdrbsar", "apcrbrdrbsar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-1-4",
        chapterId: "beginner-level3",
        order: 525,
        title: { zh: "死活 · 4/10", en: "Life&Death · 4/10" },
        instruction: { zh: "白先。先扩大眼位使白棋棋块活棋。", en: "White to play. Make the white group alive by increasing the eye space first." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cnbpcpepbqeqeres", white: "cqdqarbrdr" },
            correct: ["dscsbs"],
            wrong: ["dscscrbs", "csds", "bsds", "dpdodscsbscr", "dpdodscscrbs", "dpdocsds"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-1-5",
        chapterId: "beginner-level3",
        order: 526,
        title: { zh: "死活 · 5/10", en: "Life&Death · 5/10" },
        instruction: { zh: "白先。先扩大眼位使白棋棋块活棋。", en: "White to play. Make the white group alive by increasing the eye space first." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "doapbpcpdqfqarer", white: "aqbqcqdrbs" },
            correct: ["dscrbr"],
            wrong: ["dscrcsbr", "escr", "brds", "crds"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-1-6",
        chapterId: "beginner-level3",
        order: 527,
        title: { zh: "死活 · 6/10", en: "Life&Death · 6/10" },
        instruction: { zh: "白先。先扩大眼位使白棋棋块活棋。", en: "White to play. Make the white group alive by increasing the eye space first." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gqeqepdpcpcobobm", white: "dqcqbqbp" },
            correct: ["erfrdrapbsesaqdscs", "erfrdrapbsaraqesbr", "erfrdrapbsaraqbrescscrasbs", "erfrdrapbsaraqbrescrcs", "erfrds", "drerbrcsdsapaqbsas", "drerbrcsdsapbs", "drerbsarbrdscs", "drerbsapaqdscs", "drarbrcsbs"],
            wrong: ["drerbrcsdsbsapar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-1-7",
        chapterId: "beginner-level3",
        order: 528,
        title: { zh: "死活 · 7/10", en: "Life&Death · 7/10" },
        instruction: { zh: "白先。先扩大眼位使白棋棋块活棋。", en: "White to play. Make the white group alive by increasing the eye space first." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gqeqdpcpapeoboao", white: "brdqcqaqbp" },
            correct: ["erfrdrbqarcsbsescr", "erbqarcrdrcsdsbsascsfrgrfs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-1-8",
        chapterId: "beginner-level3",
        order: 529,
        title: { zh: "死活 · 8/10", en: "Life&Death · 8/10" },
        instruction: { zh: "白先。先扩大眼位使白棋棋块活棋。", en: "White to play. Make the white group alive by increasing the eye space first." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "frfqeqdqcqbqbo", white: "eserdrcrbr" },
            correct: ["ar"],
            wrong: ["aqarascs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-1-9",
        chapterId: "beginner-level3",
        order: 530,
        title: { zh: "死活 · 9/10", en: "Life&Death · 9/10" },
        instruction: { zh: "白先。先扩大眼位使白棋棋块活棋。", en: "White to play. Make the white group alive by increasing the eye space first." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbpcpfpaqdqeqfr", white: "bqcqbrdrer" },
            correct: ["arcsbsescr"],
            wrong: ["arcsbsesdscr", "arcsesbs", "arcscrbs", "csaresbs", "csarbses", "csarases", "bsarcses", "bsarescs", "escsarbs", "escsbsar", "fscsarbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-1-10",
        chapterId: "beginner-level3",
        order: 531,
        title: { zh: "死活 · 10/10", en: "Life&Death · 10/10" },
        instruction: { zh: "白先。先扩大眼位使白棋棋块活棋。", en: "White to play. Make the white group alive by increasing the eye space first." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gqeqfpdpeocobo", white: "crdqcpbp" },
            correct: ["erfresbqbrapcqarbsdsasfsaq", "erfresbqaqbrbsarapaocq", "erfresbqaqarapbrbs"],
        },
    },
];

const bl3LifeDeath2Levels: Level[] = [
    {
        id: "beginner-level3-bl3-life-death-2-1",
        chapterId: "beginner-level3",
        order: 532,
        title: { zh: "死活 · 1/9", en: "Life&Death · 1/9" },
        instruction: { zh: "黑先。先缩小眼位吃掉白棋。", en: "Black to play. Capture white by reducing the eye space first." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcqdqeqfqhqgr", white: "brcrdrerfrfs" },
            correct: ["arbsds"],
            wrong: ["aqar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-2-2",
        chapterId: "beginner-level3",
        order: 533,
        title: { zh: "死活 · 2/9", en: "Life&Death · 2/9" },
        instruction: { zh: "黑先。先缩小眼位吃掉白棋。", en: "Black to play. Capture white by reducing the eye space first." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "boeobqcqdqfqgqhqhr", white: "arbrcrdrfrgr" },
            correct: ["er"],
            wrong: ["gserfses"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-2-3",
        chapterId: "beginner-level3",
        order: 534,
        title: { zh: "死活 · 3/9", en: "Life&Death · 3/9" },
        instruction: { zh: "黑先。先缩小眼位吃掉白棋。", en: "Black to play. Capture white by reducing the eye space first." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bocpdpepfpgpbqhqbrbs", white: "cqdqeqfqcrerds" },
            correct: ["gr"],
            wrong: ["frgr", "hrgr", "fsgr"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-2-4",
        chapterId: "beginner-level3",
        order: 535,
        title: { zh: "死活 · 4/9", en: "Life&Death · 4/9" },
        instruction: { zh: "黑先。先缩小眼位吃掉白棋。", en: "Black to play. Capture white by reducing the eye space first." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "hoepfpgpbqcqdqhqbr", white: "fqgqcrdrercses" },
            correct: ["gr"],
            wrong: ["hrgr", "frgr"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-2-5",
        chapterId: "beginner-level3",
        order: 536,
        title: { zh: "死活 · 5/9", en: "Life&Death · 5/9" },
        instruction: { zh: "黑先。先缩小眼位吃掉白棋。", en: "Black to play. Capture white by reducing the eye space first." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bocpdpepbqfqgq", white: "dqarbrcr" },
            correct: ["er"],
            wrong: ["frer", "drer"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-2-6",
        chapterId: "beginner-level3",
        order: 537,
        title: { zh: "死活 · 6/9", en: "Life&Death · 6/9" },
        instruction: { zh: "黑先。先缩小眼位吃掉白棋。", en: "Black to play. Capture white by reducing the eye space first." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "encodobpepfpgphpbqhqbrcs", white: "cpdpcqeqfqgqcrdrer" },
            correct: ["grfrhrdsfs"],
            wrong: ["grfrhrdsbsfs", "grfrfshr", "hrgrfsgs", "fsgr", "dshr"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-2-7",
        chapterId: "beginner-level3",
        order: 538,
        title: { zh: "死活 · 7/9", en: "Life&Death · 7/9" },
        instruction: { zh: "黑先。先缩小眼位吃掉白棋。", en: "Black to play. Capture white by reducing the eye space first." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdpepfpaqbqfqhr", white: "dqeqarbrcr" },
            correct: ["erdrfrdsbs"],
            wrong: ["frerdses"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-2-8",
        chapterId: "beginner-level3",
        order: 539,
        title: { zh: "死活 · 8/9", en: "Life&Death · 8/9" },
        instruction: { zh: "黑先。先缩小眼位吃掉白棋。", en: "Black to play. Capture white by reducing the eye space first." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bobqcqdqeqfqgqhqiqarir", white: "brcrdrerfrgrhr" },
            correct: ["hsgsbscses", "bscshsgses"],
            wrong: ["hsgsisbs", "asbs", "ishsbscs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-2-9",
        chapterId: "beginner-level3",
        order: 540,
        title: { zh: "死活 · 9/9", en: "Life&Death · 9/9" },
        instruction: { zh: "黑先。先缩小眼位吃掉白棋。", en: "Black to play. Capture white by reducing the eye space first." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dsgrereqdpeocobo", white: "drbrdqcpbpap" },
            correct: ["bscrcsbqar", "bscrcsarbq"],
            wrong: ["bscrcsbqasar", "bscrarcsbqesaqcq", "bscrarcsbqesaocq", "bscrarcsaqbq", "csbscrcq", "csbscqcr", "crcqcsbs"],
        },
    },
];

const bl3LifeDeath3Levels: Level[] = [
    {
        id: "beginner-level3-bl3-life-death-3-1",
        chapterId: "beginner-level3",
        order: 541,
        title: { zh: "死活 · 1/13", en: "Life&Death · 1/13" },
        instruction: { zh: "白棋必须做出两个眼才能使角上的棋块活棋。但白棋必须按正确的顺序进行。首先，白棋在B位下一手先手，将黑棋三子置于打吃，迫使黑棋先救这些子。然后白棋可以在A位做出第二个眼。白先。通过下先手来使棋块活棋。", en: "White has to make two eyes to make the group in the corner alive. But, White has to do this in the correct order. First, White plays a sente move at B, placing the three black stones in atari and forcing Black to save these stones first. White can then make a second eye at A. White to play. Make the group alive by playing a sente move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aobocpcqcsdodrdsepeq", white: "aparbpbrcrdqerfrgq" },
            marks: { A: "bq", B: "bs" },
            correct: ["bsdpbq"],
            wrong: ["bqbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-3-2",
        chapterId: "beginner-level3",
        order: 542,
        title: { zh: "死活 · 2/13", en: "Life&Death · 2/13" },
        instruction: { zh: "白先。通过下先手来使棋块活棋。", en: "White to play. Make the group alive by playing a sente move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmbocogoapdpepfpdqgqergrdses", white: "bpbqeqfqbrcrdrfras" },
            correct: ["csfsaq"],
            wrong: ["aqcs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-3-3",
        chapterId: "beginner-level3",
        order: 543,
        title: { zh: "死活 · 3/13", en: "Life&Death · 3/13" },
        instruction: { zh: "白先。通过下先手来使棋块活棋。", en: "White to play. Make the group alive by playing a sente move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dnboeofogocpdpgpbqfqhqfrbsfs", white: "epfpeqgqarbrcrdrer" },
            correct: ["esgrcs", "escsgr"],
            wrong: ["cses"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-3-4",
        chapterId: "beginner-level3",
        order: 544,
        title: { zh: "死活 · 4/13", en: "Life&Death · 4/13" },
        instruction: { zh: "白先。通过下先手来使棋块活棋。", en: "White to play. Make the group alive by playing a sente move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncodofoapbpfpcqdqgqeres", white: "cpdpbqarbrdrbs" },
            correct: ["crepds", "creqds"],
            wrong: ["eqep", "dscr"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-3-5",
        chapterId: "beginner-level3",
        order: 545,
        title: { zh: "死活 · 5/13", en: "Life&Death · 5/13" },
        instruction: { zh: "白先。通过下先手来使棋块活棋。", en: "White to play. Make the group alive by playing a sente move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmembnbofocpdpfpaqbqeqgqeres", white: "codoepcqarbrcsds" },
            correct: ["dqbpdr", "dqdrbp"],
            wrong: ["drdq", "bpapdqdrbpcp"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-3-6",
        chapterId: "beginner-level3",
        order: 546,
        title: { zh: "死活 · 6/13", en: "Life&Death · 6/13" },
        instruction: { zh: "白先。通过下先手来使棋块活棋。", en: "White to play. Make the group alive by playing a sente move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "codofocpfpfqbrgrbs", white: "dpepeqcrdreres" },
            correct: ["cqcsbq", "cqbqcs"],
            wrong: ["cscq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-3-7",
        chapterId: "beginner-level3",
        order: 547,
        title: { zh: "死活 · 7/13", en: "Life&Death · 7/13" },
        instruction: { zh: "白先。通过下先手来使棋块活棋。", en: "White to play. Make the group alive by playing a sente move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "anbncncodofoepaqdqfqhqdrcsds", white: "aobobpcpdpcqeqbrcr" },
            correct: ["bserar"],
            wrong: ["arbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-3-8",
        chapterId: "beginner-level3",
        order: 548,
        title: { zh: "死活 · 8/13", en: "Life&Death · 8/13" },
        instruction: { zh: "白先。通过下先手来使棋块活棋。", en: "White to play. Make the group alive by playing a sente move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "csercrdqdpeobodncn", white: "drbrcqcpbp" },
            correct: ["bsdsaq", "bsapdsaraqbqas", "bsaqdsapar"],
            wrong: ["dsesbsaq", "dsesaqbs", "aqbs", "apbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-3-9",
        chapterId: "beginner-level3",
        order: 549,
        title: { zh: "死活 · 9/13", en: "Life&Death · 9/13" },
        instruction: { zh: "白先。通过下先手来使棋块活棋。", en: "White to play. Make the group alive by playing a sente move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dmanbncnaododpdqcrcs", white: "bocoapaqbqbrbs" },
            correct: ["cqdrcp"],
            wrong: ["cpcq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-3-10",
        chapterId: "beginner-level3",
        order: 550,
        title: { zh: "死活 · 10/13", en: "Life&Death · 10/13" },
        instruction: { zh: "白先。通过下先手来使棋块活棋。", en: "White to play. Make the group alive by playing a sente move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "emfmbncndnbofogocpdphpbqdqhqcrir", white: "codoeobpepeqfqgqergrdsgs" },
            correct: ["drcqfs"],
            wrong: ["fsdr", "csdr"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-3-11",
        chapterId: "beginner-level3",
        order: 551,
        title: { zh: "死活 · 11/13", en: "Life&Death · 11/13" },
        instruction: { zh: "白先。通过下先手来使棋块活棋。", en: "White to play. Make the group alive by playing a sente move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndoeobpcpgpaqdqeqgqarfrhr", white: "dpepbqcqbrdrbscs" },
            correct: ["erfpes", "eresfqeqfp"],
            wrong: ["eresfqeqdqfp"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-3-12",
        chapterId: "beginner-level3",
        order: 552,
        title: { zh: "死活 · 12/13", en: "Life&Death · 12/13" },
        instruction: { zh: "白先。通过下先手来使棋块活棋。", en: "White to play. Make the group alive by playing a sente move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmdnenfnbocogobpdpgpbqdqeqhqgr", white: "doeofocpcqarbrcrdr" },
            correct: ["er"],
            wrong: ["fqer", "dsbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-3-13",
        chapterId: "beginner-level3",
        order: 553,
        title: { zh: "死活 · 13/13", en: "Life&Death · 13/13" },
        instruction: { zh: "白先。通过下先手来使棋块活棋。", en: "White to play. Make the group alive by playing a sente move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dmbncnboeocpdpfpdqgqgrbscsds", white: "codoapbpbqcqarbrdr" },
            correct: ["eqdnes"],
            wrong: ["eser", "eres"],
        },
    },
];

const bl3LifeDeath4Levels: Level[] = [
    {
        id: "beginner-level3-bl3-life-death-4-1",
        chapterId: "beginner-level3",
        order: 554,
        title: { zh: "死活 · 1/9", en: "Life&Death · 1/9" },
        instruction: { zh: "黑先。通过下先手来吃掉白棋棋块。", en: "Black to play. Capture the white group by playing a sente move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpcpdpepgpbqfqcrgrhr", white: "cqdqeqbrdrfrds" },
            correct: ["arcsfs"],
            wrong: ["arcsasfs", "fsar", "csbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-4-2",
        chapterId: "beginner-level3",
        order: 555,
        title: { zh: "死活 · 2/9", en: "Life&Death · 2/9" },
        instruction: { zh: "黑先。通过下先手来吃掉白棋棋块。", en: "Black to play. Capture the white group by playing a sente move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpdpepfpgpipcqgqhqbrfrir", white: "dqeqfqcrdrgrhresfs" },
            correct: ["hsgscs"],
            wrong: ["hsgsiscs", "cshs", "gshs", "dscs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-4-3",
        chapterId: "beginner-level3",
        order: 556,
        title: { zh: "死活 · 3/9", en: "Life&Death · 3/9" },
        instruction: { zh: "黑先。通过下先手来吃掉白棋棋块。", en: "Black to play. Capture the white group by playing a sente move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "anbncndnengnaofofpcqfqbrcrgr", white: "bocodoeoapcpaqbqdqeqarerasbses" },
            correct: ["csbpep"],
            wrong: ["epcs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-4-4",
        chapterId: "beginner-level3",
        order: 557,
        title: { zh: "死活 · 4/9", en: "Life&Death · 4/9" },
        instruction: { zh: "黑先。通过下先手来吃掉白棋棋块。", en: "Black to play. Capture the white group by playing a sente move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "araqbqbpcpdpeqfqgqhrfohqdsas", white: "brbscqdqdrerfrgres" },
            correct: ["cscrgs"],
            wrong: ["gscs", "crcs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-4-5",
        chapterId: "beginner-level3",
        order: 558,
        title: { zh: "死活 · 5/9", en: "Life&Death · 5/9" },
        instruction: { zh: "黑先。通过下先手来吃掉白棋棋块。", en: "Black to play. Capture the white group by playing a sente move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "codpepfphpaqbqgqarhrbshs", white: "eqfqbrcrdrgresgs" },
            correct: ["frfscs"],
            wrong: ["csfr", "fsfr", "erfr", "dqfr", "dscs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-4-6",
        chapterId: "beginner-level3",
        order: 559,
        title: { zh: "死活 · 6/9", en: "Life&Death · 6/9" },
        instruction: { zh: "黑先。通过下先手来吃掉白棋棋块。", en: "Black to play. Capture the white group by playing a sente move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aobocodoeoapfpaqfqhqarbrgrgs", white: "bpcpdpbqdqeqcrfrbsesfs" },
            correct: ["dsercsdrcs"],
            wrong: ["dsercsdrascs", "dserdrcs", "dserascs", "erdr", "csds", "ascs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-4-7",
        chapterId: "beginner-level3",
        order: 560,
        title: { zh: "死活 · 7/9", en: "Life&Death · 7/9" },
        instruction: { zh: "黑先。通过下先手来吃掉白棋棋块。", en: "Black to play. Capture the white group by playing a sente move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aobocoeoapdphpaqeqfqgqhrbscshs", white: "bpcpbqdqarbrdrerfrgrases" },
            correct: ["crcqgs"],
            wrong: ["cqcr", "dscr", "gscr"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-4-8",
        chapterId: "beginner-level3",
        order: 561,
        title: { zh: "死活 · 8/9", en: "Life&Death · 8/9" },
        instruction: { zh: "黑先。通过下先手来吃掉白棋棋块。", en: "Black to play. Capture the white group by playing a sente move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcndnfnaoboeoapepeqergrbs", white: "cobpdpaqcqdqardrasds" },
            correct: ["brbqdo"],
            wrong: ["bqbr", "crbqdocs", "crbqdobr", "crbqbrdo", "crbqcsdo", "csdo", "dobrcscp", "dobrcpcs", "dobrcrcs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-4-9",
        chapterId: "beginner-level3",
        order: 562,
        title: { zh: "死活 · 9/9", en: "Life&Death · 9/9" },
        instruction: { zh: "黑先。通过下先手来吃掉白棋棋块。", en: "Black to play. Capture the white group by playing a sente move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "enfnbocodogogpipbqhqarcrhrbscses", white: "eocpdpfpcqeqfqgqdrgrdsgs" },
            correct: ["erdqfo", "erfodq"],
            wrong: ["foerfsep", "foerepfs", "frfo", "fsfo", "bpfo"],
        },
    },
];

const bl3LifeDeath5Levels: Level[] = [
    {
        id: "beginner-level3-bl3-life-death-5-1",
        chapterId: "beginner-level3",
        order: 563,
        title: { zh: "死活 · 1/13", en: "Life&Death · 1/13" },
        instruction: { zh: "如果你在边上的二线有六颗棋子，这不足以活棋。即使轮到你下，你也不能救活这些棋子。白先。如果白棋在A位落子，黑棋将在B位落子。在A或B位落子看看会发生什么。", en: "If you have six stones along the side on the second line, this is not enough to live. Even if it is your turn to move, you can not save the stones. White to play. If White plays at A, Black will play at B. Play at A or B to see what will happen." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqcrdqeqfqgqhqiqjqjr", white: "drerfrgrhrir" },
            marks: { A: "ds", B: "is" },
            correct: ["isdsesgs", "dsishsfs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-5-2",
        chapterId: "beginner-level3",
        order: 564,
        title: { zh: "死活 · 2/13", en: "Life&Death · 2/13" },
        instruction: { zh: "如果你在边上的二线有七颗棋子，有可能活棋。如果轮到白棋下，白棋可以通过在A、B或C位落子使棋块做出两个眼。如果轮到黑棋下，白棋棋子可以被吃掉。白先。使边上的白棋棋块活棋。", en: "If you have seven stones along the side on the second line, it is possible to live. If White is to play, White can give the group two eyes by playing at A, B or C. If Black is to play, the white stones can be captured. White to play. Make the white group along the side alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqcrdqeqfqgqhqiqjqkqkr", white: "drerfrgrhrirjr" },
            marks: { A: "ds", B: "gs", C: "js" },
            correct: ["jsdsesgshs", "dsjsisfsgs", "gsdsesjsis"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-5-3",
        chapterId: "beginner-level3",
        order: 565,
        title: { zh: "死活 · 3/13", en: "Life&Death · 3/13" },
        instruction: { zh: "如果你在边上的二线有八颗棋子，即使对手先下，棋块也是活棋。如果黑棋用1攻击白棋棋块，白棋可以防守并活棋。白先。防守边上的白棋棋块。", en: "If you have eight stones along the side on the second line, the group is alive, even if your opponent is to play. If Black attacks the white group with 1, White can defend and live. White to play. Defend the white group along the side." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqcrdqeqfqgqhqiqjqkqlqlrds", white: "drerfrgrhrirjrkr" },
            marks: { 1: "ds" },
            correct: ["es", "ks"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-5-4",
        chapterId: "beginner-level3",
        order: 566,
        title: { zh: "死活 · 4/13", en: "Life&Death · 4/13" },
        instruction: { zh: "如果你在角上的二线有四颗棋子，这不足以活棋。即使轮到你下，你也不能救活这四颗棋子。在此，白棋试图用1救活这四颗棋子。通过阻止做出两个眼来吃掉白棋棋子。", en: "If you have four stones in the corner on the second line, this is not enough to live. Even if it is your turn to play, you can not save the four stones. Here, White tries to save the four stones with 1. Capture the white stones by preventing two eyes." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aqbqcqdqeqer", white: "arbrcrdrds" },
            marks: { 1: "ds" },
            correct: ["bs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-5-5",
        chapterId: "beginner-level3",
        order: 567,
        title: { zh: "死活 · 5/13", en: "Life&Death · 5/13" },
        instruction: { zh: "如果你在角上二线有五颗棋子，可以通过给棋块做两个眼来活棋。这里，白棋可以做出两个眼。如果轮到黑棋落子，黑棋可以吃掉白棋棋块。黑先。吃掉白棋棋块。", en: "If you have five stones in the corner on the second line, you can live by giving the group two eyes. Here, White can make two eyes. If it is Black's turn to play, Black can capture the white group. Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aqbqcqdqeqfqfr", white: "arbrcrdrer" },
            correct: ["esdsbs"],
            wrong: ["esdsfsbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-5-6",
        chapterId: "beginner-level3",
        order: 568,
        title: { zh: "死活 · 6/13", en: "Life&Death · 6/13" },
        instruction: { zh: "如果你在角上二线有六颗棋子，即使对手先走，你的棋块也是活棋。这里，黑棋试图用1吃掉白棋棋子。救出白棋棋块。", en: "If you have six stones in the corner on the second line, your group is alive, even if your opponent is to play. Here, Black tries to capture the white stones with 1. Save the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbqcqdqeqfqgqgrfs", white: "arbrcrdrerfr" },
            marks: { 1: "fs" },
            correct: ["esbscs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-5-7",
        chapterId: "beginner-level3",
        order: 569,
        title: { zh: "死活 · 7/13", en: "Life&Death · 7/13" },
        instruction: { zh: "白先。让边上的白棋棋块活棋。", en: "White to play. Make the white group along the side alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcqdqeqfqgqhqiqjqbrjrlr", white: "crdrerfrgrhrir" },
            correct: ["is", "cs", "fs"],
            wrong: ["jscs", "bsis"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-5-8",
        chapterId: "beginner-level3",
        order: 570,
        title: { zh: "死活 · 8/13", en: "Life&Death · 8/13" },
        instruction: { zh: "白先。让边上的白棋棋块活棋。", en: "White to play. Make the white group along the side alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "hrgqfqeqdqcqbqhpbo", white: "erdrcrbr" },
            correct: ["aresfrfsgsgrdsfsbs", "aresfrfsgsdscs", "aresfrfsgsdsgr"],
            wrong: ["frar", "esar", "bsar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-5-9",
        chapterId: "beginner-level3",
        order: 571,
        title: { zh: "死活 · 9/13", en: "Life&Death · 9/13" },
        instruction: { zh: "白先。让边上的白棋棋块活棋。", en: "White to play. Make the white group along the side alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eofohobpepgpjpcqdqeqgqiqbrjr", white: "fpfqcrdrergrhrir" },
            correct: ["fsfrfq"],
            wrong: ["frcsdsis", "isfrfsgs", "csfrfses"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-5-10",
        chapterId: "beginner-level3",
        order: 572,
        title: { zh: "死活 · 10/13", en: "Life&Death · 10/13" },
        instruction: { zh: "白先。让边上的白棋棋块活棋。", en: "White to play. Make the white group along the side alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcqdqeqgqhqiqkqbrjr", white: "crdrergrhrir" },
            correct: ["fs"],
            wrong: ["fris", "frcs", "isfr", "csfr"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-5-11",
        chapterId: "beginner-level3",
        order: 573,
        title: { zh: "死活 · 11/13", en: "Life&Death · 11/13" },
        instruction: { zh: "白先。让边上的白棋棋块活棋。", en: "White to play. Make the white group along the side alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bobpcqdqeqfqfr", white: "arcrdrer" },
            correct: ["bs"],
            wrong: ["bres", "esbr"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-5-12",
        chapterId: "beginner-level3",
        order: 574,
        title: { zh: "死活 · 12/13", en: "Life&Death · 12/13" },
        instruction: { zh: "白先。让边上的白棋棋块活棋。", en: "White to play. Make the white group along the side alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "jpbqcqdqeqfqgqhqiqarjr", white: "brcrdrerfrhrir" },
            correct: ["gr"],
            wrong: ["gsgr", "bsgr", "isgr"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-5-13",
        chapterId: "beginner-level3",
        order: 575,
        title: { zh: "死活 · 13/13", en: "Life&Death · 13/13" },
        instruction: { zh: "白先。让边上的白棋棋块活棋。", en: "White to play. Make the white group along the side alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocobpdpfphpaqbqdqfqgr", white: "cpcqbrdrerfrcs" },
            correct: ["arcrcq"],
            wrong: ["crar", "fsar"],
        },
    },
];

const bl3LifeDeath6Levels: Level[] = [
    {
        id: "beginner-level3-bl3-life-death-6-1",
        chapterId: "beginner-level3",
        order: 576,
        title: { zh: "死活 · 1/12", en: "Life&Death · 1/12" },
        instruction: { zh: "黑先。吃掉边上的棋块。", en: "Black to play. Capture the group along the side." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bohpbqcqdqeqfqgqhr", white: "brcrdrerfrgr" },
            correct: ["ar"],
            wrong: ["gsar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-6-2",
        chapterId: "beginner-level3",
        order: 577,
        title: { zh: "死活 · 2/12", en: "Life&Death · 2/12" },
        instruction: { zh: "黑先。吃掉边上的棋块。", en: "Black to play. Capture the group along the side." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpcqdqeqfqgqhqiqjqbrjr", white: "crdrergrhrircsfsis" },
            correct: ["fresgs", "frgses"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-6-3",
        chapterId: "beginner-level3",
        order: 578,
        title: { zh: "死活 · 3/12", en: "Life&Death · 3/12" },
        instruction: { zh: "黑先。吃掉边上的棋块。", en: "Black to play. Capture the group along the side." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bofpbqcqdqeqfr", white: "arbrcrdrer" },
            correct: ["esdsbs"],
            wrong: ["aqes"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-6-4",
        chapterId: "beginner-level3",
        order: 579,
        title: { zh: "死活 · 4/12", en: "Life&Death · 4/12" },
        instruction: { zh: "黑先。吃掉边上的棋块。", en: "Black to play. Capture the group along the side." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bobqcqdqeqfqgr", white: "arbrcrdrer" },
            correct: ["esdsbs"],
            wrong: ["fres"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-6-5",
        chapterId: "beginner-level3",
        order: 580,
        title: { zh: "死活 · 5/12", en: "Life&Death · 5/12" },
        instruction: { zh: "黑先。吃掉边上的棋块。", en: "Black to play. Capture the group along the side." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "krarjqiqhqgqeqdqcqbqaqkp", white: "jrirhrgrerdrcrbr" },
            correct: ["frfsfqesgsjshs", "frfsfqesbscsgsjshs", "frfsfqesbscsjsisgs", "frfsfqesbscsjsgsis", "frfsfqesjsisgs", "frfsfqesjsgsis"],
            wrong: ["fsfr", "jsfs", "bsfs", "frfsgsfq", "frfsesfq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-6-6",
        chapterId: "beginner-level3",
        order: 581,
        title: { zh: "死活 · 6/12", en: "Life&Death · 6/12" },
        instruction: { zh: "黑先。吃掉边上的棋块。", en: "Black to play. Capture the group along the side." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aqbqcqdqeqfqgqiqhr", white: "arbrcrdrer" },
            correct: ["bscsesfrfsgsgrdsfs"],
            wrong: ["fres", "fses", "esbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-6-7",
        chapterId: "beginner-level3",
        order: 582,
        title: { zh: "死活 · 7/12", en: "Life&Death · 7/12" },
        instruction: { zh: "黑先。吃掉边上的棋块。", en: "Black to play. Capture the group along the side." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bobqcqdqeqfqgqiq", white: "brcrdrerfr" },
            correct: ["argrhr"],
            wrong: ["grar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-6-8",
        chapterId: "beginner-level3",
        order: 583,
        title: { zh: "死活 · 8/12", en: "Life&Death · 8/12" },
        instruction: { zh: "黑先。吃掉边上的棋块。", en: "Black to play. Capture the group along the side." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bobqcqdqeqfqgqhqiqir", white: "brcrdrerfrgr" },
            correct: ["ar"],
            wrong: ["gsar", "hrar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-6-9",
        chapterId: "beginner-level3",
        order: 584,
        title: { zh: "死活 · 9/12", en: "Life&Death · 9/12" },
        instruction: { zh: "黑先。吃掉边上的棋块。", en: "Black to play. Capture the group along the side." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqdqeqfqgqiq", white: "arbrdrerfr" },
            correct: ["cr"],
            wrong: ["grcr"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-6-10",
        chapterId: "beginner-level3",
        order: 585,
        title: { zh: "死活 · 10/12", en: "Life&Death · 10/12" },
        instruction: { zh: "黑先。吃掉边上的棋块。", en: "Black to play. Capture the group along the side." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpfpgpjpcqdqeqhqiqbrjr", white: "fqcrdrergrhrir" },
            correct: ["fsisfrgqgs"],
            wrong: ["isfshsgq", "isfsgqhs", "isfscsgq", "csfsdsgq", "csfsgqds", "csfsisgq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-6-11",
        chapterId: "beginner-level3",
        order: 586,
        title: { zh: "死活 · 11/12", en: "Life&Death · 11/12" },
        instruction: { zh: "黑先。吃掉边上的棋块。", en: "Black to play. Capture the group along the side." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpcqdqeqgqhqiqkqbrjrcs", white: "crdrerfrgrhrirbsis" },
            correct: ["gsfsds", "gsdsfs"],
            wrong: ["fsgs", "jsgs", "dsgs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-6-12",
        chapterId: "beginner-level3",
        order: 587,
        title: { zh: "死活 · 12/12", en: "Life&Death · 12/12" },
        instruction: { zh: "黑先。吃掉边上的棋块。", en: "Black to play. Capture the group along the side." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "hrgqfqeqdqbqhpbpeocobo", white: "csgrfrerdrbrcqcp" },
            correct: ["argses"],
            wrong: ["gsar", "dpar"],
        },
    },
];

const bl3LifeDeath7Levels: Level[] = [
    {
        id: "beginner-level3-bl3-life-death-7-1",
        chapterId: "beginner-level3",
        order: 588,
        title: { zh: "死活 · 1/16", en: "Life&Death · 1/16" },
        instruction: { zh: "这种大眼的形状在日本叫“花”，在韩国叫“樱花”。在A点落子可以决定棋块的死活。白先。吃掉黑棋棋块。", en: "This formation of a large eye is called flower in Japan and cherry blossom in Korea. By playing at A you can make the group alive or dead. White to play. Capture the black group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cncocpcqdmdndqemeqfmfnfpfqgngogp", white: "bnbobpbqbrclcmcrdldrelerflfrgmgqgrhmhnhohphq" },
            marks: { A: "eo" },
            correct: ["eo"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-7-2",
        chapterId: "beginner-level3",
        order: 589,
        title: { zh: "死活 · 2/16", en: "Life&Death · 2/16" },
        instruction: { zh: "一般来说，拥有长方形六目眼位的棋块是活棋。角上的长方形是特例。这里，白棋可以吃掉黑棋棋块，因为棋块被完全包围。白1、黑2后，白棋可以在A点落子，利用紧气：黑棋不能在B点落子，否则黑棋棋子将被打吃。白先。吃掉黑棋棋块。", en: "In general a group with a rectangular 6-point eye space is alive. A rectangle in the corner is a special case. Here, White can capture the black group, since the group is completely surrounded. After White 1 and Black 2, White can play at A and use a shortage of liberties: Black can not play at B, because the black stones will then be in atari. White to play. Capture the black group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbqcqdqdrdsbs", white: "apbpcpdpepeqeresbr" },
            marks: { 1: "br", 2: "bs", A: "ar", B: "cr" },
            correct: ["arcrcs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-7-3",
        chapterId: "beginner-level3",
        order: 590,
        title: { zh: "死活 · 3/16", en: "Life&Death · 3/16" },
        instruction: { zh: "如果黑棋棋子没有被完全包围，但有一个外气，白棋无法立即吃掉棋块。但白棋通过1和3落子后，可以通过吃黑4制造一个劫。白先。制造一个劫。", en: "If the black stones are not completely surrounded, but they have 1 outside liberty, White can not capture the group immediately. But after playing 1 and 3, White can make a ko by capturing black 4. White to play. Make a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbqcqdqdrdsasbr", white: "apbpcpdpepeqerbscs" },
            marks: { 1: "bs", 2: "br", 3: "cs", 4: "as" },
            correct: ["ar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-7-4",
        chapterId: "beginner-level3",
        order: 591,
        title: { zh: "死活 · 4/16", en: "Life&Death · 4/16" },
        instruction: { zh: "如果黑棋棋子有两个外气，黑棋棋块是活棋。在白1落子后，让黑棋棋块活棋。", en: "If the black stones have two outside liberties, the black group is alive. Make the black group alive after White has played 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aqbqcqdqdrds", white: "bpcpdpepeqerbs" },
            marks: { 1: "bs" },
            correct: ["brcsasarcr"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-7-5",
        chapterId: "beginner-level3",
        order: 592,
        title: { zh: "死活 · 5/16", en: "Life&Death · 5/16" },
        instruction: { zh: "白先。吃掉黑棋棋块。", en: "White to play. Capture the black group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dqeqfqgqcrgrcsgs", white: "hobpdpepfpgpcqhqbrhrhs" },
            correct: ["eresdrdsfr"],
            wrong: ["eresfrdr", "eresdsdr", "eresbsdr", "eser", "drer", "dses", "bses"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-7-6",
        chapterId: "beginner-level3",
        order: 593,
        title: { zh: "死活 · 6/16", en: "Life&Death · 6/16" },
        instruction: { zh: "白先。吃掉黑棋棋块。", en: "White to play. Capture the black group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpgqfqfogogpfserdrcrbscqcpdo", white: "brbqbpcocndnenfnhnhmhohphqgrfrir" },
            correct: ["epeoeq"],
            wrong: ["eoep", "esep", "csep", "eqep"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-7-7",
        chapterId: "beginner-level3",
        order: 594,
        title: { zh: "死活 · 7/16", en: "Life&Death · 7/16" },
        instruction: { zh: "白先。吃掉黑棋棋块。", en: "White to play. Capture the black group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbqcqdqdrds", white: "apbpcpdpepeqeres" },
            correct: ["brbsar"],
            wrong: ["brbscrar", "bsbr"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-7-8",
        chapterId: "beginner-level3",
        order: 595,
        title: { zh: "死活 · 8/16", en: "Life&Death · 8/16" },
        instruction: { zh: "白先。吃掉黑棋棋块。", en: "White to play. Capture the black group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbqcqdqdr", white: "bpcpdpepeqer" },
            correct: ["bscsbr"],
            wrong: ["dsbs", "csbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-7-9",
        chapterId: "beginner-level3",
        order: 596,
        title: { zh: "死活 · 9/16", en: "Life&Death · 9/16" },
        instruction: { zh: "白先。吃掉黑棋棋块。", en: "White to play. Capture the black group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqdqeqfqcrgrbsesgs", white: "cpdpepfphpbqgqbrhrhs" },
            correct: ["frfsdsercsdrcs", "frfscserdsdrcs", "frfserdrcs"],
            wrong: ["frfsdserdrcs", "frfscserasds", "frfserdrdscs", "dsfr", "fsfr", "drer", "csfr"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-7-10",
        chapterId: "beginner-level3",
        order: 597,
        title: { zh: "死活 · 10/16", en: "Life&Death · 10/16" },
        instruction: { zh: "白先。吃掉黑棋棋块。", en: "White to play. Capture the black group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bscrcqdqeqfqfrgrgs", white: "hrgqhpfpepdpcpbqbr" },
            correct: ["esdser"],
            wrong: ["dses", "csds"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-7-11",
        chapterId: "beginner-level3",
        order: 598,
        title: { zh: "死活 · 11/16", en: "Life&Death · 11/16" },
        instruction: { zh: "白先。吃掉黑棋棋块。", en: "White to play. Capture the black group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbqcqdqdr", white: "apbpcpdpfpeqer" },
            correct: ["dscsbr", "bsbrcsdsas", "brbsarcrds"],
            wrong: ["bsbrdscs", "bsbrascs", "brbscrar", "brbscsar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-7-12",
        chapterId: "beginner-level3",
        order: 599,
        title: { zh: "死活 · 12/16", en: "Life&Death · 12/16" },
        instruction: { zh: "白先。吃掉黑棋棋块。", en: "White to play. Capture the black group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrcqcpdreres", white: "bqbpcodoeodqeqfqfr" },
            correct: ["csbscrdscr"],
            wrong: ["bscs", "dpcr"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-7-13",
        chapterId: "beginner-level3",
        order: 600,
        title: { zh: "死活 · 13/16", en: "Life&Death · 13/16" },
        instruction: { zh: "白先。吃掉黑棋棋块。", en: "White to play. Capture the black group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "epfpdqgqcrdrgrcsfs", white: "doeofogocphpcqhqbrhrbsgshs" },
            correct: ["freser"],
            wrong: ["fresfqgp", "esfr", "erfr", "eqer", "gpfr", "dper"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-7-14",
        chapterId: "beginner-level3",
        order: 601,
        title: { zh: "死活 · 14/16", en: "Life&Death · 14/16" },
        instruction: { zh: "白先。吃掉黑棋棋块。", en: "White to play. Capture the black group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dqepfpfqfrgrbscscrcq", white: "gshrhqgqgpfoeodpdobpbqbr" },
            correct: ["eresdr"],
            wrong: ["fser", "eser"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-7-15",
        chapterId: "beginner-level3",
        order: 602,
        title: { zh: "死活 · 15/16", en: "Life&Death · 15/16" },
        instruction: { zh: "白先。吃掉黑棋棋块。", en: "White to play. Capture the black group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "epfpdqfqgqcrgrcs", white: "doeofohocpgpcqhqbrhr" },
            correct: ["eresdrfrgs", "eresdrfrdpdsgs", "eresdrdsfr", "erdres"],
            wrong: ["eresdrfrdpdseqdq", "gseresfsfrds", "gserfses", "fsergses", "drer"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-7-16",
        chapterId: "beginner-level3",
        order: 603,
        title: { zh: "死活 · 16/16", en: "Life&Death · 16/16" },
        instruction: { zh: "白先。吃掉黑棋棋块。", en: "White to play. Capture the black group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbrcqdqdrer", white: "bqbpcpdpeqfpfr" },
            correct: ["csbses", "csbsar"],
            wrong: ["csbsapar", "escs", "arcs"],
        },
    },
];

const bl3LifeDeath8Levels: Level[] = [
    {
        id: "beginner-level3-bl3-life-death-8-1",
        chapterId: "beginner-level3",
        order: 604,
        title: { zh: "死活 · 1/12", en: "Life&Death · 1/12" },
        instruction: { zh: "黑先。利用劫让黑棋棋块活棋。", en: "Black to play. Make the black group alive using ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbqcrdrds", white: "aqbpcqdqeresepcp" },
            correct: ["ar"],
            wrong: ["brar", "asar", "apar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-8-2",
        chapterId: "beginner-level3",
        order: 605,
        title: { zh: "死活 · 2/12", en: "Life&Death · 2/12" },
        instruction: { zh: "黑先。利用劫让黑棋棋块活棋。", en: "Black to play. Make the black group alive using ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aqcscrcqcpbp", white: "arapaobocodpdqdreo" },
            correct: ["br"],
            wrong: ["bqas", "asbq", "bsbq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-8-3",
        chapterId: "beginner-level3",
        order: 606,
        title: { zh: "死活 · 3/12", en: "Life&Death · 3/12" },
        instruction: { zh: "黑先。利用劫让黑棋棋块活棋。", en: "Black to play. Make the black group alive using ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbraqcqbpbo", white: "bncncocpdpdqcrdr" },
            correct: ["ao"],
            wrong: ["bqao", "arao"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-8-4",
        chapterId: "beginner-level3",
        order: 607,
        title: { zh: "死活 · 4/12", en: "Life&Death · 4/12" },
        instruction: { zh: "黑先。利用劫让黑棋棋块活棋。", en: "Black to play. Make the black group alive using ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cscrbrbqbp", white: "arbococpcqdqdrds" },
            correct: ["as"],
            wrong: ["aqas", "apas"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-8-5",
        chapterId: "beginner-level3",
        order: 608,
        title: { zh: "死活 · 5/12", en: "Life&Death · 5/12" },
        instruction: { zh: "黑先。利用劫让黑棋棋块活棋。", en: "Black to play. Make the black group alive using ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "arbqcpcocnbnbmam", white: "blclcmdndodpcqdrbrbp" },
            correct: ["ap"],
            wrong: ["aqao", "aoaq", "boaq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-8-6",
        chapterId: "beginner-level3",
        order: 609,
        title: { zh: "死活 · 6/12", en: "Life&Death · 6/12" },
        instruction: { zh: "黑先。利用劫让黑棋棋块活棋。", en: "Black to play. Make the black group alive using ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bscsbrdrcqcpcoboap", white: "aqaraoanbncndmdodpdqeqeresds" },
            correct: ["bq"],
            wrong: ["bpas", "asbp", "crbp"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-8-7",
        chapterId: "beginner-level3",
        order: 610,
        title: { zh: "死活 · 7/12", en: "Life&Death · 7/12" },
        instruction: { zh: "黑先。利用劫让黑棋棋块活棋。", en: "Black to play. Make the black group alive using ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbraqcqcpcobo", white: "aparcrdqdpcnbndodmer" },
            correct: ["bp"],
            wrong: ["aobq", "bqao", "asao"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-8-8",
        chapterId: "beginner-level3",
        order: 611,
        title: { zh: "死活 · 8/12", en: "Life&Death · 8/12" },
        instruction: { zh: "黑先。利用劫让黑棋棋块活棋。", en: "Black to play. Make the black group alive using ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cscrcqbqapbococp", white: "aoanbncndmdodpdqdraqards" },
            correct: ["br"],
            wrong: ["bpas", "asbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-8-9",
        chapterId: "beginner-level3",
        order: 612,
        title: { zh: "死活 · 9/12", en: "Life&Death · 9/12" },
        instruction: { zh: "黑先。利用劫让黑棋棋块活棋。", en: "Black to play. Make the black group alive using ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bscrdrcqcpbpbo", white: "bncncodpdqeqerdseobrbqaq" },
            correct: ["ar"],
            wrong: ["apar", "aoar", "asar", "csar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-8-10",
        chapterId: "beginner-level3",
        order: 613,
        title: { zh: "死活 · 10/12", en: "Life&Death · 10/12" },
        instruction: { zh: "黑先。利用劫让黑棋棋块活棋。", en: "Black to play. Make the black group alive using ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brcqcpbpaococncmbm", white: "amblcldldmdndodpdqcrdrbsar" },
            correct: ["aq"],
            wrong: ["anaq", "bqaq", "bnaq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-8-11",
        chapterId: "beginner-level3",
        order: 614,
        title: { zh: "死活 · 11/12", en: "Life&Death · 11/12" },
        instruction: { zh: "黑先。利用劫让黑棋棋块活棋。", en: "Black to play. Make the black group alive using ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcpdobobncnam", white: "bmblcmdmeneoepdqcqbraq" },
            correct: ["ap"],
            wrong: ["dpap", "dnap", "anap", "bpap"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-8-12",
        chapterId: "beginner-level3",
        order: 615,
        title: { zh: "死活 · 12/12", en: "Life&Death · 12/12" },
        instruction: { zh: "黑先。利用劫让黑棋棋块活棋。", en: "Black to play. Make the black group alive using ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brcqdrbp", white: "dsereqdqcpcobo" },
            correct: ["cs"],
            wrong: ["aqcsbscr", "ascsaqbs"],
        },
    },
];

const bl3LifeDeath9Levels: Level[] = [
    {
        id: "beginner-level3-bl3-life-death-9-1",
        chapterId: "beginner-level3",
        order: 616,
        title: { zh: "死活 · 1/12", en: "Life&Death · 1/12" },
        instruction: { zh: "白先。利用劫吃掉黑棋棋块。", en: "White to play. Capture the black group using ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrcqdqdpbqbpcoapao", white: "ancnbmdoeoepeqdrcrbs" },
            correct: ["bo"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-9-2",
        chapterId: "beginner-level3",
        order: 617,
        title: { zh: "死活 · 2/12", en: "Life&Death · 2/12" },
        instruction: { zh: "白先。利用劫吃掉黑棋棋块。", en: "White to play. Capture the black group using ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "csbrbqbpbobnan", white: "ambmclcncocpcrdrcqar" },
            correct: ["bs"],
            wrong: ["aqap", "apaq", "asaq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-9-3",
        chapterId: "beginner-level3",
        order: 618,
        title: { zh: "死活 · 3/12", en: "Life&Death · 3/12" },
        instruction: { zh: "白先。利用劫吃掉黑棋棋块。", en: "White to play. Capture the black group using ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bsbraqcqcpbp", white: "bocododpdqcreranbm" },
            correct: ["ap"],
            wrong: ["aoap", "arap"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-9-4",
        chapterId: "beginner-level3",
        order: 619,
        title: { zh: "死活 · 4/12", en: "Life&Death · 4/12" },
        instruction: { zh: "白先。利用劫吃掉黑棋棋块。", en: "White to play. Capture the black group using ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cscrbrcqcpcoboap", white: "bqbsdsdrdqdpdodncnbnanao" },
            correct: ["ar"],
            wrong: ["asar", "aqar", "bpaq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-9-5",
        chapterId: "beginner-level3",
        order: 620,
        title: { zh: "死活 · 5/12", en: "Life&Death · 5/12" },
        instruction: { zh: "白先。利用劫吃掉黑棋棋块。", en: "White to play. Capture the black group using ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cscrbrcqcpbpap", white: "aqaobocododpdqdrfr" },
            correct: ["arasbs"],
            wrong: ["asar", "bsar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-9-6",
        chapterId: "beginner-level3",
        order: 621,
        title: { zh: "死活 · 6/12", en: "Life&Death · 6/12" },
        instruction: { zh: "白先。利用劫吃掉黑棋棋块。", en: "White to play. Capture the black group using ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrcqcpcobnap", white: "bpcncmdoendpdqcrbsdrcl" },
            correct: ["aobqaq"],
            wrong: ["aqbq", "bobq", "bqbo", "bmbo"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-9-7",
        chapterId: "beginner-level3",
        order: 622,
        title: { zh: "死活 · 7/12", en: "Life&Death · 7/12" },
        instruction: { zh: "白先。利用劫吃掉黑棋棋块。", en: "White to play. Capture the black group using ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cscrbrbqbpap", white: "aobococpcqdqdrds" },
            correct: ["arasbs"],
            wrong: ["asar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-9-8",
        chapterId: "beginner-level3",
        order: 623,
        title: { zh: "死活 · 8/12", en: "Life&Death · 8/12" },
        instruction: { zh: "白先。利用劫吃掉黑棋棋块。", en: "White to play. Capture the black group using ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bsbrcrcqbpbobn", white: "bmcmcncocpdqdrepbqap" },
            correct: ["ar"],
            wrong: ["aqar", "aoaq", "anaq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-9-9",
        chapterId: "beginner-level3",
        order: 624,
        title: { zh: "死活 · 9/12", en: "Life&Death · 9/12" },
        instruction: { zh: "白先。利用劫吃掉黑棋棋块。", en: "White to play. Capture the black group using ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bsbrcqcpcoboap", white: "aoanbncndodqdrcreo" },
            correct: ["aqbqbp"],
            wrong: ["bpbq", "bqaq", "araq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-9-10",
        chapterId: "beginner-level3",
        order: 625,
        title: { zh: "死活 · 10/12", en: "Life&Death · 10/12" },
        instruction: { zh: "白先。利用劫吃掉黑棋棋块。", en: "White to play. Capture the black group using ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brcrcqbpboaq", white: "bsdrdqdpcpcobncm" },
            correct: ["csaoar"],
            wrong: ["arcs", "ascs", "aocs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-9-11",
        chapterId: "beginner-level3",
        order: 626,
        title: { zh: "死活 · 11/12", en: "Life&Death · 11/12" },
        instruction: { zh: "白先。利用劫吃掉黑棋棋块。", en: "White to play. Capture the black group using ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crdqdrdsbqbpcpap", white: "braobocodpeoeqeres" },
            correct: ["asaraq", "asbscs"],
            wrong: ["bsar", "arbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-9-12",
        chapterId: "beginner-level3",
        order: 627,
        title: { zh: "死活 · 12/12", en: "Life&Death · 12/12" },
        instruction: { zh: "白先。利用劫吃掉黑棋棋块。", en: "White to play. Capture the black group using ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brcsdrdqcqcpbp", white: "arbsaobocododpeqerfp" },
            correct: ["apaqbq"],
            wrong: ["aqap", "bqaq", "asaq"],
        },
    },
];

const bl3LifeDeath10Levels: Level[] = [
    {
        id: "beginner-level3-bl3-life-death-10-1",
        chapterId: "beginner-level3",
        order: 628,
        title: { zh: "死活 · 1/12", en: "Life&Death · 1/12" },
        instruction: { zh: "黑先。利用双活救出黑棋棋块。", en: "Black to play. Save the black group with seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbrbqbpbobn", white: "araqapbmclcncocpcqcrer" },
            correct: ["an"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-10-2",
        chapterId: "beginner-level3",
        order: 629,
        title: { zh: "死活 · 2/12", en: "Life&Death · 2/12" },
        instruction: { zh: "黑先。利用双活救出黑棋棋块。", en: "Black to play. Save the black group with seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brcrdrerfrgrhrhs", white: "iriqhqgqfqeqdqcqbqfsesaraq" },
            correct: ["bs"],
            wrong: ["dsbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-10-3",
        chapterId: "beginner-level3",
        order: 630,
        title: { zh: "死活 · 3/12", en: "Life&Death · 3/12" },
        instruction: { zh: "黑先。利用双活救出黑棋棋块。", en: "Black to play. Save the black group with seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbrbqbpboan", white: "bmblcncocpcqdreqaqar" },
            correct: ["bn"],
            wrong: ["apbn"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-10-4",
        chapterId: "beginner-level3",
        order: 631,
        title: { zh: "死活 · 4/12", en: "Life&Death · 4/12" },
        instruction: { zh: "黑先。利用双活救出黑棋棋块。", en: "Black to play. Save the black group with seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brbqbpbococncmbmam", white: "anaobscrcqdpdodndmclbldk" },
            correct: ["ar"],
            wrong: ["apar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-10-5",
        chapterId: "beginner-level3",
        order: 632,
        title: { zh: "死活 · 5/12", en: "Life&Death · 5/12" },
        instruction: { zh: "黑先。利用双活救出黑棋棋块。", en: "Black to play. Save the black group with seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbrcrcqcpcoboao", white: "bnblcndndodpdqdrdsbqaqar" },
            correct: ["ap"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-10-6",
        chapterId: "beginner-level3",
        order: 633,
        title: { zh: "死活 · 6/12", en: "Life&Death · 6/12" },
        instruction: { zh: "黑先。利用双活救出黑棋棋块。", en: "Black to play. Save the black group with seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbrbqcqdqeqfqfrfs", white: "araqbpcpdpepfpgqgrirhpcsdses" },
            correct: ["dr"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-10-7",
        chapterId: "beginner-level3",
        order: 634,
        title: { zh: "死活 · 7/12", en: "Life&Death · 7/12" },
        instruction: { zh: "黑先。利用双活救出黑棋棋块。", en: "Black to play. Save the black group with seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbrcqbpbobnan", white: "apaqarcocnbmamcldqdrepcr" },
            correct: ["bq"],
            wrong: ["cpbq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-10-8",
        chapterId: "beginner-level3",
        order: 635,
        title: { zh: "死活 · 8/12", en: "Life&Death · 8/12" },
        instruction: { zh: "黑先。利用双活救出黑棋棋块。", en: "Black to play. Save the black group with seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "arbrcqcpcocnbnan", white: "bobpbscsdqdpdodncmbmdldr" },
            correct: ["apbqcr"],
            wrong: ["bqap"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-10-9",
        chapterId: "beginner-level3",
        order: 636,
        title: { zh: "死活 · 9/12", en: "Life&Death · 9/12" },
        instruction: { zh: "黑先。利用双活救出黑棋棋块。", en: "Black to play. Save the black group with seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aqbpcpcqcrdrds", white: "bsbrbqerdqfqdpdocobobm" },
            correct: ["ar"],
            wrong: ["apar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-10-10",
        chapterId: "beginner-level3",
        order: 637,
        title: { zh: "死活 · 10/12", en: "Life&Death · 10/12" },
        instruction: { zh: "黑先。利用双活救出黑棋棋块。", en: "Black to play. Save the black group with seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "blalbmcmcncocpcqbqap", white: "drdqdpdodndlakbkckbobnancrbrdm" },
            correct: ["ao"],
            wrong: ["aqao"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-10-11",
        chapterId: "beginner-level3",
        order: 638,
        title: { zh: "死活 · 11/12", en: "Life&Death · 11/12" },
        instruction: { zh: "黑先。利用双活救出黑棋棋块。", en: "Black to play. Save the black group with seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aqbqcpcocncmbmam", white: "brcrdqapblclaldmdodpeman" },
            correct: ["bo"],
            wrong: ["bpao", "aobo", "bnao", "cqbo"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-10-12",
        chapterId: "beginner-level3",
        order: 639,
        title: { zh: "死活 · 12/12", en: "Life&Death · 12/12" },
        instruction: { zh: "黑先。利用双活救出黑棋棋块。", en: "Black to play. Save the black group with seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbrcrcqcpcobo", white: "bqarbncndmdodpdqdrfr" },
            correct: ["ap"],
            wrong: ["aoap"],
        },
    },
];

const bl3LifeDeath11Levels: Level[] = [
    {
        id: "beginner-level3-bl3-life-death-11-1",
        chapterId: "beginner-level3",
        order: 640,
        title: { zh: "死活 · 1/12", en: "Life&Death · 1/12" },
        instruction: { zh: "白先。救出白棋棋块；注意假眼。", en: "White to play. Save the white group; watch out for a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpcqaraqapboaodocnfrfqepfohr", white: "bsbrcrdqbqbpdpeqer" },
            correct: ["ds"],
            wrong: ["codsescp", "codscpes"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-11-2",
        chapterId: "beginner-level3",
        order: 641,
        title: { zh: "死活 · 2/12", en: "Life&Death · 2/12" },
        instruction: { zh: "白先。救出白棋棋块；注意假眼。", en: "White to play. Save the white group; watch out for a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crbqcpdpepfqfrfsbpfobn", white: "arbrbscqdqeraq" },
            correct: ["ds", "csesds"],
            wrong: ["drds", "esdr", "csesdrds"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-11-3",
        chapterId: "beginner-level3",
        order: 642,
        title: { zh: "死活 · 3/12", en: "Life&Death · 3/12" },
        instruction: { zh: "白先。救出白棋棋块；注意假眼。", en: "White to play. Save the white group; watch out for a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gnfnemdmcmbncoaoapbmbqbrdscserhrfqgqgpgo", white: "bpcpdpdodncnenfofpeqdqdrfr" },
            correct: ["bo"],
            wrong: ["esbo"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-11-4",
        chapterId: "beginner-level3",
        order: 643,
        title: { zh: "死活 · 4/12", en: "Life&Death · 4/12" },
        instruction: { zh: "白先。救出白棋棋块；注意假眼。", en: "White to play. Save the white group; watch out for a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqapbpcpdpepfqfrfsesfo", white: "arasbsbqcrdsereq" },
            correct: ["cq"],
            wrong: ["dqcq", "drcq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-11-5",
        chapterId: "beginner-level3",
        order: 644,
        title: { zh: "死活 · 5/12", en: "Life&Death · 5/12" },
        instruction: { zh: "白先。救出白棋棋块；注意假眼。", en: "White to play. Save the white group; watch out for a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "drerfrgqhphognfnenhmiqircndpcobpbqcr", white: "cqdqeqfqgpgofoeoepcpgr" },
            correct: ["do"],
            wrong: ["hqdo"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-11-6",
        chapterId: "beginner-level3",
        order: 645,
        title: { zh: "死活 · 6/12", en: "Life&Death · 6/12" },
        instruction: { zh: "白先。救出白棋棋块；注意假眼。", en: "White to play. Save the white group; watch out for a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ereqepcpbqbp", white: "arbrbscqdr" },
            correct: ["ds"],
            wrong: ["csdq", "dqds"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-11-7",
        chapterId: "beginner-level3",
        order: 646,
        title: { zh: "死活 · 7/12", en: "Life&Death · 7/12" },
        instruction: { zh: "白先。救出白棋棋块；注意假眼。", en: "White to play. Save the white group; watch out for a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndnenesfogofmfshpdsdrcrgrfqcqhnanarbrhqbpbsbn", white: "eqerfrdqfpepeodobqgpcpcobo" },
            correct: ["gq"],
            wrong: ["apgqaoaq", "apgqaqao"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-11-8",
        chapterId: "beginner-level3",
        order: 647,
        title: { zh: "死活 · 8/12", en: "Life&Death · 8/12" },
        instruction: { zh: "白先。救出白棋棋块；注意假眼。", en: "White to play. Save the white group; watch out for a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqapbpcpdpeqfqfreobrhr", white: "asarbqcrcsdreres" },
            correct: ["cqbsar"],
            wrong: ["bscq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-11-9",
        chapterId: "beginner-level3",
        order: 648,
        title: { zh: "死活 · 9/12", en: "Life&Death · 9/12" },
        instruction: { zh: "白先。救出白棋棋块；注意假眼。", en: "White to play. Save the white group; watch out for a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gsgrgqfpgoepfnendncocpcqbqarbsaqcmhphq", white: "crdserfreqdqdpdoeofofqbr" },
            correct: ["fs"],
            wrong: ["gpfsfpes", "gpfsesfp"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-11-10",
        chapterId: "beginner-level3",
        order: 649,
        title: { zh: "死活 · 10/12", en: "Life&Death · 10/12" },
        instruction: { zh: "白先。救出白棋棋块；注意假眼。", en: "White to play. Save the white group; watch out for a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbqbpcpdpepeqfrfsgq", white: "arbrcscqdqer" },
            correct: ["dresds"],
            wrong: ["esdr", "dsdrescr", "dsdrcres"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-11-11",
        chapterId: "beginner-level3",
        order: 650,
        title: { zh: "死活 · 11/12", en: "Life&Death · 11/12" },
        instruction: { zh: "白先。救出白棋棋块；注意假眼。", en: "White to play. Save the white group; watch out for a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fqgrdsesfsbscshrgpgofodpdncnbnbofmiqip", white: "coarbrcqcpbpapdqeqerfrfpep" },
            correct: ["do"],
            wrong: ["gqdo"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-11-12",
        chapterId: "beginner-level3",
        order: 651,
        title: { zh: "死活 · 12/12", en: "Life&Death · 12/12" },
        instruction: { zh: "白先。救出白棋棋块；注意假眼。", en: "White to play. Save the white group; watch out for a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bsbrbqbpcpdpepfqgqhqirisip", white: "cqdqeqfrfsgrhrhs" },
            correct: ["ds"],
            wrong: ["drds", "crdscser", "csds"],
        },
    },
];

const bl3LifeDeath12Levels: Level[] = [
    {
        id: "beginner-level3-bl3-life-death-12-1",
        chapterId: "beginner-level3",
        order: 652,
        title: { zh: "死活 · 1/12", en: "Life&Death · 1/12" },
        instruction: { zh: "黑先。吃掉白棋棋块；利用假眼。", en: "Black to play. Capture the white group; use a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpcpcqdqeqfrfpgr", white: "aqbqbrbscrdr" },
            correct: ["dseser"],
            wrong: ["esds", "erds"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-12-2",
        chapterId: "beginner-level3",
        order: 653,
        title: { zh: "死活 · 2/12", en: "Life&Death · 2/12" },
        instruction: { zh: "黑先。吃掉白棋棋块；利用假眼。", en: "Black to play. Capture the white group; use a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bncndnbmenfogofmfqfrerdrcrbrco", white: "arbqboancpcqdqeqepeodo" },
            correct: ["apaqaobpao", "apaoaqbpaq"],
            wrong: ["aqap", "aoap", "asaq", "amaoapbp"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-12-3",
        chapterId: "beginner-level3",
        order: 654,
        title: { zh: "死活 · 3/12", en: "Life&Death · 3/12" },
        instruction: { zh: "黑先。吃掉白棋棋块；利用假眼。", en: "Black to play. Capture the white group; use a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cnfqeqdraoapaqbqbrcsbnemfmgngogpgreodmcl", white: "fpenfncrcqdqdpbpbocododnerep" },
            correct: ["fo"],
            wrong: ["dsfo"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-12-4",
        chapterId: "beginner-level3",
        order: 655,
        title: { zh: "死活 · 4/12", en: "Life&Death · 4/12" },
        instruction: { zh: "黑先。吃掉白棋棋块；利用假眼。", en: "Black to play. Capture the white group; use a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "araqbqdpeofogpgqgrgsfsbpcocn", white: "brbscqdqdrdsesfrfqep" },
            correct: ["eqerfp"],
            wrong: ["fpeq", "crfp", "csfp", "ereq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-12-5",
        chapterId: "beginner-level3",
        order: 656,
        title: { zh: "死活 · 5/12", en: "Life&Death · 5/12" },
        instruction: { zh: "黑先。吃掉白棋棋块；利用假眼。", en: "Black to play. Capture the white group; use a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpbocodoeoepfqfrfsdsgp", white: "aqbqbrbscrereqdqdpcp" },
            correct: ["dr"],
            wrong: ["esdr"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-12-6",
        chapterId: "beginner-level3",
        order: 657,
        title: { zh: "死活 · 6/12", en: "Life&Death · 6/12" },
        instruction: { zh: "黑先。吃掉白棋棋块；利用假眼。", en: "Black to play. Capture the white group; use a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqbpcpdpeqfqgrhrgpfses", white: "asarbrcqdqdrerfrgs" },
            correct: ["cs"],
            wrong: ["hscs", "dscs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-12-7",
        chapterId: "beginner-level3",
        order: 658,
        title: { zh: "死活 · 7/12", en: "Life&Death · 7/12" },
        instruction: { zh: "黑先。吃掉白棋棋块；利用假眼。", en: "Black to play. Capture the white group; use a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmbncnasaraqapaoandmenfnfsfrfqeqdqgp", white: "dodndpcsdrerbrbqbpcqboco" },
            correct: ["es"],
            wrong: ["bses"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-12-8",
        chapterId: "beginner-level3",
        order: 659,
        title: { zh: "死活 · 8/12", en: "Life&Death · 8/12" },
        instruction: { zh: "黑先。吃掉白棋棋块；利用假眼。", en: "Black to play. Capture the white group; use a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "asbpcpdpfrhrgpfqep", white: "brcscqdqdser" },
            correct: ["araqbqbsar"],
            wrong: ["bqar", "aqar", "drareqes", "eqardres", "crar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-12-9",
        chapterId: "beginner-level3",
        order: 660,
        title: { zh: "死活 · 9/12", en: "Life&Death · 9/12" },
        instruction: { zh: "黑先。吃掉白棋棋块；利用假眼。", en: "Black to play. Capture the white group; use a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcmcodoenemckfofpepdqcqerfraoanam", white: "aqbqdrcrdsbpcpdpbocnbndn" },
            correct: ["bs"],
            wrong: ["brbs", "eobs", "eqbs", "esbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-12-10",
        chapterId: "beginner-level3",
        order: 661,
        title: { zh: "死活 · 10/12", en: "Life&Death · 10/12" },
        instruction: { zh: "黑先。吃掉白棋棋块；利用假眼。", en: "Black to play. Capture the white group; use a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fmbncndneofogpfsesdscscraoapaqardqgrgq", white: "dpcobpbqcqdrerfqdo" },
            correct: ["freqep", "frepeq", "ep"],
            wrong: ["eqep", "boep"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-12-11",
        chapterId: "beginner-level3",
        order: 662,
        title: { zh: "死活 · 11/12", en: "Life&Death · 11/12" },
        instruction: { zh: "黑先。吃掉白棋棋块；利用假眼。", en: "Black to play. Capture the white group; use a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqbsdsesfsfrfqepeodocobobm", white: "arbrbqbpapcpdpdqdrer" },
            correct: ["crcscr"],
            wrong: ["cscr"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-12-12",
        chapterId: "beginner-level3",
        order: 663,
        title: { zh: "死活 · 12/12", en: "Life&Death · 12/12" },
        instruction: { zh: "黑先。吃掉白棋棋块；利用假眼。", en: "Black to play. Capture the white group; use a false eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqbpcpdpepeqdrfqgr", white: "arbrcrcscqdqer" },
            correct: ["es"],
            wrong: ["dses", "fses", "fres"],
        },
    },
];

const bl3LifeDeath13Levels: Level[] = [
    {
        id: "beginner-level3-bl3-life-death-13-1",
        chapterId: "beginner-level3",
        order: 664,
        title: { zh: "死活 · 1/24", en: "Life&Death · 1/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cscrcpbpbnfqdqeqgrdohr", white: "drercqbqbrarap" },
            correct: ["bs"],
            wrong: ["dsbs", "frbs", "esbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-13-2",
        chapterId: "beginner-level3",
        order: 665,
        title: { zh: "死活 · 2/24", en: "Life&Death · 2/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbpcpdqeqfrfsfp", white: "bqcqbsdreres" },
            correct: ["br"],
            wrong: ["csbr", "arcr", "crar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-13-3",
        chapterId: "beginner-level3",
        order: 666,
        title: { zh: "死活 · 3/24", en: "Life&Death · 3/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crdrcpdpbncndnbl", white: "brcsbpboao" },
            correct: ["aq"],
            wrong: ["arbq", "bqbsasaq", "bqbsaqasarbs", "bsbq", "asbq", "cqaqarbs", "cqaqbqar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-13-4",
        chapterId: "beginner-level3",
        order: 667,
        title: { zh: "死活 · 4/24", en: "Life&Death · 4/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brbqbpcpcndnenfogpgqgrfresdsfn", white: "fserdrcrcqdpdoeofpfq" },
            correct: ["eq"],
            wrong: ["cseqepes", "cseqesep", "cseqdqep"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-13-5",
        chapterId: "beginner-level3",
        order: 668,
        title: { zh: "死活 · 5/24", en: "Life&Death · 5/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crcqcodpeofogohnhphqhrgrbr", white: "csfsfrgqgpfpepdqdr" },
            correct: ["eq"],
            wrong: ["erds", "eseq", "dseq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-13-6",
        chapterId: "beginner-level3",
        order: 669,
        title: { zh: "死活 · 6/24", en: "Life&Death · 6/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aobocndodpbmdqcrdrcsaq", white: "bsbrapbpcp" },
            correct: ["ar"],
            wrong: ["bqar", "cqar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-13-7",
        chapterId: "beginner-level3",
        order: 670,
        title: { zh: "死活 · 7/24", en: "Life&Death · 7/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbqcpcobndqeperes", white: "dsdrcrcqbpar" },
            correct: ["bs"],
            wrong: ["brbsaqao", "aqbsaobr"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-13-8",
        chapterId: "beginner-level3",
        order: 671,
        title: { zh: "死活 · 8/24", en: "Life&Death · 8/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aobocodpdqdrdseo", white: "brcrcpbpap" },
            correct: ["ar"],
            wrong: ["cqaraqbs", "cqarcsaq", "cqarbsaq", "cqarasbscsaq", "cqarasbsaqcs", "csarcqaqasbs", "csaraqcqasbq", "csaraqcqbqas", "csarbqas", "csarasbsaqcqasbq", "ascs", "bscqbqar", "bscqarbq", "bscqaqbq", "bqcsbsar", "aqcq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-13-9",
        chapterId: "beginner-level3",
        order: 672,
        title: { zh: "死活 · 9/24", en: "Life&Death · 9/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrdrcqdpdocncmdlbl", white: "bmbnbococpbqaq" },
            correct: ["ap"],
            wrong: ["aoam", "amapbpao", "amapaobp", "anap"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-13-10",
        chapterId: "beginner-level3",
        order: 673,
        title: { zh: "死活 · 10/24", en: "Life&Death · 10/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcqdqeqfrgrfpbodn", white: "brcrdreres" },
            correct: ["ar"],
            wrong: ["aqar", "ascs", "bsar", "csar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-13-11",
        chapterId: "beginner-level3",
        order: 674,
        title: { zh: "死活 · 11/24", en: "Life&Death · 11/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ereqepencobobpapaqdngr", white: "arbqcqcpdpdr" },
            correct: ["bs"],
            wrong: ["dsbr", "csbr", "brcsdsbs", "brcsbsds", "crbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-13-12",
        chapterId: "beginner-level3",
        order: 675,
        title: { zh: "死活 · 12/24", en: "Life&Death · 12/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dserdqcqcpbocoepes", white: "arbqbpcrdr" },
            correct: ["bscsapbrcr"],
            wrong: ["bscsbrap", "csbsbrap", "csbsapbr", "apbscsbr", "apbsbrcs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-13-13",
        chapterId: "beginner-level3",
        order: 676,
        title: { zh: "死活 · 13/24", en: "Life&Death · 13/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "anbncodpdqdrcrdn", white: "bsbraqcqcpbo" },
            correct: ["bp"],
            wrong: ["aobp", "apbp", "bqao"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-13-14",
        chapterId: "beginner-level3",
        order: 677,
        title: { zh: "死活 · 14/24", en: "Life&Death · 14/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcqdpdobofpfogqfresfshr", white: "arbrcrdsdqeqfq" },
            correct: ["bs"],
            wrong: ["erbs", "drbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-13-15",
        chapterId: "beginner-level3",
        order: 678,
        title: { zh: "死活 · 15/24", en: "Life&Death · 15/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrcrdrdqdpcocncmblckan", white: "aqbqcqbobnbmam" },
            correct: ["cpapbp"],
            wrong: ["cpapaobp", "aobpcpap", "aobpapcp", "apcp", "bpao"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-13-16",
        chapterId: "beginner-level3",
        order: 679,
        title: { zh: "死活 · 16/24", en: "Life&Death · 16/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbpcqdqeqfrfsfp", white: "asaraqbqcrdrer" },
            correct: ["bs"],
            wrong: ["escs", "cses", "dsbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-13-17",
        chapterId: "beginner-level3",
        order: 680,
        title: { zh: "死活 · 17/24", en: "Life&Death · 17/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqapbpcpfpfrfsesgqepdphr", white: "arasbsdscrbqereq" },
            correct: ["cq"],
            wrong: ["dqcq", "drcq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-13-18",
        chapterId: "beginner-level3",
        order: 681,
        title: { zh: "死活 · 18/24", en: "Life&Death · 18/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbrcrcqcpcocncmclbler", white: "bsarbqbpbobnbmam" },
            correct: ["ao"],
            wrong: ["aqao"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-13-19",
        chapterId: "beginner-level3",
        order: 682,
        title: { zh: "死活 · 19/24", en: "Life&Death · 19/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "araqbpcpcqepeqgqhrhqgodo", white: "bsbrbqcrdqerfrgr" },
            correct: ["ds"],
            wrong: ["gsdsesdrcsdr", "gsdsdres", "esgs", "fsds", "drgsfsds", "drgsdsfs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-13-20",
        chapterId: "beginner-level3",
        order: 683,
        title: { zh: "死活 · 20/24", en: "Life&Death · 20/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "escsfreqdqcqbqaqhrgq", white: "arbrcrdrer" },
            correct: ["bs"],
            wrong: ["fsbs", "dsbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-13-21",
        chapterId: "beginner-level3",
        order: 684,
        title: { zh: "死活 · 21/24", en: "Life&Death · 21/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brcrdsereqepdocnbnenbl", white: "arbqcqdrdqdpcobo" },
            correct: ["bs"],
            wrong: ["aocsbpaq", "aocsaqbp", "apcs", "bpcsaoaq", "bpcsaqao", "aqcsaobp", "aqcsbpao"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-13-22",
        chapterId: "beginner-level3",
        order: 685,
        title: { zh: "死活 · 22/24", en: "Life&Death · 22/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbqcqdqeqfqgqhqiqjqjr", white: "irhrgrerdrcrbr" },
            correct: ["fr"],
            wrong: ["isfrfsgs", "bsfrfsis"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-13-23",
        chapterId: "beginner-level3",
        order: 686,
        title: { zh: "死活 · 23/24", en: "Life&Death · 23/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bsbrcqdpepfqbpgqhrhpir", white: "cscrdqeqerfrgs" },
            correct: ["dsfsgr"],
            wrong: ["dsfsesgr", "esgr", "grdsesdr", "grdsdres", "fsds"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-13-24",
        chapterId: "beginner-level3",
        order: 687,
        title: { zh: "死活 · 24/24", en: "Life&Death · 24/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcrdrcpcocnbmamdmep", white: "arbrbsbpbobnan" },
            correct: ["ap"],
            wrong: ["aqap"],
        },
    },
];

const bl3LifeDeath14Levels: Level[] = [
    {
        id: "beginner-level3-bl3-life-death-14-1",
        chapterId: "beginner-level3",
        order: 688,
        title: { zh: "死活 · 1/24", en: "Life&Death · 1/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqbrcpdpepfpgphqhrfshobo", white: "crcqeqgqcserfqgrgs" },
            correct: ["dqdres"],
            wrong: ["esdq", "drdq", "dses"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-14-2",
        chapterId: "beginner-level3",
        order: 689,
        title: { zh: "死活 · 2/24", en: "Life&Death · 2/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbrbpcpdpeqfrfpbnhr", white: "araqbqcqdqdreres" },
            correct: ["cs"],
            wrong: ["crcsdsas", "ascs", "dscs", "fscs", "apcs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-14-3",
        chapterId: "beginner-level3",
        order: 690,
        title: { zh: "死活 · 3/24", en: "Life&Death · 3/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "asbsbraobodqdrdofrcofp", white: "cscrcqbqbpap" },
            correct: ["ar"],
            wrong: ["cpar", "aqar", "dsar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-14-4",
        chapterId: "beginner-level3",
        order: 691,
        title: { zh: "死活 · 4/24", en: "Life&Death · 4/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crbpcpdpepeqeresbn", white: "bsbqcqdqdrds" },
            correct: ["araqbr"],
            wrong: ["brar", "aqar", "asar", "csbr"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-14-5",
        chapterId: "beginner-level3",
        order: 692,
        title: { zh: "死活 · 5/24", en: "Life&Death · 5/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqbrcrdrerblcmdneofpfqendlbk", white: "apbpcqdqepdococnbnbm" },
            correct: ["dpcpeqamao"],
            wrong: ["eqdp", "ameq", "aoeq", "cpdp", "aneq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-14-6",
        chapterId: "beginner-level3",
        order: 693,
        title: { zh: "死活 · 6/24", en: "Life&Death · 6/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dqdrdsbrbqbpcodoeofpgqhqiripfnbn", white: "escscrcqcpdpepeqfqgrfs" },
            correct: ["erfrdr"],
            wrong: ["frer", "hrer"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-14-7",
        chapterId: "beginner-level3",
        order: 694,
        title: { zh: "死活 · 7/24", en: "Life&Death · 7/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "arbqcqcserdpephqhrhpgpenco", white: "brcrdqeqfqgqgrgsfsesds" },
            correct: ["bs"],
            wrong: ["drbs", "asbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-14-8",
        chapterId: "beginner-level3",
        order: 695,
        title: { zh: "死活 · 8/24", en: "Life&Death · 8/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brcqdpblcmdndmckepcrbo", white: "aqbqcpcocnbnbmam" },
            correct: ["ao"],
            wrong: ["apaoanbp", "bpao", "arao", "doao", "alao"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-14-9",
        chapterId: "beginner-level3",
        order: 696,
        title: { zh: "死活 · 9/24", en: "Life&Death · 9/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bncocpdqdrdscsbldn", white: "bscrbqcqbpbo" },
            correct: ["araqao"],
            wrong: ["aoar", "aqar", "apar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-14-10",
        chapterId: "beginner-level3",
        order: 697,
        title: { zh: "死活 · 10/24", en: "Life&Death · 10/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brdsereqdpcobnaodnbm", white: "arbqbpbocpcrdrdq" },
            correct: ["bs"],
            wrong: ["csbs", "apbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-14-11",
        chapterId: "beginner-level3",
        order: 698,
        title: { zh: "死活 · 11/24", en: "Life&Death · 11/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ereqdpcpcn", white: "brcqdr" },
            correct: ["bpcsbqdqar", "bpbqcsdsaqarbs"],
            wrong: ["csbpboaqdsbs", "csbpboaqbsds", "bqbp", "dsbpbocsdqes"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-14-12",
        chapterId: "beginner-level3",
        order: 699,
        title: { zh: "死活 · 12/24", en: "Life&Death · 12/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brbqhrhqcpdpepfphpbodserfrfshofn", white: "cscrcqdqeqfqgqgrgs" },
            correct: ["esdres"],
            wrong: ["dres", "hsdr", "bsdr", "gpdr"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-14-13",
        chapterId: "beginner-level3",
        order: 700,
        title: { zh: "死活 · 13/24", en: "Life&Death · 13/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "csdrbqcqdqeqfqgqhrhpboir", white: "arbrcrdseserfrgrgs" },
            correct: ["bsascs"],
            wrong: ["bsasaqcs", "aqbs", "asbs", "hsbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-14-14",
        chapterId: "beginner-level3",
        order: 701,
        title: { zh: "死活 · 14/24", en: "Life&Death · 14/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqbocpdpeoeqergranbn", white: "brcqdqdrdsbpapao" },
            correct: ["ar"],
            wrong: ["aqarcsbs", "aqarbscs", "bsaraqcs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-14-15",
        chapterId: "beginner-level3",
        order: 702,
        title: { zh: "死活 · 15/24", en: "Life&Death · 15/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "arbshrhqgqfpepdpcqbqcohogsir", white: "brcrdsdqeqfqfrgrfs" },
            correct: ["er"],
            wrong: ["hser"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-14-16",
        chapterId: "beginner-level3",
        order: 703,
        title: { zh: "死活 · 16/24", en: "Life&Death · 16/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqaoanbncndodpdrerenfp", white: "bsbrcrcqcpcoboap" },
            correct: ["ar"],
            wrong: ["aqarbpap"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-14-17",
        chapterId: "beginner-level3",
        order: 704,
        title: { zh: "死活 · 17/24", en: "Life&Death · 17/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bocodpdqerdseqdn", white: "arbrdrcqcpbpap" },
            correct: ["bs"],
            wrong: ["csbs", "crbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-14-18",
        chapterId: "beginner-level3",
        order: 705,
        title: { zh: "死活 · 18/24", en: "Life&Death · 18/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brbqbpcodnenfngogpfqfrbngq", white: "cpcqcrcsdoeofofpeqer" },
            correct: ["dpepesdsdq", "dpepdq"],
            wrong: ["dpepesdsfsdq", "esdp", "dqdp", "drdq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-14-19",
        chapterId: "beginner-level3",
        order: 706,
        title: { zh: "死活 · 19/24", en: "Life&Death · 19/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "craqapbpcpdqeqfrfphr", white: "arbrbqcqdrer" },
            correct: ["cs"],
            wrong: ["bscs", "escs", "dscs", "fscs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-14-20",
        chapterId: "beginner-level3",
        order: 707,
        title: { zh: "死活 · 20/24", en: "Life&Death · 20/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "arbralblcmdmdodpcqdrfoek", white: "aqbqcpcobocnbmam" },
            correct: ["ao"],
            wrong: ["anbnapbp", "anbnaoap", "apbpanbn", "apbpaoan", "dnao"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-14-21",
        chapterId: "beginner-level3",
        order: 708,
        title: { zh: "死活 · 21/24", en: "Life&Death · 21/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brcqcodpeoenemdlclbmbleqcr", white: "aqbqbpcpaododnbncm" },
            correct: ["cnbocn"],
            wrong: ["cnbodmcn", "cnbococn", "bocn", "dmcn"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-14-22",
        chapterId: "beginner-level3",
        order: 709,
        title: { zh: "死活 · 22/24", en: "Life&Death · 22/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbqcrdrereqepeodncnbnanem", white: "arbrcqdqdpdocobobp" },
            correct: ["apaqao"],
            wrong: ["aqap", "aoap", "csaq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-14-23",
        chapterId: "beginner-level3",
        order: 710,
        title: { zh: "死活 · 23/24", en: "Life&Death · 23/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "anbncodoepeqeresdscsenar", white: "asbsbrbqcpdpdqdrboao" },
            correct: ["craqbpapcq"],
            wrong: ["aqap", "apbp"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-14-24",
        chapterId: "beginner-level3",
        order: 711,
        title: { zh: "死活 · 24/24", en: "Life&Death · 24/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "anbncodpdqdrfrdn", white: "bscrcqbqcpapbo" },
            correct: ["araoaq"],
            wrong: ["araobraq", "araoasaq", "aoar", "dsar"],
        },
    },
];

const bl3LifeDeath15Levels: Level[] = [
    {
        id: "beginner-level3-bl3-life-death-15-1",
        chapterId: "beginner-level3",
        order: 712,
        title: { zh: "死活 · 1/24", en: "Life&Death · 1/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "csbpcpdqeqfqgqdobn", white: "brbqcqdr" },
            correct: ["bsdseresfsfrcr"],
            wrong: ["bsdsesercrds", "aqbs", "asaq", "arbs", "erbs", "dsbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-15-2",
        chapterId: "beginner-level3",
        order: 713,
        title: { zh: "死活 · 2/24", en: "Life&Death · 2/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqaobocodpeqeresdscseo", white: "bsbrcrdrbpcp" },
            correct: ["aq"],
            wrong: ["apcq", "cqaqapar", "arcq", "dqap"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-15-3",
        chapterId: "beginner-level3",
        order: 714,
        title: { zh: "死活 · 3/24", en: "Life&Death · 3/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcqeqfqgqhqiq", white: "brcrerfr" },
            correct: ["dsfsgrgshr"],
            wrong: ["dsfsgrgshshresgs", "dsfsgsgr", "drargrhr", "drarbsgr", "ardrdsgr", "grdrdsar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-15-4",
        chapterId: "beginner-level3",
        order: 715,
        title: { zh: "死活 · 4/24", en: "Life&Death · 4/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocpdqdrdofrbn", white: "crcqbqbpap" },
            correct: ["ar"],
            wrong: ["bsar", "csar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-15-5",
        chapterId: "beginner-level3",
        order: 716,
        title: { zh: "死活 · 5/24", en: "Life&Death · 5/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrcqdpepfqgrgphrbp", white: "asbscrdsdqerfrfs" },
            correct: ["eq"],
            wrong: ["cseq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-15-6",
        chapterId: "beginner-level3",
        order: 717,
        title: { zh: "死活 · 6/24", en: "Life&Death · 6/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrcranblcmcncodpdqeodlbk", white: "bqcqcpbobnbmam" },
            correct: ["aqapbp"],
            wrong: ["aqapaobp", "apaq", "aoaq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-15-7",
        chapterId: "beginner-level3",
        order: 718,
        title: { zh: "死活 · 7/24", en: "Life&Death · 7/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fresgshrhqhpgpepdpcpfobqarbpcr", white: "bsbrdscqdqeqfqgqgr" },
            correct: ["er"],
            wrong: ["drfp", "cshs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-15-8",
        chapterId: "beginner-level3",
        order: 719,
        title: { zh: "死活 · 8/24", en: "Life&Death · 8/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brbqbpesfrfqgpgofnemdmbnhrhqgmbm", white: "crcqdsereqdpfpfoen" },
            correct: ["dn"],
            wrong: ["fseo", "doeoepdn", "doeodnep", "eodo", "coeo"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-15-9",
        chapterId: "beginner-level3",
        order: 720,
        title: { zh: "死活 · 9/24", en: "Life&Death · 9/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "hqhpgobqbrcrgnfmelencncobpcmgliockdrfrgrhr", white: "cqdqeqfqgqgpcpdofofnem" },
            correct: ["ep"],
            wrong: ["dmdneoep", "dmdnepeo", "eoepdndm", "eoepdmdn", "dnepeodm", "dnepdmeo"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-15-10",
        chapterId: "beginner-level3",
        order: 721,
        title: { zh: "死活 · 10/24", en: "Life&Death · 10/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bsbrcqdqepfpgqhqhrhsgpbp", white: "grgsfqeqerdrcs" },
            correct: ["fscrds"],
            wrong: ["crfs", "dsfs", "escr"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-15-11",
        chapterId: "beginner-level3",
        order: 722,
        title: { zh: "死活 · 11/24", en: "Life&Death · 11/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bsbrbococpdqerepfrbm", white: "arbqbpcqdrcs" },
            correct: ["ap"],
            wrong: ["crap", "dsap", "esap"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-15-12",
        chapterId: "beginner-level3",
        order: 723,
        title: { zh: "死活 · 12/24", en: "Life&Death · 12/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brcrdqdpdocncmblaldl", white: "bqcqcpcobnbmam" },
            correct: ["ao"],
            wrong: ["apbo", "boapaqao", "boapaoaq", "aqbo", "bpao"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-15-13",
        chapterId: "beginner-level3",
        order: 724,
        title: { zh: "死活 · 13/24", en: "Life&Death · 13/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcpdpeqerfpbn", white: "bsbqdqdr" },
            correct: ["ar"],
            wrong: ["brcqcrds", "cqaraqdscsbr", "cqaraqdsbrcs", "cqarbraq", "aqdscscqcrar", "aqdsarcr", "aqdscrar", "aqdsbrcq", "craraqds", "crardsaq", "dsaraqcrcqbr", "cscqcrar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-15-14",
        chapterId: "beginner-level3",
        order: 725,
        title: { zh: "死活 · 14/24", en: "Life&Death · 14/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbocpcqdrdobnfr", white: "cscrbrbqbp" },
            correct: ["asbsaq"],
            wrong: ["asbsapas", "apas", "aqas"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-15-15",
        chapterId: "beginner-level3",
        order: 726,
        title: { zh: "死活 · 15/24", en: "Life&Death · 15/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqapbnbocpdqeresep", white: "arcrdrdscq" },
            correct: ["bs"],
            wrong: ["brbs", "bqbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-15-16",
        chapterId: "beginner-level3",
        order: 727,
        title: { zh: "死活 · 16/24", en: "Life&Death · 16/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aoanbncndodpdqcqdrdsen", white: "cscrbrbqapbococp" },
            correct: ["asaqbp"],
            wrong: ["asaqarbp", "arbp", "bpar", "aqas"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-15-17",
        chapterId: "beginner-level3",
        order: 728,
        title: { zh: "死活 · 17/24", en: "Life&Death · 17/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dsesereqdpcpbpbneo", white: "bsbqcqdqdr" },
            correct: ["ar"],
            wrong: ["csaraqbr", "brcs", "crar", "aqcs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-15-18",
        chapterId: "beginner-level3",
        order: 729,
        title: { zh: "死活 · 18/24", en: "Life&Death · 18/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "drcqcpcockerfrbmbldkelflgmhnbnhogqgkhrgpfn", white: "dqeqfqfpdpdocncmdlemfmgnclgo" },
            correct: ["en"],
            wrong: ["foen", "eoen", "dnen"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-15-19",
        chapterId: "beginner-level3",
        order: 730,
        title: { zh: "死活 · 19/24", en: "Life&Death · 19/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "anbncndoeoeqfrdrcsbsfo", white: "arbrcrdqdpcpbo" },
            correct: ["bq"],
            wrong: ["aobq", "bpaoapbq", "bpaobqap", "apbq", "cobq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-15-20",
        chapterId: "beginner-level3",
        order: 731,
        title: { zh: "死活 · 20/24", en: "Life&Death · 20/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbqcpdpeqfrfsbpfp", white: "arbrcscqdqer" },
            correct: ["dr"],
            wrong: ["esdr", "dsdrcres", "dsdrescr", "cres"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-15-21",
        chapterId: "beginner-level3",
        order: 732,
        title: { zh: "死活 · 21/24", en: "Life&Death · 21/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brbqbpcpdrdsdpepfqgqhrhpir", white: "cqcrdqeqerfrgrgs" },
            correct: ["es"],
            wrong: ["cses", "bses", "hscs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-15-22",
        chapterId: "beginner-level3",
        order: 733,
        title: { zh: "死活 · 22/24", en: "Life&Death · 22/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brdqblbmdmeneoepcmdr", white: "cpdobobncnam" },
            correct: ["bq"],
            wrong: ["cqbq", "anbq", "dpbqapbp", "dpbqanap", "aobq", "apbq", "aqbq", "dnbq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-15-23",
        chapterId: "beginner-level3",
        order: 734,
        title: { zh: "死活 · 23/24", en: "Life&Death · 23/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcqdqeqfqgqhq", white: "brcrdrer" },
            correct: ["ar"],
            wrong: ["frargrhr", "esar", "bsarfrgrfsds"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-15-24",
        chapterId: "beginner-level3",
        order: 735,
        title: { zh: "死活 · 24/24", en: "Life&Death · 24/24" },
        instruction: { zh: "白先。救出你的棋块。", en: "White to play. Save your group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bsbrfrgshrhqgpfpepdpcqbpip", white: "cscrdqeqfqgqgres" },
            correct: ["er"],
            wrong: ["fsdr", "drfs", "dsfs"],
        },
    },
];

const bl3LifeDeath16Levels: Level[] = [
    {
        id: "beginner-level3-bl3-life-death-16-1",
        chapterId: "beginner-level3",
        order: 736,
        title: { zh: "死活 · 1/24", en: "Life&Death · 1/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "craqapbpcpdpepfqfrfses", white: "arbrbqcqdqeqerds" },
            correct: ["bs"],
            wrong: ["csbsdrds", "drcs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-16-2",
        chapterId: "beginner-level3",
        order: 737,
        title: { zh: "死活 · 2/24", en: "Life&Death · 2/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbrbqcpdpepfpdsgqhphrhs", white: "cqcrcsdqeqfqgrgses" },
            correct: ["fr"],
            wrong: ["erdr", "drer", "fsfr"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-16-3",
        chapterId: "beginner-level3",
        order: 738,
        title: { zh: "死活 · 3/24", en: "Life&Death · 3/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bncocpdpcrdrerdn", white: "bsbrcqbpboao" },
            correct: ["aqarbqapbq"],
            wrong: ["aqarbqapdqbq", "aqardqbq", "aqaranbq", "aqarcsbq", "bqaq", "araq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-16-4",
        chapterId: "beginner-level3",
        order: 739,
        title: { zh: "死活 · 4/24", en: "Life&Death · 4/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aqanbncndodpdqcqdrdmfr", white: "cscrbrbqcpcoboao" },
            correct: ["bp"],
            wrong: ["aras", "apbp", "asar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-16-5",
        chapterId: "beginner-level3",
        order: 740,
        title: { zh: "死活 · 5/24", en: "Life&Death · 5/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aobncneoeperdrcsbsdsfrenblel", white: "arbrcrdqdpdocoboap" },
            correct: ["bq"],
            wrong: ["anbq", "bpbq", "cqbq", "asbq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-16-6",
        chapterId: "beginner-level3",
        order: 741,
        title: { zh: "死活 · 6/24", en: "Life&Death · 6/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "braqbpcpereqbncndpen", white: "bqcrcqapdrdsao" },
            correct: ["bs"],
            wrong: ["anbs", "esar", "esbs", "arbs", "asbs", "dqbs", "bobs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-16-7",
        chapterId: "beginner-level3",
        order: 742,
        title: { zh: "死活 · 7/24", en: "Life&Death · 7/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "codrdsaqbpapardoepfpgqgrgobnir", white: "frfsesbsbrbqcpdpdqeqfq" },
            correct: ["cr"],
            wrong: ["cqcr", "ercr", "cscr", "gscr", "ascr"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-16-8",
        chapterId: "beginner-level3",
        order: 743,
        title: { zh: "死活 · 8/24", en: "Life&Death · 8/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brbqfrfscpcoepfpgphqhrhodo", white: "cscrcqeqerfqgqgrgs" },
            correct: ["dqdres"],
            wrong: ["dqdrdpes", "esdsfsdq", "esdsdqfs", "dses", "drdq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-16-9",
        chapterId: "beginner-level3",
        order: 744,
        title: { zh: "死活 · 9/24", en: "Life&Death · 9/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "araobocodpdqdrdnfr", white: "bsbraqcqcpbp" },
            correct: ["apascr", "crasap"],
            wrong: ["apascscr", "crascsap", "cscr"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-16-10",
        chapterId: "beginner-level3",
        order: 745,
        title: { zh: "死活 · 10/24", en: "Life&Death · 10/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brbkckcldmdndocpcqcrepbnamao", white: "arbqbpbococnbmblal" },
            correct: ["anapan"],
            wrong: ["apan", "aqan", "cman", "akan"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-16-11",
        chapterId: "beginner-level3",
        order: 746,
        title: { zh: "死活 · 11/24", en: "Life&Death · 11/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "arasfsgrfqeqcpbpapeodqhrgp", white: "aqbqbrcrdrerfr" },
            correct: ["esdsbsgsfs"],
            wrong: ["esdsbsgshsfs", "esdsgsbs", "bscsases", "bscsesas", "dses", "csbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-16-12",
        chapterId: "beginner-level3",
        order: 747,
        title: { zh: "死活 · 12/24", en: "Life&Death · 12/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpcqdqerdseqcn", white: "bsbqcrdr" },
            correct: ["ar"],
            wrong: ["bpar", "esar", "aqar", "csesards"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-16-13",
        chapterId: "beginner-level3",
        order: 748,
        title: { zh: "死活 · 13/24", en: "Life&Death · 13/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brcrcpepfpgphpipiqirisdnco", white: "csdrdqeqfqgqhqhrhs" },
            correct: ["dsesfr"],
            wrong: ["esfsfrgr", "esfsdsergrds", "esfsdserdsgr", "esfserds", "esfsgrdsfrer", "esfsgrdsgsfr", "fsfrgses", "fsfresgs", "frfsesgr", "frfsgrds", "frfsergr", "grfr"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-16-14",
        chapterId: "beginner-level3",
        order: 749,
        title: { zh: "死活 · 14/24", en: "Life&Death · 14/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "apbpcpdpeqfqgrgpircs", white: "aqbqdqdrdserfrfs" },
            correct: ["cqcrbr"],
            wrong: ["crcq", "brcq"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-16-15",
        chapterId: "beginner-level3",
        order: 750,
        title: { zh: "死活 · 15/24", en: "Life&Death · 15/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "apbpbmcmcnbkencqdqdrdsepeo", white: "aqbqbrcrcpcobobn" },
            correct: ["bsaocs"],
            wrong: ["csbs", "anao", "aoan", "ascs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-16-16",
        chapterId: "beginner-level3",
        order: 751,
        title: { zh: "死活 · 16/24", en: "Life&Death · 16/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dsdreqepdocobofrenbm", white: "crbqbpcpdpdq" },
            correct: ["bscsbr"],
            wrong: ["bscsarbrasaq", "bscsarbraqap", "bscsarbrapas", "arbr", "apbsaqar", "apbscsaq", "apbsaraq", "brbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-16-17",
        chapterId: "beginner-level3",
        order: 752,
        title: { zh: "死活 · 17/24", en: "Life&Death · 17/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "anbncodnepeodreqfr", white: "arcrbqcqcpbo" },
            correct: ["bscsap"],
            wrong: ["bscsaoap", "aobs", "apbs", "csbs", "dsbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-16-18",
        chapterId: "beginner-level3",
        order: 753,
        title: { zh: "死活 · 18/24", en: "Life&Death · 18/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqanbncndodpdqdrcr", white: "arbrbscqcpbpbo" },
            correct: ["apaqao"],
            wrong: ["apaqcsao", "apaqcoao", "aqap", "aoap", "csao", "coap"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-16-19",
        chapterId: "beginner-level3",
        order: 754,
        title: { zh: "死活 · 19/24", en: "Life&Death · 19/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fsgrgqfpepdpcpbqcrbphp", white: "brcqdqdrdseqfqfr" },
            correct: ["arbses"],
            wrong: ["esar", "bsar", "csar"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-16-20",
        chapterId: "beginner-level3",
        order: 755,
        title: { zh: "死活 · 20/24", en: "Life&Death · 20/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbrbqbpeqgrgqgpfoeodocoirho", white: "cscrcqcpdpepfpfqfr" },
            correct: ["fsesdr"],
            wrong: ["fsesgsdr", "fseserdr", "esfserdr", "esfsdrer", "erdresfs", "erdrfses", "erdrdses", "drerfsdq", "drerdqds", "dreresdq", "drerdsdq", "dser", "dqfs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-16-21",
        chapterId: "beginner-level3",
        order: 756,
        title: { zh: "死活 · 21/24", en: "Life&Death · 21/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ambmcndmdodpdqcqdrfr", white: "crbrbqcpcobobn" },
            correct: ["aoapan"],
            wrong: ["aoapcsan", "aoapbsan", "anaoapbparaq", "anaoapbpaqar", "anaoapbpcsbs", "anaoapbpbscs", "apaocsbs", "apaoaqar", "apaobpaq", "apaoanbpcsbs", "apaoanbpaqar", "csapbsan", "csapanao"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-16-22",
        chapterId: "beginner-level3",
        order: 757,
        title: { zh: "死活 · 22/24", en: "Life&Death · 22/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "arcrdrbocodndpdqbm", white: "braqcscqcpbp" },
            correct: ["ao"],
            wrong: ["apao", "asap", "bsas", "dsbs"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-16-23",
        chapterId: "beginner-level3",
        order: 758,
        title: { zh: "死活 · 23/24", en: "Life&Death · 23/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bocpdqdrdofrbn", white: "cscrcqbpaq" },
            correct: ["br"],
            wrong: ["aobrapas", "aobrasap", "arbraoas", "arbrasap", "bsbrasap", "bsbraras", "bsbraoap"],
        },
    },
    {
        id: "beginner-level3-bl3-life-death-16-24",
        chapterId: "beginner-level3",
        order: 759,
        title: { zh: "死活 · 24/24", en: "Life&Death · 24/24" },
        instruction: { zh: "黑先。吃掉白棋棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcsdsdrdqdpcobncmeo", white: "bsarcrcqbp" },
            correct: ["cpbrapaqao"],
            wrong: ["cpbrapaqboao", "cpbraqap", "cpbrboap", "cpbraoap", "brcpaqap", "brcpapaq", "brcpboap", "apcpaqao", "apcpbobr", "apcpbraq", "apcpaoaq", "aqap", "boap", "aoap"],
        },
    },
];

const bl3LifeDeath17Levels: Level[] = [
    {
        id: "beginner-level3-bl3-life-death-17-1",
        chapterId: "beginner-level3",
        order: 760,
        title: { zh: "死活 · 1/20", en: "Life&Death · 1/20" },
        instruction: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcpcqdreqbn", white: "cscrbrbq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "dead",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bpcpcqdreqbn", white: "cscrbrbq" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-17-2",
        chapterId: "beginner-level3",
        order: 761,
        title: { zh: "死活 · 2/20", en: "Life&Death · 2/20" },
        instruction: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "araqbqcqdqeqfqgqhphrir", white: "brcrdrerfrgr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "dead",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "araqbqcqdqeqfqgqhphrir", white: "brcrdrerfrgr" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-17-3",
        chapterId: "beginner-level3",
        order: 762,
        title: { zh: "死活 · 3/20", en: "Life&Death · 3/20" },
        instruction: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocncpcqdqdrfr", white: "crbrbqbp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "dead",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bocncpcqdqdrfr", white: "crbrbqbp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-17-4",
        chapterId: "beginner-level3",
        order: 763,
        title: { zh: "死活 · 4/20", en: "Life&Death · 4/20" },
        instruction: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "frgqeqdqcqbqbo", white: "arbrcrdrer" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "depends",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "frgqeqdqcqbqbo", white: "arbrcrdrer" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-17-5",
        chapterId: "beginner-level3",
        order: 764,
        title: { zh: "死活 · 5/20", en: "Life&Death · 5/20" },
        instruction: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dqdpdocrcsbscnbmcl", white: "brbqapbobncp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "alive",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dqdpdocrcsbscnbmcl", white: "brbqapbobncp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-17-6",
        chapterId: "beginner-level3",
        order: 765,
        title: { zh: "死活 · 6/20", en: "Life&Death · 6/20" },
        instruction: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcpdpeoeqergrbn", white: "bqcqdqdr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "dead",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bpcpdpeoeqergrbn", white: "bqcqdqdr" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-17-7",
        chapterId: "beginner-level3",
        order: 766,
        title: { zh: "死活 · 7/20", en: "Life&Death · 7/20" },
        instruction: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocpdqcneqer", white: "asbrbqbpcrdr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "alive",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bocpdqcneqer", white: "asbrbqbpcrdr" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-17-8",
        chapterId: "beginner-level3",
        order: 767,
        title: { zh: "死活 · 8/20", en: "Life&Death · 8/20" },
        instruction: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbpcpdpeqeresfp", white: "aqbqcqdqdrds" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "depends",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "apbpcpdpeqeresfp", white: "aqbqcqdqdrds" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-17-9",
        chapterId: "beginner-level3",
        order: 768,
        title: { zh: "死活 · 9/20", en: "Life&Death · 9/20" },
        instruction: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aparbscsdreqepeodncnbmemblfr", white: "bqbrcrdqdpdocoboao" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "alive",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "aparbscsdreqepeodncnbmemblfr", white: "bqbrcrdqdpdocoboao" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-17-10",
        chapterId: "beginner-level3",
        order: 769,
        title: { zh: "死活 · 10/20", en: "Life&Death · 10/20" },
        instruction: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcpdodqdrfrbn", white: "cscrcqbq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "dead",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bpcpdodqdrfrbn", white: "cscrcqbq" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-17-11",
        chapterId: "beginner-level3",
        order: 770,
        title: { zh: "死活 · 11/20", en: "Life&Death · 11/20" },
        instruction: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqaqanambmcncodpdqcrcserdm", white: "bsbrcqcpbpbobn" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "dead",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bqaqanambmcncodpdqcrcserdm", white: "bsbrcqcpbpbobn" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-17-12",
        chapterId: "beginner-level3",
        order: 771,
        title: { zh: "死活 · 12/20", en: "Life&Death · 12/20" },
        instruction: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocpdqdrepcnfr", white: "crcqbqbp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "dead",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bocpdqdrepcnfr", white: "crcqbqbp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-17-13",
        chapterId: "beginner-level3",
        order: 772,
        title: { zh: "死活 · 13/20", en: "Life&Death · 13/20" },
        instruction: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbobndodpdqcrercm", white: "bsbrcqcpbpao" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "dead",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "aqbobndodpdqcrercm", white: "bsbrcqcpbpao" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-17-14",
        chapterId: "beginner-level3",
        order: 773,
        title: { zh: "死活 · 14/20", en: "Life&Death · 14/20" },
        instruction: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bococpdqdrepbmfr", white: "crcqbpaq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "depends",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bococpdqdrepbmfr", white: "crcqbpaq" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-17-15",
        chapterId: "beginner-level3",
        order: 774,
        title: { zh: "死活 · 15/20", en: "Life&Death · 15/20" },
        instruction: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmcmcndodpdqdrcsbrarenbk", white: "aqbqcqcrcpcobobnan" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "alive",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bmcmcndodpdqdrcsbrarenbk", white: "aqbqcqcrcpcobobnan" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-17-16",
        chapterId: "beginner-level3",
        order: 775,
        title: { zh: "死活 · 16/20", en: "Life&Death · 16/20" },
        instruction: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocodpdqdrfrbmeo", white: "brcrcqcpbp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "depends",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bocodpdqdrfrbmeo", white: "brcrcqcpbp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-17-17",
        chapterId: "beginner-level3",
        order: 776,
        title: { zh: "死活 · 17/20", en: "Life&Death · 17/20" },
        instruction: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bsaobncncocpcqdqerfq", white: "arbqbpbocrdrds" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "dead",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bsaobncncocpcqdqerfq", white: "arbqbpbocrdrds" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-17-18",
        chapterId: "beginner-level3",
        order: 777,
        title: { zh: "死活 · 18/20", en: "Life&Death · 18/20" },
        instruction: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocodpdqdrfreobm", white: "arcrcqcpbp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "depends",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bocodpdqdrfreobm", white: "arcrcqcpbp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-17-19",
        chapterId: "beginner-level3",
        order: 778,
        title: { zh: "死活 · 19/20", en: "Life&Death · 19/20" },
        instruction: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncnbldodpdqcqcrerdm", white: "csbrbqaqaobocp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "alive",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bncnbldodpdqcqcrerdm", white: "csbrbqaqaobocp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-17-20",
        chapterId: "beginner-level3",
        order: 779,
        title: { zh: "死活 · 20/20", en: "Life&Death · 20/20" },
        instruction: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brdrcqblckcmdmdodp", white: "aqbqcpcoaobnbm" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the white group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "alive",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "brdrcqblckcmdmdodp", white: "aqbqcpcoaobnbm" },
            },
        },
    },
];

const bl3LifeDeath18Levels: Level[] = [
    {
        id: "beginner-level3-bl3-life-death-18-1",
        chapterId: "beginner-level3",
        order: 780,
        title: { zh: "死活 · 1/20", en: "Life&Death · 1/20" },
        instruction: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ambmcncocpbobqaq", white: "aoarbrcqcrdqeqdneocmblaldl" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "dead",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "ambmcncocpbobqaq", white: "aoarbrcqcrdqeqdneocmblaldl" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-18-2",
        chapterId: "beginner-level3",
        order: 781,
        title: { zh: "死活 · 2/20", en: "Life&Death · 2/20" },
        instruction: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arcrcqbqbp", white: "bocpdqdrdobnfr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "depends",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "arcrcqbqbp", white: "bocpdqdrdobnfr" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-18-3",
        chapterId: "beginner-level3",
        order: 782,
        title: { zh: "死活 · 3/20", en: "Life&Death · 3/20" },
        instruction: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bsdsdrcrcqbqap", white: "aqbrbpcpdqerepbobn" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "alive",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bsdsdrcrcqbqap", white: "aqbrbpcpdqerepbobn" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-18-4",
        chapterId: "beginner-level3",
        order: 783,
        title: { zh: "死活 · 4/20", en: "Life&Death · 4/20" },
        instruction: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "asbrcrcsbqbp", white: "aparbococpdqdrfrbmdn" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "alive",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "asbrcrcsbqbp", white: "aparbococpdqdrfrbmdn" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-18-5",
        chapterId: "beginner-level3",
        order: 784,
        title: { zh: "死活 · 5/20", en: "Life&Death · 5/20" },
        instruction: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crcqdqeqfqfr", white: "brbqcpdpepfpgqgrhpir" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "dead",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "crcqdqeqfqfr", white: "brbqcpdpepfpgqgrhpir" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-18-6",
        chapterId: "beginner-level3",
        order: 785,
        title: { zh: "死活 · 6/20", en: "Life&Death · 6/20" },
        instruction: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbqbpbobmcncm", white: "alblcldmdncocpcqbrardrdkap" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "dead",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "aqbqbpbobmcncm", white: "alblcldmdncocpcqbrardrdkap" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-18-7",
        chapterId: "beginner-level3",
        order: 786,
        title: { zh: "死活 · 7/20", en: "Life&Death · 7/20" },
        instruction: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cscrbrbqbpap", white: "aqarbsbocncpcqdrdqfr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "alive",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cscrbrbqbpap", white: "aqarbsbocncpcqdrdqfr" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-18-8",
        chapterId: "beginner-level3",
        order: 787,
        title: { zh: "死活 · 8/20", en: "Life&Death · 8/20" },
        instruction: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crcqdqeqfqgqgrfs", white: "gshshrhqgpfpepdpcpbqbrho" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "depends",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "crcqdqeqfqgqgrfs", white: "gshshrhqgpfpepdpcpbqbrho" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-18-9",
        chapterId: "beginner-level3",
        order: 788,
        title: { zh: "死活 · 9/20", en: "Life&Death · 9/20" },
        instruction: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrbscqbp", white: "aobocodpdqcrer" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "dead",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "arbrbscqbp", white: "aobocodpdqcrer" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-18-10",
        chapterId: "beginner-level3",
        order: 789,
        title: { zh: "死活 · 10/20", en: "Life&Death · 10/20" },
        instruction: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crcqdqeqfqfrgrgs", white: "hrgqfpepdpcpbqbrhpir" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "depends",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "crcqdqeqfqfrgrgs", white: "hrgqfpepdpcpbqbrhpir" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-18-11",
        chapterId: "beginner-level3",
        order: 790,
        title: { zh: "死活 · 11/20", en: "Life&Death · 11/20" },
        instruction: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbrcscqdqbpbobn", white: "bmclcncpdpcrdreqfrepdn" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "alive",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "aqbrcscqdqbpbobn", white: "bmclcncpdpcrdreqfrepdn" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-18-12",
        chapterId: "beginner-level3",
        order: 791,
        title: { zh: "死活 · 12/20", en: "Life&Death · 12/20" },
        instruction: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crcqdqeqfqfrgr", white: "hrgqfpepdpcpbqbrhpir" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "dead",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "crcqdqeqfqfrgr", white: "hrgqfpepdpcpbqbrhpir" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-18-13",
        chapterId: "beginner-level3",
        order: 792,
        title: { zh: "死活 · 13/20", en: "Life&Death · 13/20" },
        instruction: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrcrbpap", white: "bocpcobmdqdrdsep" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "alive",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "arbrcrbpap", white: "bocpcobmdqdrdsep" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-18-14",
        chapterId: "beginner-level3",
        order: 793,
        title: { zh: "死活 · 14/20", en: "Life&Death · 14/20" },
        instruction: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cscrcqdqeqfqgqgrgs", white: "bsbrbqcpdpepfpgphqhrhsho" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "alive",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cscrcqdqeqfqgqgrgs", white: "bsbrbqcpdpepfpgphqhrhsho" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-18-15",
        chapterId: "beginner-level3",
        order: 794,
        title: { zh: "死活 · 15/20", en: "Life&Death · 15/20" },
        instruction: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bsbrbqcrdrdscp", white: "ereqdqdpcobodnbmaqargr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "dead",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bsbrbqcrdrdscp", white: "ereqdqdpcobodnbmaqargr" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-18-16",
        chapterId: "beginner-level3",
        order: 795,
        title: { zh: "死活 · 16/20", en: "Life&Death · 16/20" },
        instruction: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crcqdqeqfqgqgrgs", white: "brbqcpdpepfpgphqhrhsho" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "depends",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "crcqdqeqfqgqgrgs", white: "brbqcpdpepfpgphqhrhsho" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-18-17",
        chapterId: "beginner-level3",
        order: 796,
        title: { zh: "死活 · 17/20", en: "Life&Death · 17/20" },
        instruction: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "asbraqbpbobn", white: "bmclcncocpcrdrep" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "alive",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "asbraqbpbobn", white: "bmclcncocpcrdrep" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-18-18",
        chapterId: "beginner-level3",
        order: 797,
        title: { zh: "死活 · 18/20", en: "Life&Death · 18/20" },
        instruction: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crcqdqeqfqgqgres", white: "brbqcpdpepfpgphqhrho" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "depends",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "crcqdqeqfqgqgres", white: "brbqcpdpepfpgphqhrho" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-18-19",
        chapterId: "beginner-level3",
        order: 798,
        title: { zh: "死活 · 19/20", en: "Life&Death · 19/20" },
        instruction: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bsbrcqcpcoboao", white: "apbqbncndodpdqdrcrdmbl" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "dead",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bsbrcqcpcoboao", white: "apbqbncndodpdqdrcrdmbl" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-life-death-18-20",
        chapterId: "beginner-level3",
        order: 799,
        title: { zh: "死活 · 20/20", en: "Life&Death · 20/20" },
        instruction: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "csbrcqcpbp", white: "aqcrdrdqdpcocncmeo" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋棋块的状态是什么？死棋、活棋，还是取决于谁先落子？", en: "What is the status of the black group? Dead, alive or does it depend on who is to play?" },
            options: [{ value: "alive", label: { zh: "活棋", en: "alive" } }, { value: "dead", label: { zh: "死棋", en: "dead" } }, { value: "depends", label: { zh: "取决于谁先落子", en: "depends" } }],
            correctValue: "dead",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "csbrcqcpbp", white: "aqcrdrdqdpcocncmeo" },
            },
        },
    },
];

const bl3CapturingRace1Levels: Level[] = [
    {
        id: "beginner-level3-bl3-capturing-race-1-1",
        chapterId: "beginner-level3",
        order: 800,
        title: { zh: "对杀 · 1/13", en: "Capturing Race · 1/13" },
        instruction: { zh: "在对杀中，有时可以通过做两个眼来避免战斗。或者你可以将棋块与另一个棋块连接，增加气数。如果你还没有被完全包围，可以尝试逃跑。在这个例子中，四颗白棋棋子还没有被完全包围。白棋可以通过在A点落子逃跑。通过避免战斗赢得对杀。", en: "In a capturing race you can sometimes avoid a fight by making two eyes. Or you connect your group with another group, increasing the number of liberties. If you are not yet completely surrounded, you could try to escape. In this example the four white stones are not yet completely surrounded. White can escape by playing at A. Win the capturing race by avoiding the fight." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrcocpcrdodqdreofqfrhr", white: "aqbnbobpbqcncqdpdsepeqer" },
            marks: { A: "fp" },
            correct: ["fpgpfoenfn"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-1-2",
        chapterId: "beginner-level3",
        order: 801,
        title: { zh: "对杀 · 2/13", en: "Capturing Race · 2/13" },
        instruction: { zh: "白先。通过避免战斗赢得对杀。", en: "White to play. Win the capturing race by avoiding the fight." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cnesfqgrcoaqbqcqdqerfrdp", white: "arbrcrdrbseqepgphqhrgoeoen" },
            correct: ["ds"],
            wrong: ["gqds", "gsds", "fpds"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-1-3",
        chapterId: "beginner-level3",
        order: 802,
        title: { zh: "对杀 · 3/13", en: "Capturing Race · 3/13" },
        instruction: { zh: "白先。通过避免战斗赢得对杀。", en: "White to play. Win the capturing race by avoiding the fight." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bsbrbqcpdpdqfqfpgr", white: "cqcrcserbpbocncm" },
            correct: ["dr"],
            wrong: ["aqdr", "ardr", "esdr"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-1-4",
        chapterId: "beginner-level3",
        order: 803,
        title: { zh: "对杀 · 4/13", en: "Capturing Race · 4/13" },
        instruction: { zh: "白先。通过避免战斗赢得对杀。", en: "White to play. Win the capturing race by avoiding the fight." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqapbpcpdqdrdscncm", white: "arbscrcqbqdpepfrfqfn" },
            correct: ["cs"],
            wrong: ["eqcs", "ercs", "escs"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-1-5",
        chapterId: "beginner-level3",
        order: 804,
        title: { zh: "对杀 · 5/13", en: "Capturing Race · 5/13" },
        instruction: { zh: "白先。通过避免战斗赢得对杀。", en: "White to play. Win the capturing race by avoiding the fight." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bsbrbqcqdpepcofogo", white: "crcsdqdreqcpbpfpgphpfr" },
            correct: ["bocnbn"],
            wrong: ["aqbo", "apbo"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-1-6",
        chapterId: "beginner-level3",
        order: 805,
        title: { zh: "对杀 · 6/13", en: "Capturing Race · 6/13" },
        instruction: { zh: "白先。通过避免战斗赢得对杀。", en: "White to play. Win the capturing race by avoiding the fight." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocodoepeqerdrdscldmaoaqap", white: "arbrcrbsdqdpcpbpgqgrfmeofofp" },
            correct: ["bq"],
            wrong: ["fqbq", "frbq"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-1-7",
        chapterId: "beginner-level3",
        order: 806,
        title: { zh: "对杀 · 7/13", en: "Capturing Race · 7/13" },
        instruction: { zh: "白先。通过避免战斗赢得对杀。", en: "White to play. Win the capturing race by avoiding the fight." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrcrcqcpdoeoercndnfm", white: "bqbpcobndpdqdrgqgobocmcl" },
            correct: ["eq"],
            wrong: ["cseq", "aqeq", "dseq", "esfr", "epfp", "fqeq"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-1-8",
        chapterId: "beginner-level3",
        order: 807,
        title: { zh: "对杀 · 8/13", en: "Capturing Race · 8/13" },
        instruction: { zh: "白先。通过避免战斗赢得对杀。", en: "White to play. Win the capturing race by avoiding the fight." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "boclcpcqcrcsaobmcnck", white: "bsbrbqbpapcodoepeqerfn" },
            correct: ["ar"],
            wrong: ["dpar", "dqar", "drar", "dsar"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-1-9",
        chapterId: "beginner-level3",
        order: 808,
        title: { zh: "对杀 · 9/13", en: "Capturing Race · 9/13" },
        instruction: { zh: "白先。通过避免战斗赢得对杀。", en: "White to play. Win the capturing race by avoiding the fight." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crdrerbqbpfrgqfpeodocn", white: "eqdqcqbrbscsfqepgrgs" },
            correct: ["gp"],
            wrong: ["fsdp", "hqgp", "dsdp", "esdp", "fogp"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-1-10",
        chapterId: "beginner-level3",
        order: 809,
        title: { zh: "对杀 · 10/13", en: "Capturing Race · 10/13" },
        instruction: { zh: "白先。通过避免战斗赢得对杀。", en: "White to play. Win the capturing race by avoiding the fight." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbqcqcrbsdpepfqfrgo", white: "apbpcpdocndqdrdscm" },
            correct: ["areqcs"],
            wrong: ["areqbras", "csar", "brar", "asar"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-1-11",
        chapterId: "beginner-level3",
        order: 810,
        title: { zh: "对杀 · 11/13", en: "Capturing Race · 11/13" },
        instruction: { zh: "白先。通过避免战斗赢得对杀。", en: "White to play. Win the capturing race by avoiding the fight." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrcrbocpdpdqepfofn", white: "csdsdrcqbqbpbneqfpgpfr" },
            correct: ["co", "aocoap"],
            wrong: ["aocoanap", "bsap"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-1-12",
        chapterId: "beginner-level3",
        order: 811,
        title: { zh: "对杀 · 12/13", en: "Capturing Race · 12/13" },
        instruction: { zh: "白先。通过避免战斗赢得对杀。", en: "White to play. Win the capturing race by avoiding the fight." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bsbrcrdrdseqgphphqhrepgn", white: "dqcqbqeresfrgrcodn" },
            correct: ["ar"],
            wrong: ["gsar", "aqar"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-1-13",
        chapterId: "beginner-level3",
        order: 812,
        title: { zh: "对杀 · 13/13", en: "Capturing Race · 13/13" },
        instruction: { zh: "白先。通过避免战斗赢得对杀。", en: "White to play. Win the capturing race by avoiding the fight." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpdqdrdsbqbpcocn", white: "cscrcqcpbmcmdndoepfqfrfodl" },
            correct: ["bo"],
            wrong: ["brar", "eqbr", "erbr", "esbr"],
        },
    },
];

const bl3CapturingRace2Levels: Level[] = [
    {
        id: "beginner-level3-bl3-capturing-race-2-1",
        chapterId: "beginner-level3",
        order: 813,
        title: { zh: "对杀 · 1/13", en: "Capturing Race · 1/13" },
        instruction: { zh: "你可以通过阻止对手填你的气，或增加自己的气数来赢得对杀。有时你甚至可以在填对手气的同时增加自己的气。这里，白棋有两口气，黑棋有三口气。如果白棋从右边开始，对杀会输。但白棋在A点落子可以增加一气，同时黑棋减少一气。形势就逆转了：白棋有三口气，黑棋只有两口气。用白棋赢得对杀。", en: "You can win the capturing race by preventing your opponent from filling your liberties, or by increasing the number of your liberties. Sometimes you can even gain a liberty, while filling an opponent's liberty. Here, White starts with two liberties and Black with three. White will lose the capturing race if they start from the right. But White will gain an extra liberty by playing at A, while Black loses one. The situation is then reversed: White has three liberties, and Black only two. Win the capturing race with White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpbqbrcpdodqeqfq", white: "cqcrdpepfpgogqhq" },
            marks: { A: "dr" },
            correct: ["drerfr", "dreres"],
            wrong: ["frdr"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-2-2",
        chapterId: "beginner-level3",
        order: 814,
        title: { zh: "对杀 · 2/13", en: "Capturing Race · 2/13" },
        instruction: { zh: "黑先。通过增加气数或防止损失气数来赢得对杀。", en: "Black to play. Win the capturing race by increasing the number of liberties or by preventing to lose them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcqdpepeqergr", white: "crdrdqbpcpcodo" },
            correct: ["br"],
            wrong: ["dsbr"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-2-3",
        chapterId: "beginner-level3",
        order: 815,
        title: { zh: "对杀 · 3/13", en: "Capturing Race · 3/13" },
        instruction: { zh: "黑先。通过增加气数或防止损失气数来赢得对杀。", en: "Black to play. Win the capturing race by increasing the number of liberties or by preventing to lose them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crcqcpdoeofqgq", white: "brbqbpbococmdpdq" },
            correct: ["dr"],
            wrong: ["epdr", "eqdr"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-2-4",
        chapterId: "beginner-level3",
        order: 816,
        title: { zh: "对杀 · 4/13", en: "Capturing Race · 4/13" },
        instruction: { zh: "黑先。通过增加气数或防止损失气数来赢得对杀。", en: "Black to play. Win the capturing race by increasing the number of liberties or by preventing to lose them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dqepfqdpbp", white: "eqerfpgphqiq" },
            correct: ["fr"],
            wrong: ["drfr"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-2-5",
        chapterId: "beginner-level3",
        order: 817,
        title: { zh: "对杀 · 5/13", en: "Capturing Race · 5/13" },
        instruction: { zh: "黑先。通过增加气数或防止损失气数来赢得对杀。", en: "Black to play. Win the capturing race by increasing the number of liberties or by preventing to lose them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aqapbpcpcododq", white: "arbrbqcqdpepfqgq" },
            correct: ["dr"],
            wrong: ["crdr", "eqer"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-2-6",
        chapterId: "beginner-level3",
        order: 818,
        title: { zh: "对杀 · 6/13", en: "Capturing Race · 6/13" },
        instruction: { zh: "黑先。通过增加气数或防止损失气数来赢得对杀。", en: "Black to play. Win the capturing race by increasing the number of liberties or by preventing to lose them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqbpcpdqeqfqgqgrgp", white: "dpepfpdocobocqcrdr" },
            correct: ["br"],
            wrong: ["erbr"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-2-7",
        chapterId: "beginner-level3",
        order: 819,
        title: { zh: "对杀 · 7/13", en: "Capturing Race · 7/13" },
        instruction: { zh: "黑先。通过增加气数或防止损失气数来赢得对杀。", en: "Black to play. Win the capturing race by increasing the number of liberties or by preventing to lose them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqdqepeofqfrgp", white: "eqerdrdpcpbpcndm" },
            correct: ["cr"],
            wrong: ["escr", "bqbr"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-2-8",
        chapterId: "beginner-level3",
        order: 820,
        title: { zh: "对杀 · 8/13", en: "Capturing Race · 8/13" },
        instruction: { zh: "黑先。通过增加气数或防止损失气数来赢得对杀。", en: "Black to play. Win the capturing race by increasing the number of liberties or by preventing to lose them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brapbpcpdpepeqeres", white: "aqbqcqdqdrdsboaocndneofofpfqfrhr" },
            correct: ["ar"],
            wrong: ["crar", "csar"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-2-9",
        chapterId: "beginner-level3",
        order: 821,
        title: { zh: "对杀 · 9/13", en: "Capturing Race · 9/13" },
        instruction: { zh: "黑先。通过增加气数或防止损失气数来赢得对杀。", en: "Black to play. Win the capturing race by increasing the number of liberties or by preventing to lose them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdqdrdscseqep", white: "bsbrcrcqdpdocnbn" },
            correct: ["bp"],
            wrong: ["bqbp"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-2-10",
        chapterId: "beginner-level3",
        order: 822,
        title: { zh: "对杀 · 10/13", en: "Capturing Race · 10/13" },
        instruction: { zh: "黑先。通过增加气数或防止损失气数来赢得对杀。", en: "Black to play. Win the capturing race by increasing the number of liberties or by preventing to lose them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brbqbpbococmdpepfqfrerdr", white: "cpcqcrcsdoeofpgpgqgrgsfsfn" },
            correct: ["bs"],
            wrong: ["dqds", "dsdq"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-2-11",
        chapterId: "beginner-level3",
        order: 823,
        title: { zh: "对杀 · 11/13", en: "Capturing Race · 11/13" },
        instruction: { zh: "黑先。通过增加气数或防止损失气数来赢得对杀。", en: "Black to play. Win the capturing race by increasing the number of liberties or by preventing to lose them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crcqdpepfpgqhphr", white: "brbqbpcpcndqeqfqgr" },
            correct: ["dr"],
            wrong: ["frdr", "erdr", "csdr"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-2-12",
        chapterId: "beginner-level3",
        order: 824,
        title: { zh: "对杀 · 12/13", en: "Capturing Race · 12/13" },
        instruction: { zh: "黑先。通过增加气数或防止损失气数来赢得对杀。", en: "Black to play. Win the capturing race by increasing the number of liberties or by preventing to lose them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crcqbpbocodrdndl", white: "brbqcpdpeperfqgq" },
            correct: ["bs"],
            wrong: ["aqbsards", "aqbscsdq", "aqbsdses", "csbs"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-2-13",
        chapterId: "beginner-level3",
        order: 825,
        title: { zh: "对杀 · 13/13", en: "Capturing Race · 13/13" },
        instruction: { zh: "黑先。通过增加气数或防止损失气数来赢得对杀。", en: "Black to play. Win the capturing race by increasing the number of liberties or by preventing to lose them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aqbqcqdqepbocn", white: "apbpcpdpeqfqgqgo" },
            correct: ["eo"],
            wrong: ["doeo", "ereo", "dreo", "coeo", "aoeo"],
        },
    },
];

const bl3CapturingRace3Levels: Level[] = [
    {
        id: "beginner-level3-bl3-capturing-race-3-1",
        chapterId: "beginner-level3",
        order: 826,
        title: { zh: "对杀 · 1/12", en: "Capturing race · 1/12" },
        instruction: { zh: "白先。白棋需要多少步才能吃掉黑棋？", en: "White to play. How many moves does White need to capture Black?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrbsbqcpdpereq", white: "bpbococqcrcs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋需要多少步才能吃掉黑棋？", en: "White to play. How many moves does White need to capture Black?" },
            options: [{ value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }],
            correctValue: "3",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "arbrbsbqcpdpereq", white: "bpbococqcrcs" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-3-2",
        chapterId: "beginner-level3",
        order: 827,
        title: { zh: "对杀 · 2/12", en: "Capturing race · 2/12" },
        instruction: { zh: "白先。白棋需要多少步才能吃掉黑棋？", en: "White to play. How many moves does White need to capture Black?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "asbqbparbrcsdqcoblcndoeocmckfmfocreqerds", white: "aqbodpepesbnbmcpcqapfsfrfqfpgoaohp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋需要多少步才能吃掉黑棋？", en: "White to play. How many moves does White need to capture Black?" },
            options: [{ value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }],
            correctValue: "2",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "asbqbparbrcsdqcoblcndoeocmckfmfocreqerds", white: "aqbodpepesbnbmcpcqapfsfrfqfpgoaohp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-3-3",
        chapterId: "beginner-level3",
        order: 828,
        title: { zh: "对杀 · 3/12", en: "Capturing race · 3/12" },
        instruction: { zh: "白先。白棋需要多少步才能吃掉黑棋？", en: "White to play. How many moves does White need to capture Black?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brcqcrcsdreqfqgqhphr", white: "araqbqdqdpcpboerfrgr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋需要多少步才能吃掉黑棋？", en: "White to play. How many moves does White need to capture Black?" },
            options: [{ value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }],
            correctValue: "3",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "brcqcrcsdreqfqgqhphr", white: "araqbqdqdpcpboerfrgr" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-3-4",
        chapterId: "beginner-level3",
        order: 829,
        title: { zh: "对杀 · 4/12", en: "Capturing race · 4/12" },
        instruction: { zh: "白先。白棋需要多少步才能吃掉黑棋？", en: "White to play. How many moves does White need to capture Black?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqarbrbsbpboaocrdqeqfqgqhreo", white: "bncmcocpcqbqcsdsdrerfr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋需要多少步才能吃掉黑棋？", en: "White to play. How many moves does White need to capture Black?" },
            options: [{ value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }],
            correctValue: "3",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "aqarbrbsbpboaocrdqeqfqgqhreo", white: "bncmcocpcqbqcsdsdrerfr" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-3-5",
        chapterId: "beginner-level3",
        order: 830,
        title: { zh: "对杀 · 5/12", en: "Capturing race · 5/12" },
        instruction: { zh: "白先。白棋需要多少步才能吃掉黑棋？", en: "White to play. How many moves does White need to capture Black?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crcsdreraqbqcpbp", white: "arbrbscqdqeqfqfr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋需要多少步才能吃掉黑棋？", en: "White to play. How many moves does White need to capture Black?" },
            options: [{ value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }],
            correctValue: "2",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "crcsdreraqbqcpbp", white: "arbrbscqdqeqfqfr" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-3-6",
        chapterId: "beginner-level3",
        order: 831,
        title: { zh: "对杀 · 6/12", en: "Capturing race · 6/12" },
        instruction: { zh: "白先。白棋需要多少步才能吃掉黑棋？", en: "White to play. How many moves does White need to capture Black?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocoardsdrdqdpcqeqeoaqapao", white: "cpbpbqbrcrdodndmfqfreresgoenfn" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋需要多少步才能吃掉黑棋？", en: "White to play. How many moves does White need to capture Black?" },
            options: [{ value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }],
            correctValue: "3",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bocoardsdrdqdpcqeqeoaqapao", white: "cpbpbqbrcrdodndmfqfreresgoenfn" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-3-7",
        chapterId: "beginner-level3",
        order: 832,
        title: { zh: "对杀 · 7/12", en: "Capturing race · 7/12" },
        instruction: { zh: "白先。白棋需要多少步才能吃掉黑棋？", en: "White to play. How many moves does White need to capture Black?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cscrdrercqbpbocn", white: "aqbqbrbscpdpdqfqfrfohr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋需要多少步才能吃掉黑棋？", en: "White to play. How many moves does White need to capture Black?" },
            options: [{ value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }],
            correctValue: "3",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cscrdrercqbpbocn", white: "aqbqbrbscpdpdqfqfrfohr" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-3-8",
        chapterId: "beginner-level3",
        order: 833,
        title: { zh: "对杀 · 8/12", en: "Capturing race · 8/12" },
        instruction: { zh: "白先。白棋需要多少步才能吃掉黑棋？", en: "White to play. How many moves does White need to capture Black?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fpirhpgpdqeqbqcqcrcseresiq", white: "asbraqgrhrcpdpepfqfrfsbpbnfo" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋需要多少步才能吃掉黑棋？", en: "White to play. How many moves does White need to capture Black?" },
            options: [{ value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }, { value: "5", label: { zh: "5", en: "5" } }],
            correctValue: "5",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "fpirhpgpdqeqbqcqcrcseresiq", white: "asbraqgrhrcpdpepfqfrfsbpbnfo" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-3-9",
        chapterId: "beginner-level3",
        order: 834,
        title: { zh: "对杀 · 9/12", en: "Capturing race · 9/12" },
        instruction: { zh: "白先。白棋需要多少步才能吃掉黑棋？", en: "White to play. How many moves does White need to capture Black?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crcsdmendrerfrgqapaobocodocndpcq", white: "bsbrbqbpcpdlelfmfneoepeqdqbnbmcmclfo" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋需要多少步才能吃掉黑棋？", en: "White to play. How many moves does White need to capture Black?" },
            options: [{ value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }, { value: "5", label: { zh: "5", en: "5" } }],
            correctValue: "4",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "crcsdmendrerfrgqapaobocodocndpcq", white: "bsbrbqbpcpdlelfmfneoepeqdqbnbmcmclfo" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-3-10",
        chapterId: "beginner-level3",
        order: 835,
        title: { zh: "对杀 · 10/12", en: "Capturing race · 10/12" },
        instruction: { zh: "白先。白棋需要多少步才能吃掉黑棋？", en: "White to play. How many moves does White need to capture Black?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrbsbqcrcpdpepeqgqgrgo", white: "bpbocncqdqdrerfrdn" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋需要多少步才能吃掉黑棋？", en: "White to play. How many moves does White need to capture Black?" },
            options: [{ value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }, { value: "5", label: { zh: "5", en: "5" } }],
            correctValue: "5",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "arbrbsbqcrcpdpepeqgqgrgo", white: "bpbocncqdqdrerfrdn" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-3-11",
        chapterId: "beginner-level3",
        order: 836,
        title: { zh: "对杀 · 11/12", en: "Capturing race · 11/12" },
        instruction: { zh: "白先。白棋需要多少步才能吃掉黑棋？", en: "White to play. How many moves does White need to capture Black?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gpaqgrbrbsbqbpcocqdpeodneqfqhp", white: "drcrcserepfpfofnemdmcnbnboaoapclardq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋需要多少步才能吃掉黑棋？", en: "White to play. How many moves does White need to capture Black?" },
            options: [{ value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }, { value: "5", label: { zh: "5", en: "5" } }],
            correctValue: "4",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "gpaqgrbrbsbqbpcocqdpeodneqfqhp", white: "drcrcserepfpfofnemdmcnbnboaoapclardq" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-3-12",
        chapterId: "beginner-level3",
        order: 837,
        title: { zh: "对杀 · 12/12", en: "Capturing race · 12/12" },
        instruction: { zh: "白先。白棋需要多少步才能吃掉黑棋？", en: "White to play. How many moves does White need to capture Black?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrbsbqbocpdpeqeren", white: "bpapcocnbncqcrcscl" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋需要多少步才能吃掉黑棋？", en: "White to play. How many moves does White need to capture Black?" },
            options: [{ value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }],
            correctValue: "3",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "arbrbsbqbocpdpeqeren", white: "bpapcocnbncqcrcscl" },
            },
        },
    },
];

const bl3CapturingRace4Levels: Level[] = [
    {
        id: "beginner-level3-bl3-capturing-race-4-1",
        chapterId: "beginner-level3",
        order: 838,
        title: { zh: "对杀 · 1/12", en: "Capturing Race · 1/12" },
        instruction: { zh: "黑先。通过攻击正确的棋串来赢得对杀。", en: "Black to play. Win the capturing race by attacking the right target chain." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "erfrgqgpfpendncmbobncpcqcrcsdr", white: "bsbrbqaqbpgrhrcododpdqeqfq" },
            correct: ["eo", "ep", "cn"],
            wrong: ["apao", "arfs", "asfs", "aofs"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-4-2",
        chapterId: "beginner-level3",
        order: 839,
        title: { zh: "对杀 · 2/12", en: "Capturing Race · 2/12" },
        instruction: { zh: "黑先。通过攻击正确的棋串来赢得对杀。", en: "Black to play. Win the capturing race by attacking the right target chain." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "freresbrbqapaobnfqepeodobmdm", white: "drdseqcofpgphqhrbobpcqdpdq" },
            correct: ["cr", "cs"],
            wrong: ["cngr"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-4-3",
        chapterId: "beginner-level3",
        order: 840,
        title: { zh: "对杀 · 3/12", en: "Capturing Race · 3/12" },
        instruction: { zh: "黑先。通过攻击正确的棋串来赢得对杀。", en: "Black to play. Win the capturing race by attacking the right target chain." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crdrdqergqhrhqcpbpdococm", white: "bsbrbqcqfrgreqepdpeoen" },
            correct: ["fq"],
            wrong: ["fsfq", "gsfq", "aqes", "ares", "ases", "cses", "escs"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-4-4",
        chapterId: "beginner-level3",
        order: 841,
        title: { zh: "对杀 · 4/12", en: "Capturing Race · 4/12" },
        instruction: { zh: "黑先。通过攻击正确的棋串来赢得对杀。", en: "Black to play. Win the capturing race by attacking the right target chain." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "arbqcpbpdpeqeresfqgqgrgsdn", white: "brcqdqdrdsepfpgphqhrhsho" },
            correct: ["cs"],
            wrong: ["crcs", "bsfs"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-4-5",
        chapterId: "beginner-level3",
        order: 842,
        title: { zh: "对杀 · 5/12", en: "Capturing Race · 5/12" },
        instruction: { zh: "黑先。通过攻击正确的棋串来赢得对杀。", en: "Black to play. Win the capturing race by attacking the right target chain." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqdqdrerfrfqgpbpbogofnencncscr", white: "bsbrarbqcpdpepfphpgreqhqgq" },
            correct: ["ap"],
            wrong: ["aqap", "cofs", "dofs", "eofs", "fofs"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-4-6",
        chapterId: "beginner-level3",
        order: 843,
        title: { zh: "对杀 · 6/12", en: "Capturing Race · 6/12" },
        instruction: { zh: "黑先。通过攻击正确的棋串来赢得对杀。", en: "Black to play. Win the capturing race by attacking the right target chain." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "epdpcpbqbrcrdrfpgqhqirip", white: "dqeqerfqgrhraraqapbpcqcoclbodnas" },
            correct: ["es", "fsesdsfrhs", "dsfresbsfs"],
            wrong: ["hsds", "fsesdsfrgshs", "fsesgsds", "gsds"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-4-7",
        chapterId: "beginner-level3",
        order: 844,
        title: { zh: "对杀 · 7/12", en: "Capturing Race · 7/12" },
        instruction: { zh: "黑先。通过攻击正确的棋串来赢得对杀。", en: "Black to play. Win the capturing race by attacking the right target chain." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcodrergofrhqhpcqdo", white: "arbrdqeqcrgrfq" },
            correct: ["gqhrir", "hrgqgs"],
            wrong: ["gsgq", "csfs", "aqfs", "bsds", "asds", "dpfs", "epds", "fpds"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-4-8",
        chapterId: "beginner-level3",
        order: 845,
        title: { zh: "对杀 · 8/12", en: "Capturing Race · 8/12" },
        instruction: { zh: "黑先。通过攻击正确的棋串来赢得对杀。", en: "Black to play. Win the capturing race by attacking the right target chain." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brbqeqfqgrepdpcp", white: "cqcrdqerdsbpbocodn" },
            correct: ["bscsfs"],
            wrong: ["frbs", "fsbs", "csbs"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-4-9",
        chapterId: "beginner-level3",
        order: 846,
        title: { zh: "对杀 · 9/12", en: "Capturing Race · 9/12" },
        instruction: { zh: "黑先。通过攻击正确的棋串来赢得对杀。", en: "Black to play. Win the capturing race by attacking the right target chain." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crcqbpbodpepfpgqgrgobncmcl", white: "brbqdqeqfqcpcodndmfndl" },
            correct: ["dr"],
            wrong: ["bsdr", "aqdr", "csbs", "ardr", "frdr", "erdr"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-4-10",
        chapterId: "beginner-level3",
        order: 847,
        title: { zh: "对杀 · 10/12", en: "Capturing Race · 10/12" },
        instruction: { zh: "黑先。通过攻击正确的棋串来赢得对杀。", en: "Black to play. Win the capturing race by attacking the right target chain." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "araqapbpcsereqepdocobo", white: "bqbrcpdpdqdrdseofogpfqgr" },
            correct: ["crcqes"],
            wrong: ["crcqbsasesfs", "crcqbsasbses", "bses", "escrasbs", "escrbsas", "ases"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-4-11",
        chapterId: "beginner-level3",
        order: 848,
        title: { zh: "对杀 · 11/12", en: "Capturing Race · 11/12" },
        instruction: { zh: "黑先。通过攻击正确的棋串来赢得对杀。", en: "Black to play. Win the capturing race by attacking the right target chain." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "asepfpgparhphohnfmemcnbococpdqdrdserfrhldn", white: "bscrcqbqbpapcsgqeqdphripgofqdoioeoiqfohq" },
            correct: ["en", "fn", "gn"],
            wrong: ["brgr", "braq", "aqgr", "aqbr", "aogrbraq", "aograqbr", "grgs"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-4-12",
        chapterId: "beginner-level3",
        order: 849,
        title: { zh: "对杀 · 12/12", en: "Capturing Race · 12/12" },
        instruction: { zh: "黑先。通过攻击正确的棋串来赢得对杀。", en: "Black to play. Win the capturing race by attacking the right target chain." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbrbqcqdpepfpgqgrfn", white: "crcsdsereqdqcpbpcododm" },
            correct: ["fsaqes"],
            wrong: ["fsaqfrar", "fsaqfqar", "fraq", "fqaq"],
        },
    },
];

const bl3CapturingRace5Levels: Level[] = [
    {
        id: "beginner-level3-bl3-capturing-race-5-1",
        chapterId: "beginner-level3",
        order: 850,
        title: { zh: "对杀 · 1/12", en: "Capturing Race · 1/12" },
        instruction: { zh: "白先。赢得对杀（有眼对无眼）。", en: "White to play. Win the capturing race (eye vs. no eye)." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brbqcpdpbpeqfqfrgrhrdn", white: "crcqdqergqhqiripfpep" },
            correct: ["ds"],
            wrong: ["csds", "fscs", "hscs", "gscs"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-5-2",
        chapterId: "beginner-level3",
        order: 851,
        title: { zh: "对杀 · 2/12", en: "Capturing Race · 2/12" },
        instruction: { zh: "白先。赢得对杀（有眼对无眼）。", en: "White to play. Win the capturing race (eye vs. no eye)." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqcpboaobncndnenbscrdrerdsfr", white: "arbrbqbpapgsfqhrcododpdqeqgq" },
            correct: ["fs"],
            wrong: ["grfs"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-5-3",
        chapterId: "beginner-level3",
        order: 852,
        title: { zh: "对杀 · 3/12", en: "Capturing Race · 3/12" },
        instruction: { zh: "白先。赢得对杀（有眼对无眼）。", en: "White to play. Win the capturing race (eye vs. no eye)." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbqbpcqdqdperesfrfqgp", white: "brcrdrdseqepdocoboeobm" },
            correct: ["bs"],
            wrong: ["apbs", "asbs", "aqbs", "cpbs"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-5-4",
        chapterId: "beginner-level3",
        order: 853,
        title: { zh: "对杀 · 4/12", en: "Capturing Race · 4/12" },
        instruction: { zh: "白先。赢得对杀（有眼对无眼）。", en: "White to play. Win the capturing race (eye vs. no eye)." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbpcpcqdrerfrescscn", white: "aqbqbrcrdqeqgqgreo" },
            correct: ["as"],
            wrong: ["bsas", "fqbs", "gsbs"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-5-5",
        chapterId: "beginner-level3",
        order: 854,
        title: { zh: "对杀 · 5/12", en: "Capturing Race · 5/12" },
        instruction: { zh: "白先。赢得对杀（有眼对无眼）。", en: "White to play. Win the capturing race (eye vs. no eye)." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "csdrerfrfscqcpbpapdpeo", white: "asbrbqaqcrdqeqfqgqgr" },
            correct: ["ds"],
            wrong: ["gsds", "esds", "bsar"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-5-6",
        chapterId: "beginner-level3",
        order: 855,
        title: { zh: "对杀 · 6/12", en: "Capturing Race · 6/12" },
        instruction: { zh: "白先。赢得对杀（有眼对无眼）。", en: "White to play. Win the capturing race (eye vs. no eye)." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbpapbocodnendpdqdrdscm", white: "arbqcqcpdoeoepeqergrfn" },
            correct: ["bs"],
            wrong: ["crcs", "esbr", "csbr", "brbscrcs", "brbscscr", "brbsescs", "brbsascr"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-5-7",
        chapterId: "beginner-level3",
        order: 856,
        title: { zh: "对杀 · 7/12", en: "Capturing Race · 7/12" },
        instruction: { zh: "白先。赢得对杀（有眼对无眼）。", en: "White to play. Win the capturing race (eye vs. no eye)." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "esfsfrarbqbpbocpdqeqfqgp", white: "crdrerdscqbncncodpepbrdnenbl" },
            correct: ["bsaoaq"],
            wrong: ["bsaoanaq", "asbs", "aqbs", "aobs"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-5-8",
        chapterId: "beginner-level3",
        order: 857,
        title: { zh: "对杀 · 8/12", en: "Capturing Race · 8/12" },
        instruction: { zh: "白先。赢得对杀（有眼对无眼）。", en: "White to play. Win the capturing race (eye vs. no eye)." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "drereqfrfsaqbqcqcpdocn", white: "arbrcrbsdqdpepfpfqgrhqfn" },
            correct: ["ds"],
            wrong: ["gsds"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-5-9",
        chapterId: "beginner-level3",
        order: 858,
        title: { zh: "对杀 · 9/12", en: "Capturing Race · 9/12" },
        instruction: { zh: "白先。赢得对杀（有眼对无眼）。", en: "White to play. Win the capturing race (eye vs. no eye)." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpeofpbrbqfqfrfsdnfnfmdpcp", white: "crcqdqeqerepgofogrhrgngmhp" },
            correct: ["ds"],
            wrong: ["esds", "csds", "gpds", "gqds", "gsds"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-5-10",
        chapterId: "beginner-level3",
        order: 859,
        title: { zh: "对杀 · 10/12", en: "Capturing Race · 10/12" },
        instruction: { zh: "白先。赢得对杀（有眼对无眼）。", en: "White to play. Win the capturing race (eye vs. no eye)." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aobobpcqdqdrdscodnenas", white: "aqbqbrapcpdpeperfrgp" },
            correct: ["bs"],
            wrong: ["csbsarbs", "crcs", "eqbscscr", "eqbsescs", "eqbscrcs", "esbseqcs", "esbscrcs", "esbscscr"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-5-11",
        chapterId: "beginner-level3",
        order: 860,
        title: { zh: "对杀 · 11/12", en: "Capturing Race · 11/12" },
        instruction: { zh: "白先。赢得对杀（有眼对无眼）。", en: "White to play. Win the capturing race (eye vs. no eye)." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "doepeqaqarasbseresfqgrencnemapbpcp", white: "brbqcqdqdrcsdpirfpfoeohofsgqgmhq" },
            correct: ["gshshrfrgs"],
            wrong: ["hrgs", "dscr", "frgs"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-5-12",
        chapterId: "beginner-level3",
        order: 861,
        title: { zh: "对杀 · 12/12", en: "Capturing Race · 12/12" },
        instruction: { zh: "白先。赢得对杀（有眼对无眼）。", en: "White to play. Win the capturing race (eye vs. no eye)." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "araqbqcqdrcsdpepfofqgrfn", white: "apbpcpdqeqeresdsdocncm" },
            correct: ["bscrbr", "bscras"],
            wrong: ["crbsdrfr", "brbscrdrcrfr"],
        },
    },
];

const bl3CapturingRace6Levels: Level[] = [
    {
        id: "beginner-level3-bl3-capturing-race-6-1",
        chapterId: "beginner-level3",
        order: 862,
        title: { zh: "对杀 · 1/24", en: "Capturing race · 1/24" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "arbqbpcpcocnblcldmelcr", white: "bobnbmcmdndodpdqcqbrbsdr" },
            correct: ["ao"],
            wrong: ["amap", "anap", "aqcs", "apao"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-6-2",
        chapterId: "beginner-level3",
        order: 863,
        title: { zh: "对杀 · 2/24", en: "Capturing race · 2/24" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bnendsargsgrgqbqcpfqeqdpbp", white: "asbsbrcqdqdrerfrfshphrirepfpgphn" },
            correct: ["cr"],
            wrong: ["csaq", "escs", "aqhq"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-6-3",
        chapterId: "beginner-level3",
        order: 864,
        title: { zh: "对杀 · 3/24", en: "Capturing race · 3/24" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmblcldmdncocpbpbqelfn", white: "aqbrcrcqdpeqdoanbncncmgp" },
            correct: ["ao"],
            wrong: ["boap", "apar", "amap"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-6-4",
        chapterId: "beginner-level3",
        order: 865,
        title: { zh: "对杀 · 4/24", en: "Capturing race · 4/24" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brbqbpcodoeofpeqfobn", white: "crcqcpdpepfqfrgphrgo" },
            correct: ["drercs"],
            wrong: ["eres", "dqdr", "csdr"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-6-5",
        chapterId: "beginner-level3",
        order: 866,
        title: { zh: "对杀 · 5/24", en: "Capturing race · 5/24" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dodmdlbrcrcqbocmblcndpfoflhn", white: "bnbmbkckcldkekbqbpcpdqdrfqgqhpco" },
            correct: ["ao"],
            wrong: ["aqao", "apao", "anao", "amao", "alao"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-6-6",
        chapterId: "beginner-level3",
        order: 867,
        title: { zh: "对杀 · 6/24", en: "Capturing race · 6/24" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crcqcpdoeoanbncndmgo", white: "csaqdsdrdqdpcoboaofqhp" },
            correct: ["bpapar"],
            wrong: ["bqbr", "apbp", "brarbpap", "brarbsbp", "brarbqbs", "brarapbp", "brarasbp", "arbpbrbs", "arbpbqbr", "arbpbsbr", "bsbr"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-6-7",
        chapterId: "beginner-level3",
        order: 868,
        title: { zh: "对杀 · 7/24", en: "Capturing race · 7/24" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brcrdreqepdpcobogq", white: "ardqcqbqcpbncndoeodmfo" },
            correct: ["ap"],
            wrong: ["bpaq", "aoap", "aqap", "asbs", "bsao", "anbp"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-6-8",
        chapterId: "beginner-level3",
        order: 869,
        title: { zh: "对杀 · 8/24", en: "Capturing race · 8/24" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpcodoeofogsgrgqgpgncmdq", white: "cqcrbpbobqdpepfpfqfrfsbn" },
            correct: ["er"],
            wrong: ["eqdr", "drds", "eser"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-6-9",
        chapterId: "beginner-level3",
        order: 870,
        title: { zh: "对杀 · 9/24", en: "Capturing race · 9/24" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aqbrcrcqbmcndodpdm", white: "bqbpcpcobnaodqdrfq" },
            correct: ["ar"],
            wrong: ["amcs"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-6-10",
        chapterId: "beginner-level3",
        order: 871,
        title: { zh: "对杀 · 10/24", en: "Capturing race · 10/24" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcqdqepfpfqgogn", white: "aqbpcpdpeqerhqdoeo" },
            correct: ["drfrgr"],
            wrong: ["frdr"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-6-11",
        chapterId: "beginner-level3",
        order: 872,
        title: { zh: "对杀 · 11/24", en: "Capturing race · 11/24" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "arbrcrcqbmcmcndodpenck", white: "bqaqbpcpcobndqdrepeqfrgp" },
            correct: ["aocsbo", "aocsap"],
            wrong: ["aocsanbs", "anao", "boao", "apao", "csds", "bsds"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-6-12",
        chapterId: "beginner-level3",
        order: 873,
        title: { zh: "对杀 · 12/24", en: "Capturing race · 12/24" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crcqcodpepdnfm", white: "cpbpdqdrfrgqcmclhq" },
            correct: ["bobqbr"],
            wrong: ["bqbobncn"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-6-13",
        chapterId: "beginner-level3",
        order: 874,
        title: { zh: "对杀 · 13/24", en: "Capturing race · 13/24" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcqdqdpeofobncmdmfm", white: "brcrdreqepdodncnbofrgp" },
            correct: ["cocpen"],
            wrong: ["cocpbpaq", "cocpaobm", "encoaobm", "encobpbm", "encocpaq", "encobmaq", "cpco", "bpbm", "bmbp"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-6-14",
        chapterId: "beginner-level3",
        order: 875,
        title: { zh: "对杀 · 14/24", en: "Capturing race · 14/24" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcqdpdndocmbldl", white: "brcrdqerepcpcocnbmgq" },
            correct: ["bp"],
            wrong: ["bnbp", "aqar", "bobp", "apbp"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-6-15",
        chapterId: "beginner-level3",
        order: 876,
        title: { zh: "对杀 · 15/24", en: "Capturing race · 15/24" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbrapbpcpdqdrfrgq", white: "arbqcqcrcsdpepgocobndn" },
            correct: ["aqasbrbobsards", "aqasbsbobrards"],
            wrong: ["aqasbrbobsarasar", "aqasdsbo", "dsasaqbo", "dsasbsbo", "dsasbrbo"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-6-16",
        chapterId: "beginner-level3",
        order: 877,
        title: { zh: "对杀 · 16/24", en: "Capturing race · 16/24" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqdpepeqercocn", white: "cpbpgrgqfpfoeodobmcmdmfm" },
            correct: ["bobqbrcraq", "bobqbrcrap"],
            wrong: ["bobqbrcrdqar", "bobqcrao", "bobqapbr", "bobqaqbr", "bqbo", "bnbo", "apbo"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-6-17",
        chapterId: "beginner-level3",
        order: 878,
        title: { zh: "对杀 · 17/24", en: "Capturing race · 17/24" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmbmambrcrcqdpdoeqapcngp", white: "cpcobobnanaqdnenblcldlgnbqfl" },
            correct: ["bpaobp", "bpaoap"],
            wrong: ["bpaoardm", "aobp", "ardm"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-6-18",
        chapterId: "beginner-level3",
        order: 879,
        title: { zh: "对杀 · 18/24", en: "Capturing race · 18/24" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqcpcodnendreremflfk", white: "eqdpdobpbocndmbmdlhrhqipioim" },
            correct: ["epeofofpdqepgpfqgqfrgr"],
            wrong: ["epeofofpdqepgpfqgqfrfsgr", "epeofofpdqepgpfqfrgq", "epeofofpdqepfqgp", "epeofofpgpgq", "epeofofpfqgp", "epeodqfo", "epeofpfogogpfqgn", "eofq", "dqfp"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-6-19",
        chapterId: "beginner-level3",
        order: 880,
        title: { zh: "对杀 · 19/24", en: "Capturing race · 19/24" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dqcqbqbpeneoepcm", white: "brcrdreqbocpdpdofpfrem" },
            correct: ["codndmcnbn"],
            wrong: ["codndmcnaoaq", "codndmcnbmaq", "codncndm", "dnco", "apao", "aqar", "cnaq", "bnaq"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-6-20",
        chapterId: "beginner-level3",
        order: 881,
        title: { zh: "对杀 · 20/24", en: "Capturing race · 20/24" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brcrdreqepfofn", white: "cqdqerfrfqcndmgp" },
            correct: ["cp"],
            wrong: ["bqcp", "dpcpcobo", "bpcpcodo"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-6-21",
        chapterId: "beginner-level3",
        order: 882,
        title: { zh: "对杀 · 21/24", en: "Capturing race · 21/24" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbrcrdrbncncocpdpeqep", white: "arbqcqdqbpboaoerdsfrfqfp" },
            correct: ["aqesan"],
            wrong: ["aqesascs", "anaq", "apesanaq", "ascs", "csas"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-6-22",
        chapterId: "beginner-level3",
        order: 883,
        title: { zh: "对杀 · 22/24", en: "Capturing race · 22/24" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbrbqcqdpepfpfn", white: "aqbpcpdqdrcrhqhpcnhr" },
            correct: ["ereqfqfrdsescsergr", "ereqfqfrcsesdsergr"],
            wrong: ["ereqfqfrdsesgrcs", "ereqfqfrcsesgrds", "ereqfqfresfs", "ereqdsfqgqgr", "ereqdsfqfrgq", "eqer", "csds", "dser"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-6-23",
        chapterId: "beginner-level3",
        order: 884,
        title: { zh: "对杀 · 23/24", en: "Capturing race · 23/24" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dqdpeofodncnbnem", white: "brdreqepdocoboergq" },
            correct: ["bpcpcq"],
            wrong: ["cpbp", "aocq", "cqbq", "crcq", "bqcq"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-6-24",
        chapterId: "beginner-level3",
        order: 885,
        title: { zh: "对杀 · 24/24", en: "Capturing race · 24/24" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "drerfqdpcpbpcqbn", white: "bsarbqcrdqeqephrhqho" },
            correct: ["foeoen"],
            wrong: ["foeofpen", "foeodoen", "eofp", "fpeo"],
        },
    },
];

const bl3CapturingRace7Levels: Level[] = [
    {
        id: "beginner-level3-bl3-capturing-race-7-1",
        chapterId: "beginner-level3",
        order: 886,
        title: { zh: "对杀 · 1/24", en: "Capturing race · 1/24" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bnbocoarbrcrdreqepeodnamengnfr", white: "bqaqbpcnbmaldocmbldpdmemdqcq" },
            correct: ["ao"],
            wrong: ["anao"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-7-2",
        chapterId: "beginner-level3",
        order: 887,
        title: { zh: "对杀 · 2/24", en: "Capturing race · 2/24" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brcsdsdrdqbocodoepeobm", white: "crcqcpdpbpeqerfpgq" },
            correct: ["bsases"],
            wrong: ["esbs", "aqbq", "bqaq", "asap", "arap", "apaq"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-7-3",
        chapterId: "beginner-level3",
        order: 888,
        title: { zh: "对杀 · 3/24", en: "Capturing race · 3/24" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crcqbpbocndnbmfn", white: "bqcocpdpdqergq" },
            correct: ["br"],
            wrong: ["drbr", "csbr", "aqbr"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-7-4",
        chapterId: "beginner-level3",
        order: 889,
        title: { zh: "对杀 · 4/24", en: "Capturing race · 4/24" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "hrfsesaraqapbscrdrdqepfphqhobocmcngo", white: "frgrgsbrbqcpeododpeqgnerfnem" },
            correct: ["csdscq"],
            wrong: ["dscs", "cqcs"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-7-5",
        chapterId: "beginner-level3",
        order: 890,
        title: { zh: "对杀 · 5/24", en: "Capturing race · 5/24" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqbpcpaoanbkclcmckcndodnfm", white: "arbrbobnbmblcodpdqdrgq" },
            correct: ["apaqcq"],
            wrong: ["aqal", "cqal", "amal"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-7-6",
        chapterId: "beginner-level3",
        order: 891,
        title: { zh: "对杀 · 6/24", en: "Capturing race · 6/24" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bobncpdpepdqerfofnenhn", white: "bqbpcodoeoeqfpgpgqiq" },
            correct: ["drfqcq"],
            wrong: ["fqcn"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-7-7",
        chapterId: "beginner-level3",
        order: 892,
        title: { zh: "对杀 · 7/24", en: "Capturing race · 7/24" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpdodncrdrereqbpapbncofpgqbs", white: "bobmcmdmdqeneoepcqbqelgmao" },
            correct: ["cpanboaocn", "cnanbocpaq"],
            wrong: ["cpancnboamaq", "cpancnboaqar", "cpanaqar", "cpanamaq", "anam", "cnancpboaqar", "cnancpboamaq", "aqan"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-7-8",
        chapterId: "beginner-level3",
        order: 893,
        title: { zh: "对杀 · 8/24", en: "Capturing race · 8/24" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brbqbpcobndqdpepdndmgper", white: "doeocpcqcrdrenemgohpgq" },
            correct: ["eqfqfp", "eqfpfq", "eqfpfo"],
            wrong: ["fpeq", "fqds", "frds"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-7-9",
        chapterId: "beginner-level3",
        order: 894,
        title: { zh: "对杀 · 9/24", en: "Capturing race · 9/24" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dqdpdobpenfndmcmbmel", white: "crdreqepeobocndnfrhq" },
            correct: ["cpcqbq"],
            wrong: ["cpcqcobq", "cocp", "cqco", "bqco", "bnbqcqcp", "bnbqcpcqbrco", "bnbqcpcqaqco", "bnbqcpcqapco"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-7-10",
        chapterId: "beginner-level3",
        order: 895,
        title: { zh: "对杀 · 10/24", en: "Capturing race · 10/24" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brcrcqdpdoeqfqgrgsgp", white: "bqbpcpdqdrerfrbncm" },
            correct: ["ar"],
            wrong: ["csbsards", "csbsdsfs", "bscsdsas", "bscsarasaqds", "bscsarasdsaq", "dsfs", "fsds"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-7-11",
        chapterId: "beginner-level3",
        order: 896,
        title: { zh: "对杀 · 11/24", en: "Capturing race · 11/24" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arasbscscrbqbpcpdodndmbm", white: "apbocodpdqcqerepeo" },
            correct: ["aobnaq"],
            wrong: ["aobndran", "aobndsan", "drbndscn", "drbnaoan", "dsbnaoan", "dsbndrcn"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-7-12",
        chapterId: "beginner-level3",
        order: 897,
        title: { zh: "对杀 · 12/24", en: "Capturing race · 12/24" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbqcqcrfrfqepdpfofnhr", white: "bsdqeqerescpbpapaqcodocm" },
            correct: ["csfsbr"],
            wrong: ["csfsdsbr", "csfsdrds", "brcsasar", "brcsdras", "brcsdsas", "ascsbrar", "ascsdsbr", "ascsdrbr", "drfs", "dscs"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-7-13",
        chapterId: "beginner-level3",
        order: 898,
        title: { zh: "对杀 · 13/24", en: "Capturing race · 13/24" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqbqcpdpbocnereqfpcmfqhp", white: "arbrcrdrdqcodoeoepfn" },
            correct: ["bpapaqbpbn"],
            wrong: ["aqbp", "dsbs"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-7-14",
        chapterId: "beginner-level3",
        order: 899,
        title: { zh: "对杀 · 14/24", en: "Capturing race · 14/24" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brdrdqdpbocobldlgq", white: "cqcpbpdodnfogm" },
            correct: ["bncncm"],
            wrong: ["bncnaocm", "cnbnbmcm", "aobn"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-7-15",
        chapterId: "beginner-level3",
        order: 900,
        title: { zh: "对杀 · 15/24", en: "Capturing race · 15/24" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbqcqcpcoboaodnclbldmfm", white: "anbncndodpdqcrbrerfo" },
            correct: ["apaqbscmas"],
            wrong: ["apaqasbs", "aqap", "bpap", "bscm", "ascm"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-7-16",
        chapterId: "beginner-level3",
        order: 901,
        title: { zh: "对杀 · 16/24", en: "Capturing race · 16/24" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ereqgphqhrdpcpbpgobnhs", white: "brcsdrdqcqepfpgqdoeoem" },
            correct: ["frfsesdsfq"],
            wrong: ["frfsfqes", "esfr", "fqfr"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-7-17",
        chapterId: "beginner-level3",
        order: 902,
        title: { zh: "对杀 · 17/24", en: "Capturing race · 17/24" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqbqaqaobmblcndodpdm", white: "brcrdrdqcpcobobnamepfp" },
            correct: ["ar"],
            wrong: ["apbp", "bpap", "anbp"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-7-18",
        chapterId: "beginner-level3",
        order: 903,
        title: { zh: "对杀 · 18/24", en: "Capturing race · 18/24" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bscrcqdpepfrfp", white: "csdrdqcpcodn" },
            correct: ["brbqas"],
            wrong: ["brbqdsar", "bqbrdsbp", "bqbrbpds", "dsbqarerbreqases", "dsbqbpar", "dsbqaqarapbp"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-7-19",
        chapterId: "beginner-level3",
        order: 904,
        title: { zh: "对杀 · 19/24", en: "Capturing race · 19/24" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbqbpbocpblclcmdndoem", white: "brcqdpcocnbnanbmeoepcrer" },
            correct: ["aoaqbs"],
            wrong: ["apaqbsao", "aqapbsal", "asao", "bsao"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-7-20",
        chapterId: "beginner-level3",
        order: 905,
        title: { zh: "对杀 · 20/24", en: "Capturing race · 20/24" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcqcrdrbndodpdnbm", white: "brbpcpbodqeqerep" },
            correct: ["aq"],
            wrong: ["dsarbsaqcsao", "dsarbsaqapco", "dsarbsaqascs", "csarbsdsesas"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-7-21",
        chapterId: "beginner-level3",
        order: 906,
        title: { zh: "对杀 · 21/24", en: "Capturing race · 21/24" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brcrdrcqerbpbocncm", white: "araqbqesfreqdqcpcododnfp" },
            correct: ["bn"],
            wrong: ["bsap", "dsap", "csap"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-7-22",
        chapterId: "beginner-level3",
        order: 907,
        title: { zh: "对杀 · 22/24", en: "Capturing race · 22/24" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "asbscrdrdqbqaqepfpgqgrgo", white: "dsereqdpcpcqboeodocm" },
            correct: ["brares"],
            wrong: ["brarbpesfsfresgs", "brarapesfsfrbpfqesgs", "esbrbpfsapfr", "esbrcsfsbpfr", "esbrcsfsapfr", "esbrapfsbpfr", "esbrapfscsfr", "bpbresfscsfr", "bpbresfsapfr", "bpbrapfresfs", "apbrbpfresfs", "apbresfsbpfr"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-7-23",
        chapterId: "beginner-level3",
        order: 908,
        title: { zh: "对杀 · 23/24", en: "Capturing race · 23/24" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dqdrdseqcpbpbqdoco", white: "brcrcqfqepdpfp" },
            correct: ["esfscserfr", "esfsfrarer"],
            wrong: ["esfserfr", "esfsfrarcsbs", "csar", "erfresfs", "erfrcsesgrar", "erfrcsesaraq", "erfrargr", "arfrgraqescs", "arfrgraqcsas", "arfrgraqeres", "arfrgraqfscs"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-7-24",
        chapterId: "beginner-level3",
        order: 909,
        title: { zh: "对杀 · 24/24", en: "Capturing race · 24/24" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dsdrdqeqfpgpgqgrfn", white: "crcqdpepfqfrcodm" },
            correct: ["es"],
            wrong: ["erfs", "csfs", "fsgs", "gserfshs", "gsercsfs"],
        },
    },
];

const bl3CapturingRace8Levels: Level[] = [
    {
        id: "beginner-level3-bl3-capturing-race-8-1",
        chapterId: "beginner-level3",
        order: 910,
        title: { zh: "对杀 · 1/12", en: "Capturing Race · 1/12" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "csdrereqdpcpcoboaodmbq", white: "brcrcqdqfrfqepeogpbpap" },
            correct: ["ar"],
            wrong: ["bsaq", "aqes"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-8-2",
        chapterId: "beginner-level3",
        order: 911,
        title: { zh: "对杀 · 2/12", en: "Capturing Race · 2/12" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brbqcpbodpfrereq", white: "epfqgrgqeogobscscrcqdq" },
            correct: ["dsfsar"],
            wrong: ["dsfsdres", "dsfsasar", "drfs", "asar", "aresfsdr", "aresdrfs", "aresdsdr", "aresasfs"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-8-3",
        chapterId: "beginner-level3",
        order: 912,
        title: { zh: "对杀 · 3/12", en: "Capturing Race · 3/12" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aqbrcqcpdpdodncmbmfp", white: "bqbpcocnaoblcldldmfm" },
            correct: ["an"],
            wrong: ["bnbo", "bobn", "ambn", "arbn"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-8-4",
        chapterId: "beginner-level3",
        order: 913,
        title: { zh: "对杀 · 4/12", en: "Capturing Race · 4/12" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "arbrcqbpcpdpepfpgqgrfrcm", white: "bsbqcrdrdqeqfqgpgohrhqhp" },
            correct: ["esgsdscsaq", "esgsercsaq"],
            wrong: ["esgsdscsasaq", "esgsdscserfs", "esgsercsasaq", "esgsercsfsds", "esgsercsdsfs", "eres", "gser", "fses", "dses"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-8-5",
        chapterId: "beginner-level3",
        order: 914,
        title: { zh: "对杀 · 5/12", en: "Capturing Race · 5/12" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "anbncncobpdpdqdrcrfr", white: "asbrcsbqcqcpdodncmbmembk" },
            correct: ["aqamao", "aqamap"],
            wrong: ["aqamdsao", "aoaq", "apaq", "dsao"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-8-6",
        chapterId: "beginner-level3",
        order: 915,
        title: { zh: "对杀 · 6/12", en: "Capturing Race · 6/12" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brcqcpcoepfpgpen", white: "bpbqcrdrdqfqgqhqiq" },
            correct: ["arbsbo"],
            wrong: ["arbsaqap", "bsar", "ascs", "boar", "aqbs"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-8-7",
        chapterId: "beginner-level3",
        order: 916,
        title: { zh: "对杀 · 7/12", en: "Capturing Race · 7/12" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "doeoepdsbrcqdqdrcocnbnembl", white: "dpesereqarbqbpfpgqgrfobocp" },
            correct: ["bsaoaqapan", "bsaoaqapcs", "bsaoaqapcr", "bsaoanaqas"],
            wrong: ["bsaoaqapascs", "bsaoascs", "aocs", "aqcs", "csbs", "crbs", "ancs"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-8-8",
        chapterId: "beginner-level3",
        order: 917,
        title: { zh: "对杀 · 8/12", en: "Capturing Race · 8/12" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqdqdrepfpfqgqhrhphmir", white: "bqbpcpdpeqerfrgrcmdn" },
            correct: ["dscsbr"],
            wrong: ["dscsescr", "dscscrbr", "dscsgscr", "dscsbsbr", "escr", "csbrdsbs", "csbrescr", "csbrgscr", "csbrbscr", "csbrcrbs", "gscr"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-8-9",
        chapterId: "beginner-level3",
        order: 918,
        title: { zh: "对杀 · 9/12", en: "Capturing Race · 9/12" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brcrdreqfqdpdobpbogq", white: "aqbqcqdqanbncndneneoepgn" },
            correct: ["ar"],
            wrong: ["cpap", "apco"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-8-10",
        chapterId: "beginner-level3",
        order: 919,
        title: { zh: "对杀 · 10/12", en: "Capturing Race · 10/12" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpcqdoeofogpgqhn", white: "brbqbpcocndpep" },
            correct: ["drereq"],
            wrong: ["drerdqeq", "drercreq", "drerfpcr", "dqeq", "crdr", "fpdq", "eqdq"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-8-11",
        chapterId: "beginner-level3",
        order: 920,
        title: { zh: "对杀 · 11/12", en: "Capturing Race · 11/12" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "arbqbpbocodqcreqerescm", white: "bsbrcpcqdpepfqfrfsfohp" },
            correct: ["ds"],
            wrong: ["csds", "aqds", "drcs"],
        },
    },
    {
        id: "beginner-level3-bl3-capturing-race-8-12",
        chapterId: "beginner-level3",
        order: 921,
        title: { zh: "对杀 · 12/12", en: "Capturing Race · 12/12" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqbpcodoeofpfqfr", white: "bobncmcpdpepfofnelgpgqgrhndrir" },
            correct: ["dqeqer"],
            wrong: ["dqeqcqer", "cqer", "eqdq", "fser", "ercr"],
        },
    },
];

const bl3PreparatoryAtari1Levels: Level[] = [
    {
        id: "beginner-level3-bl3-preparatory-atari-1-1",
        chapterId: "beginner-level3",
        order: 922,
        title: { zh: "准备打吃 · 1/10", en: "Preparatory Atari · 1/10" },
        instruction: { zh: "通常你需要组合多种技术来达到目标。预备打吃在这样的组合中很有用。首先，你将棋子打吃，这些棋子你不能或不想吃掉。这样做，其他棋子可以进入对你有利的位置。这里，黑棋可以通过在A点落子将一些棋子打吃，然后通过倒扑吃掉棋子。黑先。利用预备打吃吃子。", en: "Often you need a combination of techniques to reach your goal. A preparatory atari can be useful in such combinations. First, you put stones in atari, that you can not, or do not want to, capture. By doing this, other stones can come into an advantageous position for you. Here, Black can put some stones in atari by playing at A and then capture stones in a snapback. Black to play. Capture stones using a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bobpbqcqdldmdrenerfpfqgr", white: "bnckclcmcocpdodqepeq" },
            marks: { A: "eo" },
            correct: ["eodpcn"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-1-2",
        chapterId: "beginner-level3",
        order: 923,
        title: { zh: "准备打吃 · 2/10", en: "Preparatory Atari · 2/10" },
        instruction: { zh: "黑先。在预备打吃后下双打吃。", en: "Black to play. Play a double-atari after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdqeqfqepeogphp", white: "crcqdpdobpenfofpgqgriq" },
            correct: ["dncofn", "fngodn"],
            wrong: ["codn", "gofn"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-1-3",
        chapterId: "beginner-level3",
        order: 924,
        title: { zh: "准备打吃 · 3/10", en: "Preparatory Atari · 3/10" },
        instruction: { zh: "黑先。在预备打吃后下双打吃。", en: "Black to play. Play a double-atari after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "apaobocodoepfqfogq", white: "aqbpcpdpeqfrgrcrhrbs" },
            correct: ["bqardq", "dqerbq"],
            wrong: ["bqarbrcq", "bqarcqdq", "bqarerdq", "erdq", "arbq"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-1-4",
        chapterId: "beginner-level3",
        order: 925,
        title: { zh: "准备打吃 · 4/10", en: "Preparatory Atari · 4/10" },
        instruction: { zh: "黑先。在预备打吃后下双打吃。", en: "Black to play. Play a double-atari after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "hncqbpbqcrbsarcsgqeqfqhpepdrip", white: "escpdqdperhrhqgpfpcncleobogs" },
            correct: ["docofo", "fogodo"],
            wrong: ["codo", "gofo"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-1-5",
        chapterId: "beginner-level3",
        order: 926,
        title: { zh: "准备打吃 · 5/10", en: "Preparatory Atari · 5/10" },
        instruction: { zh: "黑先。在预备打吃后下双打吃。", en: "Black to play. Play a double-atari after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brbqcrdrereqfr", white: "grhrfqepdqcqbpcohocn" },
            correct: ["dpcpfp", "fpgqdp"],
            wrong: ["dpcpeofp", "dpcpgqfp", "gqfp", "fpgqeodp", "cpdp"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-1-6",
        chapterId: "beginner-level3",
        order: 927,
        title: { zh: "准备打吃 · 6/10", en: "Preparatory Atari · 6/10" },
        instruction: { zh: "黑先。在预备打吃后下双打吃。", en: "Black to play. Play a double-atari after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "csbrbqbpbocp", white: "cqcrdserdpcobnbm" },
            correct: ["docndq", "dqdrdo"],
            wrong: ["cndo", "drdq", "bsdn"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-1-7",
        chapterId: "beginner-level3",
        order: 928,
        title: { zh: "准备打吃 · 7/10", en: "Preparatory Atari · 7/10" },
        instruction: { zh: "黑先。在预备打吃后下双打吃。", en: "Black to play. Play a double-atari after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "csdsdrdqdpcpdodncmclel", white: "arbscrcqbpcocnbmblbk" },
            correct: ["bqbrbo", "bobnbq"],
            wrong: ["bqbrapaq", "bqbrbnbo", "bnbo", "bobnbrbq", "bobnapbq", "brbq"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-1-8",
        chapterId: "beginner-level3",
        order: 929,
        title: { zh: "准备打吃 · 8/10", en: "Preparatory Atari · 8/10" },
        instruction: { zh: "黑先。在预备打吃后下双打吃。", en: "Black to play. Play a double-atari after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "flkpgnhniocpcncrcmfmdqdpepfpfojo", white: "brbqcqdreqfqgpgohoiripbpinhmgmboiqik" },
            correct: ["gqhper", "ercsgq"],
            wrong: ["gqhpfrer", "imjn", "fngr"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-1-9",
        chapterId: "beginner-level3",
        order: 930,
        title: { zh: "准备打吃 · 9/10", en: "Preparatory Atari · 9/10" },
        instruction: { zh: "黑先。在预备打吃后下双打吃。", en: "Black to play. Play a double-atari after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqdqercpcobnbmclaq", white: "cmcnblckdkdodpeqfrgqgn" },
            correct: ["epfqdn", "dndmep"],
            wrong: ["dmdn"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-1-10",
        chapterId: "beginner-level3",
        order: 931,
        title: { zh: "准备打吃 · 10/10", en: "Preparatory Atari · 10/10" },
        instruction: { zh: "黑先。在预备打吃后下双打吃。", en: "Black to play. Play a double-atari after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqdqdpepfpfofngmhq", white: "bqcrdrareqfrfmeneodocpdl" },
            correct: ["cobpem", "emflco"],
            wrong: ["bpco", "fqer"],
        },
    },
];

const bl3PreparatoryAtari2Levels: Level[] = [
    {
        id: "beginner-level3-bl3-preparatory-atari-2-1",
        chapterId: "beginner-level3",
        order: 932,
        title: { zh: "准备打吃 · 1/10", en: "Preparatory Atari · 1/10" },
        instruction: { zh: "白棋可以通过在A点落子将一颗棋子打吃，然后通过征子吃掉另一颗棋子。白先。在预备打吃后下征子。", en: "White can put a stone in atari by playing at A and then capture a different stone in a ladder. White to play. Play a ladder after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpbqcpdqepgq", white: "cocqdodphm" },
            marks: { A: "eq" },
            correct: ["eqcrfp"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-2-2",
        chapterId: "beginner-level3",
        order: 933,
        title: { zh: "准备打吃 · 2/10", en: "Preparatory Atari · 2/10" },
        instruction: { zh: "白先。在预备打吃后下征子。", en: "White to play. Play a ladder after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dreqfrgqdpcp", white: "bpcqdqer" },
            correct: ["epfqdo"],
            wrong: ["epfqcododneo", "epfqcodoeodn", "cres"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-2-3",
        chapterId: "beginner-level3",
        order: 934,
        title: { zh: "准备打吃 · 3/10", en: "Preparatory Atari · 3/10" },
        instruction: { zh: "白先。在预备打吃后下征子。", en: "White to play. Play a ladder after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brcrcqbpcocndn", white: "bqcpdpdqdrdoencmflfr" },
            correct: ["boaqbn"],
            wrong: ["boaqdmbn"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-2-4",
        chapterId: "beginner-level3",
        order: 935,
        title: { zh: "准备打吃 · 4/10", en: "Preparatory Atari · 4/10" },
        instruction: { zh: "白先。在预备打吃后下征子。", en: "White to play. Play a ladder after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcqdqcrerfqgq", white: "drbpcpdpepeqbnfphqio" },
            correct: ["frdsgr"],
            wrong: ["frdsgpgr"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-2-5",
        chapterId: "beginner-level3",
        order: 936,
        title: { zh: "准备打吃 · 5/10", en: "Preparatory Atari · 5/10" },
        instruction: { zh: "白先。在预备打吃后下征子。", en: "White to play. Play a ladder after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpdpeofp", white: "dodnepeq" },
            correct: ["foengp"],
            wrong: ["enfo"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-2-6",
        chapterId: "beginner-level3",
        order: 937,
        title: { zh: "准备打吃 · 6/10", en: "Preparatory Atari · 6/10" },
        instruction: { zh: "白先。在预备打吃后下征子。", en: "White to play. Play a ladder after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cocpdpdrdseqfrfn", white: "bpcqdqcrdoerar" },
            correct: ["epfqcn"],
            wrong: ["epfqbocn", "esfs", "cses"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-2-7",
        chapterId: "beginner-level3",
        order: 938,
        title: { zh: "准备打吃 · 7/10", en: "Preparatory Atari · 7/10" },
        instruction: { zh: "白先。在预备打吃后下征子。", en: "White to play. Play a ladder after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dndocobqcqdqcrepfpbnbmclarbsck", white: "bpbocnfqeqereohndrdpelcp" },
            correct: ["endmgp", "gpfoendmfn"],
            wrong: ["dmen", "fogp", "gpfoendmgofn"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-2-8",
        chapterId: "beginner-level3",
        order: 939,
        title: { zh: "准备打吃 · 8/10", en: "Preparatory Atari · 8/10" },
        instruction: { zh: "白先。在预备打吃后下征子。", en: "White to play. Play a ladder after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcodpdqeneofpgq", white: "eqepdodnfqgogl" },
            correct: ["fogpem", "gpfoem"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-2-9",
        chapterId: "beginner-level3",
        order: 940,
        title: { zh: "准备打吃 · 9/10", en: "Preparatory Atari · 9/10" },
        instruction: { zh: "白先。在预备打吃后下征子。", en: "White to play. Play a ladder after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcodoepdqdrerfrhqip", white: "crcqcpdpboeqfqhm" },
            correct: ["eofpfogqcn", "eofpcndndmenfo"],
            wrong: ["eofpdncnbncm", "eofpdncncmbn", "eofpfogqdncnbncm", "eofpfogqdncncmbn", "eofpcndnendm", "eofpcndndmenfnfo", "fpeo", "bqfp"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-2-10",
        chapterId: "beginner-level3",
        order: 941,
        title: { zh: "准备打吃 · 10/10", en: "Preparatory Atari · 10/10" },
        instruction: { zh: "白先。在预备打吃后下征子。", en: "White to play. Play a ladder after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrcqdqdrepfpiq", white: "crbqbpcpdpeofoeqbn" },
            correct: ["ercsgpfqfrgqhq", "gpfqercsfr"],
            wrong: ["ercsgpfqfrgqgrhq", "ercsgpfqgqfr", "fqgp", "dscs"],
        },
    },
];

const bl3PreparatoryAtari3Levels: Level[] = [
    {
        id: "beginner-level3-bl3-preparatory-atari-3-1",
        chapterId: "beginner-level3",
        order: 942,
        title: { zh: "准备打吃 · 1/13", en: "Preparatory Atari · 1/13" },
        instruction: { zh: "黑棋无法立即用罩吃掉切断的棋子。但通过在A点预备打吃后，罩就可行了。黑先。在预备打吃后下罩。", en: "Black can not capture the cutting stone in a net immediately. But the net will be possible after a preparatory atari at A. Black to play. Play a net after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcndndodpeqer", white: "bnbqbrcocpdqdrepgnhp" },
            marks: { A: "fp" },
            correct: ["fpeofn"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-3-2",
        chapterId: "beginner-level3",
        order: 943,
        title: { zh: "准备打吃 · 2/13", en: "Preparatory Atari · 2/13" },
        instruction: { zh: "黑先。在预备打吃后下罩。", en: "Black to play. Play a net after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpcocndodqeqerdl", white: "bsarbqcrcqbpdrdpepgqhohp" },
            correct: ["fpeofn"],
            wrong: ["fpeoenfo", "eofp"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-3-3",
        chapterId: "beginner-level3",
        order: 944,
        title: { zh: "准备打吃 · 3/13", en: "Preparatory Atari · 3/13" },
        instruction: { zh: "黑先。在预备打吃后下罩。", en: "Black to play. Play a net after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqbpcpcodqepeqergp", white: "brcrdrcqdodpbncmcliohm" },
            correct: ["dneofn"],
            wrong: ["dneoenfo", "dneofoen", "eodn"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-3-4",
        chapterId: "beginner-level3",
        order: 945,
        title: { zh: "准备打吃 · 4/13", en: "Preparatory Atari · 4/13" },
        instruction: { zh: "黑先。在预备打吃后下罩。", en: "Black to play. Play a net after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqbpbobndrercrardp", white: "dqeqcpcofrfpcl" },
            correct: ["epfqdn"],
            wrong: ["docndmcm", "docndncm", "docncmdn", "cndo"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-3-5",
        chapterId: "beginner-level3",
        order: 946,
        title: { zh: "准备打吃 · 5/13", en: "Preparatory Atari · 5/13" },
        instruction: { zh: "黑先。在预备打吃后下罩。", en: "Black to play. Play a net after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdpepfqgqcqdncmhrclcoboanbn", white: "dreqbqenfmdmdlbpfpapdqaobrcr" },
            correct: ["fogpho"],
            wrong: ["fogpipgo", "gpfo"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-3-6",
        chapterId: "beginner-level3",
        order: 947,
        title: { zh: "准备打吃 · 6/13", en: "Preparatory Atari · 6/13" },
        instruction: { zh: "黑先。在预备打吃后下罩。", en: "Black to play. Play a net after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpcpdqeqergq", white: "aqbqcqdrcsbsardphogm" },
            correct: ["doepfo"],
            wrong: ["doepfpeo", "doepeofp", "epdo", "eodo"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-3-7",
        chapterId: "beginner-level3",
        order: 948,
        title: { zh: "准备打吃 · 7/13", en: "Preparatory Atari · 7/13" },
        instruction: { zh: "黑先。在预备打吃后下罩。", en: "Black to play. Play a net after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "drerfrfqepeofm", white: "fpeqdqcqcrbobncmhqiqhn" },
            correct: ["gpfogn"],
            wrong: ["gpfogofn", "fogp"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-3-8",
        chapterId: "beginner-level3",
        order: 949,
        title: { zh: "准备打吃 · 8/13", en: "Preparatory Atari · 8/13" },
        instruction: { zh: "黑先。在预备打吃后下罩。", en: "Black to play. Play a net after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpcqdqerfrdncmbobrclckfm", white: "dpepeqcocnbpbqaoanbmbldmdl" },
            correct: ["dobnfo"],
            wrong: ["dobnfpen", "dobnfqen"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-3-9",
        chapterId: "beginner-level3",
        order: 950,
        title: { zh: "准备打吃 · 9/13", en: "Preparatory Atari · 9/13" },
        instruction: { zh: "黑先。在预备打吃后下罩。", en: "Black to play. Play a net after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpcpdqeqergr", white: "aqbqcqdrcsbrdpcncmgn" },
            correct: ["doepfo"],
            wrong: ["doepfpeo", "doepeofp", "epdo"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-3-10",
        chapterId: "beginner-level3",
        order: 951,
        title: { zh: "准备打吃 · 10/13", en: "Preparatory Atari · 10/13" },
        instruction: { zh: "黑先。在预备打吃后下罩。", en: "Black to play. Play a net after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cocncmbmdpdqeqerem", white: "crdrcqcpbobndodmdlgpgqhn" },
            correct: ["dneofo"],
            wrong: ["dneofnfo", "dneofpfo", "eodn"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-3-11",
        chapterId: "beginner-level3",
        order: 952,
        title: { zh: "准备打吃 · 11/13", en: "Preparatory Atari · 11/13" },
        instruction: { zh: "黑先。在预备打吃后下罩。", en: "Black to play. Play a net after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpcododqeqercmbn", white: "brcrdrcqbpbodpephpgm" },
            correct: ["fpeofn"],
            wrong: ["fpeofoen", "eofp"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-3-12",
        chapterId: "beginner-level3",
        order: 953,
        title: { zh: "准备打吃 · 12/13", en: "Preparatory Atari · 12/13" },
        instruction: { zh: "黑先。在预备打吃后下罩。", en: "Black to play. Play a net after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "csbsbrbqbpcocnbl", white: "cpcqcrdodndmhqdsepirgq" },
            correct: ["dreserfsgr"],
            wrong: ["dreserfsfrgs", "dresfrer", "erdr", "esdr"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-3-13",
        chapterId: "beginner-level3",
        order: 954,
        title: { zh: "准备打吃 · 13/13", en: "Preparatory Atari · 13/13" },
        instruction: { zh: "黑先。在预备打吃后下罩。", en: "Black to play. Play a net after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dqdpcocnemerfrfqcp", white: "eqepdoendrcqcrbpboaqbrgphpiqhn" },
            correct: ["fpeofn"],
            wrong: ["fpeofofn", "fpeodnfn", "fpeogndm", "dneo"],
        },
    },
];

const bl3PreparatoryAtari4Levels: Level[] = [
    {
        id: "beginner-level3-bl3-preparatory-atari-4-1",
        chapterId: "beginner-level3",
        order: 955,
        title: { zh: "准备打吃 · 1/24", en: "Preparatory Atari · 1/24" },
        instruction: { zh: "白先。经过准备性打吃后提子。", en: "White to play. Capture after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "freqdpcpcobobm", white: "bpbqcqdqer" },
            correct: ["fqepgr"],
            wrong: ["epfq"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-4-2",
        chapterId: "beginner-level3",
        order: 956,
        title: { zh: "准备打吃 · 2/24", en: "Preparatory Atari · 2/24" },
        instruction: { zh: "白先。经过准备性打吃后提子。", en: "White to play. Capture after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "jqhohpbrgqbpbocqdqerfqjpgn", white: "cncocpbldpepeqfpgphqiqbqbn" },
            correct: ["frgrdr", "drcrfr"],
            wrong: ["grfr", "crdr", "aoaq", "apaq"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-4-3",
        chapterId: "beginner-level3",
        order: 957,
        title: { zh: "准备打吃 · 3/24", en: "Preparatory Atari · 3/24" },
        instruction: { zh: "白先。经过准备性打吃后提子。", en: "White to play. Capture after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqdqeqfqcpbofogpendnfn", white: "cqcrdrerfrgqhqbpeocn" },
            correct: ["dpcofp"],
            wrong: ["codp", "brap"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-4-4",
        chapterId: "beginner-level3",
        order: 958,
        title: { zh: "准备打吃 · 4/24", en: "Preparatory Atari · 4/24" },
        instruction: { zh: "白先。经过准备性打吃后提子。", en: "White to play. Capture after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcqdqerfqgphp", white: "bpcpdpepfpeqgobn" },
            correct: ["frgqdr"],
            wrong: ["gqfr"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-4-5",
        chapterId: "beginner-level3",
        order: 959,
        title: { zh: "准备打吃 · 5/24", en: "Preparatory Atari · 5/24" },
        instruction: { zh: "白先。经过准备性打吃后提子。", en: "White to play. Capture after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpepfofngpgm", white: "cpcodqeqfqgqgocm" },
            correct: ["fphpeo"],
            wrong: ["hpfp"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-4-6",
        chapterId: "beginner-level3",
        order: 960,
        title: { zh: "准备打吃 · 6/24", en: "Preparatory Atari · 6/24" },
        instruction: { zh: "白先。经过准备性打吃后提子。", en: "White to play. Capture after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gqirhrbmbpbocnfqepdqdpdoipgo", white: "eqfrgrhqbqcqcpcobndrerbs" },
            correct: ["dncmfp", "fpgpdn"],
            wrong: ["cmdn", "gpfp", "aoan", "apan"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-4-7",
        chapterId: "beginner-level3",
        order: 961,
        title: { zh: "准备打吃 · 7/24", en: "Preparatory Atari · 7/24" },
        instruction: { zh: "白先。经过准备性打吃后提子。", en: "White to play. Capture after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gneodobqcpesgrgqgpfsarcqaq", white: "gsipiofrhqhrbpbocncmemhsancl" },
            correct: ["erdscr"],
            wrong: ["dser", "drer"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-4-8",
        chapterId: "beginner-level3",
        order: 962,
        title: { zh: "准备打吃 · 8/24", en: "Preparatory Atari · 8/24" },
        instruction: { zh: "白先。经过准备性打吃后提子。", en: "White to play. Capture after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "drcqdpepcobncmbrel", white: "cnbpdoeofpfqerfrfn" },
            correct: ["cpdndq"],
            wrong: ["cpdneqdq", "bocp"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-4-9",
        chapterId: "beginner-level3",
        order: 963,
        title: { zh: "准备打吃 · 9/24", en: "Preparatory Atari · 9/24" },
        instruction: { zh: "白先。经过准备性打吃后提子。", en: "White to play. Capture after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcqdreqfrfphq", white: "dqdpcpbperbn" },
            correct: ["cresbr"],
            wrong: ["epes"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-4-10",
        chapterId: "beginner-level3",
        order: 964,
        title: { zh: "准备打吃 · 10/24", en: "Preparatory Atari · 10/24" },
        instruction: { zh: "白先。经过准备性打吃后提子。", en: "White to play. Capture after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqdqepfogohohq", white: "brbqcpdpeofngndn" },
            correct: ["eqfpdr", "eqfpcr", "eqfper", "eqfpfr", "eqfpfq"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-4-11",
        chapterId: "beginner-level3",
        order: 965,
        title: { zh: "准备打吃 · 11/24", en: "Preparatory Atari · 11/24" },
        instruction: { zh: "白先。经过准备性打吃后提子。", en: "White to play. Capture after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbscsdrcqbqdpcnhphqdm", white: "bpcpdqeqergpgn" },
            correct: ["doepfo"],
            wrong: ["epdo"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-4-12",
        chapterId: "beginner-level3",
        order: 966,
        title: { zh: "准备打吃 · 12/24", en: "Preparatory Atari · 12/24" },
        instruction: { zh: "白先。经过准备性打吃后提子。", en: "White to play. Capture after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brbqcsdrergrfqgpgobs", white: "bpcpbncqcrdqeqfpfofnfs" },
            correct: ["frgqds"],
            wrong: ["frgqesds"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-4-13",
        chapterId: "beginner-level3",
        order: 967,
        title: { zh: "准备打吃 · 13/24", en: "Preparatory Atari · 13/24" },
        instruction: { zh: "白先。经过准备性打吃后提子。", en: "White to play. Capture after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqbpcrdqeqfresgp", white: "erdrcqcpbocndp" },
            correct: ["brdsaq", "brdsap", "brdsar", "brdsbs"],
            wrong: ["csbr", "dscs"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-4-14",
        chapterId: "beginner-level3",
        order: 968,
        title: { zh: "准备打吃 · 14/24", en: "Preparatory Atari · 14/24" },
        instruction: { zh: "白先。经过准备性打吃后提子。", en: "White to play. Capture after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brcqdqerfqgqhrir", white: "bqcpdpepeqfpgphqhobo" },
            correct: ["frgrdr", "drcrfr", "crdrfr"],
            wrong: ["grfr"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-4-15",
        chapterId: "beginner-level3",
        order: 969,
        title: { zh: "准备打吃 · 15/24", en: "Preparatory Atari · 15/24" },
        instruction: { zh: "白先。经过准备性打吃后提子。", en: "White to play. Capture after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "emclblfrfqepdocoboanamhpaldmfm", white: "cpbneqeresbraoapakbkckdkekbpdp" },
            correct: ["eofpdn"],
            wrong: ["fpeo"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-4-16",
        chapterId: "beginner-level3",
        order: 970,
        title: { zh: "准备打吃 · 16/24", en: "Preparatory Atari · 16/24" },
        instruction: { zh: "白先。经过准备性打吃后提子。", en: "White to play. Capture after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eqfqdqgpgocpcobndnbmfnem", white: "bqcqbpbodrerfrgqhrhpcneo" },
            correct: ["dpdofp"],
            wrong: ["dpdoenep", "dpdoepfp", "dpdodmep", "dodp"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-4-17",
        chapterId: "beginner-level3",
        order: 971,
        title: { zh: "准备打吃 · 17/24", en: "Preparatory Atari · 17/24" },
        instruction: { zh: "白先。经过准备性打吃后提子。", en: "White to play. Capture after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcrdqeqfqgrhqirip", white: "hrgqgpfpepdpcpcqcn" },
            correct: ["frhsdr"],
            wrong: ["frhserdr", "hphs"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-4-18",
        chapterId: "beginner-level3",
        order: 972,
        title: { zh: "准备打吃 · 18/24", en: "Preparatory Atari · 18/24" },
        instruction: { zh: "白先。经过准备性打吃后提子。", en: "White to play. Capture after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcpdocnepgqgrgo", white: "codpdqcqerfrbr" },
            correct: ["eodnfp"],
            wrong: ["dneo"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-4-19",
        chapterId: "beginner-level3",
        order: 973,
        title: { zh: "准备打吃 · 19/24", en: "Preparatory Atari · 19/24" },
        instruction: { zh: "白先。经过准备性打吃后提子。", en: "White to play. Capture after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "epeqerfrfsgqhqemelgminiododn", white: "dsdrdqdpcocndmdlbpesdkcmfogsgpgr" },
            correct: ["eoenfq"],
            wrong: ["eoenfpfq", "eneo"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-4-20",
        chapterId: "beginner-level3",
        order: 974,
        title: { zh: "准备打吃 · 20/24", en: "Preparatory Atari · 20/24" },
        instruction: { zh: "白先。经过准备性打吃后提子。", en: "White to play. Capture after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eqfqgpdpdogrhrho", white: "cqcpdqerfrgqdnem" },
            correct: ["epfpeo"],
            wrong: ["epfpcoeo", "fpep"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-4-21",
        chapterId: "beginner-level3",
        order: 975,
        title: { zh: "准备打吃 · 21/24", en: "Preparatory Atari · 21/24" },
        instruction: { zh: "白先。经过准备性打吃后提子。", en: "White to play. Capture after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcododpepfqgrhr", white: "bocnbmdneofpgqhqiqgoen" },
            correct: ["eqfrdqcpcq", "eqfrdqcpbq"],
            wrong: ["freq"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-4-22",
        chapterId: "beginner-level3",
        order: 976,
        title: { zh: "准备打吃 · 22/24", en: "Preparatory Atari · 22/24" },
        instruction: { zh: "白先。经过准备性打吃后提子。", en: "White to play. Capture after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crcqcpbobnepdogldkck", white: "cmcncodpdqeq" },
            correct: ["eodnemenfnfodmeogo"],
            wrong: ["eodnemenfnfodmeofpgo", "eodnemenfnfofpgo", "eodnemendmfn", "eodnfpdm", "fpeofnfogofqgper", "dneofnfq"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-4-23",
        chapterId: "beginner-level3",
        order: 977,
        title: { zh: "准备打吃 · 23/24", en: "Preparatory Atari · 23/24" },
        instruction: { zh: "白先。经过准备性打吃后提子。", en: "White to play. Capture after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "blbkcocpdqeqfpfndk", white: "crcqbpbobnbmdpar" },
            correct: ["docndm"],
            wrong: ["docncmdn", "docndncm", "cndo"],
        },
    },
    {
        id: "beginner-level3-bl3-preparatory-atari-4-24",
        chapterId: "beginner-level3",
        order: 978,
        title: { zh: "准备打吃 · 24/24", en: "Preparatory Atari · 24/24" },
        instruction: { zh: "白先。经过准备性打吃后提子。", en: "White to play. Capture after a preparatory atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbpbocodncmcrcsdqeqdphqhoemfm", white: "bsbrbqcqcpdrdoeoepen" },
            correct: ["fqeresfrgr"],
            wrong: ["fqeresfrdsfp", "fqerfrds", "fqerdsfr", "erfq", "dsfq", "aras", "apao"],
        },
    },
];

const bl3ConnectCut1Levels: Level[] = [
    {
        id: "beginner-level3-bl3-connect-cut-1-1",
        chapterId: "beginner-level3",
        order: 979,
        title: { zh: "连接与切断 · 1/13", en: "Connect and Cut · 1/13" },
        instruction: { zh: "一路跳通常是好形且行棋方向好。但若对手两边都很强，一路跳可能被切断。白棋在黑棋棋块两边都很强。白棋可以在A点打入楔子切断一路阵型。黑棋可以尝试通过打吃来连接，但那样不行。白先。切断黑棋棋子。", en: "A 1-point jump is often a strong shape and good haengma. But if your opponent is strong on both sides, the 1-point jump can be cut. White is strong on both sides of the black group. White can play a wedge at A and cut the 1-point formation. Black can try to connect by playing an atari, but that will not work. White to play. Cut the black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "emeoeq", white: "cmcncpcqcrgogpgqgr" },
            marks: { A: "ep" },
            correct: ["epdpfpdodq"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-1-2",
        chapterId: "beginner-level3",
        order: 980,
        title: { zh: "连接与切断 · 2/13", en: "Connect and Cut · 2/13" },
        instruction: { zh: "白先。切断黑棋棋子。", en: "White to play. Cut the black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fqfpdpdohp", white: "cqdqeqbpfnemcmdk" },
            correct: ["epeofo"],
            wrong: ["eoep"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-1-3",
        chapterId: "beginner-level3",
        order: 981,
        title: { zh: "连接与切断 · 3/13", en: "Connect and Cut · 3/13" },
        instruction: { zh: "白先。下出最佳的切断。", en: "White to play. Play the best cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eldrdscpcocmclcrcqflgldkbk", white: "bmblbscseoemfofmepeqergrbrbqbpbo" },
            correct: ["cndnbndodm", "cndnbndmdo"],
            wrong: ["dncn", "bncn", "dmcn"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-1-4",
        chapterId: "beginner-level3",
        order: 982,
        title: { zh: "连接与切断 · 4/13", en: "Connect and Cut · 4/13" },
        instruction: { zh: "白先。下出最佳的切断。", en: "White to play. Play the best cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bscsdsdreqepbocoenfngphm", white: "apbpcpcqcrbremdmbmdpck" },
            correct: ["dodncn"],
            wrong: ["dodneocn", "dndo"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-1-5",
        chapterId: "beginner-level3",
        order: 983,
        title: { zh: "连接与切断 · 5/13", en: "Connect and Cut · 5/13" },
        instruction: { zh: "白先。下出最佳的切断。", en: "White to play. Play the best cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpbocncmdodpeqerfl", white: "arbqcqcpcodqdrcsbsgohqgm" },
            correct: ["epfpeo"],
            wrong: ["dnen", "bnbm"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-1-6",
        chapterId: "beginner-level3",
        order: 984,
        title: { zh: "连接与切断 · 6/13", en: "Connect and Cut · 6/13" },
        instruction: { zh: "白先。下出最佳的切断。", en: "White to play. Play the best cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcpdocnbnfohoan", white: "bqcqdqfqgqbmcmdmfmhmbkfl" },
            correct: ["eoependpfp", "eoenepdnfn"],
            wrong: ["gogpgnfp"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-1-7",
        chapterId: "beginner-level3",
        order: 985,
        title: { zh: "连接与切断 · 7/13", en: "Connect and Cut · 7/13" },
        instruction: { zh: "白先。下出最佳的切断。", en: "White to play. Play the best cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dreqbqbpeoencmco", white: "arbrcrcqfpgphq" },
            correct: ["epdqdp", "epdpdq"],
            wrong: ["dpep"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-1-8",
        chapterId: "beginner-level3",
        order: 986,
        title: { zh: "连接与切断 · 8/13", en: "Connect and Cut · 8/13" },
        instruction: { zh: "白先。下出最佳的切断。", en: "White to play. Play the best cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dqdrdodnemfn", white: "bpcqcrcncmdlepfqgqiq" },
            correct: ["dp"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-1-9",
        chapterId: "beginner-level3",
        order: 987,
        title: { zh: "连接与切断 · 9/13", en: "Connect and Cut · 9/13" },
        instruction: { zh: "白先。下出最佳的切断。", en: "White to play. Play the best cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqaqapbocndneodpdqdrerfogphpfm", white: "brcrcqcpbpcodoeqfrgq" },
            correct: ["bn"],
            wrong: ["enem", "epfq"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-1-10",
        chapterId: "beginner-level3",
        order: 988,
        title: { zh: "连接与切断 · 10/13", en: "Connect and Cut · 10/13" },
        instruction: { zh: "白先。下出最佳的切断。", en: "White to play. Play the best cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrcrcqeqfqgqhp", white: "bqbpcpdqepfpencm" },
            correct: ["dr"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-1-11",
        chapterId: "beginner-level3",
        order: 989,
        title: { zh: "连接与切断 · 11/13", en: "Connect and Cut · 11/13" },
        instruction: { zh: "白先。下出最佳的切断。", en: "White to play. Play the best cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cocpeoepdrfnfm", white: "brbqbpbocndneqfqgpgo" },
            correct: ["dqcqcr"],
            wrong: ["cqdq"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-1-12",
        chapterId: "beginner-level3",
        order: 990,
        title: { zh: "连接与切断 · 12/13", en: "Connect and Cut · 12/13" },
        instruction: { zh: "白先。下出最佳的切断。", en: "White to play. Play the best cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqcrdpeqerdsdnemel", white: "brbqbpcpbmbnclfrfqfpfngmhphm" },
            correct: ["doeocoepen", "doeocoenep"],
            wrong: ["eodo"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-1-13",
        chapterId: "beginner-level3",
        order: 991,
        title: { zh: "连接与切断 · 13/13", en: "Connect and Cut · 13/13" },
        instruction: { zh: "白先。下出最佳的切断。", en: "White to play. Play the best cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcpdpdserfohodnipiq", white: "cscrcqbqaqfqgqhqir" },
            correct: ["eqdqdr"],
            wrong: ["dqeqepfp"],
        },
    },
];

const bl3ConnectCut2Levels: Level[] = [
    {
        id: "beginner-level3-bl3-connect-cut-2-1",
        chapterId: "beginner-level3",
        order: 992,
        title: { zh: "连接与切断 · 1/18", en: "Connect and Cut · 1/18" },
        instruction: { zh: "一种常见的连接技术是沿着边线弯曲。黑棋先通过1位弯曲来连接。如果白棋试图用2阻止黑棋，黑棋可以在A点落子。黑先。完成连接。", en: "A frequently occurring technique to connect is to bend along the side. Black connects here by first bending with 1. If White tries to stop Black with 2, Black can play at A. Black to play. Finish the connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqdqeqhqfr", white: "cpdpepfqgr" },
            marks: { 1: "fr", 2: "gr", A: "gq" },
            correct: ["gqfphrergsdrcr", "gqfperhrir"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-2-2",
        chapterId: "beginner-level3",
        order: 993,
        title: { zh: "连接与切断 · 2/18", en: "Connect and Cut · 2/18" },
        instruction: { zh: "黑棋可以在A点通过一路跳连接两个棋块。如果白棋试图分割这两个棋块，黑棋可以在第一行落子来连接。连接这两个黑棋棋块。", en: "Black can connect the two groups with a 1-point jump at A. If White tries to separate the groups, Black can connect by playing on the first line.  Connect the two black groups." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aqbqcrgqhqiq", white: "bpcpdqfpgphp" },
            marks: { A: "er" },
            correct: ["erdrds"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-2-3",
        chapterId: "beginner-level3",
        order: 994,
        title: { zh: "连接与切断 · 3/18", en: "Connect and Cut · 3/18" },
        instruction: { zh: "通常，连接棋子有不同方法。但并非每种方法都同样高效。黑棋可以通过在B点落子以简单方式连接这两颗棋子。但在A点落子也能连接棋子。而且在A点落子能让黑棋在角上获得更好结果。为黑棋下出最高效的连接。", en: "Often, there are different ways to connect your stones. But not every way is equally efficient. Black can connect the two stones in a simple way by playing at B. But by playing at A, the stones are connected too. And playing at A gives Black a better result in the corner. Play the most efficient connection for Black." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "drfq", white: "codpdq" },
            marks: { A: "cr", B: "er" },
            correct: ["crereq"],
            wrong: ["ercr"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-2-4",
        chapterId: "beginner-level3",
        order: 995,
        title: { zh: "连接与切断 · 4/18", en: "Connect and Cut · 4/18" },
        instruction: { zh: "黑先。下出最佳的连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crcqdpepco", white: "dqdrfqfpgocpbpcmem" },
            correct: ["bobqbr"],
            wrong: ["bobqapbr", "bqbo"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-2-5",
        chapterId: "beginner-level3",
        order: 996,
        title: { zh: "连接与切断 · 5/18", en: "Connect and Cut · 5/18" },
        instruction: { zh: "黑先。下出最佳的连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqdqcpfqgrbpgp", white: "eqepdpcobobmdn" },
            correct: ["er"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-2-6",
        chapterId: "beginner-level3",
        order: 997,
        title: { zh: "连接与切断 · 6/18", en: "Connect and Cut · 6/18" },
        instruction: { zh: "黑先。下出最佳的连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqbpcocn", white: "bobncpdpfqhq" },
            correct: ["bm"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-2-7",
        chapterId: "beginner-level3",
        order: 998,
        title: { zh: "连接与切断 · 7/18", en: "Connect and Cut · 7/18" },
        instruction: { zh: "黑先。下出最佳的连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqbpcocnckdk", white: "cmdndodpcqcrfqem" },
            correct: ["bmblcl"],
            wrong: ["blbm"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-2-8",
        chapterId: "beginner-level3",
        order: 999,
        title: { zh: "连接与切断 · 8/18", en: "Connect and Cut · 8/18" },
        instruction: { zh: "黑先。下出最佳的连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bncodndpdqdr", white: "cqcpbocmcrar" },
            correct: ["bp"],
            wrong: ["cnap"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-2-9",
        chapterId: "beginner-level3",
        order: 1000,
        title: { zh: "连接与切断 · 9/18", en: "Connect and Cut · 9/18" },
        instruction: { zh: "黑先。下出最佳的连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crcqbpcocncm", white: "bocpdodpdqdrfr" },
            correct: ["bq", "aq", "br"],
            wrong: ["bnbqaobr", "aobqbnbr"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-2-10",
        chapterId: "beginner-level3",
        order: 1001,
        title: { zh: "连接与切断 · 10/18", en: "Connect and Cut · 10/18" },
        instruction: { zh: "黑先。下出最佳的连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpbqcn", white: "bocpdpfqhq" },
            correct: ["co"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-2-11",
        chapterId: "beginner-level3",
        order: 1002,
        title: { zh: "连接与切断 · 11/18", en: "Connect and Cut · 11/18" },
        instruction: { zh: "黑先。下出最佳的连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcobncmcl", white: "crdqfqcndndo" },
            correct: ["cp"],
            wrong: ["brcp"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-2-12",
        chapterId: "beginner-level3",
        order: 1003,
        title: { zh: "连接与切断 · 12/18", en: "Connect and Cut · 12/18" },
        instruction: { zh: "黑先。下出最佳的连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqdpfqhq", white: "eqbpcocn" },
            correct: ["ep"],
            wrong: ["bqep"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-2-13",
        chapterId: "beginner-level3",
        order: 1004,
        title: { zh: "连接与切断 · 13/18", en: "Connect and Cut · 13/18" },
        instruction: { zh: "黑先。下出最佳的连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqdqephpip", white: "fpeodocpbpbqgn" },
            correct: ["fqgqgp"],
            wrong: ["gqfq"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-2-14",
        chapterId: "beginner-level3",
        order: 1005,
        title: { zh: "连接与切断 · 14/18", en: "Connect and Cut · 14/18" },
        instruction: { zh: "黑先。下出最佳的连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crcqdpeqgq", white: "cpcododqcm" },
            correct: ["ep"],
            wrong: ["drep"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-2-15",
        chapterId: "beginner-level3",
        order: 1006,
        title: { zh: "连接与切断 · 15/18", en: "Connect and Cut · 15/18" },
        instruction: { zh: "黑先。下出最佳的连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqcpbobphrgqdqcr", white: "bncodocmeoepiqiphognemeqir" },
            correct: ["erfrfq"],
            wrong: ["frer"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-2-16",
        chapterId: "beginner-level3",
        order: 1007,
        title: { zh: "连接与切断 · 16/18", en: "Connect and Cut · 16/18" },
        instruction: { zh: "黑先。下出最佳的连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "epbrcrcqdpcodndmcl", white: "eqbqbpcpdqenfofpfrfl" },
            correct: ["do"],
            wrong: ["bodo"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-2-17",
        chapterId: "beginner-level3",
        order: 1008,
        title: { zh: "连接与切断 · 17/18", en: "Connect and Cut · 17/18" },
        instruction: { zh: "黑先。下出最佳的连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bndoeoaqbqcqcrbsardsfnbo", white: "bmdpdqdranaoapbpamdmelfqfphphm" },
            correct: ["cp"],
            wrong: ["cocp"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-2-18",
        chapterId: "beginner-level3",
        order: 1009,
        title: { zh: "连接与切断 · 18/18", en: "Connect and Cut · 18/18" },
        instruction: { zh: "黑先。下出最佳的连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brbpcqdrerdpepgr", white: "bqbocpdqeqdoeo" },
            correct: ["co"],
            wrong: ["fqap", "aqfp", "crfp"],
        },
    },
];

const bl3ConnectCut3Levels: Level[] = [
    {
        id: "beginner-level3-bl3-connect-cut-3-1",
        chapterId: "beginner-level3",
        order: 1010,
        title: { zh: "连接与切断 · 1/12", en: "Connect and Cut · 1/12" },
        instruction: { zh: "白先。在A点切断是好是坏？", en: "White to play. Is cutting at A good or bad?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpcoepfpfofrfm", white: "bqcqdqcndneo" },
            marks: { A: "dp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。在A点切断是好是坏？", en: "White to play. Is cutting at A good or bad?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "bad", label: { zh: "坏", en: "bad" } }],
            correctValue: "good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cpcoepfpfofrfm", white: "bqcqdqcndneo" },
                marks: { A: "dp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-3-2",
        chapterId: "beginner-level3",
        order: 1011,
        title: { zh: "连接与切断 · 2/12", en: "Connect and Cut · 2/12" },
        instruction: { zh: "白先。在A点切断是好是坏？", en: "White to play. Is cutting at A good or bad?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpcocnbndqdr", white: "aqbpbocscrcqfqgpgn" },
            marks: { A: "dp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。在A点切断是好是坏？", en: "White to play. Is cutting at A good or bad?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "bad", label: { zh: "坏", en: "bad" } }],
            correctValue: "bad",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cpcocnbndqdr", white: "aqbpbocscrcqfqgpgn" },
                marks: { A: "dp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-3-3",
        chapterId: "beginner-level3",
        order: 1012,
        title: { zh: "连接与切断 · 3/12", en: "Connect and Cut · 3/12" },
        instruction: { zh: "白先。在A点切断是好是坏？", en: "White to play. Is cutting at A good or bad?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brbqcpcobobnepfpgpfrhq", white: "bmcmcnbkdneodqcqfofm" },
            marks: { A: "dp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。在A点切断是好是坏？", en: "White to play. Is cutting at A good or bad?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "bad", label: { zh: "坏", en: "bad" } }],
            correctValue: "bad",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "brbqcpcobobnepfpgpfrhq", white: "bmcmcnbkdneodqcqfofm" },
                marks: { A: "dp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-3-4",
        chapterId: "beginner-level3",
        order: 1013,
        title: { zh: "连接与切断 · 4/12", en: "Connect and Cut · 4/12" },
        instruction: { zh: "白先。在A点切断是好是坏？", en: "White to play. Is cutting at A good or bad?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eqeoem", white: "cpcngogq" },
            marks: { A: "ep" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。在A点切断是好是坏？", en: "White to play. Is cutting at A good or bad?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "bad", label: { zh: "坏", en: "bad" } }],
            correctValue: "bad",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "eqeoem", white: "cpcngogq" },
                marks: { A: "ep" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-3-5",
        chapterId: "beginner-level3",
        order: 1014,
        title: { zh: "连接与切断 · 5/12", en: "Connect and Cut · 5/12" },
        instruction: { zh: "白先。在A点切断是好是坏？", en: "White to play. Is cutting at A good or bad?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpbpbndoeoepgpfm", white: "bqcqdqeqdpcnbmdmgrdk" },
            marks: { A: "co" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。在A点切断是好是坏？", en: "White to play. Is cutting at A good or bad?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "bad", label: { zh: "坏", en: "bad" } }],
            correctValue: "good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cpbpbndoeoepgpfm", white: "bqcqdqeqdpcnbmdmgrdk" },
                marks: { A: "co" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-3-6",
        chapterId: "beginner-level3",
        order: 1015,
        title: { zh: "连接与切断 · 6/12", en: "Connect and Cut · 6/12" },
        instruction: { zh: "白先。在A点切断是好是坏？", en: "White to play. Is cutting at A good or bad?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fneoepcsdsdrdq", white: "bsbrcrcqdpdodnbpgq" },
            marks: { A: "eq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。在A点切断是好是坏？", en: "White to play. Is cutting at A good or bad?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "bad", label: { zh: "坏", en: "bad" } }],
            correctValue: "good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "fneoepcsdsdrdq", white: "bsbrcrcqdpdodnbpgq" },
                marks: { A: "eq" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-3-7",
        chapterId: "beginner-level3",
        order: 1016,
        title: { zh: "连接与切断 · 7/12", en: "Connect and Cut · 7/12" },
        instruction: { zh: "白先。在A点切断是好是坏？", en: "White to play. Is cutting at A good or bad?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eqeoemipin", white: "cpcqbocmgqgpgogm" },
            marks: { A: "ep" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。在A点切断是好是坏？", en: "White to play. Is cutting at A good or bad?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "bad", label: { zh: "坏", en: "bad" } }],
            correctValue: "good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "eqeoemipin", white: "cpcqbocmgqgpgogm" },
                marks: { A: "ep" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-3-8",
        chapterId: "beginner-level3",
        order: 1017,
        title: { zh: "连接与切断 · 8/12", en: "Connect and Cut · 8/12" },
        instruction: { zh: "白先。在A点切断是好是坏？", en: "White to play. Is cutting at A good or bad?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brcqdrfqhqho", white: "araqbqcpdpdqbofo" },
            marks: { A: "er" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。在A点切断是好是坏？", en: "White to play. Is cutting at A good or bad?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "bad", label: { zh: "坏", en: "bad" } }],
            correctValue: "good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "brcqdrfqhqho", white: "araqbqcpdpdqbofo" },
                marks: { A: "er" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-3-9",
        chapterId: "beginner-level3",
        order: 1018,
        title: { zh: "连接与切断 · 9/12", en: "Connect and Cut · 9/12" },
        instruction: { zh: "白先。在A点切断是好是坏？", en: "White to play. Is cutting at A good or bad?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "erdqdpcocncm", white: "hqgobnbodrcrcqcp" },
            marks: { A: "eq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。在A点切断是好是坏？", en: "White to play. Is cutting at A good or bad?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "bad", label: { zh: "坏", en: "bad" } }],
            correctValue: "good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "erdqdpcocncm", white: "hqgobnbodrcrcqcp" },
                marks: { A: "eq" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-3-10",
        chapterId: "beginner-level3",
        order: 1019,
        title: { zh: "连接与切断 · 10/12", en: "Connect and Cut · 10/12" },
        instruction: { zh: "白先。在A点切断是好是坏？", en: "White to play. Is cutting at A good or bad?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "codofoho", white: "cpdqfqemcmgm" },
            marks: { A: "eo" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。在A点切断是好是坏？", en: "White to play. Is cutting at A good or bad?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "bad", label: { zh: "坏", en: "bad" } }],
            correctValue: "bad",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "codofoho", white: "cpdqfqemcmgm" },
                marks: { A: "eo" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-3-11",
        chapterId: "beginner-level3",
        order: 1020,
        title: { zh: "连接与切断 · 11/12", en: "Connect and Cut · 11/12" },
        instruction: { zh: "白先。在A点切断是好是坏？", en: "White to play. Is cutting at A good or bad?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqcpbobmcndm", white: "dqdpdocobn" },
            marks: { A: "bp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。在A点切断是好是坏？", en: "White to play. Is cutting at A good or bad?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "bad", label: { zh: "坏", en: "bad" } }],
            correctValue: "good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cqcpbobmcndm", white: "dqdpdocobn" },
                marks: { A: "bp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-3-12",
        chapterId: "beginner-level3",
        order: 1021,
        title: { zh: "连接与切断 · 12/12", en: "Connect and Cut · 12/12" },
        instruction: { zh: "白先。在A点切断是好是坏？", en: "White to play. Is cutting at A good or bad?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dqeqfqcpcobocm", white: "bpcqdrbrerfrgqgoemfm" },
            marks: { A: "dp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。在A点切断是好是坏？", en: "White to play. Is cutting at A good or bad?" },
            options: [{ value: "good", label: { zh: "好", en: "good" } }, { value: "bad", label: { zh: "坏", en: "bad" } }],
            correctValue: "bad",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dqeqfqcpcobocm", white: "bpcqdrbrerfrgqgoemfm" },
                marks: { A: "dp" },
            },
        },
    },
];

const bl3ConnectCut4Levels: Level[] = [
    {
        id: "beginner-level3-bl3-connect-cut-4-1",
        chapterId: "beginner-level3",
        order: 1022,
        title: { zh: "连接与切断 · 1/12", en: "Connect and Cut · 1/12" },
        instruction: { zh: "黑先。应对这个切断。", en: "Black to play. Respond to this cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crcqbpcocncm", white: "cpdodpdqdrbofr" },
            marks: { 1: "bo" },
            correct: ["bq", "ap", "aq", "br", "ar"],
            wrong: ["bnbqaobr", "aobqbnbr"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-4-2",
        chapterId: "beginner-level3",
        order: 1023,
        title: { zh: "连接与切断 · 2/12", en: "Connect and Cut · 2/12" },
        instruction: { zh: "黑先。应对这个切断。", en: "Black to play. Respond to this cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cocpdqeqgp", white: "cqdpdocndm" },
            marks: { 1: "cq" },
            correct: ["bqcrbr"],
            wrong: ["bqcrdrbr", "crbq"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-4-3",
        chapterId: "beginner-level3",
        order: 1024,
        title: { zh: "连接与切断 · 3/12", en: "Connect and Cut · 3/12" },
        instruction: { zh: "黑先。应对这个切断。", en: "Black to play. Respond to this cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "gpgqiqbqbpcocnhreogo", white: "gmcqdobrcrdqeqfqgrfrarbmcmdmem" },
            marks: { 1: "do" },
            correct: ["dndpen"],
            wrong: ["dpdnepcp", "dpdncpep"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-4-4",
        chapterId: "beginner-level3",
        order: 1025,
        title: { zh: "连接与切断 · 4/12", en: "Connect and Cut · 4/12" },
        instruction: { zh: "黑先。应对这个切断。", en: "Black to play. Respond to this cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crcqcpbocn", white: "cododpdqdrfrembp" },
            marks: { 1: "bp" },
            correct: ["bn", "an", "bm"],
            wrong: ["bqbn", "apbn"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-4-5",
        chapterId: "beginner-level3",
        order: 1026,
        title: { zh: "连接与切断 · 5/12", en: "Connect and Cut · 5/12" },
        instruction: { zh: "黑先。应对这个切断。", en: "Black to play. Respond to this cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crcqergrfqfpfo", white: "bpcpdpepcmeqdrds" },
            marks: { 1: "ds" },
            correct: ["dq"],
            wrong: ["csdq", "esdq", "bqdq"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-4-6",
        chapterId: "beginner-level3",
        order: 1027,
        title: { zh: "连接与切断 · 6/12", en: "Connect and Cut · 6/12" },
        instruction: { zh: "黑先。应对这个切断。", en: "Black to play. Respond to this cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crcqcpdrbocn", white: "erdqeqgrdpdocobnfn" },
            marks: { 1: "bn" },
            correct: ["bm"],
            wrong: ["bpcm", "apcm", "anbm"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-4-7",
        chapterId: "beginner-level3",
        order: 1028,
        title: { zh: "连接与切断 · 7/12", en: "Connect and Cut · 7/12" },
        instruction: { zh: "黑先。应对这个切断。", en: "Black to play. Respond to this cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eqeoem", white: "cqcpcogpepcmiq" },
            marks: { 1: "ep" },
            correct: ["fp"],
            wrong: ["dpfpdqdo", "dpfpdodq"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-4-8",
        chapterId: "beginner-level3",
        order: 1029,
        title: { zh: "连接与切断 · 8/12", en: "Connect and Cut · 8/12" },
        instruction: { zh: "黑先。应对这个切断。", en: "Black to play. Respond to this cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqcpdpepcmfqfrfs", white: "crdqeqeresfpgpgqfn" },
            marks: { 1: "fp" },
            correct: ["dsdrbr"],
            wrong: ["grhr", "hrgr", "hsgs", "brgr", "drds"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-4-9",
        chapterId: "beginner-level3",
        order: 1030,
        title: { zh: "连接与切断 · 9/12", en: "Connect and Cut · 9/12" },
        instruction: { zh: "黑先。应对这个切断。", en: "Black to play. Respond to this cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crcqbpcocncm", white: "bqcpdodpdqdrfrdn" },
            marks: { 1: "bq" },
            correct: ["br"],
            wrong: ["bobr", "aqbr"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-4-10",
        chapterId: "beginner-level3",
        order: 1031,
        title: { zh: "连接与切断 · 10/12", en: "Connect and Cut · 10/12" },
        instruction: { zh: "黑先。应对这个切断。", en: "Black to play. Respond to this cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "drdqepfqfrenelgmglgk", white: "crcqcpcncmeogrgqgpgohnhmcl" },
            marks: { 1: "eo" },
            correct: ["fodofpfngn"],
            wrong: ["fodofnfp", "dofodpdn", "dofodndp"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-4-11",
        chapterId: "beginner-level3",
        order: 1032,
        title: { zh: "连接与切断 · 11/12", en: "Connect and Cut · 11/12" },
        instruction: { zh: "黑先。应对这个切断。", en: "Black to play. Respond to this cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "blcldmcnbncocpcqfkdkem", white: "drcrbqbobpanambmcmdndofq" },
            marks: { 1: "dn" },
            correct: ["aoapalaobr"],
            wrong: ["alao", "dpep", "epdp", "dqeq", "eqdq"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-4-12",
        chapterId: "beginner-level3",
        order: 1033,
        title: { zh: "连接与切断 · 12/12", en: "Connect and Cut · 12/12" },
        instruction: { zh: "黑先。应对这个切断。", en: "Black to play. Respond to this cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "clcmcncoeoemeqdrfr", white: "crcqcpbobnbmepgrgqgpgogmgl" },
            marks: { 1: "ep" },
            correct: ["dpfpdq"],
            wrong: ["dpfpdodq", "fpdpfofq", "fpdpfqfo"],
        },
    },
];

const bl3ConnectCut5Levels: Level[] = [
    {
        id: "beginner-level3-bl3-connect-cut-5-1",
        chapterId: "beginner-level3",
        order: 1034,
        title: { zh: "连接与切断 · 1/12", en: "Connect and Cut · 1/12" },
        instruction: { zh: "白先。是否有必要防止在A点的切断？", en: "White to play. Is it necessary to prevent the cut at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dqdrfqep", white: "crcqdpdo" },
            marks: { A: "cp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。是否有必要防止在A点的切断？", en: "White to play. Is it necessary to prevent the cut at A?" },
            options: [{ value: "necessary", label: { zh: "有必要", en: "necessary" } }, { value: "not necessary", label: { zh: "没必要", en: "not necessary" } }],
            correctValue: "not necessary",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dqdrfqep", white: "crcqdpdo" },
                marks: { A: "cp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-5-2",
        chapterId: "beginner-level3",
        order: 1035,
        title: { zh: "连接与切断 · 2/12", en: "Connect and Cut · 2/12" },
        instruction: { zh: "白先。是否有必要防止在A点的切断？", en: "White to play. Is it necessary to prevent the cut at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "drdqdpdoeocncm", white: "dnenfnfoepeqerdl" },
            marks: { A: "fp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。是否有必要防止在A点的切断？", en: "White to play. Is it necessary to prevent the cut at A?" },
            options: [{ value: "necessary", label: { zh: "有必要", en: "necessary" } }, { value: "not necessary", label: { zh: "没必要", en: "not necessary" } }],
            correctValue: "not necessary",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "drdqdpdoeocncm", white: "dnenfnfoepeqerdl" },
                marks: { A: "fp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-5-3",
        chapterId: "beginner-level3",
        order: 1036,
        title: { zh: "连接与切断 · 3/12", en: "Connect and Cut · 3/12" },
        instruction: { zh: "白先。是否有必要防止在A点的切断？", en: "White to play. Is it necessary to prevent the cut at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncncock", white: "cpcqboeq" },
            marks: { A: "bp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。是否有必要防止在A点的切断？", en: "White to play. Is it necessary to prevent the cut at A?" },
            options: [{ value: "necessary", label: { zh: "有必要", en: "necessary" } }, { value: "not necessary", label: { zh: "没必要", en: "not necessary" } }],
            correctValue: "necessary",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bncncock", white: "cpcqboeq" },
                marks: { A: "bp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-5-4",
        chapterId: "beginner-level3",
        order: 1037,
        title: { zh: "连接与切断 · 4/12", en: "Connect and Cut · 4/12" },
        instruction: { zh: "白先。是否有必要防止在A点的切断？", en: "White to play. Is it necessary to prevent the cut at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpbocncmckdqeqergq", white: "cqcrdrdpepcoen" },
            marks: { A: "cp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。是否有必要防止在A点的切断？", en: "White to play. Is it necessary to prevent the cut at A?" },
            options: [{ value: "necessary", label: { zh: "有必要", en: "necessary" } }, { value: "not necessary", label: { zh: "没必要", en: "not necessary" } }],
            correctValue: "necessary",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bpbocncmckdqeqergq", white: "cqcrdrdpepcoen" },
                marks: { A: "cp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-5-5",
        chapterId: "beginner-level3",
        order: 1038,
        title: { zh: "连接与切断 · 5/12", en: "Connect and Cut · 5/12" },
        instruction: { zh: "白先。是否有必要防止在A点的切断？", en: "White to play. Is it necessary to prevent the cut at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbsbqcqcpdqeqcmelgq", white: "aqapbpcobndndpepfnfp" },
            marks: { A: "cn" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。是否有必要防止在A点的切断？", en: "White to play. Is it necessary to prevent the cut at A?" },
            options: [{ value: "necessary", label: { zh: "有必要", en: "necessary" } }, { value: "not necessary", label: { zh: "没必要", en: "not necessary" } }],
            correctValue: "not necessary",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "arbsbqcqcpdqeqcmelgq", white: "aqapbpcobndndpepfnfp" },
                marks: { A: "cn" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-5-6",
        chapterId: "beginner-level3",
        order: 1039,
        title: { zh: "连接与切断 · 6/12", en: "Connect and Cut · 6/12" },
        instruction: { zh: "白先。是否有必要防止在A点的切断？", en: "White to play. Is it necessary to prevent the cut at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brcrcqbpbocl", white: "drdqcpcobnepgq" },
            marks: { A: "cn" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。是否有必要防止在A点的切断？", en: "White to play. Is it necessary to prevent the cut at A?" },
            options: [{ value: "necessary", label: { zh: "有必要", en: "necessary" } }, { value: "not necessary", label: { zh: "没必要", en: "not necessary" } }],
            correctValue: "necessary",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "brcrcqbpbocl", white: "drdqcpcobnepgq" },
                marks: { A: "cn" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-5-7",
        chapterId: "beginner-level3",
        order: 1040,
        title: { zh: "连接与切断 · 7/12", en: "Connect and Cut · 7/12" },
        instruction: { zh: "白先。是否有必要防止在A点的切断？", en: "White to play. Is it necessary to prevent the cut at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpbocododmck", white: "bqcpdpepfqhq" },
            marks: { A: "cq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。是否有必要防止在A点的切断？", en: "White to play. Is it necessary to prevent the cut at A?" },
            options: [{ value: "necessary", label: { zh: "有必要", en: "necessary" } }, { value: "not necessary", label: { zh: "没必要", en: "not necessary" } }],
            correctValue: "not necessary",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bpbocododmck", white: "bqcpdpepfqhq" },
                marks: { A: "cq" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-5-8",
        chapterId: "beginner-level3",
        order: 1041,
        title: { zh: "连接与切断 · 8/12", en: "Connect and Cut · 8/12" },
        instruction: { zh: "白先。是否有必要防止在A点的切断？", en: "White to play. Is it necessary to prevent the cut at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpdqereqepeogr", white: "cqcrdrdpcobododm" },
            marks: { A: "cp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。是否有必要防止在A点的切断？", en: "White to play. Is it necessary to prevent the cut at A?" },
            options: [{ value: "necessary", label: { zh: "有必要", en: "necessary" } }, { value: "not necessary", label: { zh: "没必要", en: "not necessary" } }],
            correctValue: "not necessary",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bpdqereqepeogr", white: "cqcrdrdpcobododm" },
                marks: { A: "cp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-5-9",
        chapterId: "beginner-level3",
        order: 1042,
        title: { zh: "连接与切断 · 9/12", en: "Connect and Cut · 9/12" },
        instruction: { zh: "白先。是否有必要防止在A点的切断？", en: "White to play. Is it necessary to prevent the cut at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpcodncl", white: "bqdqfq" },
            marks: { A: "cq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。是否有必要防止在A点的切断？", en: "White to play. Is it necessary to prevent the cut at A?" },
            options: [{ value: "necessary", label: { zh: "有必要", en: "necessary" } }, { value: "not necessary", label: { zh: "没必要", en: "not necessary" } }],
            correctValue: "necessary",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cpcodncl", white: "bqdqfq" },
                marks: { A: "cq" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-5-10",
        chapterId: "beginner-level3",
        order: 1043,
        title: { zh: "连接与切断 · 10/12", en: "Connect and Cut · 10/12" },
        instruction: { zh: "白先。是否有必要防止在A点的切断？", en: "White to play. Is it necessary to prevent the cut at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bscrarbqdrds", white: "bpcqdqerfqdo" },
            marks: { A: "cp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。是否有必要防止在A点的切断？", en: "White to play. Is it necessary to prevent the cut at A?" },
            options: [{ value: "necessary", label: { zh: "有必要", en: "necessary" } }, { value: "not necessary", label: { zh: "没必要", en: "not necessary" } }],
            correctValue: "not necessary",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bscrarbqdrds", white: "bpcqdqerfqdo" },
                marks: { A: "cp" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-5-11",
        chapterId: "beginner-level3",
        order: 1044,
        title: { zh: "连接与切断 · 11/12", en: "Connect and Cut · 11/12" },
        instruction: { zh: "白先。是否有必要防止在A点的切断？", en: "White to play. Is it necessary to prevent the cut at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpbqcqdqcn", white: "epdpcpbocl" },
            marks: { A: "co" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。是否有必要防止在A点的切断？", en: "White to play. Is it necessary to prevent the cut at A?" },
            options: [{ value: "necessary", label: { zh: "有必要", en: "necessary" } }, { value: "not necessary", label: { zh: "没必要", en: "not necessary" } }],
            correctValue: "necessary",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bpbqcqdqcn", white: "epdpcpbocl" },
                marks: { A: "co" },
            },
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-5-12",
        chapterId: "beginner-level3",
        order: 1045,
        title: { zh: "连接与切断 · 12/12", en: "Connect and Cut · 12/12" },
        instruction: { zh: "白先。是否有必要防止在A点的切断？", en: "White to play. Is it necessary to prevent the cut at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cocndlen", white: "brbpdpeqgq" },
            marks: { A: "cp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。是否有必要防止在A点的切断？", en: "White to play. Is it necessary to prevent the cut at A?" },
            options: [{ value: "necessary", label: { zh: "有必要", en: "necessary" } }, { value: "not necessary", label: { zh: "没必要", en: "not necessary" } }],
            correctValue: "not necessary",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cocndlen", white: "brbpdpeqgq" },
                marks: { A: "cp" },
            },
        },
    },
];

const bl3ConnectCut6Levels: Level[] = [
    {
        id: "beginner-level3-bl3-connect-cut-6-1",
        chapterId: "beginner-level3",
        order: 1046,
        title: { zh: "连接与切断 · 1/24", en: "Connect and Cut · 1/24" },
        instruction: { zh: "黑先。选择最佳连接：A、B或C。", en: "Black to play. Choose the best connection: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fpeocsbrbqcpcodofngpio", white: "cndncrcqbpbodpepfqgqerclhq" },
            marks: { C: "dr", A: "dq", B: "eq" },
            correct: ["dr"],
            wrong: ["dqdr", "eqdq"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-6-2",
        chapterId: "beginner-level3",
        order: 1047,
        title: { zh: "连接与切断 · 2/24", en: "Connect and Cut · 2/24" },
        instruction: { zh: "黑先。选择最佳连接：A、B或C。", en: "Black to play. Choose the best connection: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcqdpcodn", white: "bpcpcrdqeqgq" },
            marks: { A: "bo", B: "ap", C: "br" },
            correct: ["br"],
            wrong: ["bobr", "apbr"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-6-3",
        chapterId: "beginner-level3",
        order: 1048,
        title: { zh: "连接与切断 · 3/24", en: "Connect and Cut · 3/24" },
        instruction: { zh: "黑先。选择最佳连接：A、B或C。", en: "Black to play. Choose the best connection: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eohpgofocsbsbrbqcqeqdpdohn", white: "crdrdqdsergpfpepbpcpcodndmbmdkhr" },
            marks: { C: "fr", A: "fq", B: "gq" },
            correct: ["frfqgq"],
            wrong: ["gqfr", "fqfr"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-6-4",
        chapterId: "beginner-level3",
        order: 1049,
        title: { zh: "连接与切断 · 4/24", en: "Connect and Cut · 4/24" },
        instruction: { zh: "黑先。选择最佳连接：A、B或C。", en: "Black to play. Choose the best connection: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpcn", white: "cpdpfqhq" },
            marks: { A: "bo", B: "co", C: "bq" },
            correct: ["bq"],
            wrong: ["bobq", "cobq"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-6-5",
        chapterId: "beginner-level3",
        order: 1050,
        title: { zh: "连接与切断 · 5/24", en: "Connect and Cut · 5/24" },
        instruction: { zh: "黑先。选择最佳连接：A、B或C。", en: "Black to play. Choose the best connection: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqdpepeqercobohp", white: "brbpcpdqdrdodndlgn" },
            marks: { A: "ap", B: "bq", C: "cr" },
            correct: ["bq"],
            wrong: ["apbq", "crbq"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-6-6",
        chapterId: "beginner-level3",
        order: 1051,
        title: { zh: "连接与切断 · 6/24", en: "Connect and Cut · 6/24" },
        instruction: { zh: "黑先。选择最佳连接：A、B或C。", en: "Black to play. Choose the best connection: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcqcrdrdmcmel", white: "erdqdpcpfqdnen" },
            marks: { A: "bn", B: "bo", C: "bp" },
            correct: ["bobpap"],
            wrong: ["bpbo", "bnbp"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-6-7",
        chapterId: "beginner-level3",
        order: 1052,
        title: { zh: "连接与切断 · 7/24", en: "Connect and Cut · 7/24" },
        instruction: { zh: "黑先。选择最佳连接：A、B或C。", en: "Black to play. Choose the best connection: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eqgsfsfrcsbsbrbqbpdrerhriqiocn", white: "crcqdqdshsgrgqfqfpepgn" },
            marks: { C: "is", A: "dp", B: "es" },
            correct: ["is"],
            wrong: ["dpes", "esds"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-6-8",
        chapterId: "beginner-level3",
        order: 1053,
        title: { zh: "连接与切断 · 8/24", en: "Connect and Cut · 8/24" },
        instruction: { zh: "黑先。选择最佳连接：A、B或C。", en: "Black to play. Choose the best connection: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "gohpipdpcpcqbqboiqeofo", white: "crbrdqcofqhqcndoenfngnhohmblbnirhrdrfr" },
            marks: { C: "gp", A: "ep", B: "fp" },
            correct: ["fp"],
            wrong: ["epgp", "gpep"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-6-9",
        chapterId: "beginner-level3",
        order: 1054,
        title: { zh: "连接与切断 · 9/24", en: "Connect and Cut · 9/24" },
        instruction: { zh: "黑先。选择最佳连接：A、B或C。", en: "Black to play. Choose the best connection: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqdpepcpbocncmblamdkbr", white: "bmbnbpcodoeofpeqdqhq" },
            marks: { A: "an", B: "ap", C: "cq" },
            correct: ["ap"],
            wrong: ["ancq", "cqao"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-6-10",
        chapterId: "beginner-level3",
        order: 1055,
        title: { zh: "连接与切断 · 10/24", en: "Connect and Cut · 10/24" },
        instruction: { zh: "黑先。选择最佳连接：A、B或C。", en: "Black to play. Choose the best connection: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dqcpcogqhqcmiq", white: "fqgphpeoemip" },
            marks: { A: "eq", B: "er", C: "fr" },
            correct: ["frereq"],
            wrong: ["erfr", "eqfr"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-6-11",
        chapterId: "beginner-level3",
        order: 1056,
        title: { zh: "连接与切断 · 11/24", en: "Connect and Cut · 11/24" },
        instruction: { zh: "黑先。选择最佳连接：A、B或C。", en: "Black to play. Choose the best connection: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "hrcpbpcqbrdpeoenfmgngogpfqeqim", white: "bocodofofnelemcrdrdqbqapercmdnao" },
            marks: { C: "aq", A: "ep", B: "fp" },
            correct: ["ep"],
            wrong: ["fpep", "aqep"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-6-12",
        chapterId: "beginner-level3",
        order: 1057,
        title: { zh: "连接与切断 · 12/24", en: "Connect and Cut · 12/24" },
        instruction: { zh: "黑先。选择最佳连接：A、B或C。", en: "Black to play. Choose the best connection: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dodpdqdrhqiqipio", white: "brbqbpcocneqepeoemgphphn" },
            marks: { A: "er", B: "fr", C: "gr" },
            correct: ["freres"],
            wrong: ["erfrfqgqgrfs", "erfrfqgqfsgr", "grer"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-6-13",
        chapterId: "beginner-level3",
        order: 1058,
        title: { zh: "连接与切断 · 13/24", en: "Connect and Cut · 13/24" },
        instruction: { zh: "黑先。选择最佳连接：A、B或C。", en: "Black to play. Choose the best connection: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "drdqdpcqeoenemdmgm", white: "cpdodncmclepfpfrhqdkek" },
            marks: { A: "cn", B: "co", C: "bp" },
            correct: ["cncobn"],
            wrong: ["cocn", "bpco"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-6-14",
        chapterId: "beginner-level3",
        order: 1059,
        title: { zh: "连接与切断 · 14/24", en: "Connect and Cut · 14/24" },
        instruction: { zh: "黑先。选择最佳连接：A、B或C。", en: "Black to play. Choose the best connection: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brcqcpboeq", white: "cocnbpbqen" },
            marks: { A: "bn", B: "ap", C: "aq" },
            correct: ["bn"],
            wrong: ["aqbn", "apbn"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-6-15",
        chapterId: "beginner-level3",
        order: 1060,
        title: { zh: "连接与切断 · 15/24", en: "Connect and Cut · 15/24" },
        instruction: { zh: "黑先。选择最佳连接：A、B或C。", en: "Black to play. Choose the best connection: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dqhqgqfpbsbrcqcpgpcngnhoeoepfnirbm", white: "dnemfmfqeqgrhrdrcrcsdpiqiojrdojpin" },
            marks: { A: "co", B: "er", C: "fr" },
            correct: ["frerfs"],
            wrong: ["erfr", "coer"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-6-16",
        chapterId: "beginner-level3",
        order: 1061,
        title: { zh: "连接与切断 · 16/24", en: "Connect and Cut · 16/24" },
        instruction: { zh: "黑先。选择最佳连接：A、B或C。", en: "Black to play. Choose the best connection: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpcocnbndmclfpepdpfn", white: "bqcqdqeqgqcpbododnfogohpgr" },
            marks: { A: "en", B: "ao", C: "eo" },
            correct: ["eo"],
            wrong: ["aoeo", "eneo"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-6-17",
        chapterId: "beginner-level3",
        order: 1062,
        title: { zh: "连接与切断 · 17/24", en: "Connect and Cut · 17/24" },
        instruction: { zh: "黑先。选择最佳连接：A、B或C。", en: "Black to play. Choose the best connection: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eqdqcpbp", white: "bqcqdrerfqfp" },
            marks: { A: "do", B: "eo", C: "dp" },
            correct: ["eo"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-6-18",
        chapterId: "beginner-level3",
        order: 1063,
        title: { zh: "连接与切断 · 18/24", en: "Connect and Cut · 18/24" },
        instruction: { zh: "黑先。选择最佳连接：A、B或C。", en: "Black to play. Choose the best connection: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brcrdrgqgpgo", white: "dqcqbqbofqfpdoen" },
            marks: { A: "er", B: "fr", C: "gr" },
            correct: ["freres"],
            wrong: ["grfr", "erfr"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-6-19",
        chapterId: "beginner-level3",
        order: 1064,
        title: { zh: "连接与切断 · 19/24", en: "Connect and Cut · 19/24" },
        instruction: { zh: "黑先。选择最佳连接：A、B或C。", en: "Black to play. Choose the best connection: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cocneogo", white: "cpdpcmdlfq" },
            marks: { A: "em", B: "en", C: "do" },
            correct: ["em"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-6-20",
        chapterId: "beginner-level3",
        order: 1065,
        title: { zh: "连接与切断 · 20/24", en: "Connect and Cut · 20/24" },
        instruction: { zh: "黑先。选择最佳连接：A、B或C。", en: "Black to play. Choose the best connection: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "frfqeqdpdocncmdl", white: "dserdqcqcpcodnen" },
            marks: { A: "fo", B: "ep", C: "fp" },
            correct: ["fo"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-6-21",
        chapterId: "beginner-level3",
        order: 1066,
        title: { zh: "连接与切断 · 21/24", en: "Connect and Cut · 21/24" },
        instruction: { zh: "黑先。选择最佳连接：A、B或C。", en: "Black to play. Choose the best connection: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcqdpdodm", white: "brcreqfqdqcp" },
            marks: { A: "bo", B: "co", C: "bp" },
            correct: ["bp"],
            wrong: ["cobp", "bobp"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-6-22",
        chapterId: "beginner-level3",
        order: 1067,
        title: { zh: "连接与切断 · 22/24", en: "Connect and Cut · 22/24" },
        instruction: { zh: "黑先。选择最佳连接：A、B或C。", en: "Black to play. Choose the best connection: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cocncmdpdqer", white: "crdrcqcpbobn" },
            marks: { A: "do", B: "eq", C: "fq" },
            correct: ["fq"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-6-23",
        chapterId: "beginner-level3",
        order: 1068,
        title: { zh: "连接与切断 · 23/24", en: "Connect and Cut · 23/24" },
        instruction: { zh: "黑先。选择最佳连接：A、B或C。", en: "Black to play. Choose the best connection: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqcpcodndmbnfpfqhqhp", white: "dqdpdoepenfogoioiqiphm" },
            marks: { A: "dr", B: "er", C: "es" },
            correct: ["drereq"],
            wrong: ["erdr", "esdr"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-6-24",
        chapterId: "beginner-level3",
        order: 1069,
        title: { zh: "连接与切断 · 24/24", en: "Connect and Cut · 24/24" },
        instruction: { zh: "黑先。选择最佳连接：A、B或C。", en: "Black to play. Choose the best connection: A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "arbrcrdrgqgpiqhoin", white: "bqcqdqbofqfpfogngldm" },
            marks: { A: "fr", B: "es", C: "fs" },
            correct: ["freres"],
            wrong: ["esfr", "fseserfr"],
        },
    },
];

const bl3ConnectCut7Levels: Level[] = [
    {
        id: "beginner-level3-bl3-connect-cut-7-1",
        chapterId: "beginner-level3",
        order: 1070,
        title: { zh: "连接与切断 · 1/10", en: "Connect and Cut · 1/10" },
        instruction: { zh: "白先。以最佳方式防御这个切断。", en: "White to play. Defend the best way against the cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "drcrcqcofpgpiq", white: "dqeqereo" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-7-2",
        chapterId: "beginner-level3",
        order: 1071,
        title: { zh: "连接与切断 · 2/10", en: "Connect and Cut · 2/10" },
        instruction: { zh: "白先。以最佳方式防御这个切断。", en: "White to play. Defend the best way against the cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcpcndmdlfogohoepeqfqfriq", white: "erdqdpeofngndrflhl" },
            correct: ["dn"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-7-3",
        chapterId: "beginner-level3",
        order: 1072,
        title: { zh: "连接与切断 · 3/10", en: "Connect and Cut · 3/10" },
        instruction: { zh: "白先。以最佳方式防御这个切断。", en: "White to play. Defend the best way against the cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpcocnbndldoeofpfq", white: "cqbqbpbodpep" },
            correct: ["er"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-7-4",
        chapterId: "beginner-level3",
        order: 1073,
        title: { zh: "连接与切断 · 4/10", en: "Connect and Cut · 4/10" },
        instruction: { zh: "白先。以最佳方式防御这个切断。", en: "White to play. Defend the best way against the cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dqdpcpepgphphqiqircr", white: "brcqbqdreqgqhr" },
            correct: ["fr"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-7-5",
        chapterId: "beginner-level3",
        order: 1074,
        title: { zh: "连接与切断 · 5/10", en: "Connect and Cut · 5/10" },
        instruction: { zh: "白先。以最佳方式防御这个切断。", en: "White to play. Defend the best way against the cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpcqcncmdkfpfqhq", white: "dqeqdoemfl" },
            correct: ["eo"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-7-6",
        chapterId: "beginner-level3",
        order: 1075,
        title: { zh: "连接与切断 · 6/10", en: "Connect and Cut · 6/10" },
        instruction: { zh: "白先。以最佳方式防御这个切断。", en: "White to play. Defend the best way against the cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqdqdpeofocrfq", white: "bqcpdoen" },
            correct: ["co"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-7-7",
        chapterId: "beginner-level3",
        order: 1076,
        title: { zh: "连接与切断 · 7/10", en: "Connect and Cut · 7/10" },
        instruction: { zh: "白先。以最佳方式防御这个切断。", en: "White to play. Defend the best way against the cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brbqcpcodoendlfqhqiq", white: "crcqdpeofoho" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-7-8",
        chapterId: "beginner-level3",
        order: 1077,
        title: { zh: "连接与切断 · 8/10", en: "Connect and Cut · 8/10" },
        instruction: { zh: "白先。以最佳方式防御这个切断。", en: "White to play. Defend the best way against the cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqcpcocncldkfofpfqiqgr", white: "dqeqdodmemgm" },
            correct: ["eo"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-7-9",
        chapterId: "beginner-level3",
        order: 1078,
        title: { zh: "连接与切断 · 9/10", en: "Connect and Cut · 9/10" },
        instruction: { zh: "白先。以最佳方式防御这个切断。", en: "White to play. Defend the best way against the cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "drdqdpdodnbpbrcs", white: "bncndmenepeqer" },
            correct: ["fm"],
        },
    },
    {
        id: "beginner-level3-bl3-connect-cut-7-10",
        chapterId: "beginner-level3",
        order: 1079,
        title: { zh: "连接与切断 · 10/10", en: "Connect and Cut · 10/10" },
        instruction: { zh: "白先。以最佳方式防御这个切断。", en: "White to play. Defend the best way against the cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crbrbqbpcodoeogrhqhp", white: "cpcqdrepfofn" },
            correct: ["fq"],
        },
    },
];

export const LEVELS: Level[] = [
    ...bl3Capture1Levels,
    ...bl3Capture2Levels,
    ...bl3Capture3Levels,
    ...bl3Capture4Levels,
    ...bl3Capture5Levels,
    ...bl3Capture6Levels,
    ...bl3Capture7Levels,
    ...bl3Joseki1Levels,
    ...bl3Joseki2Levels,
    ...bl3Joseki3Levels,
    ...bl3Joseki4Levels,
    ...bl3Opening1Levels,
    ...bl3Opening2Levels,
    ...bl3Opening3Levels,
    ...bl3Opening4Levels,
    ...bl3Haengma1Levels,
    ...bl3Haengma2Levels,
    ...bl3Haengma3Levels,
    ...bl3Haengma4Levels,
    ...bl3Seki1Levels,
    ...bl3Seki2Levels,
    ...bl3Skills1Levels,
    ...bl3Skills2Levels,
    ...bl3Skills3Levels,
    ...bl3Skills4Levels,
    ...bl3Skills5Levels,
    ...bl3Skills6Levels,
    ...bl3Skills7Levels,
    ...bl3Endgame1Levels,
    ...bl3Endgame2Levels,
    ...bl3Endgame3Levels,
    ...bl3Endgame4Levels,
    ...bl3Endgame5Levels,
    ...bl3FalseEye1Levels,
    ...bl3FalseEye2Levels,
    ...bl3FalseEye3Levels,
    ...bl3FalseEye4Levels,
    ...bl3LifeDeath1Levels,
    ...bl3LifeDeath2Levels,
    ...bl3LifeDeath3Levels,
    ...bl3LifeDeath4Levels,
    ...bl3LifeDeath5Levels,
    ...bl3LifeDeath6Levels,
    ...bl3LifeDeath7Levels,
    ...bl3LifeDeath8Levels,
    ...bl3LifeDeath9Levels,
    ...bl3LifeDeath10Levels,
    ...bl3LifeDeath11Levels,
    ...bl3LifeDeath12Levels,
    ...bl3LifeDeath13Levels,
    ...bl3LifeDeath14Levels,
    ...bl3LifeDeath15Levels,
    ...bl3LifeDeath16Levels,
    ...bl3LifeDeath17Levels,
    ...bl3LifeDeath18Levels,
    ...bl3CapturingRace1Levels,
    ...bl3CapturingRace2Levels,
    ...bl3CapturingRace3Levels,
    ...bl3CapturingRace4Levels,
    ...bl3CapturingRace5Levels,
    ...bl3CapturingRace6Levels,
    ...bl3CapturingRace7Levels,
    ...bl3CapturingRace8Levels,
    ...bl3PreparatoryAtari1Levels,
    ...bl3PreparatoryAtari2Levels,
    ...bl3PreparatoryAtari3Levels,
    ...bl3PreparatoryAtari4Levels,
    ...bl3ConnectCut1Levels,
    ...bl3ConnectCut2Levels,
    ...bl3ConnectCut3Levels,
    ...bl3ConnectCut4Levels,
    ...bl3ConnectCut5Levels,
    ...bl3ConnectCut6Levels,
    ...bl3ConnectCut7Levels,
];
